var _defineProperty = require("/codebuild/output/src073659321/src/turo-project/turo-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

(function (e, a) {
  for (var i in a) {
    e[i] = a[i];
  }
})(exports,
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 15);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  //     Underscore.js 1.4.4
  //     http://underscorejs.org
  //     (c) 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
  //     Underscore may be freely distributed under the MIT license.
  (function () {
    // Baseline setup
    // --------------
    // Establish the root object, `window` in the browser, or `global` on the server.
    var root = this; // Save the previous value of the `_` variable.

    var previousUnderscore = root._; // Establish the object that gets returned to break out of a loop iteration.

    var breaker = {}; // Save bytes in the minified (but not gzipped) version:

    var ArrayProto = Array.prototype,
        ObjProto = Object.prototype,
        FuncProto = Function.prototype; // Create quick reference variables for speed access to core prototypes.

    var push = ArrayProto.push,
        slice = ArrayProto.slice,
        concat = ArrayProto.concat,
        toString = ObjProto.toString,
        hasOwnProperty = ObjProto.hasOwnProperty; // All **ECMAScript 5** native function implementations that we hope to use
    // are declared here.

    var nativeForEach = ArrayProto.forEach,
        nativeMap = ArrayProto.map,
        nativeReduce = ArrayProto.reduce,
        nativeReduceRight = ArrayProto.reduceRight,
        nativeFilter = ArrayProto.filter,
        nativeEvery = ArrayProto.every,
        nativeSome = ArrayProto.some,
        nativeIndexOf = ArrayProto.indexOf,
        nativeLastIndexOf = ArrayProto.lastIndexOf,
        nativeIsArray = Array.isArray,
        nativeKeys = Object.keys,
        nativeBind = FuncProto.bind; // Create a safe reference to the Underscore object for use below.

    var _ = function _(obj) {
      if (obj instanceof _) return obj;
      if (!(this instanceof _)) return new _(obj);
      this._wrapped = obj;
    }; // Export the Underscore object for **Node.js**, with
    // backwards-compatibility for the old `require()` API. If we're in
    // the browser, add `_` as a global object via a string identifier,
    // for Closure Compiler "advanced" mode.


    if (true) {
      if (typeof module !== 'undefined' && module.exports) {
        exports = module.exports = _;
      }

      exports._ = _;
    } else {
      root._ = _;
    } // Current version.


    _.VERSION = '1.4.4'; // Collection Functions
    // --------------------
    // The cornerstone, an `each` implementation, aka `forEach`.
    // Handles objects with the built-in `forEach`, arrays, and raw objects.
    // Delegates to **ECMAScript 5**'s native `forEach` if available.

    var each = _.each = _.forEach = function (obj, iterator, context) {
      if (obj == null) return;

      if (nativeForEach && obj.forEach === nativeForEach) {
        obj.forEach(iterator, context);
      } else if (obj.length === +obj.length) {
        for (var i = 0, l = obj.length; i < l; i++) {
          if (iterator.call(context, obj[i], i, obj) === breaker) return;
        }
      } else {
        for (var key in obj) {
          if (_.has(obj, key)) {
            if (iterator.call(context, obj[key], key, obj) === breaker) return;
          }
        }
      }
    }; // Return the results of applying the iterator to each element.
    // Delegates to **ECMAScript 5**'s native `map` if available.


    _.map = _.collect = function (obj, iterator, context) {
      var results = [];
      if (obj == null) return results;
      if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
      each(obj, function (value, index, list) {
        results[results.length] = iterator.call(context, value, index, list);
      });
      return results;
    };

    var reduceError = 'Reduce of empty array with no initial value'; // **Reduce** builds up a single result from a list of values, aka `inject`,
    // or `foldl`. Delegates to **ECMAScript 5**'s native `reduce` if available.

    _.reduce = _.foldl = _.inject = function (obj, iterator, memo, context) {
      var initial = arguments.length > 2;
      if (obj == null) obj = [];

      if (nativeReduce && obj.reduce === nativeReduce) {
        if (context) iterator = _.bind(iterator, context);
        return initial ? obj.reduce(iterator, memo) : obj.reduce(iterator);
      }

      each(obj, function (value, index, list) {
        if (!initial) {
          memo = value;
          initial = true;
        } else {
          memo = iterator.call(context, memo, value, index, list);
        }
      });
      if (!initial) throw new TypeError(reduceError);
      return memo;
    }; // The right-associative version of reduce, also known as `foldr`.
    // Delegates to **ECMAScript 5**'s native `reduceRight` if available.


    _.reduceRight = _.foldr = function (obj, iterator, memo, context) {
      var initial = arguments.length > 2;
      if (obj == null) obj = [];

      if (nativeReduceRight && obj.reduceRight === nativeReduceRight) {
        if (context) iterator = _.bind(iterator, context);
        return initial ? obj.reduceRight(iterator, memo) : obj.reduceRight(iterator);
      }

      var length = obj.length;

      if (length !== +length) {
        var keys = _.keys(obj);

        length = keys.length;
      }

      each(obj, function (value, index, list) {
        index = keys ? keys[--length] : --length;

        if (!initial) {
          memo = obj[index];
          initial = true;
        } else {
          memo = iterator.call(context, memo, obj[index], index, list);
        }
      });
      if (!initial) throw new TypeError(reduceError);
      return memo;
    }; // Return the first value which passes a truth test. Aliased as `detect`.


    _.find = _.detect = function (obj, iterator, context) {
      var result;
      any(obj, function (value, index, list) {
        if (iterator.call(context, value, index, list)) {
          result = value;
          return true;
        }
      });
      return result;
    }; // Return all the elements that pass a truth test.
    // Delegates to **ECMAScript 5**'s native `filter` if available.
    // Aliased as `select`.


    _.filter = _.select = function (obj, iterator, context) {
      var results = [];
      if (obj == null) return results;
      if (nativeFilter && obj.filter === nativeFilter) return obj.filter(iterator, context);
      each(obj, function (value, index, list) {
        if (iterator.call(context, value, index, list)) results[results.length] = value;
      });
      return results;
    }; // Return all the elements for which a truth test fails.


    _.reject = function (obj, iterator, context) {
      return _.filter(obj, function (value, index, list) {
        return !iterator.call(context, value, index, list);
      }, context);
    }; // Determine whether all of the elements match a truth test.
    // Delegates to **ECMAScript 5**'s native `every` if available.
    // Aliased as `all`.


    _.every = _.all = function (obj, iterator, context) {
      iterator || (iterator = _.identity);
      var result = true;
      if (obj == null) return result;
      if (nativeEvery && obj.every === nativeEvery) return obj.every(iterator, context);
      each(obj, function (value, index, list) {
        if (!(result = result && iterator.call(context, value, index, list))) return breaker;
      });
      return !!result;
    }; // Determine if at least one element in the object matches a truth test.
    // Delegates to **ECMAScript 5**'s native `some` if available.
    // Aliased as `any`.


    var any = _.some = _.any = function (obj, iterator, context) {
      iterator || (iterator = _.identity);
      var result = false;
      if (obj == null) return result;
      if (nativeSome && obj.some === nativeSome) return obj.some(iterator, context);
      each(obj, function (value, index, list) {
        if (result || (result = iterator.call(context, value, index, list))) return breaker;
      });
      return !!result;
    }; // Determine if the array or object contains a given value (using `===`).
    // Aliased as `include`.


    _.contains = _.include = function (obj, target) {
      if (obj == null) return false;
      if (nativeIndexOf && obj.indexOf === nativeIndexOf) return obj.indexOf(target) != -1;
      return any(obj, function (value) {
        return value === target;
      });
    }; // Invoke a method (with arguments) on every item in a collection.


    _.invoke = function (obj, method) {
      var args = slice.call(arguments, 2);

      var isFunc = _.isFunction(method);

      return _.map(obj, function (value) {
        return (isFunc ? method : value[method]).apply(value, args);
      });
    }; // Convenience version of a common use case of `map`: fetching a property.


    _.pluck = function (obj, key) {
      return _.map(obj, function (value) {
        return value[key];
      });
    }; // Convenience version of a common use case of `filter`: selecting only objects
    // containing specific `key:value` pairs.


    _.where = function (obj, attrs, first) {
      if (_.isEmpty(attrs)) return first ? null : [];
      return _[first ? 'find' : 'filter'](obj, function (value) {
        for (var key in attrs) {
          if (attrs[key] !== value[key]) return false;
        }

        return true;
      });
    }; // Convenience version of a common use case of `find`: getting the first object
    // containing specific `key:value` pairs.


    _.findWhere = function (obj, attrs) {
      return _.where(obj, attrs, true);
    }; // Return the maximum element or (element-based computation).
    // Can't optimize arrays of integers longer than 65,535 elements.
    // See: https://bugs.webkit.org/show_bug.cgi?id=80797


    _.max = function (obj, iterator, context) {
      if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
        return Math.max.apply(Math, obj);
      }

      if (!iterator && _.isEmpty(obj)) return -Infinity;
      var result = {
        computed: -Infinity,
        value: -Infinity
      };
      each(obj, function (value, index, list) {
        var computed = iterator ? iterator.call(context, value, index, list) : value;
        computed >= result.computed && (result = {
          value: value,
          computed: computed
        });
      });
      return result.value;
    }; // Return the minimum element (or element-based computation).


    _.min = function (obj, iterator, context) {
      if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
        return Math.min.apply(Math, obj);
      }

      if (!iterator && _.isEmpty(obj)) return Infinity;
      var result = {
        computed: Infinity,
        value: Infinity
      };
      each(obj, function (value, index, list) {
        var computed = iterator ? iterator.call(context, value, index, list) : value;
        computed < result.computed && (result = {
          value: value,
          computed: computed
        });
      });
      return result.value;
    }; // Shuffle an array.


    _.shuffle = function (obj) {
      var rand;
      var index = 0;
      var shuffled = [];
      each(obj, function (value) {
        rand = _.random(index++);
        shuffled[index - 1] = shuffled[rand];
        shuffled[rand] = value;
      });
      return shuffled;
    }; // An internal function to generate lookup iterators.


    var lookupIterator = function lookupIterator(value) {
      return _.isFunction(value) ? value : function (obj) {
        return obj[value];
      };
    }; // Sort the object's values by a criterion produced by an iterator.


    _.sortBy = function (obj, value, context) {
      var iterator = lookupIterator(value);
      return _.pluck(_.map(obj, function (value, index, list) {
        return {
          value: value,
          index: index,
          criteria: iterator.call(context, value, index, list)
        };
      }).sort(function (left, right) {
        var a = left.criteria;
        var b = right.criteria;

        if (a !== b) {
          if (a > b || a === void 0) return 1;
          if (a < b || b === void 0) return -1;
        }

        return left.index < right.index ? -1 : 1;
      }), 'value');
    }; // An internal function used for aggregate "group by" operations.


    var group = function group(obj, value, context, behavior) {
      var result = {};
      var iterator = lookupIterator(value || _.identity);
      each(obj, function (value, index) {
        var key = iterator.call(context, value, index, obj);
        behavior(result, key, value);
      });
      return result;
    }; // Groups the object's values by a criterion. Pass either a string attribute
    // to group by, or a function that returns the criterion.


    _.groupBy = function (obj, value, context) {
      return group(obj, value, context, function (result, key, value) {
        (_.has(result, key) ? result[key] : result[key] = []).push(value);
      });
    }; // Counts instances of an object that group by a certain criterion. Pass
    // either a string attribute to count by, or a function that returns the
    // criterion.


    _.countBy = function (obj, value, context) {
      return group(obj, value, context, function (result, key) {
        if (!_.has(result, key)) result[key] = 0;
        result[key]++;
      });
    }; // Use a comparator function to figure out the smallest index at which
    // an object should be inserted so as to maintain order. Uses binary search.


    _.sortedIndex = function (array, obj, iterator, context) {
      iterator = iterator == null ? _.identity : lookupIterator(iterator);
      var value = iterator.call(context, obj);
      var low = 0,
          high = array.length;

      while (low < high) {
        var mid = low + high >>> 1;
        iterator.call(context, array[mid]) < value ? low = mid + 1 : high = mid;
      }

      return low;
    }; // Safely convert anything iterable into a real, live array.


    _.toArray = function (obj) {
      if (!obj) return [];
      if (_.isArray(obj)) return slice.call(obj);
      if (obj.length === +obj.length) return _.map(obj, _.identity);
      return _.values(obj);
    }; // Return the number of elements in an object.


    _.size = function (obj) {
      if (obj == null) return 0;
      return obj.length === +obj.length ? obj.length : _.keys(obj).length;
    }; // Array Functions
    // ---------------
    // Get the first element of an array. Passing **n** will return the first N
    // values in the array. Aliased as `head` and `take`. The **guard** check
    // allows it to work with `_.map`.


    _.first = _.head = _.take = function (array, n, guard) {
      if (array == null) return void 0;
      return n != null && !guard ? slice.call(array, 0, n) : array[0];
    }; // Returns everything but the last entry of the array. Especially useful on
    // the arguments object. Passing **n** will return all the values in
    // the array, excluding the last N. The **guard** check allows it to work with
    // `_.map`.


    _.initial = function (array, n, guard) {
      return slice.call(array, 0, array.length - (n == null || guard ? 1 : n));
    }; // Get the last element of an array. Passing **n** will return the last N
    // values in the array. The **guard** check allows it to work with `_.map`.


    _.last = function (array, n, guard) {
      if (array == null) return void 0;

      if (n != null && !guard) {
        return slice.call(array, Math.max(array.length - n, 0));
      } else {
        return array[array.length - 1];
      }
    }; // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
    // Especially useful on the arguments object. Passing an **n** will return
    // the rest N values in the array. The **guard**
    // check allows it to work with `_.map`.


    _.rest = _.tail = _.drop = function (array, n, guard) {
      return slice.call(array, n == null || guard ? 1 : n);
    }; // Trim out all falsy values from an array.


    _.compact = function (array) {
      return _.filter(array, _.identity);
    }; // Internal implementation of a recursive `flatten` function.


    var flatten = function flatten(input, shallow, output) {
      each(input, function (value) {
        if (_.isArray(value)) {
          shallow ? push.apply(output, value) : flatten(value, shallow, output);
        } else {
          output.push(value);
        }
      });
      return output;
    }; // Return a completely flattened version of an array.


    _.flatten = function (array, shallow) {
      return flatten(array, shallow, []);
    }; // Return a version of the array that does not contain the specified value(s).


    _.without = function (array) {
      return _.difference(array, slice.call(arguments, 1));
    }; // Produce a duplicate-free version of the array. If the array has already
    // been sorted, you have the option of using a faster algorithm.
    // Aliased as `unique`.


    _.uniq = _.unique = function (array, isSorted, iterator, context) {
      if (_.isFunction(isSorted)) {
        context = iterator;
        iterator = isSorted;
        isSorted = false;
      }

      var initial = iterator ? _.map(array, iterator, context) : array;
      var results = [];
      var seen = [];
      each(initial, function (value, index) {
        if (isSorted ? !index || seen[seen.length - 1] !== value : !_.contains(seen, value)) {
          seen.push(value);
          results.push(array[index]);
        }
      });
      return results;
    }; // Produce an array that contains the union: each distinct element from all of
    // the passed-in arrays.


    _.union = function () {
      return _.uniq(concat.apply(ArrayProto, arguments));
    }; // Produce an array that contains every item shared between all the
    // passed-in arrays.


    _.intersection = function (array) {
      var rest = slice.call(arguments, 1);
      return _.filter(_.uniq(array), function (item) {
        return _.every(rest, function (other) {
          return _.indexOf(other, item) >= 0;
        });
      });
    }; // Take the difference between one array and a number of other arrays.
    // Only the elements present in just the first array will remain.


    _.difference = function (array) {
      var rest = concat.apply(ArrayProto, slice.call(arguments, 1));
      return _.filter(array, function (value) {
        return !_.contains(rest, value);
      });
    }; // Zip together multiple lists into a single array -- elements that share
    // an index go together.


    _.zip = function () {
      var args = slice.call(arguments);

      var length = _.max(_.pluck(args, 'length'));

      var results = new Array(length);

      for (var i = 0; i < length; i++) {
        results[i] = _.pluck(args, "" + i);
      }

      return results;
    }; // Converts lists into objects. Pass either a single array of `[key, value]`
    // pairs, or two parallel arrays of the same length -- one of keys, and one of
    // the corresponding values.


    _.object = function (list, values) {
      if (list == null) return {};
      var result = {};

      for (var i = 0, l = list.length; i < l; i++) {
        if (values) {
          result[list[i]] = values[i];
        } else {
          result[list[i][0]] = list[i][1];
        }
      }

      return result;
    }; // If the browser doesn't supply us with indexOf (I'm looking at you, **MSIE**),
    // we need this function. Return the position of the first occurrence of an
    // item in an array, or -1 if the item is not included in the array.
    // Delegates to **ECMAScript 5**'s native `indexOf` if available.
    // If the array is large and already in sort order, pass `true`
    // for **isSorted** to use binary search.


    _.indexOf = function (array, item, isSorted) {
      if (array == null) return -1;
      var i = 0,
          l = array.length;

      if (isSorted) {
        if (typeof isSorted == 'number') {
          i = isSorted < 0 ? Math.max(0, l + isSorted) : isSorted;
        } else {
          i = _.sortedIndex(array, item);
          return array[i] === item ? i : -1;
        }
      }

      if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item, isSorted);

      for (; i < l; i++) {
        if (array[i] === item) return i;
      }

      return -1;
    }; // Delegates to **ECMAScript 5**'s native `lastIndexOf` if available.


    _.lastIndexOf = function (array, item, from) {
      if (array == null) return -1;
      var hasIndex = from != null;

      if (nativeLastIndexOf && array.lastIndexOf === nativeLastIndexOf) {
        return hasIndex ? array.lastIndexOf(item, from) : array.lastIndexOf(item);
      }

      var i = hasIndex ? from : array.length;

      while (i--) {
        if (array[i] === item) return i;
      }

      return -1;
    }; // Generate an integer Array containing an arithmetic progression. A port of
    // the native Python `range()` function. See
    // [the Python documentation](http://docs.python.org/library/functions.html#range).


    _.range = function (start, stop, step) {
      if (arguments.length <= 1) {
        stop = start || 0;
        start = 0;
      }

      step = arguments[2] || 1;
      var len = Math.max(Math.ceil((stop - start) / step), 0);
      var idx = 0;
      var range = new Array(len);

      while (idx < len) {
        range[idx++] = start;
        start += step;
      }

      return range;
    }; // Function (ahem) Functions
    // ------------------
    // Create a function bound to a given object (assigning `this`, and arguments,
    // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
    // available.


    _.bind = function (func, context) {
      if (func.bind === nativeBind && nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
      var args = slice.call(arguments, 2);
      return function () {
        return func.apply(context, args.concat(slice.call(arguments)));
      };
    }; // Partially apply a function by creating a version that has had some of its
    // arguments pre-filled, without changing its dynamic `this` context.


    _.partial = function (func) {
      var args = slice.call(arguments, 1);
      return function () {
        return func.apply(this, args.concat(slice.call(arguments)));
      };
    }; // Bind all of an object's methods to that object. Useful for ensuring that
    // all callbacks defined on an object belong to it.


    _.bindAll = function (obj) {
      var funcs = slice.call(arguments, 1);
      if (funcs.length === 0) funcs = _.functions(obj);
      each(funcs, function (f) {
        obj[f] = _.bind(obj[f], obj);
      });
      return obj;
    }; // Memoize an expensive function by storing its results.


    _.memoize = function (func, hasher) {
      var memo = {};
      hasher || (hasher = _.identity);
      return function () {
        var key = hasher.apply(this, arguments);
        return _.has(memo, key) ? memo[key] : memo[key] = func.apply(this, arguments);
      };
    }; // Delays a function for the given number of milliseconds, and then calls
    // it with the arguments supplied.


    _.delay = function (func, wait) {
      var args = slice.call(arguments, 2);
      return setTimeout(function () {
        return func.apply(null, args);
      }, wait);
    }; // Defers a function, scheduling it to run after the current call stack has
    // cleared.


    _.defer = function (func) {
      return _.delay.apply(_, [func, 1].concat(slice.call(arguments, 1)));
    }; // Returns a function, that, when invoked, will only be triggered at most once
    // during a given window of time.


    _.throttle = function (func, wait) {
      var context, args, timeout, result;
      var previous = 0;

      var later = function later() {
        previous = new Date();
        timeout = null;
        result = func.apply(context, args);
      };

      return function () {
        var now = new Date();
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;

        if (remaining <= 0) {
          clearTimeout(timeout);
          timeout = null;
          previous = now;
          result = func.apply(context, args);
        } else if (!timeout) {
          timeout = setTimeout(later, remaining);
        }

        return result;
      };
    }; // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.


    _.debounce = function (func, wait, immediate) {
      var timeout, result;
      return function () {
        var context = this,
            args = arguments;

        var later = function later() {
          timeout = null;
          if (!immediate) result = func.apply(context, args);
        };

        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) result = func.apply(context, args);
        return result;
      };
    }; // Returns a function that will be executed at most one time, no matter how
    // often you call it. Useful for lazy initialization.


    _.once = function (func) {
      var ran = false,
          memo;
      return function () {
        if (ran) return memo;
        ran = true;
        memo = func.apply(this, arguments);
        func = null;
        return memo;
      };
    }; // Returns the first function passed as an argument to the second,
    // allowing you to adjust arguments, run code before and after, and
    // conditionally execute the original function.


    _.wrap = function (func, wrapper) {
      return function () {
        var args = [func];
        push.apply(args, arguments);
        return wrapper.apply(this, args);
      };
    }; // Returns a function that is the composition of a list of functions, each
    // consuming the return value of the function that follows.


    _.compose = function () {
      var funcs = arguments;
      return function () {
        var args = arguments;

        for (var i = funcs.length - 1; i >= 0; i--) {
          args = [funcs[i].apply(this, args)];
        }

        return args[0];
      };
    }; // Returns a function that will only be executed after being called N times.


    _.after = function (times, func) {
      if (times <= 0) return func();
      return function () {
        if (--times < 1) {
          return func.apply(this, arguments);
        }
      };
    }; // Object Functions
    // ----------------
    // Retrieve the names of an object's properties.
    // Delegates to **ECMAScript 5**'s native `Object.keys`


    _.keys = nativeKeys || function (obj) {
      if (obj !== Object(obj)) throw new TypeError('Invalid object');
      var keys = [];

      for (var key in obj) {
        if (_.has(obj, key)) keys[keys.length] = key;
      }

      return keys;
    }; // Retrieve the values of an object's properties.


    _.values = function (obj) {
      var values = [];

      for (var key in obj) {
        if (_.has(obj, key)) values.push(obj[key]);
      }

      return values;
    }; // Convert an object into a list of `[key, value]` pairs.


    _.pairs = function (obj) {
      var pairs = [];

      for (var key in obj) {
        if (_.has(obj, key)) pairs.push([key, obj[key]]);
      }

      return pairs;
    }; // Invert the keys and values of an object. The values must be serializable.


    _.invert = function (obj) {
      var result = {};

      for (var key in obj) {
        if (_.has(obj, key)) result[obj[key]] = key;
      }

      return result;
    }; // Return a sorted list of the function names available on the object.
    // Aliased as `methods`


    _.functions = _.methods = function (obj) {
      var names = [];

      for (var key in obj) {
        if (_.isFunction(obj[key])) names.push(key);
      }

      return names.sort();
    }; // Extend a given object with all the properties in passed-in object(s).


    _.extend = function (obj) {
      each(slice.call(arguments, 1), function (source) {
        if (source) {
          for (var prop in source) {
            obj[prop] = source[prop];
          }
        }
      });
      return obj;
    }; // Return a copy of the object only containing the whitelisted properties.


    _.pick = function (obj) {
      var copy = {};
      var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
      each(keys, function (key) {
        if (key in obj) copy[key] = obj[key];
      });
      return copy;
    }; // Return a copy of the object without the blacklisted properties.


    _.omit = function (obj) {
      var copy = {};
      var keys = concat.apply(ArrayProto, slice.call(arguments, 1));

      for (var key in obj) {
        if (!_.contains(keys, key)) copy[key] = obj[key];
      }

      return copy;
    }; // Fill in a given object with default properties.


    _.defaults = function (obj) {
      each(slice.call(arguments, 1), function (source) {
        if (source) {
          for (var prop in source) {
            if (obj[prop] == null) obj[prop] = source[prop];
          }
        }
      });
      return obj;
    }; // Create a (shallow-cloned) duplicate of an object.


    _.clone = function (obj) {
      if (!_.isObject(obj)) return obj;
      return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
    }; // Invokes interceptor with the obj, and then returns obj.
    // The primary purpose of this method is to "tap into" a method chain, in
    // order to perform operations on intermediate results within the chain.


    _.tap = function (obj, interceptor) {
      interceptor(obj);
      return obj;
    }; // Internal recursive comparison function for `isEqual`.


    var eq = function eq(a, b, aStack, bStack) {
      // Identical objects are equal. `0 === -0`, but they aren't identical.
      // See the Harmony `egal` proposal: http://wiki.ecmascript.org/doku.php?id=harmony:egal.
      if (a === b) return a !== 0 || 1 / a == 1 / b; // A strict comparison is necessary because `null == undefined`.

      if (a == null || b == null) return a === b; // Unwrap any wrapped objects.

      if (a instanceof _) a = a._wrapped;
      if (b instanceof _) b = b._wrapped; // Compare `[[Class]]` names.

      var className = toString.call(a);
      if (className != toString.call(b)) return false;

      switch (className) {
        // Strings, numbers, dates, and booleans are compared by value.
        case '[object String]':
          // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
          // equivalent to `new String("5")`.
          return a == String(b);

        case '[object Number]':
          // `NaN`s are equivalent, but non-reflexive. An `egal` comparison is performed for
          // other numeric values.
          return a != +a ? b != +b : a == 0 ? 1 / a == 1 / b : a == +b;

        case '[object Date]':
        case '[object Boolean]':
          // Coerce dates and booleans to numeric primitive values. Dates are compared by their
          // millisecond representations. Note that invalid dates with millisecond representations
          // of `NaN` are not equivalent.
          return +a == +b;
        // RegExps are compared by their source patterns and flags.

        case '[object RegExp]':
          return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
      }

      if (typeof a != 'object' || typeof b != 'object') return false; // Assume equality for cyclic structures. The algorithm for detecting cyclic
      // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

      var length = aStack.length;

      while (length--) {
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] == a) return bStack[length] == b;
      } // Add the first object to the stack of traversed objects.


      aStack.push(a);
      bStack.push(b);
      var size = 0,
          result = true; // Recursively compare objects and arrays.

      if (className == '[object Array]') {
        // Compare array lengths to determine if a deep comparison is necessary.
        size = a.length;
        result = size == b.length;

        if (result) {
          // Deep compare the contents, ignoring non-numeric properties.
          while (size--) {
            if (!(result = eq(a[size], b[size], aStack, bStack))) break;
          }
        }
      } else {
        // Objects with different constructors are not equivalent, but `Object`s
        // from different frames are.
        var aCtor = a.constructor,
            bCtor = b.constructor;

        if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor && _.isFunction(bCtor) && bCtor instanceof bCtor)) {
          return false;
        } // Deep compare objects.


        for (var key in a) {
          if (_.has(a, key)) {
            // Count the expected number of properties.
            size++; // Deep compare each member.

            if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack))) break;
          }
        } // Ensure that both objects contain the same number of properties.


        if (result) {
          for (key in b) {
            if (_.has(b, key) && !size--) break;
          }

          result = !size;
        }
      } // Remove the first object from the stack of traversed objects.


      aStack.pop();
      bStack.pop();
      return result;
    }; // Perform a deep comparison to check if two objects are equal.


    _.isEqual = function (a, b) {
      return eq(a, b, [], []);
    }; // Is a given array, string, or object empty?
    // An "empty" object has no enumerable own-properties.


    _.isEmpty = function (obj) {
      if (obj == null) return true;
      if (_.isArray(obj) || _.isString(obj)) return obj.length === 0;

      for (var key in obj) {
        if (_.has(obj, key)) return false;
      }

      return true;
    }; // Is a given value a DOM element?


    _.isElement = function (obj) {
      return !!(obj && obj.nodeType === 1);
    }; // Is a given value an array?
    // Delegates to ECMA5's native Array.isArray


    _.isArray = nativeIsArray || function (obj) {
      return toString.call(obj) == '[object Array]';
    }; // Is a given variable an object?


    _.isObject = function (obj) {
      return obj === Object(obj);
    }; // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.


    each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp'], function (name) {
      _['is' + name] = function (obj) {
        return toString.call(obj) == '[object ' + name + ']';
      };
    }); // Define a fallback version of the method in browsers (ahem, IE), where
    // there isn't any inspectable "Arguments" type.

    if (!_.isArguments(arguments)) {
      _.isArguments = function (obj) {
        return !!(obj && _.has(obj, 'callee'));
      };
    } // Optimize `isFunction` if appropriate.


    if (true) {
      _.isFunction = function (obj) {
        return typeof obj === 'function';
      };
    } // Is a given object a finite number?


    _.isFinite = function (obj) {
      return isFinite(obj) && !isNaN(parseFloat(obj));
    }; // Is the given value `NaN`? (NaN is the only number which does not equal itself).


    _.isNaN = function (obj) {
      return _.isNumber(obj) && obj != +obj;
    }; // Is a given value a boolean?


    _.isBoolean = function (obj) {
      return obj === true || obj === false || toString.call(obj) == '[object Boolean]';
    }; // Is a given value equal to null?


    _.isNull = function (obj) {
      return obj === null;
    }; // Is a given variable undefined?


    _.isUndefined = function (obj) {
      return obj === void 0;
    }; // Shortcut function for checking if an object has a given property directly
    // on itself (in other words, not on a prototype).


    _.has = function (obj, key) {
      return hasOwnProperty.call(obj, key);
    }; // Utility Functions
    // -----------------
    // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
    // previous owner. Returns a reference to the Underscore object.


    _.noConflict = function () {
      root._ = previousUnderscore;
      return this;
    }; // Keep the identity function around for default iterators.


    _.identity = function (value) {
      return value;
    }; // Run a function **n** times.


    _.times = function (n, iterator, context) {
      var accum = Array(n);

      for (var i = 0; i < n; i++) {
        accum[i] = iterator.call(context, i);
      }

      return accum;
    }; // Return a random integer between min and max (inclusive).


    _.random = function (min, max) {
      if (max == null) {
        max = min;
        min = 0;
      }

      return min + Math.floor(Math.random() * (max - min + 1));
    }; // List of HTML entities for escaping.


    var entityMap = {
      escape: {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
        '/': '&#x2F;'
      }
    };
    entityMap.unescape = _.invert(entityMap.escape); // Regexes containing the keys and values listed immediately above.

    var entityRegexes = {
      escape: new RegExp('[' + _.keys(entityMap.escape).join('') + ']', 'g'),
      unescape: new RegExp('(' + _.keys(entityMap.unescape).join('|') + ')', 'g')
    }; // Functions for escaping and unescaping strings to/from HTML interpolation.

    _.each(['escape', 'unescape'], function (method) {
      _[method] = function (string) {
        if (string == null) return '';
        return ('' + string).replace(entityRegexes[method], function (match) {
          return entityMap[method][match];
        });
      };
    }); // If the value of the named property is a function then invoke it;
    // otherwise, return it.


    _.result = function (object, property) {
      if (object == null) return null;
      var value = object[property];
      return _.isFunction(value) ? value.call(object) : value;
    }; // Add your own custom functions to the Underscore object.


    _.mixin = function (obj) {
      each(_.functions(obj), function (name) {
        var func = _[name] = obj[name];

        _.prototype[name] = function () {
          var args = [this._wrapped];
          push.apply(args, arguments);
          return result.call(this, func.apply(_, args));
        };
      });
    }; // Generate a unique integer id (unique within the entire client session).
    // Useful for temporary DOM ids.


    var idCounter = 0;

    _.uniqueId = function (prefix) {
      var id = ++idCounter + '';
      return prefix ? prefix + id : id;
    }; // By default, Underscore uses ERB-style template delimiters, change the
    // following template settings to use alternative delimiters.


    _.templateSettings = {
      evaluate: /<%([\s\S]+?)%>/g,
      interpolate: /<%=([\s\S]+?)%>/g,
      escape: /<%-([\s\S]+?)%>/g
    }; // When customizing `templateSettings`, if you don't want to define an
    // interpolation, evaluation or escaping regex, we need one that is
    // guaranteed not to match.

    var noMatch = /(.)^/; // Certain characters need to be escaped so that they can be put into a
    // string literal.

    var escapes = {
      "'": "'",
      '\\': '\\',
      '\r': 'r',
      '\n': 'n',
      '\t': 't',
      "\u2028": 'u2028',
      "\u2029": 'u2029'
    };
    var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g; // JavaScript micro-templating, similar to John Resig's implementation.
    // Underscore templating handles arbitrary delimiters, preserves whitespace,
    // and correctly escapes quotes within interpolated code.

    _.template = function (text, data, settings) {
      var render;
      settings = _.defaults({}, settings, _.templateSettings); // Combine delimiters into one regular expression via alternation.

      var matcher = new RegExp([(settings.escape || noMatch).source, (settings.interpolate || noMatch).source, (settings.evaluate || noMatch).source].join('|') + '|$', 'g'); // Compile the template source, escaping string literals appropriately.

      var index = 0;
      var source = "__p+='";
      text.replace(matcher, function (match, escape, interpolate, evaluate, offset) {
        source += text.slice(index, offset).replace(escaper, function (match) {
          return '\\' + escapes[match];
        });

        if (escape) {
          source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
        }

        if (interpolate) {
          source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
        }

        if (evaluate) {
          source += "';\n" + evaluate + "\n__p+='";
        }

        index = offset + match.length;
        return match;
      });
      source += "';\n"; // If a variable is not specified, place data values in local scope.

      if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
      source = "var __t,__p='',__j=Array.prototype.join," + "print=function(){__p+=__j.call(arguments,'');};\n" + source + "return __p;\n";

      try {
        render = new Function(settings.variable || 'obj', '_', source);
      } catch (e) {
        e.source = source;
        throw e;
      }

      if (data) return render(data, _);

      var template = function template(data) {
        return render.call(this, data, _);
      }; // Provide the compiled function source as a convenience for precompilation.


      template.source = 'function(' + (settings.variable || 'obj') + '){\n' + source + '}';
      return template;
    }; // Add a "chain" function, which will delegate to the wrapper.


    _.chain = function (obj) {
      return _(obj).chain();
    }; // OOP
    // ---------------
    // If Underscore is called as a function, it returns a wrapped object that
    // can be used OO-style. This wrapper holds altered versions of all the
    // underscore functions. Wrapped objects may be chained.
    // Helper function to continue chaining intermediate results.


    var result = function result(obj) {
      return this._chain ? _(obj).chain() : obj;
    }; // Add all of the Underscore functions to the wrapper object.


    _.mixin(_); // Add all mutator Array functions to the wrapper.


    each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function (name) {
      var method = ArrayProto[name];

      _.prototype[name] = function () {
        var obj = this._wrapped;
        method.apply(obj, arguments);
        if ((name == 'shift' || name == 'splice') && obj.length === 0) delete obj[0];
        return result.call(this, obj);
      };
    }); // Add all accessor Array functions to the wrapper.

    each(['concat', 'join', 'slice'], function (name) {
      var method = ArrayProto[name];

      _.prototype[name] = function () {
        return result.call(this, method.apply(this._wrapped, arguments));
      };
    });

    _.extend(_.prototype, {
      // Start chaining a wrapped Underscore object.
      chain: function chain() {
        this._chain = true;
        return this;
      },
      // Extracts the result from a wrapped and chained object.
      value: function value() {
        return this._wrapped;
      }
    });
  }).call(this);
  /***/
},
/* 1 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__output__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__precision_hacks__ = __webpack_require__(35);

  var noUnits = null; //////////////////////////////////////////////////////

  var MAX_SF = 14;

  function createNumberLiteral(num, precisionDigits, precisionType) {
    var dp = precisionDigits,
        sf = Math.min(dp, MAX_SF),
        literal;

    switch (precisionType) {
      case "dp":
        literal = num.toFixed(dp);
        break;

      case "sf":
        literal = __WEBPACK_IMPORTED_MODULE_2__precision_hacks__["a"
        /* default */
        ].toPrecision10(num, sf);
        break;

      default:
        literal = __WEBPACK_IMPORTED_MODULE_2__precision_hacks__["a"
        /* default */
        ].toPrecision10(num, MAX_SF);
    }

    return literal;
  } //////////////////////////////////////////////////////
  // TuroNumber constructor.
  //////////////////////////////////////////////////////


  function TuroNumber(number, unit, valueType, original) {
    if (!this) {
      return new TuroNumber(number, unit, valueType, original);
    }

    this._init(number, unit, valueType, original);
  } // scope tricks


  var newInstance, recycle; //////////////////////////////////////////////////////
  // TuroNumber methods.
  //////////////////////////////////////////////////////

  __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.extend(TuroNumber.prototype, {
    _init: function _init(number, unit, valueType, parent) {
      this.number = number;
      this.valueType = valueType;
      this.unit = unit || noUnits; // we may want to derive from the original.

      this._original = parent;
      delete this.literal;
      return this;
    },
    prepareLiteral: function prepareLiteral(prefs) {
      this.setPrecision(prefs.precisionDigits, prefs.precisionType);
    },
    setPrecision: function setPrecision(precisionDigits, precisionType) {
      if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isNumber(this.number)) {
        this.literal = createNumberLiteral(this.number, precisionDigits, precisionType);
      }
    },
    convert: function convert(newUnit) {
      if (this._original) {
        // we use the original, to not lose 
        // accuracy.
        return this._original.convert(newUnit);
      }

      return newInstance(this.unit.convert(this.number, newUnit), newUnit, this.valueType, this);
    },
    toString: function toString(display, prefs) {
      this.prepareLiteral(prefs);
      return __WEBPACK_IMPORTED_MODULE_1__output__["a"
      /* default */
      ].toString(this, display, prefs);
    }
  });

  Object.defineProperties(TuroNumber.prototype, {
    number: {
      get: function get() {
        return this._value;
      },
      set: function set(v) {
        this._value = v;
      }
    },
    value: {
      get: function get() {
        return this._value;
      },
      set: function set(v) {
        this._value = v;
      }
    }
  }); //////////////////////////////////////////////////////
  // Static methods.
  //////////////////////////////////////////////////////

  var pool = [];

  newInstance = function newInstance(number, unit, valueType, original) {
    var obj;

    if (pool.length) {
      obj = pool.pop();

      obj._init(number, unit, valueType, original);
    } else {
      obj = new TuroNumber(number, unit, valueType, original);
    }

    return obj;
  };

  recycle = function recycle(turoNumber) {
    if (turoNumber) {
      pool.push(turoNumber);
    }
  }; //////////////////////////////////////////////////////

  /* harmony default export */


  __webpack_exports__["a"] = {
    TuroNumber: TuroNumber,
    newInstance: newInstance,
    recycle: recycle
  };
  /***/
},
/* 2 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__turo_number__ = __webpack_require__(1);

  var NO_UNITS = null; ///////////////////////////////////////////////////////////////////////////////
  // Exported functions.
  ///////////////////////////////////////////////////////////////////////////////

  function isDimensionless(operandValue) {
    return !operandValue.unit || operandValue.unit.isDimensionless();
  }

  function makeMixin(simpleValueCalculator) {
    var list = Object(__WEBPACK_IMPORTED_MODULE_0_underscore__["toArray"])(arguments);

    if (Object(__WEBPACK_IMPORTED_MODULE_0_underscore__["isFunction"])(simpleValueCalculator)) {
      list.shift();
      list.push({
        simpleValueCalculator: simpleValueCalculator
      });
    }

    return list;
  } ///////////////////////////////////////////////////////////////////////////////


  function checkDivideByZero(leftNode, leftValue, rightNode, rightValue, ctx) {
    if (rightValue.number === 0) {
      ctx.reportError('DIVIDE_BY_ZERO', rightNode);
      return false;
    }

    return true;
  }

  function checkPercentNoUnits(operandNode, operandValue, ctx) {
    if (operandValue.valueType === 'percent' && !isDimensionless(operandValue)) {
      ctx.reportError('DIMENSION_MISMATCH', operandNode);
      return false;
    }

    return true;
  } ///////////////////////////////////////////////////////////////////////////////


  var mixins = {
    simpleTestingOperator: {
      nodeCalculator: function nodeCalculator(x, y) {
        return this.simpleValueCalculator(x, y);
      }
    },
    binaryMatchingUnits: {
      preflightCheck: function preflightCheck(leftNode, leftValue, rightNode, rightValue, ctx) {
        if (isDimensionless(leftValue)) {
          if (isDimensionless(rightValue)) {
            return true;
          } // left is dimensionless, but right isn't.


          return ctx.reportError('DIMENSION_MISMATCH', leftNode, rightNode);
        } else {
          if (isDimensionless(rightValue)) {
            // left is not dimensionless, but right is.
            return ctx.reportError('DIMENSION_MISMATCH', leftNode, rightNode);
          }
        }

        if (!leftValue.unit.matchesDimensions(rightValue.unit)) {
          return ctx.reportError('DIMENSION_MISMATCH', leftNode, rightNode);
        }

        return true;
      },
      prepareRight: function prepareRight(leftValue, rightValue) {
        if (isDimensionless(leftValue)) {
          return rightValue;
        }

        return rightValue.convert(leftValue.unit);
      },
      unitCalculator: function unitCalculator(leftValue, rightValue) {
        return leftValue.unit || null;
      }
    },
    binaryReturnNoUnits: {
      unitCalculator: function unitCalculator(leftValue, rightValue) {
        return null;
      }
    },
    binaryAnyUnits: {
      turoValueCalculator: function turoValueCalculator(leftValue, rightValue) {
        var calculatedUnit = this.unitCalculator(leftValue, rightValue);
        var simpleValue = this.simpleValueCalculator(leftValue.value, rightValue.value);

        if (calculatedUnit) {
          var unitConversion = calculatedUnit.simplify();
          return __WEBPACK_IMPORTED_MODULE_1__turo_number__["a"
          /* default */
          ].newInstance(simpleValue * unitConversion.value, unitConversion.unit, this.returnValueType);
        }

        return __WEBPACK_IMPORTED_MODULE_1__turo_number__["a"
        /* default */
        ].newInstance(simpleValue, null, this.returnValueType);
      },
      preflightCheck: function preflightCheck(leftNode, leftValue, rightNode, rightValue, ctx) {
        return true;
      }
    },
    unaryIdentity: {
      preflightCheck: function preflightCheck(leftNode, leftValue, ctx) {
        // check for units being incompatable.
        // report unit errors.
        return true;
      },
      turoValueCalculator: function turoValueCalculator(operand) {
        var simpleValue = this.simpleValueCalculator(operand.value);
        return __WEBPACK_IMPORTED_MODULE_1__turo_number__["a"
        /* default */
        ].newInstance(simpleValue, operand.unit, this.returnValueType);
      },
      simpleValueCalculator: function simpleValueCalculator(x) {
        return x;
      }
    },
    binaryDivideUtils: {
      nodeCalculator: function nodeCalculator(leftNode, rightNode, ctx) {
        var leftValue = ctx.evaluate(leftNode, ctx),
            rightValue = ctx.evaluate(rightNode, ctx);

        if (!this.performPreflightCheck(leftNode, leftValue, rightNode, rightValue, ctx)) {
          return;
        }

        if (isDimensionless(leftValue) && !isDimensionless(rightValue)) {
          if (!rightNode.unitLiteral) {
            rightValue = __WEBPACK_IMPORTED_MODULE_1__turo_number__["a"
            /* default */
            ].newInstance(rightValue.number, rightValue.unit.pow(-1), rightValue.valueType);
          }
        }

        return this.turoValueCalculator(leftValue, rightValue, ctx);
      },
      preflightCheck: checkDivideByZero,
      unitCalculator: function unitCalculator(leftValue, rightValue) {
        if (isDimensionless(leftValue)) {
          return rightValue.unit;
        }

        if (isDimensionless(rightValue)) {
          return leftValue.unit;
        }

        return leftValue.unit.per(rightValue.unit);
      }
    },
    binaryMultiplyUtils: {
      unitCalculator: function unitCalculator(leftValue, rightValue) {
        if (isDimensionless(leftValue)) {
          return rightValue.unit;
        }

        if (isDimensionless(rightValue)) {
          return leftValue.unit;
        }

        return leftValue.unit.by(rightValue.unit);
      }
    },
    unitsUtils: {
      canDimensionsIntegerDivide: function canDimensionsIntegerDivide(value, num) {
        var canDo = true;
        var dimensions = value.unit.getDimension().dimensions;
        Object(__WEBPACK_IMPORTED_MODULE_0_underscore__["chain"])(dimensions).values().each(function (d) {
          canDo = canDo && d % num === 0;
        });
        return canDo;
      }
    },
    unaryAngleToDimensionless: {
      preflightCheck: function preflightCheck(operandNode, operandValue, ctx) {
        // check for units being incompatable.
        // report unit errors.
        if (isDimensionless(operandValue) || operandValue.unit.getDimension().shortName === 'Angle') {
          return true;
        }

        return ctx.reportError('DIMENSION_MISMATCH', operandNode);
      },
      turoValueCalculator: function turoValueCalculator(operandValue, ctx) {
        var simpleValue = this.simpleValueCalculator(this.toRadians(operandValue, ctx).value);
        return __WEBPACK_IMPORTED_MODULE_1__turo_number__["a"
        /* default */
        ].newInstance(simpleValue, NO_UNITS, this.returnValueType);
      }
    },
    trigUtils: {
      getDefaultAngleUnit: function getDefaultAngleUnit(ctx) {
        var prefs = ctx.prefs,
            units = ctx.units,
            unit = units.unitSchemes.getUnitNames(prefs.unitScheme, 'Angle')[0];
        return units.getUnit(unit);
      },
      isRadians: function isRadians(unit) {
        return unit.name === 'radians';
      },
      fromRadians: function fromRadians(operandValue, ctx) {
        if (isDimensionless(operandValue)) {
          operandValue = __WEBPACK_IMPORTED_MODULE_1__turo_number__["a"
          /* default */
          ].newInstance(operandValue.number, this.getRadians(ctx), operandValue.valueType);
        }

        var preferredUnit = this.getDefaultAngleUnit(ctx);

        if (!this.isRadians(preferredUnit)) {
          operandValue = operandValue.convert(preferredUnit);
        }

        return operandValue;
      },
      toRadians: function toRadians(operandValue, ctx) {
        if (isDimensionless(operandValue)) {
          operandValue = __WEBPACK_IMPORTED_MODULE_1__turo_number__["a"
          /* default */
          ].newInstance(operandValue.number, this.getDefaultAngleUnit(ctx), operandValue.valueType);
        }

        if (!this.isRadians(operandValue.unit)) {
          operandValue = operandValue.convert(this.getRadians(ctx));
        }

        return operandValue;
      },
      getRadians: function getRadians(ctx) {
        return ctx.units.getUnit('radians');
      }
    },
    unaryDimensionlessToAngle: {
      preflightCheck: function preflightCheck(operandNode, operandValue, ctx) {
        // check for units being incompatable.
        // report unit errors.
        if (isDimensionless(operandValue)) {
          return true;
        }

        return ctx.reportError('DIMENSION_MISMATCH', operandNode);
      },
      turoValueCalculator: function turoValueCalculator(operandValue, ctx) {
        console.log('turoValueCalculator');

        var calculatedUnit = this.unitCalculator(operandValue, ctx),
            simpleValue = this.simpleValueCalculator(this.toRadians(operandValue, ctx).value),
            resultValue = __WEBPACK_IMPORTED_MODULE_1__turo_number__["a"
        /* default */
        ].newInstance(simpleValue, this.getRadians(ctx), this.returnValueType);

        return this.fromRadians(resultValue, ctx);
      },
      unitCalculator: function unitCalculator(operandValue, ctx) {
        if (isDimensionless(operandValue)) {
          return this.getDefaultAngleUnit(ctx);
        }

        return operandValue.unit;
      }
    },
    binaryNoUnits: {
      turoValueCalculator: function turoValueCalculator(leftValue, rightValue) {
        var simpleValue = this.simpleValueCalculator(leftValue.value, rightValue.value);
        return __WEBPACK_IMPORTED_MODULE_1__turo_number__["a"
        /* default */
        ].newInstance(simpleValue, NO_UNITS, this.returnValueType);
      },
      preflightCheck: function preflightCheck(leftNode, leftValue, rightNode, rightValue, ctx) {
        var ok = true;

        if (!isDimensionless(leftValue)) {
          ok = false;
          ctx.reportError('DIMENSION_MISMATCH', leftNode);
        }

        if (!isDimensionless(rightValue)) {
          ok = false;
          ctx.reportError('DIMENSION_MISMATCH', rightNode);
        }

        return ok;
      }
    },
    binaryPercentNoUnits: {
      preflightCheck: function preflightCheck(leftNode, leftValue, rightNode, rightValue, ctx) {
        return checkPercentNoUnits(leftNode, leftValue, ctx) && checkPercentNoUnits(rightNode, rightValue, ctx);
      },
      unitCalculator: function unitCalculator(leftValue, rightValue) {
        if (leftValue.valueType !== 'percent') {
          return leftValue.unit;
        } else {
          return rightValue.unit;
        }
      }
    },
    binaryPercentDivide: {
      preflightCheck: function preflightCheck() {
        return mixins.binaryPercentNoUnits.preflightCheck.apply(null, arguments) || checkDivideByZero.apply(null, arguments);
      },
      unitCalculator: function unitCalculator(leftValue, rightValue) {
        if (leftValue.valueType !== 'percent') {
          return leftValue.unit;
        }

        if (!isDimensionless(rightValue)) {
          return rightValue.unit;
        }
      }
    },
    unaryNoUnits: {
      turoValueCalculator: function turoValueCalculator(leftValue) {
        var simpleValue = this.simpleValueCalculator(leftValue.value);
        return __WEBPACK_IMPORTED_MODULE_1__turo_number__["a"
        /* default */
        ].newInstance(simpleValue, NO_UNITS, this.returnValueType);
      },
      preflightCheck: function preflightCheck(leftNode, leftValue, ctx) {
        var ok = true;

        if (!isDimensionless(leftValue)) {
          ok = false;
          ctx.reportError('DIMENSION_MISMATCH', leftNode);
        }

        return ok;
      }
    }
  };
  mixins.makeMixin = makeMixin;
  mixins.isDimensionless = isDimensionless;
  /* harmony default export */

  __webpack_exports__["a"] = mixins;
  /***/
},
/* 3 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__ASTVisitor__ = __webpack_require__(29);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__VisitorContext__ = __webpack_require__(30);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__ASTVisitor__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_1__VisitorContext__["a"];
  });
  /***/

},
/* 4 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "b", function () {
    return defaultOperators;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return createDefaultOperators;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__all__ = __webpack_require__(25);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__Operators__ = __webpack_require__(42);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(2);
  /* unused harmony reexport Operators */

  /* unused harmony reexport mixins */


  var createDefaultOperators = function createDefaultOperators(prefs) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__all__["a"
    /* default */
    ])(new __WEBPACK_IMPORTED_MODULE_1__Operators__["a"
    /* default */
    ](undefined, prefs || {}));
  };

  var defaultOperators = createDefaultOperators();
  /***/
},
/* 5 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var Dimension = function () {
    function Dimension(initial) {
      _classCallCheck(this, Dimension);

      if (typeof initial === "string") {
        this.dimensions = {};
        this.dimensions[initial] = 1;
        this.shortName = initial;
        this._isSimple = true;
      } else {
        this.dimensions = initial || {};
      }

      this.initProperties();
    }

    _createClass(Dimension, [{
      key: "initProperties",
      value: function initProperties() {
        var _this = this;

        Object.keys(this.dimensions).forEach(function (k) {
          if (!_this.dimensions[k]) {
            delete _this.dimensions[k];
          }
        });
        var cardinality = this.cardinality();
        this._isSimple = cardinality == 1;
        this._isDimensionless = cardinality == 0;
      }
    }, {
      key: "isEqual",
      value: function isEqual(that) {
        if (!that.dimensions) {
          return;
        }

        return this._minimalContains(that) && that._minimalContains(this);
      }
    }, {
      key: "isDimensionless",
      value: function isDimensionless() {
        return this._isDimensionless;
      }
    }, {
      key: "_minimalContains",
      value: function _minimalContains(that) {
        var i = 0,
            keys = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.keys(that.dimensions),
            max = keys.length,
            key,
            l,
            r;

        for (; i < max; i++) {
          key = keys[i];
          l = this.dimensions[key];
          r = that.dimensions[key];
          /* jshint bitwise: false */

          if (l && !r || !l && r) {
            /* jshint bitwise: true */
            return false;
          }

          if (l !== r) {
            return false;
          }
        }

        return true;
      }
    }, {
      key: "isSimple",
      value: function isSimple() {
        return this._isSimple; //return _.foldl(_.values(this.dimensions), function (l,r) { return l + r; }, 0) === 1;
      }
    }, {
      key: "contains",
      value: function contains(that) {
        var i = 0,
            keys = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.keys(that.dimensions),
            max = keys.length,
            key,
            thatCardinality,
            thisCardinality;

        for (; i < max; i++) {
          key = keys[i];
          thatCardinality = that.dimensions[key];
          thisCardinality = this.dimensions[key] || 0;

          if (thisCardinality > 0 && thatCardinality > 0) {
            if (thatCardinality > thisCardinality) {
              return false;
            }
          } else if (thisCardinality < 0 && thatCardinality < 0) {
            if (thatCardinality < thisCardinality) {
              return false;
            }
          } else {
            return false;
          }
        }

        return true;
      }
    }, {
      key: "cardinality",
      value: function cardinality() {
        return this.isSimple() ? 1 : __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.chain(this.dimensions).values().reduce(function (p, q) {
          return p + (q > 0 ? q : -q);
        }, 0).value();
      }
    }, {
      key: "by",
      value: function by(that) {
        var _this2 = this;

        var sum = {};
        Object.assign(sum, this.dimensions, that.dimensions);
        Object.keys(sum).forEach(function (key) {
          sum[key] = (_this2.dimensions[key] || 0) + (that.dimensions[key] || 0);
        });
        return new Dimension(sum);
      }
    }, {
      key: "per",
      value: function per(that) {
        var _this3 = this;

        var sum = {};
        Object.assign(sum, this.dimensions, that.dimensions);
        Object.keys(sum).forEach(function (key) {
          sum[key] = (_this3.dimensions[key] || 0) - (that.dimensions[key] || 0);
        });
        return new Dimension(sum);
      }
    }, {
      key: "pow",
      value: function pow(_pow) {
        var _this4 = this;

        var sum = {};
        Object.keys(this.dimensions).forEach(function (key) {
          sum[key] = (_this4.dimensions[key] || 0) * _pow;
        });
        return new Dimension(sum);
      }
    }]);

    return Dimension;
  }();
  /* harmony default export */


  __webpack_exports__["a"] = Dimension;
  Dimension.NONE = new Dimension();
  /***/
},
/* 6 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  } // TODO should this include source and destination Unit objects?


  var Multiple = function () {
    function Multiple(top, bottom) {
      _classCallCheck(this, Multiple);

      if (top === undefined) {
        top = 1;
      }

      this.top = top;
      this.bottom = bottom || 1;
    }

    _createClass(Multiple, [{
      key: "set",
      value: function set(t, b) {
        this.top = t || 1;
        this.bottom = b || 1;
      }
    }, {
      key: "times",
      value: function times(that) {
        return new Multiple(this.top * that.top, this.bottom * that.bottom);
      }
    }, {
      key: "_times",
      value: function _times(that) {
        this.top *= that.top;
        this.bottom *= that.bottom;
        return this;
      }
    }, {
      key: "divide",
      value: function divide(that) {
        return new Multiple(this.top * that.bottom, this.bottom * that.top);
      }
    }, {
      key: "_divide",
      value: function _divide(that) {
        this.top *= that.bottom;
        this.bottom *= that.top;
        return this;
      }
    }, {
      key: "value",
      value: function value(x) {
        x = x || 1;
        return x * this.top / this.bottom;
      }
    }, {
      key: "toString",
      value: function toString() {
        return "[" + this.top + ", " + this.bottom + "]";
      }
    }], [{
      key: "container",
      value: function container(name) {
        var container = {};

        if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isString(name)) {
          container[name] = new Multiple();
        }

        return container;
      }
    }, {
      key: "one",
      value: function one() {
        return new Multiple(1, 1);
      }
    }, {
      key: "quantity",
      value: function quantity(value) {
        var one = new Multiple();
        one.top = value;
        return one;
      }
    }]);

    return Multiple;
  }();
  /* harmony default export */


  __webpack_exports__["a"] = Multiple;
  /***/
},
/* 7 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: true
  });
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return Array.from(arr);
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  } ////////////////////////////////////////////////////////////////////////////////////////////


  var ASTNode = function () {
    function ASTNode() {
      _classCallCheck(this, ASTNode);

      for (var _len = arguments.length, children = Array(_len), _key = 0; _key < _len; _key++) {
        children[_key] = arguments[_key];
      }

      this._children = children.filter(function (child) {
        return child && child.accept;
      });
    }

    _createClass(ASTNode, [{
      key: 'clone',
      value: function clone() {
        var that = new this.constructor();
        Object.assign(that, this);
        return that;
      }
    }, {
      key: 'accept',
      value: function accept(visitor) {
        throw new Error("unimplemented");
      }
    }, {
      key: 'children',
      get: function get() {
        return this._children;
      }
    }, {
      key: 'offsetFirst',
      get: function get() {
        if (this._offsetFirst === undefined) {
          var children = this.children;
          this._offsetFirst = children.length > 0 ? children[0].offsetFirst : -1;
        }

        return this._offsetFirst;
      }
    }, {
      key: 'offsetLast',
      get: function get() {
        if (this._offsetLast === undefined) {
          var children = this.children;
          this._offsetLast = children.length > 0 ? children[children.length - 1].offsetLast : -1;
        }

        return this._offsetLast;
      }
    }]);

    return ASTNode;
  }(); ////////////////////////////////////////////////////////////////////////////////////////////


  var BinaryNode = function (_ASTNode) {
    _inherits(BinaryNode, _ASTNode);

    function BinaryNode(left, right, literal) {
      _classCallCheck(this, BinaryNode);

      var _this = _possibleConstructorReturn(this, (BinaryNode.__proto__ || Object.getPrototypeOf(BinaryNode)).call(this, left, right));

      _this.left = left;
      _this.right = right;
      _this.literal = literal;
      return _this;
    }

    _createClass(BinaryNode, [{
      key: 'accept',
      value: function accept(visitor) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        return visitor.visitBinaryOperator.apply(visitor, [this].concat(args));
      }
    }]);

    return BinaryNode;
  }(ASTNode); ////////////////////////////////////////////////////////////////////////////////////////////


  var UnaryOperationNode = function (_ASTNode2) {
    _inherits(UnaryOperationNode, _ASTNode2);

    function UnaryOperationNode(operand, literal, isPrefix) {
      _classCallCheck(this, UnaryOperationNode);

      var _this2 = _possibleConstructorReturn(this, (UnaryOperationNode.__proto__ || Object.getPrototypeOf(UnaryOperationNode)).call(this, operand));

      _this2.value = operand;
      _this2.isPrefix = isPrefix;
      _this2.literal = literal;
      return _this2;
    }

    _createClass(UnaryOperationNode, [{
      key: 'accept',
      value: function accept(visitor) {
        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }

        return visitor.visitUnaryOperation.apply(visitor, [this].concat(args));
      }
    }]);

    return UnaryOperationNode;
  }(ASTNode); ////////////////////////////////////////////////////////////////////////////////////////////


  var ParensNode = function (_ASTNode3) {
    _inherits(ParensNode, _ASTNode3);

    function ParensNode(ast) {
      _classCallCheck(this, ParensNode);

      var _this3 = _possibleConstructorReturn(this, (ParensNode.__proto__ || Object.getPrototypeOf(ParensNode)).call(this, ast));

      _this3.astType = 'parens';
      _this3.ast = ast;
      return _this3;
    }

    _createClass(ParensNode, [{
      key: 'accept',
      value: function accept(visitor) {
        for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        return visitor.visitParens.apply(visitor, [this].concat(args));
      }
    }]);

    return ParensNode;
  }(ASTNode); ////////////////////////////////////////////////////////////////////////////////////////////


  var UnitLiteralNode = function (_ASTNode4) {
    _inherits(UnitLiteralNode, _ASTNode4);

    function UnitLiteralNode(unit, literal) {
      _classCallCheck(this, UnitLiteralNode);

      var _this4 = _possibleConstructorReturn(this, (UnitLiteralNode.__proto__ || Object.getPrototypeOf(UnitLiteralNode)).call(this));

      _this4.unit = unit;
      _this4.literal = literal;
      return _this4;
    }

    _createClass(UnitLiteralNode, [{
      key: 'accept',
      value: function accept(visitor) {
        for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
          args[_key5 - 1] = arguments[_key5];
        }

        return visitor.visitUnitLiteral.apply(visitor, [this].concat(args));
      }
    }]);

    return UnitLiteralNode;
  }(ASTNode); ////////////////////////////////////////////////////////////////////////////////////////////


  var UnitPowerNode = function (_ASTNode5) {
    _inherits(UnitPowerNode, _ASTNode5);

    function UnitPowerNode(unitNode, numberNode) {
      _classCallCheck(this, UnitPowerNode);

      var _this5 = _possibleConstructorReturn(this, (UnitPowerNode.__proto__ || Object.getPrototypeOf(UnitPowerNode)).call(this, unitNode, numberNode));

      _this5.unit = unitNode.unit.pow(numberNode.value);
      _this5.unitNode = unitNode;
      _this5.exponent = numberNode;
      _this5._offsetLast = _this5.exponent.offsetLast; // HACK. I don't know where _offsetLast is being set.

      return _this5;
    }

    _createClass(UnitPowerNode, [{
      key: 'accept',
      value: function accept(visitor) {
        for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
          args[_key6 - 1] = arguments[_key6];
        }

        return visitor.visitUnitPower.apply(visitor, [this].concat(args));
      }
    }]);

    return UnitPowerNode;
  }(ASTNode); ////////////////////////////////////////////////////////////////////////////////////////////


  var UnitMultOp = function (_ASTNode6) {
    _inherits(UnitMultOp, _ASTNode6);

    function UnitMultOp(literal, left, right) {
      _classCallCheck(this, UnitMultOp);

      var _this6 = _possibleConstructorReturn(this, (UnitMultOp.__proto__ || Object.getPrototypeOf(UnitMultOp)).call(this, left, right));

      _this6.left = left;
      _this6.right = right;
      var unit;

      switch (literal) {
        case '/':
          if (_this6.left) {
            unit = left.unit.per(right.unit);
          } else {
            unit = right.unit.pow(-1);
          }

          break;

        case '*':
          unit = _this6.left.unit.by(_this6.right.unit);
          literal = ' ';
          break;
      }

      _this6.unit = unit;
      _this6.literal = literal;
      return _this6;
    }

    _createClass(UnitMultOp, [{
      key: 'accept',
      value: function accept(visitor) {
        for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
          args[_key7 - 1] = arguments[_key7];
        }

        return visitor.visitUnitMultOp.apply(visitor, [this].concat(args));
      }
    }]);

    return UnitMultOp;
  }(ASTNode); ////////////////////////////////////////////////////////////////////////////////////////////


  var NumberNode = function (_ASTNode7) {
    _inherits(NumberNode, _ASTNode7);

    function NumberNode(string) {
      _classCallCheck(this, NumberNode);

      var _this7 = _possibleConstructorReturn(this, (NumberNode.__proto__ || Object.getPrototypeOf(NumberNode)).call(this));

      _this7.valueType = "number";

      _this7.setValue(string);

      return _this7;
    }

    _createClass(NumberNode, [{
      key: 'setValue',
      value: function setValue(string) {
        if (typeof string === 'number') {
          this.value = string;
          this.literal = "" + string;
        } else if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isArray(string)) {
          this.literal = string.join("");
          this.value = parseInt(string, 10);
        } else if (typeof string === 'string') {
          this.literal = string;
          this.value = parseFloat(string, 10);
        } // XXX


        this._value = this.value;
      }
    }, {
      key: 'accept',
      value: function accept(visitor) {
        for (var _len8 = arguments.length, args = Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
          args[_key8 - 1] = arguments[_key8];
        }

        return visitor.visitNumberNode.apply(visitor, [this].concat(args));
      }
    }, {
      key: 'offsetLast',
      get: function get() {
        if (this.unitNode) {
          this._offsetLast = this.unitNode.offsetLast;
        }

        return this._offsetLast;
      }
    }]);

    return NumberNode;
  }(ASTNode); ////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * VariableDefinition
   */


  var VariableDefinition = function (_ASTNode8) {
    _inherits(VariableDefinition, _ASTNode8);

    function VariableDefinition(identifier, definition, value) {
      _classCallCheck(this, VariableDefinition);

      var _this8 = _possibleConstructorReturn(this, (VariableDefinition.__proto__ || Object.getPrototypeOf(VariableDefinition)).call(this, definition));

      _this8.identifier = identifier;
      _this8.ast = definition;
      _this8.value = value;
      return _this8;
    }

    _createClass(VariableDefinition, [{
      key: 'accept',
      value: function accept(visitor) {
        for (var _len9 = arguments.length, args = Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
          args[_key9 - 1] = arguments[_key9];
        }

        return visitor.visitVariableDefinition.apply(visitor, [this].concat(args));
      }
    }]);

    return VariableDefinition;
  }(ASTNode); ////////////////////////////////////////////////////////////////////////////////////////////


  var IdentifierNode = function (_ASTNode9) {
    _inherits(IdentifierNode, _ASTNode9);

    function IdentifierNode(string, scope) {
      _classCallCheck(this, IdentifierNode);

      var _this9 = _possibleConstructorReturn(this, (IdentifierNode.__proto__ || Object.getPrototypeOf(IdentifierNode)).call(this));

      if (typeof string === 'string') {
        _this9.literal = _this9.name = string;
      } else if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isArray(string)) {
        _this9.literal = _this9.name = string.join("");
      }

      _this9.scope = scope;
      return _this9;
    }

    _createClass(IdentifierNode, [{
      key: 'accept',
      value: function accept(visitor) {
        for (var _len10 = arguments.length, args = Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
          args[_key10 - 1] = arguments[_key10];
        }

        return visitor.visitIdentifier.apply(visitor, [this].concat(args));
      }
    }]);

    return IdentifierNode;
  }(ASTNode); ////////////////////////////////////////////////////////////////////////////////////////////


  var StatementNode = function (_ASTNode10) {
    _inherits(StatementNode, _ASTNode10);

    function StatementNode(statementType, ast) {
      _classCallCheck(this, StatementNode);

      var _this10 = _possibleConstructorReturn(this, (StatementNode.__proto__ || Object.getPrototypeOf(StatementNode)).call(this, ast));

      _this10.statementType = statementType;
      _this10._visitorMethodName = "visit" + statementType + "Statement";

      if (ast.accept) {
        _this10.ast = ast;
      } else if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isObject(ast)) {
        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.extend(_this10, ast);
      } else {
        _this10.ast = ast;
      }

      return _this10;
    }

    _createClass(StatementNode, [{
      key: 'accept',
      value: function accept(visitor) {
        try {
          var _visitor$_visitorMeth;

          for (var _len11 = arguments.length, args = Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
            args[_key11 - 1] = arguments[_key11];
          }

          return (_visitor$_visitorMeth = visitor[this._visitorMethodName]).call.apply(_visitor$_visitorMeth, [visitor, this].concat(args));
        } catch (e) {
          console.error("visitor." + this._visitorMethodName + " not found");
          throw e;
        }
      }
    }]);

    return StatementNode;
  }(ASTNode); ////////////////////////////////////////////////////////////////////////////////////////////


  var EditorLinesNode = function (_ASTNode11) {
    _inherits(EditorLinesNode, _ASTNode11);

    function EditorLinesNode(lines) {
      var _ref;

      _classCallCheck(this, EditorLinesNode);

      var _this11 = _possibleConstructorReturn(this, (_ref = EditorLinesNode.__proto__ || Object.getPrototypeOf(EditorLinesNode)).call.apply(_ref, [this].concat(_toConsumableArray(lines))));

      _this11.lines = lines;
      return _this11;
    }

    _createClass(EditorLinesNode, [{
      key: 'accept',
      value: function accept(visitor) {
        for (var _len12 = arguments.length, args = Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
          args[_key12 - 1] = arguments[_key12];
        }

        return visitor.visitEditorLinesNode.apply(visitor, [this].concat(args));
      }
    }]);

    return EditorLinesNode;
  }(ASTNode); ////////////////////////////////////////////////////////////////////////////////////////////


  var UnparsedText = function (_ASTNode12) {
    _inherits(UnparsedText, _ASTNode12);

    function UnparsedText(text, line, offset, lastLineNum) {
      _classCallCheck(this, UnparsedText);

      var _this12 = _possibleConstructorReturn(this, (UnparsedText.__proto__ || Object.getPrototypeOf(UnparsedText)).call(this));

      _this12.text = text;
      _this12.lineFirst = line;
      _this12.isUnparsed = true;
      _this12._offsetFirst = offset;
      _this12.statementOffsetFirst = offset;
      _this12.statementOffsetLast = offset + text.length;
      _this12.lineLast = lastLineNum;
      return _this12;
    }

    _createClass(UnparsedText, [{
      key: 'accept',
      value: function accept(visitor) {
        return;
      }
    }]);

    return UnparsedText;
  }(ASTNode); ////////////////////////////////////////////////////////////////////////////////////////////

  /* harmony default export */


  __webpack_exports__["default"] = {
    IdentifierNode: IdentifierNode,
    NumberNode: NumberNode,
    BinaryNode: BinaryNode,
    StatementNode: StatementNode,
    UnaryOperationNode: UnaryOperationNode,
    ParensNode: ParensNode,
    UnitLiteralNode: UnitLiteralNode,
    UnitMultOp: UnitMultOp,
    UnitPowerNode: UnitPowerNode,
    EditorLinesNode: EditorLinesNode,
    UnparsedText: UnparsedText,
    VariableDefinition: VariableDefinition
  };
  /***/
},
/* 8 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__Dimension__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__Multiple__ = __webpack_require__(6);

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  /**
   * A series of objects that will build up to units
   */

  /**
   * Some untility methods to build Unit
   */

  /**
   * Takes:
   * * a list of unitnames,
   * * map of { unitname: dimensionality }
   * * a plan object: {top: [ list of single units ]}
   *
   * e.g. { m: 2, cm: -1 }, empty_plan
   * returns:
   * {
   *    top   : [ m. m ],
   *    bottom: [ cm ]
   * }
   */


  function planConversions(map, plan) {
    plan = plan || {
      top: [],
      bottom: []
    };

    __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(map, function (i, unitName) {
      var dimensionality = map[unitName],
          pI;

      if (dimensionality < 0) {
        for (pI = dimensionality; pI < 0; pI++) {
          plan.bottom.push(unitName);
        }
      } else if (dimensionality > 0) {
        for (pI = 0; pI < dimensionality; pI++) {
          plan.top.push(unitName);
        }
      }

      return plan;
    });

    return plan;
  }
  /**
   * A combination of simple units, into a single object. e.g. miles per hour. This should be able to
   * provide a conversion to other units of the equivalent dimensionality.
   */


  var CompoundUnit = function () {
    function CompoundUnit(table, constituentUnits, dimension) {
      _classCallCheck(this, CompoundUnit);

      if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isString(constituentUnits)) {
        this.name = constituentUnits;
      } else {
        this.simpleUnits = constituentUnits;
      }

      this.unitsTable = table;
      this._dimension = dimension || this._deriveDimension();
    }

    _createClass(CompoundUnit, [{
      key: 'getDimension',
      value: function getDimension() {
        return this._dimension;
      }
    }, {
      key: '_deriveDimension',
      value: function _deriveDimension() {
        var self = this;
        var dimension = __WEBPACK_IMPORTED_MODULE_1__Dimension__["a"
        /* default */
        ].NONE;

        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(self.simpleUnits, function (i, key) {
          var scalar = self.simpleUnits[key],
              unit = self.unitsTable.getUnit(key),
              myDimension = unit.getDimension();
          dimension = dimension.by(myDimension.pow(scalar));
        });

        return dimension;
      } // schemes should be mutable.
      // addUnitScheme("imperial")
      // if scheme is currently _mixed, then it should be replaced

    }, {
      key: 'getUnitSchemes',
      value: function getUnitSchemes() {
        if (this._unitSchemes_user) {
          return this._unitSchemes_user;
        }

        if (this._unitSchemes) {
          return this._unitSchemes;
        }

        this._unitSchemes = function (self) {
          var unitsTable = self.unitsTable,
              myUnitSchemes = [];

          if (self.baseUnit) {
            return self.baseUnit.getUnitSchemes();
          }

          __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(self.simpleUnits, function (i, key) {
            var unit = unitsTable.getUnit(key),
                unitSchemes;

            if (myUnitSchemes) {
              myUnitSchemes = unit.getUnitSchemes();
            } else {
              // this should allow the same unit with different
              // schemes, e.g. metric and si.
              unitSchemes = unit.getUnitSchemes(); // units without schemes shouldn't make a difference
              // e.g. km / h => metric
              // case "_mixed":
              // case []: no scheme, e.g. hour
              // case [unitname]

              if (unitSchemes === "_mixed" || myUnitSchemes === "_mixed") {
                myUnitSchemes = "_mixed";
              } else if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isEmpty(unitSchemes) || __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isEmpty(myUnitSchemes)) {
                myUnitSchemes = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isEmpty(unitSchemes) ? myUnitSchemes : unitSchemes;
              } else {
                myUnitSchemes = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.intersection(myUnitSchemes, unitSchemes);

                if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isEmpty(myUnitSchemes)) {
                  myUnitSchemes = "_mixed";
                }
              }
            }
          });

          var userSchemes = self._unitSchemes_user;

          if (userSchemes) {
            if (myUnitSchemes === "_mixed") {
              myUnitSchemes = userSchemes;
            } else {
              myUnitSchemes = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.union(myUnitSchemes, userSchemes);
            }
          }

          return myUnitSchemes;
        }(this);

        return this._unitSchemes;
      }
    }, {
      key: 'addUnitScheme',
      value: function addUnitScheme(label) {
        var userSchemes = this._unitSchemes_user;

        if (!userSchemes) {
          userSchemes = this._unitSchemes_user = [label];
        } else {
          userSchemes.push(label);
        } // we'll blow away the cache this._unitSchemes later.
        // there's no point blowing away just us,
        // because we don't know what else is going to happen.

      }
    }, {
      key: 'isDimensionless',
      value: function isDimensionless() {
        return this.getDimension().isDimensionless();
      }
    }, {
      key: 'getSimpleUnits',
      value: function getSimpleUnits() {
        if (this.simpleUnits) {
          return this.simpleUnits;
        } else if (this.name) {
          if (this._simpleUnits) {
            return this._simpleUnits;
          }

          var compound = {};
          compound[this.name] = 1;
          this._simpleUnits = compound;
          return compound;
        }
      }
    }, {
      key: 'matchesDimensions',
      value: function matchesDimensions(destinationUnit) {
        return this.getDimension().isEqual(destinationUnit.getDimension());
      }
    }, {
      key: 'cardinality',
      value: function cardinality() {
        if (this._cardinality) {
          return this._cardinality;
        }

        if (this.name) {
          this._cardinality = 1;
        } else if (this.simpleUnits) {
          var u = this.simpleUnits;
          this._cardinality = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.reduce(u, function (memo, i, key) {
            var value = u[key];
            value = value > 0 ? value : -value;
            return memo + value;
          }, 0);
        }

        return this._cardinality;
      }
    }, {
      key: 'refactoredNode',
      value: function refactoredNode(quantity, unitScheme, useSimpleUnitsOnly) {
        var candidates = this._reductions(unitScheme, useSimpleUnitsOnly),
            // this is a rubbish algorithhm for choosing which candidate to move to.
        newUnit = candidates[0];

        if (candidates.length === 0) {
          throw new Error("Cannot factor unit into anything sensible");
        }

        if (typeof quantity === 'number') {
          quantity = new __WEBPACK_IMPORTED_MODULE_2__Multiple__["a"
          /* default */
          ](quantity, 1);
        } else if (!quantity) {
          quantity = __WEBPACK_IMPORTED_MODULE_2__Multiple__["a"
          /* default */
          ].one();
        } else {
          console.log('Quantity is ' + (typeof quantity === 'undefined' ? 'undefined' : _typeof(quantity)) + ': ' + quantity);
        }

        var multiplier = this._convert(quantity, newUnit);

        return {
          multiplier: multiplier,
          value: multiplier.value(),
          unit: newUnit
        };
      }
    }, {
      key: '_reductions',
      value: function _reductions(unitScheme, simpleUnitsOnly) {
        var simplified = this.simplify(),
            list,
            reduced;

        if (simpleUnitsOnly) {
          list = [];
        } else {
          list = findCompoundUnits(this.unitsTable.units, simplified.unit, unitScheme);
        }

        if (list.length) {
          reduced = findReductions(simplified.unit, list, unitScheme);
          return reduced.matches.length ? reduced.matches : [this];
        } else {
          if (unitScheme) {
            return [translateToUnitScheme(simplified.unit, unitScheme)];
          } else {
            return [this];
          }
        }
      }
    }, {
      key: '_convertSimpleUnit',
      value: function _convertSimpleUnit(quantity, destinationUnit) {
        if (this.multiples && destinationUnit.name) {
          var mult = this._simpleUnitConverter(destinationUnit.name);

          return quantity._times(mult);
        } else {
          throw new Error("Cannot convert from " + this.name + " to " + destinationUnit.name);
        }
      }
    }, {
      key: '_simpleUnitConverter',
      value: function _simpleUnitConverter(destinationUnitName) {
        return this.multiples[destinationUnitName];
      }
    }, {
      key: 'convert',
      value: function convert(quantity, destinationUnit) {
        return this._convert(__WEBPACK_IMPORTED_MODULE_2__Multiple__["a"
        /* default */
        ].quantity(quantity), destinationUnit).value();
      }
    }, {
      key: '_convert',
      value: function _convert(quantity, destinationUnit) {
        var self = this,
            mult;

        if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isString(destinationUnit)) {
          destinationUnit = this.unitsTable.getUnit(destinationUnit);
        }

        if (!this.matchesDimensions(destinationUnit)) {
          throw new Error("CANNOT CONVERT - DIMENSION MISMATCH");
        }

        if (this === destinationUnit) {
          return quantity;
        } // TODO javascript numbers
        // check if this is a named unit.


        if (this.multiples && destinationUnit.multiples) {
          mult = this._simpleUnitConverter(destinationUnit.name); // Bug fix: litre => gallon. (litre and gallon are defined in terms of different units)
          // Better fix: calculate new ratio, then add & cross fertilize multiples so we don't have to go the long way round
          // next time.

          if (mult) {
            return quantity._times(mult);
          }
        } // first we need to get a map of { dimensionName: { unitName: dimensionInt }}
        // this will help us make a list of conversions, on a dimension by dimension basis.


        var srcNode = this._convertToDimensionDimensionalityMap(),
            dstNode = destinationUnit._convertToDimensionDimensionalityMap();

        var srcDimensionalityMap = srcNode.map,
            dstDimensionalityMap = dstNode.map; // 1 kg / month * year in kg
        // 1 kg / month in kg/year

        function balancePlans(srcPlan, destPlan) {
          if (srcPlan.top.length && srcPlan.bottom.length) {
            destPlan.top.push(srcPlan.bottom);
            srcPlan.bottom = [];
          }

          if (destPlan.top.length && destPlan.bottom.length) {
            srcPlan.top.push(destPlan.bottom);
            destPlan.bottom = [];
          }
        } // for each dimension, make a list of pairs of simple units to convert between.
        // top and bottoms are used to reduced the error that we'll be introducing from crappy
        // arithmetic.
        // km/h/s => m/s^2
        // src: { top: [km], bottom: [h, s] },
        // dst: { top: [m],  bottom: [s, s] },


        var srcPlan = {
          top: [],
          bottom: []
        },
            dstPlan = {
          top: [],
          bottom: []
        };

        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(srcDimensionalityMap, function (i, dimensionName) {
          var srcUnitMap = srcDimensionalityMap[dimensionName],
              dstUnitMap = dstDimensionalityMap[dimensionName];
          var _srcPlan = {
            top: [],
            bottom: []
          },
              _dstPlan = {
            top: [],
            bottom: []
          };
          planConversions(srcUnitMap, _srcPlan);
          planConversions(dstUnitMap, _dstPlan);
          balancePlans(_srcPlan, _dstPlan); // XXX horrible conversion between a single pair of conversion plans and multiple ones

          srcPlan.top.push(_srcPlan.top);
          srcPlan.bottom.push(_srcPlan.bottom);
          dstPlan.top.push(_dstPlan.top);
          dstPlan.bottom.push(_dstPlan.bottom);
        });

        function simpleConversion(product, srcList, dstList) {
          // we're going to make the assumption that all units in the same dimension are
          // in the same direction (i.e. all +ve or all -ve);
          // The by product of this assumption is that we can assume that srcList and destList
          // are same length;
          srcList = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.flatten(srcList);
          dstList = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.flatten(dstList);

          if (srcList.length !== dstList.length) {
            throw new Error("UNEXPECTED_UNIT_CONVERSION_PROBLEMS");
          } // TODO javascript numbers used here.


          for (var j = 0, max = srcList.length; j < max; j++) {
            if (srcList[j] !== dstList[j]) {
              var srcUnit = self.unitsTable.getUnit(srcList[j]),
                  dstUnit = self.unitsTable.getUnit(dstList[j]);
              product = srcUnit._convertSimpleUnit(product, dstUnit);
            }
          }

          return product;
        }

        var product = simpleConversion(quantity, srcPlan.top, dstPlan.top).divide(simpleConversion(__WEBPACK_IMPORTED_MODULE_2__Multiple__["a"
        /* default */
        ].one(), srcPlan.bottom, dstPlan.bottom)); // TODO this is a javascript number.

        var result = product._times(srcNode.multiplier)._divide(dstNode.multiplier);

        return result;
      }
      /**
       * Unpacks a unit into its simplest constituent parts, and buckets them into
       * dimensions.
       *
       * Part of the conversion is to lookup unit statements such as
       *  unit kph : 1000 km/h
       *
       * The `1000` is collected in the return value's (aka the node's) `multiple`
       * property.
       *
       * return {
       *  map: { length: {mi: 1}, time: { s: -1, h: -1 } }
       *  multiplier: Multiple
       *  simplified: {}
       * }
       *
       * Simple example of map:
       *
       *   m^3 s^2 => { length: { m: 3 }, time: { s: 2 }};
       *
       * Will recursively discover dimensions from compound units:
       *
       *   mph/s => { length: {mi: 1}, time: { s: -1, h: -1 } }
       *
       *
       * `simplified`: gives the maximal expansion of units, with the union
       * of single dimension units in this unit, and the expansion of base units.
       *
       *    mph/s => { mi: 1, h: -1, h: -1 }
       */

    }, {
      key: '_convertToDimensionDimensionalityMap',
      value: function _convertToDimensionDimensionalityMap(node, dimensionMultiplier) {
        var currentMap, multiplier;
        node = node || {
          map: {},
          // TODO javascript number is used.
          multiplier: new __WEBPACK_IMPORTED_MODULE_2__Multiple__["a"
          /* default */
          ](),
          simplified: {},
          namedCompoundUnits: []
        };
        currentMap = node.map;
        dimensionMultiplier = dimensionMultiplier || 1;
        multiplier = node.multiplier;
        var self = this,
            dimensionObj = self.getDimension(),
            dimensions = dimensionObj.dimensions,
            simpleUnits;

        if (dimensionObj.isSimple() && self.name) {
          // not sure if we need to check self.name;
          var dimension = dimensionObj.shortName;
          var currentUnitMap = currentMap[dimension] || (currentMap[dimension] = {}),
              currentValue = currentUnitMap[self.name] || 0,
              // We are using a javascript number here.
          // TODO check assumption we never actually do the calculation here.
          // TODO consider complex number dimensions / javascript number
          newValue = currentValue + dimensions[dimension] * dimensionMultiplier;
          currentUnitMap[self.name] = newValue;
          node.simplified[self.name] = newValue;
          return node;
        }

        if (self.baseUnit) {
          node.namedCompoundUnits.push(self.name);
          node.multiplier = node.multiplier._times(self.baseMultiple);
          return self.baseUnit._convertToDimensionDimensionalityMap(node, dimensionMultiplier);
        }

        simpleUnits = self.getSimpleUnits();

        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(self.simpleUnits, function (i, unitName) {
          var dimensionality = simpleUnits[unitName],
              subUnit = self.unitsTable.getUnit(unitName);

          subUnit._convertToDimensionDimensionalityMap(node, dimensionality * dimensionMultiplier);
        });

        return node;
      }
    }, {
      key: 'isEqual',
      value: function isEqual(other) {
        return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isEqual(this.getSimpleUnits(), other.getSimpleUnits());
      } // TODO rename to simplified
      // This will take an arbitrarily complicate unit and return a
      // minimal compount unit composed soley
      // of simple units.
      // Units of the same dimension are canceled out and normalized
      // e.g. kg / month * year => kg
      // Where units are mixed, the one used most is used.
      // m * m * km => m^3
      // Compound units are replace with their base units
      // kph / s => km/h s => km/s^2
      // N h / cm^2 => kg m/s^2 * h / cm^2 => kg / s cm^2
      // A multiple is also provided to translate the old unit into the new unit.

    }, {
      key: 'simplify',
      value: function simplify() {
        // TODO guard that this is not a simple unit.
        var node = this._simplifiedNode();

        node.value = node.multiplier.value();
        return node;
      }
    }, {
      key: '_simplifiedNode',
      value: function _simplifiedNode() {
        var self = this,
            multiplier = __WEBPACK_IMPORTED_MODULE_2__Multiple__["a"
        /* default */
        ].one(),
            unit,
            myUnits;

        var dimensionalityNode = self._convertToDimensionDimensionalityMap(),
            dim2Unit = dimensionalityNode.map; // TODO options:
        // "scheme": "metric", "imperial", "si", "user"
        //  tons / (km km m) =>
        //    imperial: tons mi^-3
        //    metric: tonnes km^-3
        //    si: kg m^-3
        //    user: tons km^-3
        // compound: true, // should try and use compound named units.
        //  tons / (km km m) =>
        //    imperial: tons lt-1
        //


        if (!__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isEmpty(dimensionalityNode.namedCompoundUnits)) {
          myUnits = dimensionalityNode.simplified;
        } else {} // we'll fill this in as we make changes.
        // myUnits = _.clone(this.getSimpleUnits());
        // for each dimension...


        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(dim2Unit, function (i, dimension) {
          var unitMap = dim2Unit[dimension],
              // we make a list of things that need to be converted
          plan = planConversions(unitMap),
              // year^2 / month => { top: ["year", "year"], bottom: ["month"] }
          remainingList,
              direction;

          var increment = function increment(key, num) {
            function inc(map) {
              if (map[key]) {
                if (!(map[key] += num)) {
                  delete map[key];
                }
              } else {
                map[key] = num;
              }
            }

            inc(myUnits);
            inc(unitMap);
          }; // check if we need to cancel anything out.
          // i.e. if we have both a top and a bottom part of the plan.


          if (!__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isEmpty(plan.top) && !__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isEmpty(plan.bottom)) {
            var removalList;

            if (plan.top.length >= plan.bottom.length) {
              removalList = plan.bottom;
              remainingList = plan.top;
              direction = +1;
            } else {
              removalList = plan.top;
              remainingList = plan.bottom;
              direction = -1;
            } // the list with the smallest number of dimensions should be eradicated.
            // { top: [ year, year ], bottom: [ month ]}
            // removalList = [ month ]
            // myUnits will end up as the units we return.


            myUnits = myUnits || dimensionalityNode.simplified; // Now we have: the list of units we need to elminate.
            // we can pair off with units on the other side.

            __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(removalList, function (removable) {
              var cancelable = remainingList.shift(); // { year: 2, month: -1 } => { year: 1 }

              increment(removable, direction);
              increment(cancelable, -direction); // now calculate the multipler

              cancelable = self.unitsTable.getUnit(cancelable);
              removable = self.unitsTable.getUnit(removable); // cancelable = year
              // removable = month

              if (direction > 0) {
                multiplier = cancelable._convertSimpleUnit(multiplier, removable);
              } else {
                multiplier = removable._convertSimpleUnit(multiplier, cancelable);
              }
            });

            removalList.length = 0;
          }

          function magnitude(u) {
            var value = unitMap[u],
                abs = value >= 0 ? value : -value;
            return abs;
          }

          function pickTheNicestOne(u) {
            var value = magnitude(u) * 1024;
            return value + 0;
          }

          if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.size(unitMap) > 1) {
            var top, topUnit; // we have the situation where one dimension is represented
            // by multiple units (e.g. m cm), which could be weird.

            top = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.chain(unitMap).keys().max(magnitude).value();
            topUnit = self.unitsTable.getUnit(top); // it would be really nice if we could make this a cleverer
            // which unit we use to represent each dimension.
            // I don't understand this snippet, 
            // and that alarms me a little. See uses for direction.
            // direction = magnitude(top);
            // direction = direction >=0 ? 1 : -1;

            direction = 1; // use one if we've got one, but we have one if you need it.

            myUnits = myUnits || dimensionalityNode.simplified;

            __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(unitMap, function (index, unit) {
              if (unit === top) {
                return;
              }

              var other = self.unitsTable.getUnit(unit),
                  unitMag = magnitude(unit); // convert each one into the most common
              // 1 m^2 cm^3 => cm^5

              var conversion = other._convert(__WEBPACK_IMPORTED_MODULE_2__Multiple__["a"
              /* default */
              ].one(), topUnit);

              var i = 0;

              for (; i < unitMag; i++) {
                // TODO a javascript number
                multiplier = multiplier._times(conversion);
              }

              increment(unit, -direction * unitMag);
              increment(top, direction * unitMag);
            });
          }
        }); // TODO re-factor the new simplified unit, with the baseUnits that
        // we removed above.


        unit = self;

        if (myUnits) {
          unit = new CompoundUnit(this.unitsTable, myUnits); // multiplier = self.convert(multiplier, unit);
        } else {} // No modifications were need:
        // * there were no named compound units
        // * there were no units of the same dimension that needed canceling out.
        // Mutliply by the multiplier from converting named compound units to their base units.


        multiplier = multiplier._times(dimensionalityNode.multiplier);
        return {
          multiplier: multiplier,
          unit: unit
        };
      }
    }, {
      key: '_removeZeroDimensions',
      value: function _removeZeroDimensions(object) {
        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(object, function (i, key) {
          if (!object[key]) {
            delete object[key];
          }
        });
      }
    }, {
      key: 'by',
      value: function by(other) {
        // other is a compound unit
        var newCompound = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.clone(other.getSimpleUnits());

        var mySimpleUnits = this.getSimpleUnits();

        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(this.getSimpleUnits(), function (i, unitName) {
          newCompound[unitName] = (newCompound[unitName] || 0) + mySimpleUnits[unitName];
        });

        this._removeZeroDimensions(newCompound);

        return new CompoundUnit(this.unitsTable, newCompound, this.getDimension().by(other.getDimension()));
      }
    }, {
      key: 'per',
      value: function per(other) {
        var newCompound = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.clone(other.getSimpleUnits());

        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(newCompound, function (i, unitName) {
          newCompound[unitName] = -newCompound[unitName];
        });

        var mySimpleUnits = this.getSimpleUnits();

        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(mySimpleUnits, function (i, unitName) {
          newCompound[unitName] = (newCompound[unitName] || 0) + mySimpleUnits[unitName];
        });

        this._removeZeroDimensions(newCompound);

        return new CompoundUnit(this.unitsTable, newCompound, this.getDimension().per(other.getDimension()));
      }
    }, {
      key: 'pow',
      value: function pow(power) {
        if (typeof power !== 'number') {
          throw new Error("UNIT_WITH_NON_NUMERICAL_POWER");
        }

        var newCompound = power ? __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.clone(this.getSimpleUnits()) : {};

        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(newCompound, function (i, unitName) {
          newCompound[unitName] *= power;
        });

        return new CompoundUnit(this.unitsTable, newCompound, this.getDimension().pow(power));
      }
    }, {
      key: 'accept',
      value: function accept(visitor) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        return visitor.visitUnit.apply(visitor, [this].concat(args));
      }
    }]);

    return CompoundUnit;
  }(); // Utility functions only relevant for reductions.
  // From a list of units, filter the ones that will be useful to us
  // to factor the reducingUnit.

  /* harmony default export */


  __webpack_exports__["a"] = CompoundUnit;

  function findCompoundUnits(allUnits, reducingUnit, unitScheme) {
    var list = [],
        unitDimension = reducingUnit.getDimension();

    __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(allUnits, function (i, unitName) {
      var unit = allUnits[unitName],
          dimension = unit.getDimension(); // only compound ones needed

      if (dimension.cardinality() <= 1) {
        return;
      }

      if (unitDimension.contains(dimension)) {
        // we're only interested in units that can reduce the reducingUnit
        // TODO: consider unit schemes.
        if (!unitScheme || __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.indexOf(unit.getUnitSchemes(), unitScheme) >= 0) {
          list.push(unit);
        }
      }
    });

    list = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.sortBy(list, function (unit) {
      return unit.cardinality();
    });
    return list;
  } // complete is a unit that is refactored.
  // result is a the result object.
  // Add complete iff it has a lower cardinality (i.e. expresses the dimension in the fewest possible units)
  // that the current best.


  function considerBest(result, complete) {
    var best = result.bestCardinality,
        cardinality = complete.cardinality();

    if (best < cardinality) {
      return;
    } else if (best === cardinality) {
      var i = 0,
          max = result.matches.length;

      for (; i < max; i++) {
        // check we haven't got a duplicate
        if (result.matches[i].isEqual(complete)) {
          return;
        }
      }

      result.matches.push(complete);
    } else {
      result.bestCardinality = cardinality;
      result.matches = [complete];
    }
  } // Translate this compound unit in to the target unitScheme,
  // unit - which is guaranteed to contain only simple named units.
  // unitScheme - the unitScheme passed to the refactoredNode method.


  function translateToUnitScheme(unit, unitScheme) {
    var unitTable = unit.unitsTable,
        unitSchemes = unitTable.unitSchemes,
        simpleUnits = unit.getSimpleUnits(),
        newSimpleUnits = {};

    __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(simpleUnits, function (i, key) {
      var partUnit = unitTable.getUnit(key),
          dimensionName = partUnit.getDimension().shortName,
          newPartUnit;

      if (!dimensionName) {
        throw new Error("Trying to translate " + partUnit.name + " into " + unitScheme + " but it's not simple");
      }

      newPartUnit = unitSchemes.findClosestUnit(partUnit, unitScheme, dimensionName);
      newSimpleUnits[newPartUnit.name] = simpleUnits[key];
    });

    return new CompoundUnit(unitTable, newSimpleUnits);
  }
  /*
   * reducingUnit - the remaining unit needed to be factored.
   * currentBigUnits - the list of unconsidered named compound units.
   * accumulator - a candidate result unit. i.e. reducingUnit * accumulator = paritally factored initial reducingUnit
   * test - the named compound unit we have just tested to see if it is contained in the reducing unit.
   * result - the list of complete accumulator units.
   */


  function findReductions(reducingUnit, currentBigUnits, unitScheme, accumulator, test, result) {
    result = result || {
      bestCardinality: 9999999,
      matches: []
    };
    accumulator = accumulator || new CompoundUnit(reducingUnit.unitsTable, {}); // we should assume that reducing unit is simple;

    if (test) {
      // if test completely matches reducing unit, then our job is done.
      if (test.matchesDimensions(reducingUnit)) {
        // We have constructed an accumulator out of named compound units only.
        considerBest(result, accumulator.by(test));
        return result;
      }

      if (!reducingUnit.getDimension().contains(test.getDimension())) {
        // We can't reduce the unit with the test unit, so
        // remove it from the pool.
        currentBigUnits = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.reject(currentBigUnits, function (un) {
          return un === test;
        });
      } else {
        // We can reduce the unit with the test unit, so replace the
        // accumulator with a new one.
        accumulator = accumulator.by(test); // this is how many units we've accumulated already (the 1 is test)

        var currentCardinality = accumulator.cardinality(); // If we gave up now, our cardinality would be be
        // increased by the total dimension cardinality of what's left.
        // maximumCardinality = currentCardinality + (reducingUnit.getDimension().cardinality() - test.getDimension().cardinality());
        // optimisation, though it's unlikely to do anything in all but
        // the most complicated units.

        if (currentCardinality > result.bestCardinality) {
          return result;
        } // TODO how can this be made less heavy weight?


        reducingUnit = reducingUnit.per(test)._simplifiedNode().unit; // maximumCardinality is not very useful, but we can calculate it here as:
        // maximumCardinality = currentCardinality + reducingUnit.getDimension().cardinality();
      }
    } // We've run out of named compound units to test.
    // We only have named simple units left.


    if (currentBigUnits.length === 0) {
      // Translate the remaining simple units into unit scheme
      // appropriate units.
      if (unitScheme) {
        reducingUnit = translateToUnitScheme(reducingUnit, unitScheme);
      }

      considerBest(result, accumulator.by(reducingUnit));
      return result;
    }

    __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(currentBigUnits, function (next) {
      // recurse if we haven't seen this before, except if we've just looked at it.
      if (test === next || !accumulator.simpleUnits[next.name]) {
        findReductions(reducingUnit, currentBigUnits, unitScheme, accumulator, next, result);
      }
    });

    return result;
  }
  /***/

},
/* 9 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var UnitSchemes = function () {
    function UnitSchemes() {
      _classCallCheck(this, UnitSchemes);

      this._table = {};
      this._noScheme = {};
      this._dimensionTable = {};
    }

    _createClass(UnitSchemes, [{
      key: "addUnit",
      value: function addUnit(unit, additionalSchemes) {
        var self = this,
            unitSchemes = additionalSchemes || unit.getUnitSchemes(); // e.g.
        // include "fundamental"
        // unit m (Scientific)

        var dimension = unit.getDimension(),
            dimensionName = dimension.shortName;

        if (dimensionName) {
          this._dimensionTable[dimensionName] = dimension;
        } else {
          var allDimensions = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.values(this._dimensionTable);

          for (var i = 0, max = allDimensions.length; i < max; i++) {
            var d = allDimensions[i];

            if (d.isEqual(dimension)) {
              unit._dimension = d;
              break;
            }
          }
        }

        if (unitSchemes && unitSchemes.length) {
          __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(unitSchemes, function (unitScheme) {
            var table = self._table[unitScheme] || (self._table[unitScheme] = {});

            self._addUnitToScheme(table, unit);
          });
        } else {
          self._addUnitToScheme(self._noScheme, unit);
        }
      }
    }, {
      key: "_addUnitToScheme",
      value: function _addUnitToScheme(table, unit) {
        var dimension = unit.getDimension(),
            dimensionName = dimension.shortName,
            units;

        if (dimensionName) {
          units = table[dimensionName] || (table[dimensionName] = []);
          units.push(unit);
        } else {
          console.log("WARN: " + unit.name + " isn't included in the keyboard: it has no named dimension");
        }

        delete this._keyboardCache;
      }
    }, {
      key: "getUnitSchemes",
      value: function getUnitSchemes() {
        if (!this._keyboardCache) {
          this._keyboardCache = {};
        }

        if (!this._keyboardCache.unitSchemes) {
          this._keyboardCache.unitSchemes = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.keys(this._table);
        }

        return this._keyboardCache.unitSchemes;
      }
    }, {
      key: "getDimensions",
      value: function getDimensions(unitScheme) {
        var self = this;

        if (!this._keyboardCache) {
          this._keyboardCache = {};
        }

        var table = this._keyboardCache.unitSchemeDimensions;

        if (!table) {
          this._keyboardCache.unitSchemeDimensions = table = {};
        }

        if (!table[unitScheme]) {
          var dimensionNames = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.union(__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.keys(this._table[unitScheme]), __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.keys(this._noScheme));

          dimensionNames = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.sortBy(dimensionNames, function (dimensionName) {
            return self._dimensionTable[dimensionName].cardinality();
          });
          table[unitScheme] = dimensionNames;
        }

        return table[unitScheme];
      }
    }, {
      key: "getUnitNames",
      value: function getUnitNames(unitScheme, dimension) {
        if (!unitScheme) {
          return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.pluck(this._noScheme[dimension], "name");
        }

        if (!this._keyboardCache) {
          this._keyboardCache = {};
        }

        var table = this._keyboardCache.schemeDimensionUnitNames;

        if (!table) {
          this._keyboardCache.schemeDimensionUnitNames = table = {};
        }

        if (!table[unitScheme]) {
          table[unitScheme] = {};
        }

        table = table[unitScheme];

        if (!table[dimension]) {
          var units = this._table[unitScheme] && this._table[unitScheme][dimension];
          units = units || this._noScheme[dimension] || [];
          table[dimension] = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.pluck(units, "name");
        }

        return table[dimension];
      }
    }, {
      key: "findClosestUnit",
      value: function findClosestUnit(srcUnit, unitScheme, dimensionName) {
        var abs = function abs(n) {
          return n > 0 ? n : -n;
        };

        this.getUnitNames(unitScheme, dimensionName);
        var closestUnit = srcUnit,
            closestDistanceToOne = 9999999,
            table = this._table[unitScheme][dimensionName],
            srcUnitName = srcUnit.name;

        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(table, function (unit) {
          var conv = unit._simpleUnitConverter(srcUnitName),
              distToOne = closestDistanceToOne;

          if (conv) {
            distToOne = abs(conv.value() - 1);

            if (distToOne < closestDistanceToOne) {
              closestDistanceToOne = distToOne;
              closestUnit = unit;
            }
          }
        });

        return closestUnit;
      }
    }]);

    return UnitSchemes;
  }();
  /* harmony default export */


  __webpack_exports__["a"] = UnitSchemes;
  /***/
},
/* 10 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__Scope__ = __webpack_require__(24);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__Scope__["a"];
  });
  /***/

},
/* 11 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__to_source__ = __webpack_require__(27);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__StringDisplay__ = __webpack_require__(12);

  var toString = Object(__WEBPACK_IMPORTED_MODULE_0__to_source__["a"
  /* createToString */
  ])(new __WEBPACK_IMPORTED_MODULE_1__StringDisplay__["a"
  /* default */
  ]());
  /* harmony default export */

  __webpack_exports__["a"] = {
    toTokenArray: __WEBPACK_IMPORTED_MODULE_0__to_source__["c"
    /* toTokenArray */
    ],
    toString: toString,
    toStringWithDisplay: __WEBPACK_IMPORTED_MODULE_0__to_source__["b"
    /* toStringWithDisplay */
    ]
  };
  /***/
},
/* 12 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var StringDisplay = function () {
    function StringDisplay() {
      _classCallCheck(this, StringDisplay);
    }

    _createClass(StringDisplay, [{
      key: "bracketStart",
      value: function bracketStart(token, string, context, offset) {
        return string;
      }
    }, {
      key: "bracketEnd",
      value: function bracketEnd(token, string, context, offset) {
        return string;
      }
      /********
       * Colors and styles.
       */

    }, {
      key: "identifier",
      value: function identifier(token, string, context, offset) {
        return string;
      }
    }, {
      key: "operator",
      value: function operator(token, string, context, offset) {
        return string;
      }
    }, {
      key: "number",
      value: function number(token, string, context, offset) {
        return string;
      }
    }, {
      key: "unitLiteral",
      value: function unitLiteral(token, string, context, offset) {
        return string;
      }
    }, {
      key: "powerStart",
      value: function powerStart(token, string, context, offset) {
        return string;
      }
    }, {
      key: "powerEnd",
      value: function powerEnd(token, string, context, offset) {}
    }, {
      key: "unitStart",
      value: function unitStart(token, string, context, offset) {}
    }, {
      key: "unitEnd",
      value: function unitEnd(token, string, context, offset) {}
    }, {
      key: "errorStart",
      value: function errorStart(token, string, context, offset) {}
    }, {
      key: "errorEnd",
      value: function errorEnd(token, string, context, offset) {}
    }]);

    return StringDisplay;
  }();
  /* harmony default export */


  __webpack_exports__["a"] = StringDisplay;
  /***/
},
/* 13 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var AbstractOperation = function () {
    function AbstractOperation() {
      _classCallCheck(this, AbstractOperation);
    }

    _createClass(AbstractOperation, [{
      key: "evaluate",
      // publically called by the evaluator.
      value: function evaluate(leftNode, rightNode, ctx) {} // calculates calculates the operands, and then uses them to calculate 
      // the result.
      // Returns an AST node.

    }, {
      key: "nodeCalculator",
      value: function nodeCalculator(leftNode, rightNode, ctx) {} // checks for any operands that would cause errors (e.g. unit dimensionality, divide by zero),
      // returns true if no errors. Reports errors with ctx if so.
      // Returns Boolean

    }, {
      key: "preflightCheck",
      value: function preflightCheck(leftNode, leftValue, rightNode, rightValue, ctx) {} // Calculates the unit of the result (using unitCalculator), normalizes 
      // the right hand operand to be compatible with the left (using prepareRight)
      // the calculates the simple values (using simpleValueCalculator).
      // Returns a TuroNumber

    }, {
      key: "turoValueCalculator",
      value: function turoValueCalculator(leftValue, rightValue) {}
    }]);

    return AbstractOperation;
  }();
  /* harmony default export */


  __webpack_exports__["a"] = AbstractOperation;
  /***/
},
/* 14 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* unused harmony export AbstractStorage */

  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "b", function () {
    return CompositeStorage;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return DocumentLoader;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return BundleDocumentLoader;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(63);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  } /////////////////////////////////////////////////////////////////////////


  var AbstractStorage = function () {
    function AbstractStorage() {
      _classCallCheck(this, AbstractStorage);

      this._state = {
        isLoading: {},
        documents: {}
      }; // subclasses should call this constructor
      // with AbstractStorage.call(this) in their own constructors.
    }

    _createClass(AbstractStorage, [{
      key: 'hasDocument',
      value: function hasDocument(slug) {
        return this.getDocument(slug);
      }
    }, {
      key: 'isLoadingDocument',
      value: function isLoadingDocument(slug) {
        return this._state.isLoading[slug];
      } // func (slug: String, documentCreator: ({id, document}, cb) -> Void, cb)
      // Should write to cache, for availability elsewhere

    }, {
      key: 'loadDocument',
      value: function loadDocument(slug, documentCreator, callback) {
        var self = this,
            listeners = self._state.isLoading[slug];
        var isNew = !slug;

        if (listeners) {
          listeners.push(callback);
          return;
        }

        listeners = [callback];

        if (!isNew) {
          self._state.isLoading[slug] = listeners;
        }

        this.loadJSON(slug).then(function (_ref) {
          var docData = _ref.docData,
              loader = _ref.loader;

          if (isNew) {
            slug = "" + docData.id;
          } // evaluates doc


          documentCreator(docData, function (err, doc) {
            // JS is single threaded, so nothing can add to listeners
            delete self._state.isLoading[slug];

            if (err) {
              console.error('Error loading ' + slug + ': ' + err);
              listeners.forEach(function (cb) {
                return cb(err);
              });
              return;
            }

            doc.location = {
              slug: slug,
              loader: loader
            };
            self._state.documents[slug] = doc;
            listeners.forEach(function (cb) {
              return cb(null, doc);
            });
          });
        }).catch(function (err) {
          delete self._state.isLoading[slug];
          listeners.forEach(function (cb) {
            return cb(err);
          });
        }); // load string,
        // create editable document with evaluate string
        // calls back with model.
      }
    }, {
      key: 'getDocument',
      value: function getDocument(slug) {
        return this._state.documents[slug];
      }
    }, {
      key: 'loadJSON',
      value: function loadJSON(location) {
        return Promise.reject('Unimplemented method loadJSON');
      }
    }, {
      key: 'saveDocument',
      value: function saveDocument(doc) {
        return Promise.reject('Unimplemented method saveDocument');
      }
    }]);

    return AbstractStorage;
  }();

  var CompositeStorage = function (_AbstractStorage) {
    _inherits(CompositeStorage, _AbstractStorage);

    function CompositeStorage(loaders) {
      _classCallCheck(this, CompositeStorage);

      var _this = _possibleConstructorReturn(this, (CompositeStorage.__proto__ || Object.getPrototypeOf(CompositeStorage)).call(this));

      _this.loaders = loaders;
      return _this;
    }

    _createClass(CompositeStorage, [{
      key: 'loadJSON',
      value: function loadJSON(slug) {
        var generator =
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(loaders) {
          var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, loader;

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context.prev = 3;
                  _iterator = loaders[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                    _context.next = 12;
                    break;
                  }

                  loader = _step.value;
                  _context.next = 9;
                  return loader;

                case 9:
                  _iteratorNormalCompletion = true;
                  _context.next = 5;
                  break;

                case 12:
                  _context.next = 18;
                  break;

                case 14:
                  _context.prev = 14;
                  _context.t0 = _context['catch'](3);
                  _didIteratorError = true;
                  _iteratorError = _context.t0;

                case 18:
                  _context.prev = 18;
                  _context.prev = 19;

                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }

                case 21:
                  _context.prev = 21;

                  if (!_didIteratorError) {
                    _context.next = 24;
                    break;
                  }

                  throw _iteratorError;

                case 24:
                  return _context.finish(21);

                case 25:
                  return _context.finish(18);

                case 26:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this, [[3, 14, 18, 26], [19,, 21, 25]]);
        });

        var g = generator(this.loaders);

        var tryNext = function tryNext() {
          var next = g.next();

          if (next.done) {
            return Promise.reject('NO DOCUMENT IN ANY LOADER');
          }

          var loader = next.value;
          return loader.loadJSON(slug).then(function (docData) {
            return Promise.resolve({
              docData: docData,
              loader: loader
            });
          }).catch(function (e) {
            return tryNext();
          });
        };

        return tryNext();
      }
    }, {
      key: 'saveDocument',
      value: function saveDocument(doc) {
        var _doc$location = doc.location,
            slug = _doc$location.slug,
            loader = _doc$location.loader;

        if (loader && loader.saveJSON) {
          var json = {
            document: doc.text,
            id: slug,
            title: doc.title || doc.id
          };
          return loader.saveJSON(slug, json);
        } else {
          return Promise.reject('CANNOT SAVE');
        }
      }
    }]);

    return CompositeStorage;
  }(AbstractStorage);

  var DocumentLoader = function () {
    function DocumentLoader() {
      _classCallCheck(this, DocumentLoader);
    }

    _createClass(DocumentLoader, [{
      key: 'loadJSON',
      value: function loadJSON(slug) {
        return Promise.reject('Unimplemented method loadJSON');
      }
    }, {
      key: 'saveJSON',
      value: function saveJSON(slug, doc) {
        return Promise.reject('Unimplemented method saveDocument');
      }
    }]);

    return DocumentLoader;
  }();

  var BundleDocumentLoader = function (_DocumentLoader) {
    _inherits(BundleDocumentLoader, _DocumentLoader);

    function BundleDocumentLoader(files) {
      var implicitImports = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      _classCallCheck(this, BundleDocumentLoader);

      var _this2 = _possibleConstructorReturn(this, (BundleDocumentLoader.__proto__ || Object.getPrototypeOf(BundleDocumentLoader)).call(this));

      _this2.files = files;
      _this2.implicitImports = implicitImports;
      return _this2;
    }

    _createClass(BundleDocumentLoader, [{
      key: 'loadJSON',
      value: function loadJSON(slug) {
        var id = slug;
        var string = this.files[id];

        if (string) {
          return Promise.resolve({
            id: id,
            title: slug,
            document: string,
            implicitImports: this.implicitImports
          });
        } else {
          return Promise.reject('BundleDocumentLoader: NO_DOCUMENT ' + slug);
        }
      }
    }]);

    return BundleDocumentLoader;
  }(DocumentLoader);
  /***/

},
/* 15 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: true
  });
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "TuroDocument", function () {
    return TuroDocument;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "loaders", function () {
    return loaders;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__document__ = __webpack_require__(16);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__storage_app_bundle_storage__ = __webpack_require__(54);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__storage_abstract_storage__ = __webpack_require__(14);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "EditableDocument", function () {
    return __WEBPACK_IMPORTED_MODULE_0__document__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "CompositeStorage", function () {
    return __WEBPACK_IMPORTED_MODULE_2__storage_abstract_storage__["b"];
  }); // By default, documents are loaded only from the bundle. 
  // You can add your own document loaders using the composite storage class.


  __WEBPACK_IMPORTED_MODULE_0__document__["a"
  /* EditableDocument */
  ].storage = __WEBPACK_IMPORTED_MODULE_1__storage_app_bundle_storage__["b"
  /* storage */
  ];
  var TuroDocument = __WEBPACK_IMPORTED_MODULE_0__document__["a"
  /* EditableDocument */
  ];
  var loaders = {
    bundleLoader: __WEBPACK_IMPORTED_MODULE_1__storage_app_bundle_storage__["a"
    /* bundleLoader */
    ],
    DocumentLoader: __WEBPACK_IMPORTED_MODULE_2__storage_abstract_storage__["c"
    /* DocumentLoader */
    ]
  };
  /***/
},
/* 16 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__EditableDocument__ = __webpack_require__(17);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__EditableDocument__["a"];
  });
  /***/

},
/* 17 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__units__ = __webpack_require__(18);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__parser__ = __webpack_require__(20);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__operators__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__symbols__ = __webpack_require__(10);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__DocumentHelper__ = __webpack_require__(45);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__DocumentModel__ = __webpack_require__(47);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_underscore__);

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var statics;

  function promiseCallback(resolve, reject) {
    for (var _len = arguments.length, defaultArgs = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      defaultArgs[_key - 2] = arguments[_key];
    }

    return function (err) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      if (!err) {
        resolve.apply(undefined, defaultArgs.concat(args));
      } else {
        reject(err);
      }
    };
  } ///////////////////////////////////////////////////////////////////////////////


  var EditableDocument = function () {
    function EditableDocument(id) {
      _classCallCheck(this, EditableDocument);

      if (!this) {
        return new EditableDocument(id);
      }

      var importScope = __WEBPACK_IMPORTED_MODULE_3__symbols__["a"
      /* Scope */
      ].newScope(undefined, statics.units),
          scope = importScope.newScope(id);

      this._state = {
        id: id,
        model: new __WEBPACK_IMPORTED_MODULE_5__DocumentModel__["a"
        /* default */
        ](id),
        importScope: importScope,
        scope: scope
      };
      var parser = new __WEBPACK_IMPORTED_MODULE_1__parser__["a"
      /* Parser */
      ](scope); // Scope rules control the access to units, 
      // so novel units can drop in and out of scope. 
      // However, redefining existing units has undefined 
      // results.
      // This is probably the worst of both worlds,
      // so we may not want to scope units with block scope

      parser.units = scope.units;
      parser.operators = __WEBPACK_IMPORTED_MODULE_2__operators__["b"
      /* defaultOperators */
      ];
      this.parser = parser;
      this.documentHelper = new __WEBPACK_IMPORTED_MODULE_4__DocumentHelper__["a"
      /* default */
      ](EditableDocument.storage);
    }
    /**
     * Asynchronously imports one or more documents into this document's parent scope.
     * 
     * @param id - a string or list of strings the underlying storage will map to a document
     * @param callback - func (err, doc)
     * @return boolean - true iff the import completed synchronously
     */


    _createClass(EditableDocument, [{
      key: 'import_withCallback',
      value: function import_withCallback(id, callback) {
        if (!callback) {
          callback = statics.noCallback;
        }

        if (!id) {
          return callback(null, this);
        }

        var toImport = id;

        if (!Object(__WEBPACK_IMPORTED_MODULE_6_underscore__["isArray"])(id)) {
          toImport = [id];
        }

        var scope = this._state.importScope;
        return this.documentHelper.import(toImport, scope, statics.createEditableDocument_withCallback, callback);
      }
    }, {
      key: 'import',
      value: function _import(id) {
        var _this = this;

        return new Promise(function (resolve, reject) {
          _this.import_withCallback(id, promiseCallback(resolve, reject, _this));
        });
      }
    }, {
      key: '_freshScope',
      value: function _freshScope() {
        return this.scope.fresh();
      }
      /**
       * Evaluates the document.
       *
       * If the document is immediately executable, then do so
       * and call callbackNow().
       *
       * If the document is not ready to be accurately evaluated
       * Ensure it is by loading any resources asynchronously 
       * and then call callbackMaybeLater().
       *
       * While the document is waiting, call callbackNow() with interim 
       * results.
       *
       * @return isReady, if the no asynchronous activity is needed.
       */

    }, {
      key: 'evaluateDocument_withCallback',
      value: function evaluateDocument_withCallback(string, callback, optionalDocumentCreator) {
        var _this2 = this;

        var scope = this._freshScope();

        this.scope = scope;
        return this._firstParseEval(string, optionalDocumentCreator, function (err) {
          if (err) {
            callback(err);
            return false;
          }

          return _this2._evalDocumentSync(string, callback);
        });
      }
    }, {
      key: 'evaluateDocument',
      value: function evaluateDocument(string) {
        var _this3 = this;

        var promise = new Promise(function (resolve, reject) {
          _this3.evaluateDocument_withCallback(string, function (err, doc) {
            if (!err) {
              resolve(doc);
            } else {
              reject(err);
            }
          });
        });
        return promise;
      }
    }, {
      key: 'reeevaluateDocument',
      value: function reeevaluateDocument(callback) {
        return this._evalDocumentSync(this.text, callback);
      }
    }, {
      key: '_firstParseEval',
      value: function _firstParseEval(string, optionalDocumentCreator, syncEval) {
        var firstParseNode = this.parser.parse(string + '\n', 'DocumentFirstParse');
        var context = {
          string: string,
          documentEvaluator: optionalDocumentCreator || statics.createEditableDocument_withCallback,
          scope: this.scope,
          document: this
        }; // If this was all done synchronously, then isReady should 
        // contain this, i.e. the document.

        var isReady;
        this.documentHelper.evaluate(firstParseNode, function (err, doc) {
          isReady = syncEval(err, doc);
        }, context);
        return isReady;
      }
    }, {
      key: '_evalDocumentSync',
      value: function _evalDocumentSync(string, callback) {
        var scope = this.scope,
            model = this._state.model; // Here's where turo the calculator starts.

        var nodes = this.parser.parse(string + '\n', 'EditorText').lines;
        model.batchUpdate(nodes, scope);
        var statements = model.statementsInWrittenOrder;
        statements.forEach(function (s) {
          var node = s.node,
              first = node.statementOffsetFirst,
              last = node.statementOffsetLast;
          s.info.text = string.substring(first, last);
        });
        this._state.text = string;

        if (callback) {
          callback(null, this);
        }

        return this;
      }
    }, {
      key: 'evaluateStatement',
      value: function evaluateStatement(id, string) {
        var _this4 = this;

        return new Promise(function (resolve, reject) {
          _this4.evaluateStatement_withCallback(id, string, promiseCallback(resolve, reject));
        });
      }
    }, {
      key: 'evaluateStatement_withCallback',
      value: function evaluateStatement_withCallback(id, string, callback) {
        var _this5 = this;

        if (!callback) {
          callback = statics.noCallback;
        }

        return this._firstParseEval(string, undefined, function (err) {
          if (err) {
            callback(err);
            return false;
          }

          return _this5._evalStatementSync(id, string, callback);
        });
      }
    }, {
      key: 'getStatement',
      value: function getStatement(id) {
        return this._state.model.getStatement(id);
      }
    }, {
      key: '_evalStatementSync',
      value: function _evalStatementSync(id, string, callback) {
        var scope = this.scope,
            // XXX scope should come from the statement/node itself, not document.
        // TODO the parser should be dealing with this.
        model = this._state.model;
        this.parser.scope = scope;
        var nodes = this.parser.parse(string + '\n', 'EditorText').lines;
        var statements = model.interactiveUpdate(id, nodes[0], scope); // Now, to keep the document text updated, we add the text to the statement.
        // We cannot rely on 'statements' containing the statement with id=id.

        var s = model.getStatement(id);
        s.info.text = string; // We now have a different document, so delete the original text.

        delete this._state.text;

        if (callback) {
          callback(null, statements);
        }

        return statements;
      } // events: {
      //   requestLines: ['startLine', 'endLine'],
      //   requestDocument: [],
      //   updateTextLines: ['lines', 'characterOffset', 'lineOffset'],
      //   updateResultLines: ['resultLines']
      // },

    }, {
      key: 'createEditTokenForCursor',
      value: function createEditTokenForCursor(offset, line, column) {
        return {
          offset: offset,
          line: line,
          column: column
        };
      } // TODO: wtf is an editToken?

    }, {
      key: 'findStatementForEditToken',
      value: function findStatementForEditToken(editToken) {
        var model = this._state.model;

        if (editToken.id) {
          return model.getStatement(editToken.id);
        } // After the first edit, all our line numbers 
        // are screwed.


        if (model.state !== __WEBPACK_IMPORTED_MODULE_5__DocumentModel__["a"
        /* default */
        ].State.OK) {
          // Re-evaluating is an expensive but easy way of fixing that.
          this.reeevaluateDocument();
        }

        var id = model.findStatementIdByLineCol(editToken.line, editToken.column) || model.findStatementIdByOffset(editToken.offset) || null;

        if (id) {
          return model.getStatement(id);
        }
      }
    }, {
      key: 'setEditPoint',
      value: function setEditPoint(token) {
        // const {column, offset, line} = token;
        this.editToken = token;
        return this;
      }
    }, {
      key: 'getActions',
      value: function getActions() {
        return this._editActions;
      }
    }]);

    return EditableDocument;
  }(); ///////////////////////////////////////////////////////////////////////////////


  Object.defineProperties(EditableDocument.prototype, {
    scope: {
      get: function get() {
        return this._state.scope;
      },
      set: function set(newValue) {
        this._state.scope = newValue;
        this.parser.scope = newValue;
      }
    },
    importScope: {
      get: function get() {
        return this._state.importScope;
      },
      set: function set(parentScope) {
        this.scope.parent = parentScope;
        this._state.importScope = parentScope;
      }
    },
    id: {
      get: function get() {
        return this._state.id;
      }
    },
    editToken: {
      get: function get() {
        return this._state.editToken;
      },
      set: function set(token) {
        if (token != undefined) {
          this._editActions = new EditorActions(this, token);
        } else {
          this._editActions = null;
        }

        this._state.editToken = token;
      }
    },
    model: {
      get: function get() {
        return this._state.model;
      }
    },
    statements: {
      get: function get() {
        return this.model.statementsInWrittenOrder;
      }
    },
    units: {
      get: function get() {
        return statics.units;
      }
    },
    overwriteExistingDefinitions: {
      set: function set(newValue) {
        this._state.model.overwriteExistingDefinitions = !!newValue;
      }
    },
    lineByLineMode: {
      set: function set(newValue) {
        this.overwriteExistingDefinitions = newValue;
      }
    },
    text: {
      get: function get() {
        var text = this._state.text;

        if (text) {
          return text;
        }

        text = this.model.statementsInWrittenOrder.map(function (s) {
          return s.info.text || '';
        }).join('\n');
        return text;
      }
    }
  }); ///////////////////////////////////////////////////////////////////////////////

  statics = {
    initializeDocument: function initializeDocument(theDocument, docData, cb) {
      var id = docData.id,
          string = docData.document,
          title = docData.title,
          implicitImports = docData.implicitImports;
      theDocument.title = title;

      function evalString() {
        if (string) {
          theDocument.evaluateDocument_withCallback(string, cb);
        } else {
          cb(null, theDocument);
        }
      }

      function importDocs() {
        if (implicitImports) {
          theDocument.import_withCallback(implicitImports, evalString);
        } else {
          evalString();
        }
      }

      importDocs();
      return theDocument;
    },
    createEditableDocument_withCallback: function createEditableDocument_withCallback(docData, cb) {
      var id = docData.id;
      var theDocument = new EditableDocument(id);
      return statics.initializeDocument(theDocument, docData, cb);
    },
    createEditableDocument: function createEditableDocument(id) {
      return new EditableDocument(id);
    },
    loadEditableDocument_withCallback: function loadEditableDocument_withCallback(documentId, imports, cb) {
      var theDocument = new EditableDocument(documentId);

      function createDocument(docData, cb) {
        var id = docData.id;
        var doc = documentId === id && documentId ? theDocument : new EditableDocument(id);
        return statics.initializeDocument(doc, docData, cb);
      } // We do two things and a but here.
      // 1. Load the imports.
      // 2. Load the file we've been asked to get.
      // But: the file we're loading may be importing files that have been written 
      // with the same implicit imports (i.e. user generated files),
      // so they have to have the same imports.


      theDocument.import_withCallback(imports, function thenLoadAndEvaluateDocument() {
        EditableDocument.storage.loadDocument(documentId, createDocument, cb);
      });
      return theDocument;
    },
    loadEditableDocument: function loadEditableDocument(documentId, optionalImports) {
      return new Promise(function (resolve, reject) {
        statics.loadEditableDocument_withCallback(documentId, optionalImports, function (err, doc) {
          if (!err) {
            resolve(doc);
          } else {
            reject(err);
          }
        });
      });
    },
    saveEditableDocument: function saveEditableDocument(doc) {
      return EditableDocument.storage.saveDocument(doc);
    },
    // units requires everything 
    // to be in the same scope. For complexity reasons.
    units: new __WEBPACK_IMPORTED_MODULE_0__units__["a"
    /* Units */
    ](),
    noCallback: function noCallback() {}
  };
  /**
   * EditableDocument
   * Class methods
   *   class createDocument(id: String)
   *   class loadDocument(url: URL)
   * 
   * Methods
   *   import(string|[string], callback)
   *   evaluateStringDocument(string, callback) -> Bool
   *   evaluateStringStatement(string, callback, callbackInterim) -> Bool
   * 
   * Properties:
   *   id
   *   scope
   *   string
   *   status
   *   model
   */

  /*
   * You should probably set this.
   */

  EditableDocument.storage = null;
  EditableDocument.create = statics.createEditableDocument;
  EditableDocument.load = statics.loadEditableDocument;
  EditableDocument.save = statics.saveEditableDocument;
  /* harmony default export */

  __webpack_exports__["a"] = EditableDocument;
  /***/
},
/* 18 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__Units__ = __webpack_require__(19);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__CompoundUnit__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__Multiple__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__Dimension__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__UnitSchemes__ = __webpack_require__(9);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__Units__["a"];
  });
  /* unused harmony reexport CompoundUnit */

  /* unused harmony reexport Dimension */

  /* unused harmony reexport Multiple */

  /* unused harmony reexport UnitSchemes */

  /***/

},
/* 19 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__CompoundUnit__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__Multiple__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__Dimension__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__UnitSchemes__ = __webpack_require__(9);

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  /*********************************************
    Units table.
  *********************************************/


  function isStringOrUnit(obj) {
    return typeof obj === 'string' || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj.unitsTable;
  }

  var Units = function () {
    function Units(initial) {
      _classCallCheck(this, Units);

      this.units = initial || {};
      this.unitSchemes = new __WEBPACK_IMPORTED_MODULE_4__UnitSchemes__["a"
      /* default */
      ](); // Big units table, including aliases.

      this._bigTable = {};
    }

    _createClass(Units, [{
      key: 'addUnit',
      value: function addUnit(name, relativeTo_x, relativeTo_units, unitSchemes, dimensionName, alternatives) {
        var unit;

        if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isString(relativeTo_x) && typeof relativeTo_units === 'undefined') {
          unit = this._addUnitWithDimension(name, relativeTo_x);
        } else if (typeof relativeTo_x === 'number' && _typeof(isStringOrUnit(relativeTo_units))) {
          unit = this._addUnitRelativeToAnotherUnit(name, relativeTo_x, 1, relativeTo_units);
        } else if (isStringOrUnit(relativeTo_x) && typeof relativeTo_units === 'number') {
          unit = this._addUnitRelativeToAnotherUnit(name, 1, relativeTo_units, relativeTo_x);
        } else if (isStringOrUnit(relativeTo_x) && typeof relativeTo_units === 'undefined') {
          unit = this._addUnitFromExistingUnit(name, relativeTo_x);
        } else {
          throw new Error("UNKNOWN UNIT SYNTAX");
        }

        if (unitSchemes && unitSchemes.length) {
          unit._unitSchemes_user = unitSchemes;
        }

        if (dimensionName) {
          unit.getDimension().shortName = dimensionName;
        }

        this.unitSchemes.addUnit(unit);

        if (alternatives) {
          this.addUnitAliases(unit, alternatives);
        }

        this._bigTable[name] = unit;
        return unit;
      }
    }, {
      key: 'addUnitAliases',
      value: function addUnitAliases(unit, aliases) {
        if (aliases.length === 0) {
          return;
        }

        var t = this._bigTable;

        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(aliases, function (n) {
          t[n] = unit;
        });

        var shortName = unit.name,
            singular = aliases[0] || unit.singular || shortName,
            plural = aliases[1] || unit.plural || singular;
        unit.singular = singular;
        unit.plural = plural;
        unit.alternatives = aliases;
      }
    }, {
      key: 'addUnitSchemes',
      value: function addUnitSchemes(unit, schemes) {
        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(schemes, function (scheme) {
          unit.addUnitScheme(scheme);
        });

        this.unitSchemes.addUnit(unit, schemes);
      }
    }, {
      key: '_addUnitWithDimension',
      value: function _addUnitWithDimension(name, dimension) {
        this.units[name] = new __WEBPACK_IMPORTED_MODULE_1__CompoundUnit__["a"
        /* default */
        ](this, name, new __WEBPACK_IMPORTED_MODULE_3__Dimension__["a"
        /* default */
        ](dimension));
        return this.units[name];
      }
    }, {
      key: '_addUnitRelativeToAnotherUnit',
      value: function _addUnitRelativeToAnotherUnit(name, t, b, other) {
        var self = this;

        if (typeof other === 'string') {
          other = this.getUnit(other);
        }

        var unit = new __WEBPACK_IMPORTED_MODULE_1__CompoundUnit__["a"
        /* default */
        ](this, name, other.getDimension());

        if (other.name) {
          var src = unit.multiples || (unit.multiples = __WEBPACK_IMPORTED_MODULE_2__Multiple__["a"
          /* default */
          ].container(name)),
              dst = other.multiples || (other.multiples = __WEBPACK_IMPORTED_MODULE_2__Multiple__["a"
          /* default */
          ].container(other.name));

          __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(dst, function (i, k) {
            var target = dst[k];
            src[k] = new __WEBPACK_IMPORTED_MODULE_2__Multiple__["a"
            /* default */
            ](target.top * t, target.bottom * b); // this.multiples[name] || (this.multiples[name] = new Multiple());

            var existingUnit = self.getUnit(k),
                multiple = existingUnit.multiples[name] || (existingUnit.multiples[name] = new __WEBPACK_IMPORTED_MODULE_2__Multiple__["a"
            /* default */
            ]());
            multiple.set(b * target.bottom, t * target.top);
          });
        }

        if (other.baseUnit) {
          unit.baseUnit = other.baseUnit;
          unit.baseMultiple = new __WEBPACK_IMPORTED_MODULE_2__Multiple__["a"
          /* default */
          ](other.baseMultiple.top * t, other.baseMultiple.bottom * b);
        } else if (!unit.getDimension().isSimple()) {
          unit.baseUnit = other;
          unit.baseMultiple = new __WEBPACK_IMPORTED_MODULE_2__Multiple__["a"
          /* default */
          ](t, b);
        }

        unit.definitionMultiple = new __WEBPACK_IMPORTED_MODULE_2__Multiple__["a"
        /* default */
        ](t, b);
        unit.definitionUnit = other; // Given no other details, we should be able to use this to work out our unit scheme.

        unit._unitSchemes = other.getUnitSchemes();
        this.units[name] = unit;
        return unit;
      }
    }, {
      key: '_addUnitFromExistingUnit',
      value: function _addUnitFromExistingUnit(name, unit) {
        unit.name = name;
        this.units[name] = unit;
        return unit;
      }
    }, {
      key: 'createUnitScheme',
      value: function createUnitScheme(unitSchemeName, units) {
        var self = this;

        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(units, function (unit) {
          if (typeof unit === "string") {
            unit = self.units[unit];
          }

          if (unit && unit.addUnitScheme) {
            unit.addUnitScheme(unitSchemeName);
          }
        });

        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(self.units, function (i, key) {
          var unit = self.units[key];
          delete unit._unitSchemes;
        }); // we'll generate it on demand,
        // but destroy the cache if we change anything.

      }
    }, {
      key: 'getUnit',
      value: function getUnit(name) {
        return this._bigTable[name];
      }
    }, {
      key: 'getUnitNames',
      value: function getUnitNames() {
        return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.keys(this.units);
      }
    }, {
      key: 'getDimension',
      value: function getDimension(name) {
        // TODO this should return the Dimension object.
        return this.getUnit(name).getDimension();
      }
    }, {
      key: 'convert',
      value: function convert(num, src, dest) {
        // TODO this should check for getUnit being falsey.
        var srcUnit = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isString(src) ? this.getUnit(src) : src,
            dstUnit = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isString(dest) ? this.getUnit(dest) : dest;

        if (srcUnit && dstUnit) {
          return srcUnit.convert(num, dstUnit);
        }

        console.error("Cannot find " + src + " unit");
        throw new Error("Cannot find " + src + " unit");
      }
    }]);

    return Units;
  }();
  /* harmony default export */


  __webpack_exports__["a"] = Units;
  /***/
},
/* 20 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__Parser__ = __webpack_require__(21);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__Parser__["a"];
  });
  /***/

},
/* 21 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__grammar__ = __webpack_require__(22);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__grammar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__grammar__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__symbols__ = __webpack_require__(10);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__operators__ = __webpack_require__(4);

  var DEFAULT_PREFS = {
    unitScheme: undefined,
    useUnitRefactor: true,
    simpleUnits: true,
    precisionType: undefined,
    // sf or dp
    precisionDigits: 4,
    formatComma: undefined,
    formatDot: "."
  }; // prefs should be accessible from outside of the parser, e.g. someplace like turo.js

  function TuroParser(scope) {
    var prefs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.defaults({}, DEFAULT_PREFS);
    this.parseContext = {
      scope: scope || __WEBPACK_IMPORTED_MODULE_2__symbols__["a"
      /* Scope */
      ].newScope()
    };
    this.operators = Object(__WEBPACK_IMPORTED_MODULE_3__operators__["a"
    /* createDefaultOperators */
    ])(prefs);
  }

  __WEBPACK_IMPORTED_MODULE_1__grammar___default.a._parse = __WEBPACK_IMPORTED_MODULE_1__grammar___default.a.parse;
  TuroParser.prototype = __WEBPACK_IMPORTED_MODULE_1__grammar___default.a;

  __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.extend(TuroParser.prototype, {
    parse: function parse(node) {
      var startRule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "PaddedStatement";
      var options = startRule ? {
        startRule: startRule
      } : {};
      return this._parse(node, options);
    },
    reset: function reset() {
      this.parseContext.scope = this.parseContext.scope.fresh();
    }
  });

  Object.defineProperties(TuroParser.prototype, {
    scope: {
      set: function set(scope) {
        this.parseContext.scope = scope;
      },
      get: function get() {
        return this.parseContext.scope;
      }
    }
  });
  /* harmony default export */

  __webpack_exports__["a"] = TuroParser;
  /***/
},
/* 22 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*
   * Generated by PEG.js 0.10.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() {
      this.constructor = child;
    }

    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message = message;
    this.expected = expected;
    this.found = found;
    this.location = location;
    this.name = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  peg$SyntaxError.buildMessage = function (expected, found) {
    var DESCRIBE_EXPECTATION_FNS = {
      literal: function literal(expectation) {
        return "\"" + literalEscape(expectation.text) + "\"";
      },
      "class": function _class(expectation) {
        var escapedParts = "",
            i;

        for (i = 0; i < expectation.parts.length; i++) {
          escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
        }

        return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
      },
      any: function any(expectation) {
        return "any character";
      },
      end: function end(expectation) {
        return "end of input";
      },
      other: function other(expectation) {
        return expectation.description;
      }
    };

    function hex(ch) {
      return ch.charCodeAt(0).toString(16).toUpperCase();
    }

    function literalEscape(s) {
      return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
        return '\\x0' + hex(ch);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
        return '\\x' + hex(ch);
      });
    }

    function classEscape(s) {
      return s.replace(/\\/g, '\\\\').replace(/\]/g, '\\]').replace(/\^/g, '\\^').replace(/-/g, '\\-').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
        return '\\x0' + hex(ch);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
        return '\\x' + hex(ch);
      });
    }

    function describeExpectation(expectation) {
      return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
    }

    function describeExpected(expected) {
      var descriptions = new Array(expected.length),
          i,
          j;

      for (i = 0; i < expected.length; i++) {
        descriptions[i] = describeExpectation(expected[i]);
      }

      descriptions.sort();

      if (descriptions.length > 0) {
        for (i = 1, j = 1; i < descriptions.length; i++) {
          if (descriptions[i - 1] !== descriptions[i]) {
            descriptions[j] = descriptions[i];
            j++;
          }
        }

        descriptions.length = j;
      }

      switch (descriptions.length) {
        case 1:
          return descriptions[0];

        case 2:
          return descriptions[0] + " or " + descriptions[1];

        default:
          return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
      }
    }

    function describeFound(found) {
      return found ? "\"" + literalEscape(found) + "\"" : "end of input";
    }

    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
  };

  function peg$parse(input, options) {
    options = options !== void 0 ? options : {};

    var peg$FAILED = {},
        peg$startRuleFunctions = _defineProperty({
      DocumentFirstParse: peg$parseDocumentFirstParse,
      EditorText: peg$parseEditorText,
      Statement: peg$parseStatement,
      NumberLiteral: peg$parseNumberLiteral,
      PaddedStatement: peg$parsePaddedStatement
    }, "EditorText", peg$parseEditorText),
        peg$startRuleFunction = peg$parseDocumentFirstParse,
        peg$c0 = function peg$c0(list) {
      var statements = [];

      for (var i = 0, max = list.length; i < max; i += 2) {
        if (list[i][0]) {
          statements.push(list[i][0]);
        }
      }

      return new ast.StatementNode("StatementList", statements);
    },
        peg$c1 = ";",
        peg$c2 = peg$literalExpectation(";", false),
        peg$c3 = function peg$c3(lines) {
      return new ast.EditorLinesNode(lines);
    },
        peg$c4 = function peg$c4(node, lineEnd) {
      var _location$start = location().start,
          offset = _location$start.offset,
          line = _location$start.line;
      return helper.decorateStatement(node, line, offset, lineEnd);
    },
        peg$c5 = function peg$c5(lineEnd) {
      var _location$start2 = location().start,
          offset = _location$start2.offset,
          line = _location$start2.line;
      return helper.decorateStatement(null, line, offset, lineEnd);
    },
        peg$c6 = function peg$c6(node, lineEnd) {
      var _location$start3 = location().start,
          offset = _location$start3.offset,
          line = _location$start3.line;
      return helper.decorateStatement(node, line, offset, lineEnd);
    },
        peg$c7 = function peg$c7(lineEnd) {
      var _location$start4 = location().start,
          offset = _location$start4.offset,
          line = _location$start4.line;
      return helper.decorateStatement(null, line, offset, lineEnd);
    },
        peg$c8 = "unit",
        peg$c9 = peg$literalExpectation("unit", false),
        peg$c10 = function peg$c10(unit, colon) {
      // unit = { id, alternatives, schemes }
      if (colon) {
        // Brand new unit
        parseContext.scope.addUnit(unit, unit.id, unit.alternatives);
      } else {
        // New alternative names for an existing unit
        parseContext.scope.addUnit(unit, null, unit.alternatives);
      }
    },
        peg$c11 = "const",
        peg$c12 = peg$literalExpectation("const", false),
        peg$c13 = function peg$c13(id) {
      parseContext.scope.addVariable(id, {});
    },
        peg$c14 = /^[^\r\n]/,
        peg$c15 = peg$classExpectation(["\r", "\n"], true, false),
        peg$c16 = function peg$c16(text, eol) {
      return {
        text: (text || []).join(''),
        offsetLast: eol[0],
        lineLast: eol[1]
      };
    },
        peg$c17 = /^[\r\n]/,
        peg$c18 = peg$classExpectation(["\r", "\n"], false, false),
        peg$c19 = function peg$c19() {
      var _location$start5 = location().start,
          offset = _location$start5.offset,
          line = _location$start5.line;
      return [offset, line];
    },
        peg$c20 = function peg$c20(node) {
      return node;
    },
        peg$c21 = function peg$c21(node) {
      node.scope = parseContext.scope;
      return node;
    },
        peg$c22 = function peg$c22(unit) {
      return new ast.StatementNode("UnitDefinition", unit);
    },
        peg$c23 = function peg$c23(unit) {
      parseContext.scope.addUnit(unit, unit.name, unit.alternatives);
      return unit;
    },
        peg$c24 = function peg$c24(unit) {
      return unit;
    },
        peg$c25 = function peg$c25(unitNode, alternatives, schemes) {
      // Unsure if this the right thing to do: 
      // allow both alternatives and schemes to be optional.
      if (schemes) {
        units.addUnitSchemes(unitNode.unit, schemes);
      }

      if (alternatives.length) {
        units.addUnitAliases(unitNode.unit, alternatives);
        parseContext.scope.addUnit(unitNode.unit, null, alternatives);
      }

      return unitNode.unit;
    },
        peg$c26 = function peg$c26(id, dimension, num, unitNode) {
      return units.addUnit(id.id, num || 1.0, unitNode.unit, id.schemes, dimension, id.alternatives);
    },
        peg$c27 = function peg$c27(id, dimension) {
      return units.addUnit(id.id, dimension, undefined, id.schemes, undefined, id.alternatives);
    },
        peg$c28 = function peg$c28(num, id, dimension, unitNode) {
      return units.addUnit(id.id, unitNode.unit, num, id.schemes, dimension, id.alternatives);
    },
        peg$c29 = ":",
        peg$c30 = peg$literalExpectation(":", false),
        peg$c31 = function peg$c31(ids, schemes) {
      return {
        id: ids[0],
        alternatives: ids[1],
        schemes: schemes
      };
    },
        peg$c32 = function peg$c32(unitName, alternatives) {
      return [unitName, alternatives];
    },
        peg$c33 = function peg$c33(alternatives) {
      var alts = [];

      for (var i = 0, max = alternatives.length; i < max; i++) {
        alts.push(alternatives[i][1]);
      }

      return alts;
    },
        peg$c34 = function peg$c34(schemeLiterals) {
      if (!schemeLiterals.length) {
        return;
      }

      var schemes = [];

      for (var i = 0, max = schemeLiterals.length; i < max; i++) {
        schemes.push(schemeLiterals[i][1]);
      }

      return schemes;
    },
        peg$c35 = ",",
        peg$c36 = peg$literalExpectation(",", false),
        peg$c37 = function peg$c37(dimension) {
      return dimension;
    },
        peg$c38 = peg$otherExpectation("dimensionName"),
        peg$c39 = peg$otherExpectation("newUnitName"),
        peg$c40 = peg$otherExpectation("unitScheme"),
        peg$c41 = function peg$c41(optionalPer, head, tail) {
      var _location$start6 = location().start,
          offset = _location$start6.offset,
          line = _location$start6.line;
      var unitNode = head,
          op;

      for (var i = 0; i < tail.length; i++) {
        op = tail[i][0];
        unitNode = new ast.UnitMultOp(helper.infixAliases[op.opName] || op.opName, unitNode, tail[i][1]);
        helper.decorateNonTerminal(unitNode, op.line, op.offset, op.literal);
      }

      op = optionalPer ? optionalPer[0] : optionalPer;

      if (op) {
        unitNode = new ast.UnitMultOp('/', null, unitNode);
        unitNode._offsetFirst = offset;
        helper.decorateNonTerminal(unitNode, op.line, op.offset, op.literal);
      }

      return unitNode;
    },
        peg$c42 = function peg$c42(op) {
      return op;
    },
        peg$c43 = function peg$c43(space) {
      var _location$start7 = location().start,
          offset = _location$start7.offset,
          line = _location$start7.line;
      return {
        offset: offset,
        line: line,
        literal: space,
        opName: '*'
      };
    },
        peg$c44 = peg$otherExpectation("unitPer"),
        peg$c45 = function peg$c45(literal) {
      var _location$start8 = location().start,
          offset = _location$start8.offset,
          line = _location$start8.line;
      return {
        offset: offset,
        line: line,
        literal: literal,
        opName: '/'
      };
    },
        peg$c46 = "per",
        peg$c47 = peg$literalExpectation("per", false),
        peg$c48 = "/",
        peg$c49 = peg$literalExpectation("/", false),
        peg$c50 = function peg$c50(unitNode, op, num) {
      var node = new ast.UnitPowerNode(unitNode, num);
      return helper.decorateNonTerminal(node, op.line, op.offset, op.literal);
    },
        peg$c51 = function peg$c51(unitNode) {
      return unitNode;
    },
        peg$c52 = peg$otherExpectation("unitPower"),
        peg$c53 = function peg$c53(literal) {
      var _location$start9 = location().start,
          offset = _location$start9.offset,
          line = _location$start9.line;
      return {
        literal: literal,
        offset: offset,
        line: line
      };
    },
        peg$c54 = "^",
        peg$c55 = peg$literalExpectation("^", false),
        peg$c56 = "**",
        peg$c57 = peg$literalExpectation("**", false),
        peg$c58 = function peg$c58() {
      return "^";
    },
        peg$c59 = peg$otherExpectation("unit"),
        peg$c60 = function peg$c60(unitName) {
      return !!parseContext.scope.findUnit(unitName);
    },
        peg$c61 = function peg$c61(unitName) {
      var node = new ast.UnitLiteralNode(parseContext.scope.findUnit(unitName), unitName);
      var _location$start10 = location().start,
          offset = _location$start10.offset,
          line = _location$start10.line;
      return helper.decorateTerminal(node, line, offset, unitName);
    },
        peg$c62 = "import",
        peg$c63 = peg$literalExpectation("import", false),
        peg$c64 = function peg$c64(filename) {
      return new ast.StatementNode("Import", filename);
    },
        peg$c65 = "\"",
        peg$c66 = peg$literalExpectation("\"", false),
        peg$c67 = /^[^"]/,
        peg$c68 = peg$classExpectation(["\""], true, false),
        peg$c69 = function peg$c69(string) {
      return (string || []).join("");
    },
        peg$c70 = function peg$c70(variable) {
      variable.isConstant = true;
      return variable;
    },
        peg$c71 = function peg$c71(identifier, definition) {
      return parseContext.scope.addVariable(identifier, new ast.VariableDefinition(identifier, definition));
    },
        peg$c72 = peg$otherExpectation("assignment"),
        peg$c73 = "=",
        peg$c74 = peg$literalExpectation("=", false),
        peg$c75 = function peg$c75(lhs, operation) {
      if (operation) {
        return new ast.BinaryNode(lhs, operation[3], operation[1]);
      }

      return lhs;
    },
        peg$c76 = peg$otherExpectation("comparator"),
        peg$c77 = "!=",
        peg$c78 = peg$literalExpectation("!=", false),
        peg$c79 = "<=",
        peg$c80 = peg$literalExpectation("<=", false),
        peg$c81 = "==",
        peg$c82 = peg$literalExpectation("==", false),
        peg$c83 = ">=",
        peg$c84 = peg$literalExpectation(">=", false),
        peg$c85 = "<",
        peg$c86 = peg$literalExpectation("<", false),
        peg$c87 = ">",
        peg$c88 = peg$literalExpectation(">", false),
        peg$c89 = function peg$c89(node, unitConversion) {
      if (unitConversion) {
        var op = unitConversion[0],
            unitNode = unitConversion[1];
        node = new ast.BinaryNode(node, unitNode, op.literal);
        helper.decorateNonTerminal(node, op.line, op.offset, op.literal);
      }

      return node;
    },
        peg$c90 = function peg$c90(op, unitNode) {
      return [op, unitNode];
    },
        peg$c91 = peg$otherExpectation("unitIn"),
        peg$c92 = "in",
        peg$c93 = peg$literalExpectation("in", false),
        peg$c94 = function peg$c94() {
      var _location$start11 = location().start,
          offset = _location$start11.offset,
          line = _location$start11.line;
      return {
        literal: 'in',
        offset: offset
      };
    },
        peg$c95 = function peg$c95(head, tail) {
      return helper.unpackLeftBinaryOperations(head, tail);
    },
        peg$c96 = function peg$c96(literal) {
      var _location$start12 = location().start,
          offset = _location$start12.offset,
          line = _location$start12.line;
      return {
        literal: literal,
        offset: offset
      };
    },
        peg$c97 = peg$otherExpectation("plusMinus"),
        peg$c98 = "+",
        peg$c99 = peg$literalExpectation("+", false),
        peg$c100 = "-",
        peg$c101 = peg$literalExpectation("-", false),
        peg$c102 = "||",
        peg$c103 = peg$literalExpectation("||", false),
        peg$c104 = peg$otherExpectation("multiplyDivide"),
        peg$c105 = function peg$c105(literal) {
      var _location$start13 = location().start,
          offset = _location$start13.offset,
          line = _location$start13.line;

      if (typeof literal !== 'string') {
        literal = literal[0];
      }

      return {
        literal: literal,
        offset: offset
      };
    },
        peg$c106 = "*",
        peg$c107 = peg$literalExpectation("*", false),
        peg$c108 = "\xD7",
        peg$c109 = peg$literalExpectation("\xD7", false),
        peg$c110 = "\xF7",
        peg$c111 = peg$literalExpectation("\xF7", false),
        peg$c112 = "&&",
        peg$c113 = peg$literalExpectation("&&", false),
        peg$c114 = "at",
        peg$c115 = peg$literalExpectation("at", false),
        peg$c116 = "of",
        peg$c117 = peg$literalExpectation("of", false),
        peg$c118 = "by",
        peg$c119 = peg$literalExpectation("by", false),
        peg$c120 = "every",
        peg$c121 = peg$literalExpectation("every", false),
        peg$c122 = function peg$c122(node, unitNode) {
      if (unitNode) {
        node.unitLiteral = unitNode.unit;
        node.unitNode = unitNode;
        unitNode.valueNode = node;
        delete node._offsetLast;
      }

      return node;
    },
        peg$c123 = function peg$c123(prefixes, operand) {
      return helper.unpackUnaryOperations(operand, prefixes, true);
    },
        peg$c124 = function peg$c124(head, tail) {
      return helper.unpackRightBinaryOperations(head, tail);
    },
        peg$c125 = peg$otherExpectation("infixOp"),
        peg$c126 = function peg$c126(literal) {
      var _location$start14 = location().start,
          offset = _location$start14.offset,
          line = _location$start14.line;
      return {
        literal: literal,
        offset: offset
      };
    },
        peg$c127 = function peg$c127(operator) {
      return operators && operators.hasInfixOperator(operator);
    },
        peg$c128 = function peg$c128(operator) {
      return operator;
    },
        peg$c129 = "\u221A",
        peg$c130 = peg$literalExpectation("\u221A", false),
        peg$c131 = function peg$c131(prefixes, value) {
      value = helper.unpackUnaryOperations(value, prefixes, true); //UnaryOperationNode

      return value;
    },
        peg$c132 = peg$otherExpectation("prefixOp"),
        peg$c133 = function peg$c133(literal) {
      var _location$start15 = location().start,
          offset = _location$start15.offset,
          line = _location$start15.line;
      return {
        literal: literal,
        offset: offset
      };
    },
        peg$c134 = "sqrt",
        peg$c135 = peg$literalExpectation("sqrt", false),
        peg$c136 = "!",
        peg$c137 = peg$literalExpectation("!", false),
        peg$c138 = function peg$c138() {
      return "!";
    },
        peg$c139 = function peg$c139(literal) {
      return operators && operators.hasPrefixOperator(literal);
    },
        peg$c140 = function peg$c140(literal) {
      return literal;
    },
        peg$c141 = function peg$c141(value, postfixes) {
      value = helper.unpackUnaryOperations(value, postfixes, false); //UnaryOperationNode

      return value;
    },
        peg$c142 = peg$otherExpectation("postfixOp"),
        peg$c143 = function peg$c143() {
      return "!";
    },
        peg$c144 = "%",
        peg$c145 = peg$literalExpectation("%", false),
        peg$c146 = function peg$c146(literal) {
      return operators && operators.hasPostfixOperator(literal);
    },
        peg$c147 = function peg$c147(t) {
      var _location$start16 = location().start,
          offset = _location$start16.offset,
          line = _location$start16.line;
      return helper.decorateTerminal(t, line, offset, t.literal || t.name);
    },
        peg$c148 = function peg$c148(po, expression, pc) {
      var _location$start17 = location().start,
          offset = _location$start17.offset,
          line = _location$start17.line;
      var parens = new ast.ParensNode(expression);
      parens.inBrackets = true;
      expression._og_offsetFirst = expression.offsetFirst;
      expression._og_offsetLast = expression.offsetLast;
      parens._offsetFirst = offset;
      parens._offsetLast = pc.offset;
      parens.isMissingParensClose = pc.offset >= inputLength;
      return parens;
    },
        peg$c149 = peg$otherExpectation("parensOpen"),
        peg$c150 = "(",
        peg$c151 = peg$literalExpectation("(", false),
        peg$c152 = peg$otherExpectation("parensClose"),
        peg$c153 = ")",
        peg$c154 = peg$literalExpectation(")", false),
        peg$c155 = function peg$c155() {
      var _location$start18 = location().start,
          offset = _location$start18.offset,
          line = _location$start18.line;
      return {
        offset: offset
      };
    },
        peg$c156 = peg$otherExpectation("variable"),
        peg$c157 = function peg$c157(identifier) {
      return parseContext.scope.findVariable(identifier);
    },
        peg$c158 = function peg$c158(identifier) {
      return new ast.IdentifierNode(identifier, parseContext.scope);
    },
        peg$c159 = "\uFDFC",
        peg$c160 = peg$literalExpectation("\uFDFC", false),
        peg$c161 = "\u20A1",
        peg$c162 = peg$literalExpectation("\u20A1", false),
        peg$c163 = "\u20AE",
        peg$c164 = peg$literalExpectation("\u20AE", false),
        peg$c165 = "\u20A6",
        peg$c166 = peg$literalExpectation("\u20A6", false),
        peg$c167 = "$",
        peg$c168 = peg$literalExpectation("$", false),
        peg$c169 = "\xA3",
        peg$c170 = peg$literalExpectation("\xA3", false),
        peg$c171 = "\u20B9",
        peg$c172 = peg$literalExpectation("\u20B9", false),
        peg$c173 = "\xA5",
        peg$c174 = peg$literalExpectation("\xA5", false),
        peg$c175 = "\u20AD",
        peg$c176 = peg$literalExpectation("\u20AD", false),
        peg$c177 = "\u0192",
        peg$c178 = peg$literalExpectation("\u0192", false),
        peg$c179 = "\u20A9",
        peg$c180 = peg$literalExpectation("\u20A9", false),
        peg$c181 = "\u20A8",
        peg$c182 = peg$literalExpectation("\u20A8", false),
        peg$c183 = "\u20AC",
        peg$c184 = peg$literalExpectation("\u20AC", false),
        peg$c185 = "\u20AA",
        peg$c186 = peg$literalExpectation("\u20AA", false),
        peg$c187 = "\u20B1",
        peg$c188 = peg$literalExpectation("\u20B1", false),
        peg$c189 = "\u0E3F",
        peg$c190 = peg$literalExpectation("\u0E3F", false),
        peg$c191 = "\u060B",
        peg$c192 = peg$literalExpectation("\u060B", false),
        peg$c193 = "\u17DB",
        peg$c194 = peg$literalExpectation("\u17DB", false),
        peg$c195 = "\u20AB",
        peg$c196 = peg$literalExpectation("\u20AB", false),
        peg$c197 = "\u20B4",
        peg$c198 = peg$literalExpectation("\u20B4", false),
        peg$c199 = peg$otherExpectation("identifier"),
        peg$c200 = function peg$c200(head, tail) {
      return head + (tail || []).join("");
    },
        peg$c201 = function peg$c201(number) {
      var node = new ast.NumberNode(number.literal);
      node.exponent = number.exponent;
      node.integerPart = number.integerPart;
      node.sign = number.sign;
      return node;
    },
        peg$c202 = function peg$c202(numberObj) {
      return parseFloat(numberObj.literal, 10);
    },
        peg$c203 = function peg$c203(sign, valueNode, exp) {
      valueNode.exponent = exp;
      valueNode.number = valueNode.literal;
      valueNode.sign = sign;
      var literal = (sign ? sign : '') + valueNode.literal;

      if (exp) {
        literal += 'e' + exp;
      }

      valueNode.literal = literal;
      return valueNode;
    },
        peg$c204 = function peg$c204(whole, decimal) {
      return {
        mantissa: decimal,
        integerPart: whole,
        literal: whole + (decimal ? decimal : '')
      };
    },
        peg$c205 = function peg$c205(decimal) {
      return {
        mantissa: decimal,
        integerPart: '0',
        literal: decimal
      };
    },
        peg$c206 = function peg$c206(digits) {
      return digits;
    },
        peg$c207 = peg$otherExpectation("digits"),
        peg$c208 = /^[0-9]/,
        peg$c209 = peg$classExpectation([["0", "9"]], false, false),
        peg$c210 = function peg$c210(digits) {
      // this is helpful for knowing if we have EOF e.g. keyboard, autocomplete
      var _location$start19 = location().start,
          offset = _location$start19.offset,
          line = _location$start19.line;
      self.lastDigitOffset = offset + digits.length;
      return (digits || []).join("");
    },
        peg$c211 = function peg$c211(digits) {
      return "." + digits;
    },
        peg$c212 = peg$otherExpectation("point"),
        peg$c213 = ".",
        peg$c214 = peg$literalExpectation(".", false),
        peg$c215 = function peg$c215(integer) {
      return integer;
    },
        peg$c216 = peg$otherExpectation("exponent"),
        peg$c217 = "e",
        peg$c218 = peg$literalExpectation("e", false),
        peg$c219 = "E",
        peg$c220 = peg$literalExpectation("E", false),
        peg$c221 = function peg$c221(number) {
      var node = new ast.NumberNode(number);
      var _location$start20 = location().start,
          offset = _location$start20.offset,
          line = _location$start20.line;
      return helper.decorateTerminal(node, line, offset, number);
    },
        peg$c222 = function peg$c222(string) {
      return parseInt(string, 10);
    },
        peg$c223 = function peg$c223(sign, digits) {
      return (sign ? sign : '') + digits;
    },
        peg$c224 = "test",
        peg$c225 = peg$literalExpectation("test", false),
        peg$c226 = "include",
        peg$c227 = peg$literalExpectation("include", false),
        peg$c228 = "units",
        peg$c229 = peg$literalExpectation("units", false),
        peg$c230 = "let",
        peg$c231 = peg$literalExpectation("let", false),
        peg$c232 = peg$otherExpectation("some whitespace"),
        peg$c233 = /^[ \t\xA0]/,
        peg$c234 = peg$classExpectation([" ", "\t", "\xA0"], false, false),
        peg$c235 = /^[ \t]/,
        peg$c236 = peg$classExpectation([" ", "\t"], false, false),
        peg$c237 = "//",
        peg$c238 = peg$literalExpectation("//", false),
        peg$c239 = /^[^\n]/,
        peg$c240 = peg$classExpectation(["\n"], true, false),
        peg$c241 = peg$otherExpectation("whitespace"),
        peg$c242 = "_",
        peg$c243 = peg$literalExpectation("_", false),
        peg$c244 = "\\",
        peg$c245 = peg$literalExpectation("\\", false),
        peg$c246 = function peg$c246(sequence) {
      return sequence;
    },
        peg$c247 = "\u200C",
        peg$c248 = peg$literalExpectation("\u200C", false),
        peg$c249 = "\u200D",
        peg$c250 = peg$literalExpectation("\u200D", false),
        peg$c251 = "u",
        peg$c252 = peg$literalExpectation("u", false),
        peg$c253 = function peg$c253(digits) {
      digits = (digits || []).join('');
      return String.fromCharCode(parseInt(digits, 16));
    },
        peg$c254 = /^[0-9a-f]/i,
        peg$c255 = peg$classExpectation([["0", "9"], ["a", "f"]], false, true),
        peg$c256 = /^[a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137-\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148-\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C-\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA-\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9-\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC-\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF-\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F-\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0-\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB-\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE-\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0561-\u0587\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6-\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FC7\u1FD0-\u1FD3\u1FD6-\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6-\u1FF7\u210A\u210E-\u210F\u2113\u212F\u2134\u2139\u213C-\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65-\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73-\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3-\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7FA\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A]/,
        peg$c257 = peg$classExpectation([["a", "z"], "\xB5", ["\xDF", "\xF6"], ["\xF8", "\xFF"], "\u0101", "\u0103", "\u0105", "\u0107", "\u0109", "\u010B", "\u010D", "\u010F", "\u0111", "\u0113", "\u0115", "\u0117", "\u0119", "\u011B", "\u011D", "\u011F", "\u0121", "\u0123", "\u0125", "\u0127", "\u0129", "\u012B", "\u012D", "\u012F", "\u0131", "\u0133", "\u0135", ["\u0137", "\u0138"], "\u013A", "\u013C", "\u013E", "\u0140", "\u0142", "\u0144", "\u0146", ["\u0148", "\u0149"], "\u014B", "\u014D", "\u014F", "\u0151", "\u0153", "\u0155", "\u0157", "\u0159", "\u015B", "\u015D", "\u015F", "\u0161", "\u0163", "\u0165", "\u0167", "\u0169", "\u016B", "\u016D", "\u016F", "\u0171", "\u0173", "\u0175", "\u0177", "\u017A", "\u017C", ["\u017E", "\u0180"], "\u0183", "\u0185", "\u0188", ["\u018C", "\u018D"], "\u0192", "\u0195", ["\u0199", "\u019B"], "\u019E", "\u01A1", "\u01A3", "\u01A5", "\u01A8", ["\u01AA", "\u01AB"], "\u01AD", "\u01B0", "\u01B4", "\u01B6", ["\u01B9", "\u01BA"], ["\u01BD", "\u01BF"], "\u01C6", "\u01C9", "\u01CC", "\u01CE", "\u01D0", "\u01D2", "\u01D4", "\u01D6", "\u01D8", "\u01DA", ["\u01DC", "\u01DD"], "\u01DF", "\u01E1", "\u01E3", "\u01E5", "\u01E7", "\u01E9", "\u01EB", "\u01ED", ["\u01EF", "\u01F0"], "\u01F3", "\u01F5", "\u01F9", "\u01FB", "\u01FD", "\u01FF", "\u0201", "\u0203", "\u0205", "\u0207", "\u0209", "\u020B", "\u020D", "\u020F", "\u0211", "\u0213", "\u0215", "\u0217", "\u0219", "\u021B", "\u021D", "\u021F", "\u0221", "\u0223", "\u0225", "\u0227", "\u0229", "\u022B", "\u022D", "\u022F", "\u0231", ["\u0233", "\u0239"], "\u023C", ["\u023F", "\u0240"], "\u0242", "\u0247", "\u0249", "\u024B", "\u024D", ["\u024F", "\u0293"], ["\u0295", "\u02AF"], "\u0371", "\u0373", "\u0377", ["\u037B", "\u037D"], "\u0390", ["\u03AC", "\u03CE"], ["\u03D0", "\u03D1"], ["\u03D5", "\u03D7"], "\u03D9", "\u03DB", "\u03DD", "\u03DF", "\u03E1", "\u03E3", "\u03E5", "\u03E7", "\u03E9", "\u03EB", "\u03ED", ["\u03EF", "\u03F3"], "\u03F5", "\u03F8", ["\u03FB", "\u03FC"], ["\u0430", "\u045F"], "\u0461", "\u0463", "\u0465", "\u0467", "\u0469", "\u046B", "\u046D", "\u046F", "\u0471", "\u0473", "\u0475", "\u0477", "\u0479", "\u047B", "\u047D", "\u047F", "\u0481", "\u048B", "\u048D", "\u048F", "\u0491", "\u0493", "\u0495", "\u0497", "\u0499", "\u049B", "\u049D", "\u049F", "\u04A1", "\u04A3", "\u04A5", "\u04A7", "\u04A9", "\u04AB", "\u04AD", "\u04AF", "\u04B1", "\u04B3", "\u04B5", "\u04B7", "\u04B9", "\u04BB", "\u04BD", "\u04BF", "\u04C2", "\u04C4", "\u04C6", "\u04C8", "\u04CA", "\u04CC", ["\u04CE", "\u04CF"], "\u04D1", "\u04D3", "\u04D5", "\u04D7", "\u04D9", "\u04DB", "\u04DD", "\u04DF", "\u04E1", "\u04E3", "\u04E5", "\u04E7", "\u04E9", "\u04EB", "\u04ED", "\u04EF", "\u04F1", "\u04F3", "\u04F5", "\u04F7", "\u04F9", "\u04FB", "\u04FD", "\u04FF", "\u0501", "\u0503", "\u0505", "\u0507", "\u0509", "\u050B", "\u050D", "\u050F", "\u0511", "\u0513", "\u0515", "\u0517", "\u0519", "\u051B", "\u051D", "\u051F", "\u0521", "\u0523", "\u0525", "\u0527", ["\u0561", "\u0587"], ["\u1D00", "\u1D2B"], ["\u1D6B", "\u1D77"], ["\u1D79", "\u1D9A"], "\u1E01", "\u1E03", "\u1E05", "\u1E07", "\u1E09", "\u1E0B", "\u1E0D", "\u1E0F", "\u1E11", "\u1E13", "\u1E15", "\u1E17", "\u1E19", "\u1E1B", "\u1E1D", "\u1E1F", "\u1E21", "\u1E23", "\u1E25", "\u1E27", "\u1E29", "\u1E2B", "\u1E2D", "\u1E2F", "\u1E31", "\u1E33", "\u1E35", "\u1E37", "\u1E39", "\u1E3B", "\u1E3D", "\u1E3F", "\u1E41", "\u1E43", "\u1E45", "\u1E47", "\u1E49", "\u1E4B", "\u1E4D", "\u1E4F", "\u1E51", "\u1E53", "\u1E55", "\u1E57", "\u1E59", "\u1E5B", "\u1E5D", "\u1E5F", "\u1E61", "\u1E63", "\u1E65", "\u1E67", "\u1E69", "\u1E6B", "\u1E6D", "\u1E6F", "\u1E71", "\u1E73", "\u1E75", "\u1E77", "\u1E79", "\u1E7B", "\u1E7D", "\u1E7F", "\u1E81", "\u1E83", "\u1E85", "\u1E87", "\u1E89", "\u1E8B", "\u1E8D", "\u1E8F", "\u1E91", "\u1E93", ["\u1E95", "\u1E9D"], "\u1E9F", "\u1EA1", "\u1EA3", "\u1EA5", "\u1EA7", "\u1EA9", "\u1EAB", "\u1EAD", "\u1EAF", "\u1EB1", "\u1EB3", "\u1EB5", "\u1EB7", "\u1EB9", "\u1EBB", "\u1EBD", "\u1EBF", "\u1EC1", "\u1EC3", "\u1EC5", "\u1EC7", "\u1EC9", "\u1ECB", "\u1ECD", "\u1ECF", "\u1ED1", "\u1ED3", "\u1ED5", "\u1ED7", "\u1ED9", "\u1EDB", "\u1EDD", "\u1EDF", "\u1EE1", "\u1EE3", "\u1EE5", "\u1EE7", "\u1EE9", "\u1EEB", "\u1EED", "\u1EEF", "\u1EF1", "\u1EF3", "\u1EF5", "\u1EF7", "\u1EF9", "\u1EFB", "\u1EFD", ["\u1EFF", "\u1F07"], ["\u1F10", "\u1F15"], ["\u1F20", "\u1F27"], ["\u1F30", "\u1F37"], ["\u1F40", "\u1F45"], ["\u1F50", "\u1F57"], ["\u1F60", "\u1F67"], ["\u1F70", "\u1F7D"], ["\u1F80", "\u1F87"], ["\u1F90", "\u1F97"], ["\u1FA0", "\u1FA7"], ["\u1FB0", "\u1FB4"], ["\u1FB6", "\u1FB7"], "\u1FBE", ["\u1FC2", "\u1FC4"], ["\u1FC6", "\u1FC7"], ["\u1FD0", "\u1FD3"], ["\u1FD6", "\u1FD7"], ["\u1FE0", "\u1FE7"], ["\u1FF2", "\u1FF4"], ["\u1FF6", "\u1FF7"], "\u210A", ["\u210E", "\u210F"], "\u2113", "\u212F", "\u2134", "\u2139", ["\u213C", "\u213D"], ["\u2146", "\u2149"], "\u214E", "\u2184", ["\u2C30", "\u2C5E"], "\u2C61", ["\u2C65", "\u2C66"], "\u2C68", "\u2C6A", "\u2C6C", "\u2C71", ["\u2C73", "\u2C74"], ["\u2C76", "\u2C7B"], "\u2C81", "\u2C83", "\u2C85", "\u2C87", "\u2C89", "\u2C8B", "\u2C8D", "\u2C8F", "\u2C91", "\u2C93", "\u2C95", "\u2C97", "\u2C99", "\u2C9B", "\u2C9D", "\u2C9F", "\u2CA1", "\u2CA3", "\u2CA5", "\u2CA7", "\u2CA9", "\u2CAB", "\u2CAD", "\u2CAF", "\u2CB1", "\u2CB3", "\u2CB5", "\u2CB7", "\u2CB9", "\u2CBB", "\u2CBD", "\u2CBF", "\u2CC1", "\u2CC3", "\u2CC5", "\u2CC7", "\u2CC9", "\u2CCB", "\u2CCD", "\u2CCF", "\u2CD1", "\u2CD3", "\u2CD5", "\u2CD7", "\u2CD9", "\u2CDB", "\u2CDD", "\u2CDF", "\u2CE1", ["\u2CE3", "\u2CE4"], "\u2CEC", "\u2CEE", "\u2CF3", ["\u2D00", "\u2D25"], "\u2D27", "\u2D2D", "\uA641", "\uA643", "\uA645", "\uA647", "\uA649", "\uA64B", "\uA64D", "\uA64F", "\uA651", "\uA653", "\uA655", "\uA657", "\uA659", "\uA65B", "\uA65D", "\uA65F", "\uA661", "\uA663", "\uA665", "\uA667", "\uA669", "\uA66B", "\uA66D", "\uA681", "\uA683", "\uA685", "\uA687", "\uA689", "\uA68B", "\uA68D", "\uA68F", "\uA691", "\uA693", "\uA695", "\uA697", "\uA723", "\uA725", "\uA727", "\uA729", "\uA72B", "\uA72D", ["\uA72F", "\uA731"], "\uA733", "\uA735", "\uA737", "\uA739", "\uA73B", "\uA73D", "\uA73F", "\uA741", "\uA743", "\uA745", "\uA747", "\uA749", "\uA74B", "\uA74D", "\uA74F", "\uA751", "\uA753", "\uA755", "\uA757", "\uA759", "\uA75B", "\uA75D", "\uA75F", "\uA761", "\uA763", "\uA765", "\uA767", "\uA769", "\uA76B", "\uA76D", "\uA76F", ["\uA771", "\uA778"], "\uA77A", "\uA77C", "\uA77F", "\uA781", "\uA783", "\uA785", "\uA787", "\uA78C", "\uA78E", "\uA791", "\uA793", "\uA7A1", "\uA7A3", "\uA7A5", "\uA7A7", "\uA7A9", "\uA7FA", ["\uFB00", "\uFB06"], ["\uFB13", "\uFB17"], ["\uFF41", "\uFF5A"]], false, false),
        peg$c258 = /^[\u02B0-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0374\u037A\u0559\u0640\u06E5-\u06E6\u07F4-\u07F5\u07FA\u081A\u0824\u0828\u0971\u0E46\u0EC6\u10FC\u17D7\u1843\u1AA7\u1C78-\u1C7D\u1D2C-\u1D6A\u1D78\u1D9B-\u1DBF\u2071\u207F\u2090-\u209C\u2C7C-\u2C7D\u2D6F\u2E2F\u3005\u3031-\u3035\u303B\u309D-\u309E\u30FC-\u30FE\uA015\uA4F8-\uA4FD\uA60C\uA67F\uA717-\uA71F\uA770\uA788\uA7F8-\uA7F9\uA9CF\uAA70\uAADD\uAAF3-\uAAF4\uFF70\uFF9E-\uFF9F]/,
        peg$c259 = peg$classExpectation([["\u02B0", "\u02C1"], ["\u02C6", "\u02D1"], ["\u02E0", "\u02E4"], "\u02EC", "\u02EE", "\u0374", "\u037A", "\u0559", "\u0640", ["\u06E5", "\u06E6"], ["\u07F4", "\u07F5"], "\u07FA", "\u081A", "\u0824", "\u0828", "\u0971", "\u0E46", "\u0EC6", "\u10FC", "\u17D7", "\u1843", "\u1AA7", ["\u1C78", "\u1C7D"], ["\u1D2C", "\u1D6A"], "\u1D78", ["\u1D9B", "\u1DBF"], "\u2071", "\u207F", ["\u2090", "\u209C"], ["\u2C7C", "\u2C7D"], "\u2D6F", "\u2E2F", "\u3005", ["\u3031", "\u3035"], "\u303B", ["\u309D", "\u309E"], ["\u30FC", "\u30FE"], "\uA015", ["\uA4F8", "\uA4FD"], "\uA60C", "\uA67F", ["\uA717", "\uA71F"], "\uA770", "\uA788", ["\uA7F8", "\uA7F9"], "\uA9CF", "\uAA70", "\uAADD", ["\uAAF3", "\uAAF4"], "\uFF70", ["\uFF9E", "\uFF9F"]], false, false),
        peg$c260 = /^[\xAA\xBA\u01BB\u01C0-\u01C3\u0294\u05D0-\u05EA\u05F0-\u05F2\u0620-\u063F\u0641-\u064A\u066E-\u066F\u0671-\u06D3\u06D5\u06EE-\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u0800-\u0815\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0972-\u0977\u0979-\u097F\u0985-\u098C\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC-\u09DD\u09DF-\u09E1\u09F0-\u09F1\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33\u0A35-\u0A36\u0A38-\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0-\u0AE1\u0B05-\u0B0C\u0B0F-\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B5C-\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58-\u0C59\u0C60-\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0-\u0CE1\u0CF1-\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45\u0E81-\u0E82\u0E84\u0E87-\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065-\u1066\u106E-\u1070\u1075-\u1081\u108E\u10D0-\u10FA\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17DC\u1820-\u1842\u1844-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE-\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C77\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5-\u1CF6\u2135-\u2138\u2D30-\u2D67\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3006\u303C\u3041-\u3096\u309F\u30A1-\u30FA\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA014\uA016-\uA48C\uA4D0-\uA4F7\uA500-\uA60B\uA610-\uA61F\uA62A-\uA62B\uA66E\uA6A0-\uA6E5\uA7FB-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA6F\uAA71-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAAE0-\uAAEA\uAAF2\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40-\uFB41\uFB43-\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF66-\uFF6F\uFF71-\uFF9D\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
        peg$c261 = peg$classExpectation(["\xAA", "\xBA", "\u01BB", ["\u01C0", "\u01C3"], "\u0294", ["\u05D0", "\u05EA"], ["\u05F0", "\u05F2"], ["\u0620", "\u063F"], ["\u0641", "\u064A"], ["\u066E", "\u066F"], ["\u0671", "\u06D3"], "\u06D5", ["\u06EE", "\u06EF"], ["\u06FA", "\u06FC"], "\u06FF", "\u0710", ["\u0712", "\u072F"], ["\u074D", "\u07A5"], "\u07B1", ["\u07CA", "\u07EA"], ["\u0800", "\u0815"], ["\u0840", "\u0858"], "\u08A0", ["\u08A2", "\u08AC"], ["\u0904", "\u0939"], "\u093D", "\u0950", ["\u0958", "\u0961"], ["\u0972", "\u0977"], ["\u0979", "\u097F"], ["\u0985", "\u098C"], ["\u098F", "\u0990"], ["\u0993", "\u09A8"], ["\u09AA", "\u09B0"], "\u09B2", ["\u09B6", "\u09B9"], "\u09BD", "\u09CE", ["\u09DC", "\u09DD"], ["\u09DF", "\u09E1"], ["\u09F0", "\u09F1"], ["\u0A05", "\u0A0A"], ["\u0A0F", "\u0A10"], ["\u0A13", "\u0A28"], ["\u0A2A", "\u0A30"], ["\u0A32", "\u0A33"], ["\u0A35", "\u0A36"], ["\u0A38", "\u0A39"], ["\u0A59", "\u0A5C"], "\u0A5E", ["\u0A72", "\u0A74"], ["\u0A85", "\u0A8D"], ["\u0A8F", "\u0A91"], ["\u0A93", "\u0AA8"], ["\u0AAA", "\u0AB0"], ["\u0AB2", "\u0AB3"], ["\u0AB5", "\u0AB9"], "\u0ABD", "\u0AD0", ["\u0AE0", "\u0AE1"], ["\u0B05", "\u0B0C"], ["\u0B0F", "\u0B10"], ["\u0B13", "\u0B28"], ["\u0B2A", "\u0B30"], ["\u0B32", "\u0B33"], ["\u0B35", "\u0B39"], "\u0B3D", ["\u0B5C", "\u0B5D"], ["\u0B5F", "\u0B61"], "\u0B71", "\u0B83", ["\u0B85", "\u0B8A"], ["\u0B8E", "\u0B90"], ["\u0B92", "\u0B95"], ["\u0B99", "\u0B9A"], "\u0B9C", ["\u0B9E", "\u0B9F"], ["\u0BA3", "\u0BA4"], ["\u0BA8", "\u0BAA"], ["\u0BAE", "\u0BB9"], "\u0BD0", ["\u0C05", "\u0C0C"], ["\u0C0E", "\u0C10"], ["\u0C12", "\u0C28"], ["\u0C2A", "\u0C33"], ["\u0C35", "\u0C39"], "\u0C3D", ["\u0C58", "\u0C59"], ["\u0C60", "\u0C61"], ["\u0C85", "\u0C8C"], ["\u0C8E", "\u0C90"], ["\u0C92", "\u0CA8"], ["\u0CAA", "\u0CB3"], ["\u0CB5", "\u0CB9"], "\u0CBD", "\u0CDE", ["\u0CE0", "\u0CE1"], ["\u0CF1", "\u0CF2"], ["\u0D05", "\u0D0C"], ["\u0D0E", "\u0D10"], ["\u0D12", "\u0D3A"], "\u0D3D", "\u0D4E", ["\u0D60", "\u0D61"], ["\u0D7A", "\u0D7F"], ["\u0D85", "\u0D96"], ["\u0D9A", "\u0DB1"], ["\u0DB3", "\u0DBB"], "\u0DBD", ["\u0DC0", "\u0DC6"], ["\u0E01", "\u0E30"], ["\u0E32", "\u0E33"], ["\u0E40", "\u0E45"], ["\u0E81", "\u0E82"], "\u0E84", ["\u0E87", "\u0E88"], "\u0E8A", "\u0E8D", ["\u0E94", "\u0E97"], ["\u0E99", "\u0E9F"], ["\u0EA1", "\u0EA3"], "\u0EA5", "\u0EA7", ["\u0EAA", "\u0EAB"], ["\u0EAD", "\u0EB0"], ["\u0EB2", "\u0EB3"], "\u0EBD", ["\u0EC0", "\u0EC4"], ["\u0EDC", "\u0EDF"], "\u0F00", ["\u0F40", "\u0F47"], ["\u0F49", "\u0F6C"], ["\u0F88", "\u0F8C"], ["\u1000", "\u102A"], "\u103F", ["\u1050", "\u1055"], ["\u105A", "\u105D"], "\u1061", ["\u1065", "\u1066"], ["\u106E", "\u1070"], ["\u1075", "\u1081"], "\u108E", ["\u10D0", "\u10FA"], ["\u10FD", "\u1248"], ["\u124A", "\u124D"], ["\u1250", "\u1256"], "\u1258", ["\u125A", "\u125D"], ["\u1260", "\u1288"], ["\u128A", "\u128D"], ["\u1290", "\u12B0"], ["\u12B2", "\u12B5"], ["\u12B8", "\u12BE"], "\u12C0", ["\u12C2", "\u12C5"], ["\u12C8", "\u12D6"], ["\u12D8", "\u1310"], ["\u1312", "\u1315"], ["\u1318", "\u135A"], ["\u1380", "\u138F"], ["\u13A0", "\u13F4"], ["\u1401", "\u166C"], ["\u166F", "\u167F"], ["\u1681", "\u169A"], ["\u16A0", "\u16EA"], ["\u1700", "\u170C"], ["\u170E", "\u1711"], ["\u1720", "\u1731"], ["\u1740", "\u1751"], ["\u1760", "\u176C"], ["\u176E", "\u1770"], ["\u1780", "\u17B3"], "\u17DC", ["\u1820", "\u1842"], ["\u1844", "\u1877"], ["\u1880", "\u18A8"], "\u18AA", ["\u18B0", "\u18F5"], ["\u1900", "\u191C"], ["\u1950", "\u196D"], ["\u1970", "\u1974"], ["\u1980", "\u19AB"], ["\u19C1", "\u19C7"], ["\u1A00", "\u1A16"], ["\u1A20", "\u1A54"], ["\u1B05", "\u1B33"], ["\u1B45", "\u1B4B"], ["\u1B83", "\u1BA0"], ["\u1BAE", "\u1BAF"], ["\u1BBA", "\u1BE5"], ["\u1C00", "\u1C23"], ["\u1C4D", "\u1C4F"], ["\u1C5A", "\u1C77"], ["\u1CE9", "\u1CEC"], ["\u1CEE", "\u1CF1"], ["\u1CF5", "\u1CF6"], ["\u2135", "\u2138"], ["\u2D30", "\u2D67"], ["\u2D80", "\u2D96"], ["\u2DA0", "\u2DA6"], ["\u2DA8", "\u2DAE"], ["\u2DB0", "\u2DB6"], ["\u2DB8", "\u2DBE"], ["\u2DC0", "\u2DC6"], ["\u2DC8", "\u2DCE"], ["\u2DD0", "\u2DD6"], ["\u2DD8", "\u2DDE"], "\u3006", "\u303C", ["\u3041", "\u3096"], "\u309F", ["\u30A1", "\u30FA"], "\u30FF", ["\u3105", "\u312D"], ["\u3131", "\u318E"], ["\u31A0", "\u31BA"], ["\u31F0", "\u31FF"], ["\u3400", "\u4DB5"], ["\u4E00", "\u9FCC"], ["\uA000", "\uA014"], ["\uA016", "\uA48C"], ["\uA4D0", "\uA4F7"], ["\uA500", "\uA60B"], ["\uA610", "\uA61F"], ["\uA62A", "\uA62B"], "\uA66E", ["\uA6A0", "\uA6E5"], ["\uA7FB", "\uA801"], ["\uA803", "\uA805"], ["\uA807", "\uA80A"], ["\uA80C", "\uA822"], ["\uA840", "\uA873"], ["\uA882", "\uA8B3"], ["\uA8F2", "\uA8F7"], "\uA8FB", ["\uA90A", "\uA925"], ["\uA930", "\uA946"], ["\uA960", "\uA97C"], ["\uA984", "\uA9B2"], ["\uAA00", "\uAA28"], ["\uAA40", "\uAA42"], ["\uAA44", "\uAA4B"], ["\uAA60", "\uAA6F"], ["\uAA71", "\uAA76"], "\uAA7A", ["\uAA80", "\uAAAF"], "\uAAB1", ["\uAAB5", "\uAAB6"], ["\uAAB9", "\uAABD"], "\uAAC0", "\uAAC2", ["\uAADB", "\uAADC"], ["\uAAE0", "\uAAEA"], "\uAAF2", ["\uAB01", "\uAB06"], ["\uAB09", "\uAB0E"], ["\uAB11", "\uAB16"], ["\uAB20", "\uAB26"], ["\uAB28", "\uAB2E"], ["\uABC0", "\uABE2"], ["\uAC00", "\uD7A3"], ["\uD7B0", "\uD7C6"], ["\uD7CB", "\uD7FB"], ["\uF900", "\uFA6D"], ["\uFA70", "\uFAD9"], "\uFB1D", ["\uFB1F", "\uFB28"], ["\uFB2A", "\uFB36"], ["\uFB38", "\uFB3C"], "\uFB3E", ["\uFB40", "\uFB41"], ["\uFB43", "\uFB44"], ["\uFB46", "\uFBB1"], ["\uFBD3", "\uFD3D"], ["\uFD50", "\uFD8F"], ["\uFD92", "\uFDC7"], ["\uFDF0", "\uFDFB"], ["\uFE70", "\uFE74"], ["\uFE76", "\uFEFC"], ["\uFF66", "\uFF6F"], ["\uFF71", "\uFF9D"], ["\uFFA0", "\uFFBE"], ["\uFFC2", "\uFFC7"], ["\uFFCA", "\uFFCF"], ["\uFFD2", "\uFFD7"], ["\uFFDA", "\uFFDC"]], false, false),
        peg$c262 = /^[\u01C5\u01C8\u01CB\u01F2\u1F88-\u1F8F\u1F98-\u1F9F\u1FA8-\u1FAF\u1FBC\u1FCC\u1FFC]/,
        peg$c263 = peg$classExpectation(["\u01C5", "\u01C8", "\u01CB", "\u01F2", ["\u1F88", "\u1F8F"], ["\u1F98", "\u1F9F"], ["\u1FA8", "\u1FAF"], "\u1FBC", "\u1FCC", "\u1FFC"], false, false),
        peg$c264 = /^[A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178-\u0179\u017B\u017D\u0181-\u0182\u0184\u0186-\u0187\u0189-\u018B\u018E-\u0191\u0193-\u0194\u0196-\u0198\u019C-\u019D\u019F-\u01A0\u01A2\u01A4\u01A6-\u01A7\u01A9\u01AC\u01AE-\u01AF\u01B1-\u01B3\u01B5\u01B7-\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A-\u023B\u023D-\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u0386\u0388-\u038A\u038C\u038E-\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9-\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0-\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E-\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D-\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA\uFF21-\uFF3A]/,
        peg$c265 = peg$classExpectation([["A", "Z"], ["\xC0", "\xD6"], ["\xD8", "\xDE"], "\u0100", "\u0102", "\u0104", "\u0106", "\u0108", "\u010A", "\u010C", "\u010E", "\u0110", "\u0112", "\u0114", "\u0116", "\u0118", "\u011A", "\u011C", "\u011E", "\u0120", "\u0122", "\u0124", "\u0126", "\u0128", "\u012A", "\u012C", "\u012E", "\u0130", "\u0132", "\u0134", "\u0136", "\u0139", "\u013B", "\u013D", "\u013F", "\u0141", "\u0143", "\u0145", "\u0147", "\u014A", "\u014C", "\u014E", "\u0150", "\u0152", "\u0154", "\u0156", "\u0158", "\u015A", "\u015C", "\u015E", "\u0160", "\u0162", "\u0164", "\u0166", "\u0168", "\u016A", "\u016C", "\u016E", "\u0170", "\u0172", "\u0174", "\u0176", ["\u0178", "\u0179"], "\u017B", "\u017D", ["\u0181", "\u0182"], "\u0184", ["\u0186", "\u0187"], ["\u0189", "\u018B"], ["\u018E", "\u0191"], ["\u0193", "\u0194"], ["\u0196", "\u0198"], ["\u019C", "\u019D"], ["\u019F", "\u01A0"], "\u01A2", "\u01A4", ["\u01A6", "\u01A7"], "\u01A9", "\u01AC", ["\u01AE", "\u01AF"], ["\u01B1", "\u01B3"], "\u01B5", ["\u01B7", "\u01B8"], "\u01BC", "\u01C4", "\u01C7", "\u01CA", "\u01CD", "\u01CF", "\u01D1", "\u01D3", "\u01D5", "\u01D7", "\u01D9", "\u01DB", "\u01DE", "\u01E0", "\u01E2", "\u01E4", "\u01E6", "\u01E8", "\u01EA", "\u01EC", "\u01EE", "\u01F1", "\u01F4", ["\u01F6", "\u01F8"], "\u01FA", "\u01FC", "\u01FE", "\u0200", "\u0202", "\u0204", "\u0206", "\u0208", "\u020A", "\u020C", "\u020E", "\u0210", "\u0212", "\u0214", "\u0216", "\u0218", "\u021A", "\u021C", "\u021E", "\u0220", "\u0222", "\u0224", "\u0226", "\u0228", "\u022A", "\u022C", "\u022E", "\u0230", "\u0232", ["\u023A", "\u023B"], ["\u023D", "\u023E"], "\u0241", ["\u0243", "\u0246"], "\u0248", "\u024A", "\u024C", "\u024E", "\u0370", "\u0372", "\u0376", "\u0386", ["\u0388", "\u038A"], "\u038C", ["\u038E", "\u038F"], ["\u0391", "\u03A1"], ["\u03A3", "\u03AB"], "\u03CF", ["\u03D2", "\u03D4"], "\u03D8", "\u03DA", "\u03DC", "\u03DE", "\u03E0", "\u03E2", "\u03E4", "\u03E6", "\u03E8", "\u03EA", "\u03EC", "\u03EE", "\u03F4", "\u03F7", ["\u03F9", "\u03FA"], ["\u03FD", "\u042F"], "\u0460", "\u0462", "\u0464", "\u0466", "\u0468", "\u046A", "\u046C", "\u046E", "\u0470", "\u0472", "\u0474", "\u0476", "\u0478", "\u047A", "\u047C", "\u047E", "\u0480", "\u048A", "\u048C", "\u048E", "\u0490", "\u0492", "\u0494", "\u0496", "\u0498", "\u049A", "\u049C", "\u049E", "\u04A0", "\u04A2", "\u04A4", "\u04A6", "\u04A8", "\u04AA", "\u04AC", "\u04AE", "\u04B0", "\u04B2", "\u04B4", "\u04B6", "\u04B8", "\u04BA", "\u04BC", "\u04BE", ["\u04C0", "\u04C1"], "\u04C3", "\u04C5", "\u04C7", "\u04C9", "\u04CB", "\u04CD", "\u04D0", "\u04D2", "\u04D4", "\u04D6", "\u04D8", "\u04DA", "\u04DC", "\u04DE", "\u04E0", "\u04E2", "\u04E4", "\u04E6", "\u04E8", "\u04EA", "\u04EC", "\u04EE", "\u04F0", "\u04F2", "\u04F4", "\u04F6", "\u04F8", "\u04FA", "\u04FC", "\u04FE", "\u0500", "\u0502", "\u0504", "\u0506", "\u0508", "\u050A", "\u050C", "\u050E", "\u0510", "\u0512", "\u0514", "\u0516", "\u0518", "\u051A", "\u051C", "\u051E", "\u0520", "\u0522", "\u0524", "\u0526", ["\u0531", "\u0556"], ["\u10A0", "\u10C5"], "\u10C7", "\u10CD", "\u1E00", "\u1E02", "\u1E04", "\u1E06", "\u1E08", "\u1E0A", "\u1E0C", "\u1E0E", "\u1E10", "\u1E12", "\u1E14", "\u1E16", "\u1E18", "\u1E1A", "\u1E1C", "\u1E1E", "\u1E20", "\u1E22", "\u1E24", "\u1E26", "\u1E28", "\u1E2A", "\u1E2C", "\u1E2E", "\u1E30", "\u1E32", "\u1E34", "\u1E36", "\u1E38", "\u1E3A", "\u1E3C", "\u1E3E", "\u1E40", "\u1E42", "\u1E44", "\u1E46", "\u1E48", "\u1E4A", "\u1E4C", "\u1E4E", "\u1E50", "\u1E52", "\u1E54", "\u1E56", "\u1E58", "\u1E5A", "\u1E5C", "\u1E5E", "\u1E60", "\u1E62", "\u1E64", "\u1E66", "\u1E68", "\u1E6A", "\u1E6C", "\u1E6E", "\u1E70", "\u1E72", "\u1E74", "\u1E76", "\u1E78", "\u1E7A", "\u1E7C", "\u1E7E", "\u1E80", "\u1E82", "\u1E84", "\u1E86", "\u1E88", "\u1E8A", "\u1E8C", "\u1E8E", "\u1E90", "\u1E92", "\u1E94", "\u1E9E", "\u1EA0", "\u1EA2", "\u1EA4", "\u1EA6", "\u1EA8", "\u1EAA", "\u1EAC", "\u1EAE", "\u1EB0", "\u1EB2", "\u1EB4", "\u1EB6", "\u1EB8", "\u1EBA", "\u1EBC", "\u1EBE", "\u1EC0", "\u1EC2", "\u1EC4", "\u1EC6", "\u1EC8", "\u1ECA", "\u1ECC", "\u1ECE", "\u1ED0", "\u1ED2", "\u1ED4", "\u1ED6", "\u1ED8", "\u1EDA", "\u1EDC", "\u1EDE", "\u1EE0", "\u1EE2", "\u1EE4", "\u1EE6", "\u1EE8", "\u1EEA", "\u1EEC", "\u1EEE", "\u1EF0", "\u1EF2", "\u1EF4", "\u1EF6", "\u1EF8", "\u1EFA", "\u1EFC", "\u1EFE", ["\u1F08", "\u1F0F"], ["\u1F18", "\u1F1D"], ["\u1F28", "\u1F2F"], ["\u1F38", "\u1F3F"], ["\u1F48", "\u1F4D"], "\u1F59", "\u1F5B", "\u1F5D", "\u1F5F", ["\u1F68", "\u1F6F"], ["\u1FB8", "\u1FBB"], ["\u1FC8", "\u1FCB"], ["\u1FD8", "\u1FDB"], ["\u1FE8", "\u1FEC"], ["\u1FF8", "\u1FFB"], "\u2102", "\u2107", ["\u210B", "\u210D"], ["\u2110", "\u2112"], "\u2115", ["\u2119", "\u211D"], "\u2124", "\u2126", "\u2128", ["\u212A", "\u212D"], ["\u2130", "\u2133"], ["\u213E", "\u213F"], "\u2145", "\u2183", ["\u2C00", "\u2C2E"], "\u2C60", ["\u2C62", "\u2C64"], "\u2C67", "\u2C69", "\u2C6B", ["\u2C6D", "\u2C70"], "\u2C72", "\u2C75", ["\u2C7E", "\u2C80"], "\u2C82", "\u2C84", "\u2C86", "\u2C88", "\u2C8A", "\u2C8C", "\u2C8E", "\u2C90", "\u2C92", "\u2C94", "\u2C96", "\u2C98", "\u2C9A", "\u2C9C", "\u2C9E", "\u2CA0", "\u2CA2", "\u2CA4", "\u2CA6", "\u2CA8", "\u2CAA", "\u2CAC", "\u2CAE", "\u2CB0", "\u2CB2", "\u2CB4", "\u2CB6", "\u2CB8", "\u2CBA", "\u2CBC", "\u2CBE", "\u2CC0", "\u2CC2", "\u2CC4", "\u2CC6", "\u2CC8", "\u2CCA", "\u2CCC", "\u2CCE", "\u2CD0", "\u2CD2", "\u2CD4", "\u2CD6", "\u2CD8", "\u2CDA", "\u2CDC", "\u2CDE", "\u2CE0", "\u2CE2", "\u2CEB", "\u2CED", "\u2CF2", "\uA640", "\uA642", "\uA644", "\uA646", "\uA648", "\uA64A", "\uA64C", "\uA64E", "\uA650", "\uA652", "\uA654", "\uA656", "\uA658", "\uA65A", "\uA65C", "\uA65E", "\uA660", "\uA662", "\uA664", "\uA666", "\uA668", "\uA66A", "\uA66C", "\uA680", "\uA682", "\uA684", "\uA686", "\uA688", "\uA68A", "\uA68C", "\uA68E", "\uA690", "\uA692", "\uA694", "\uA696", "\uA722", "\uA724", "\uA726", "\uA728", "\uA72A", "\uA72C", "\uA72E", "\uA732", "\uA734", "\uA736", "\uA738", "\uA73A", "\uA73C", "\uA73E", "\uA740", "\uA742", "\uA744", "\uA746", "\uA748", "\uA74A", "\uA74C", "\uA74E", "\uA750", "\uA752", "\uA754", "\uA756", "\uA758", "\uA75A", "\uA75C", "\uA75E", "\uA760", "\uA762", "\uA764", "\uA766", "\uA768", "\uA76A", "\uA76C", "\uA76E", "\uA779", "\uA77B", ["\uA77D", "\uA77E"], "\uA780", "\uA782", "\uA784", "\uA786", "\uA78B", "\uA78D", "\uA790", "\uA792", "\uA7A0", "\uA7A2", "\uA7A4", "\uA7A6", "\uA7A8", "\uA7AA", ["\uFF21", "\uFF3A"]], false, false),
        peg$c266 = /^[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0982-\u0983\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09D7\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0B02-\u0B03\u0B3E\u0B40\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD7\u0C01-\u0C03\u0C41-\u0C44\u0C82-\u0C83\u0CBE\u0CC0-\u0CC4\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0D02-\u0D03\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D57\u0D82-\u0D83\u0DCF-\u0DD1\u0DD8-\u0DDF\u0DF2-\u0DF3\u0F3E-\u0F3F\u0F7F\u102B-\u102C\u1031\u1038\u103B-\u103C\u1056-\u1057\u1062-\u1064\u1067-\u106D\u1083-\u1084\u1087-\u108C\u108F\u109A-\u109C\u17B6\u17BE-\u17C5\u17C7-\u17C8\u1923-\u1926\u1929-\u192B\u1930-\u1931\u1933-\u1938\u19B0-\u19C0\u19C8-\u19C9\u1A19-\u1A1A\u1A55\u1A57\u1A61\u1A63-\u1A64\u1A6D-\u1A72\u1B04\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B82\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAC-\u1BAD\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1C24-\u1C2B\u1C34-\u1C35\u1CE1\u1CF2-\u1CF3\u302E-\u302F\uA823-\uA824\uA827\uA880-\uA881\uA8B4-\uA8C3\uA952-\uA953\uA983\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uAA2F-\uAA30\uAA33-\uAA34\uAA4D\uAA7B\uAAEB\uAAEE-\uAAEF\uAAF5\uABE3-\uABE4\uABE6-\uABE7\uABE9-\uABEA\uABEC]/,
        peg$c267 = peg$classExpectation(["\u0903", "\u093B", ["\u093E", "\u0940"], ["\u0949", "\u094C"], ["\u094E", "\u094F"], ["\u0982", "\u0983"], ["\u09BE", "\u09C0"], ["\u09C7", "\u09C8"], ["\u09CB", "\u09CC"], "\u09D7", "\u0A03", ["\u0A3E", "\u0A40"], "\u0A83", ["\u0ABE", "\u0AC0"], "\u0AC9", ["\u0ACB", "\u0ACC"], ["\u0B02", "\u0B03"], "\u0B3E", "\u0B40", ["\u0B47", "\u0B48"], ["\u0B4B", "\u0B4C"], "\u0B57", ["\u0BBE", "\u0BBF"], ["\u0BC1", "\u0BC2"], ["\u0BC6", "\u0BC8"], ["\u0BCA", "\u0BCC"], "\u0BD7", ["\u0C01", "\u0C03"], ["\u0C41", "\u0C44"], ["\u0C82", "\u0C83"], "\u0CBE", ["\u0CC0", "\u0CC4"], ["\u0CC7", "\u0CC8"], ["\u0CCA", "\u0CCB"], ["\u0CD5", "\u0CD6"], ["\u0D02", "\u0D03"], ["\u0D3E", "\u0D40"], ["\u0D46", "\u0D48"], ["\u0D4A", "\u0D4C"], "\u0D57", ["\u0D82", "\u0D83"], ["\u0DCF", "\u0DD1"], ["\u0DD8", "\u0DDF"], ["\u0DF2", "\u0DF3"], ["\u0F3E", "\u0F3F"], "\u0F7F", ["\u102B", "\u102C"], "\u1031", "\u1038", ["\u103B", "\u103C"], ["\u1056", "\u1057"], ["\u1062", "\u1064"], ["\u1067", "\u106D"], ["\u1083", "\u1084"], ["\u1087", "\u108C"], "\u108F", ["\u109A", "\u109C"], "\u17B6", ["\u17BE", "\u17C5"], ["\u17C7", "\u17C8"], ["\u1923", "\u1926"], ["\u1929", "\u192B"], ["\u1930", "\u1931"], ["\u1933", "\u1938"], ["\u19B0", "\u19C0"], ["\u19C8", "\u19C9"], ["\u1A19", "\u1A1A"], "\u1A55", "\u1A57", "\u1A61", ["\u1A63", "\u1A64"], ["\u1A6D", "\u1A72"], "\u1B04", "\u1B35", "\u1B3B", ["\u1B3D", "\u1B41"], ["\u1B43", "\u1B44"], "\u1B82", "\u1BA1", ["\u1BA6", "\u1BA7"], "\u1BAA", ["\u1BAC", "\u1BAD"], "\u1BE7", ["\u1BEA", "\u1BEC"], "\u1BEE", ["\u1BF2", "\u1BF3"], ["\u1C24", "\u1C2B"], ["\u1C34", "\u1C35"], "\u1CE1", ["\u1CF2", "\u1CF3"], ["\u302E", "\u302F"], ["\uA823", "\uA824"], "\uA827", ["\uA880", "\uA881"], ["\uA8B4", "\uA8C3"], ["\uA952", "\uA953"], "\uA983", ["\uA9B4", "\uA9B5"], ["\uA9BA", "\uA9BB"], ["\uA9BD", "\uA9C0"], ["\uAA2F", "\uAA30"], ["\uAA33", "\uAA34"], "\uAA4D", "\uAA7B", "\uAAEB", ["\uAAEE", "\uAAEF"], "\uAAF5", ["\uABE3", "\uABE4"], ["\uABE6", "\uABE7"], ["\uABE9", "\uABEA"], "\uABEC"], false, false),
        peg$c268 = /^[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1-\u05C2\u05C4-\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7-\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E4-\u08FE\u0900-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962-\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2-\u09E3\u0A01-\u0A02\u0A3C\u0A41-\u0A42\u0A47-\u0A48\u0A4B-\u0A4D\u0A51\u0A70-\u0A71\u0A75\u0A81-\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7-\u0AC8\u0ACD\u0AE2-\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62-\u0B63\u0B82\u0BC0\u0BCD\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55-\u0C56\u0C62-\u0C63\u0CBC\u0CBF\u0CC6\u0CCC-\u0CCD\u0CE2-\u0CE3\u0D41-\u0D44\u0D4D\u0D62-\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB-\u0EBC\u0EC8-\u0ECD\u0F18-\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86-\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039-\u103A\u103D-\u103E\u1058-\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085-\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752-\u1753\u1772-\u1773\u17B4-\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u1922\u1927-\u1928\u1932\u1939-\u193B\u1A17-\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80-\u1B81\u1BA2-\u1BA5\u1BA8-\u1BA9\u1BAB\u1BE6\u1BE8-\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1DC0-\u1DE6\u1DFC-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099-\u309A\uA66F\uA674-\uA67D\uA69F\uA6F0-\uA6F1\uA802\uA806\uA80B\uA825-\uA826\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uAA29-\uAA2E\uAA31-\uAA32\uAA35-\uAA36\uAA43\uAA4C\uAAB0\uAAB2-\uAAB4\uAAB7-\uAAB8\uAABE-\uAABF\uAAC1\uAAEC-\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE26]/,
        peg$c269 = peg$classExpectation([["\u0300", "\u036F"], ["\u0483", "\u0487"], ["\u0591", "\u05BD"], "\u05BF", ["\u05C1", "\u05C2"], ["\u05C4", "\u05C5"], "\u05C7", ["\u0610", "\u061A"], ["\u064B", "\u065F"], "\u0670", ["\u06D6", "\u06DC"], ["\u06DF", "\u06E4"], ["\u06E7", "\u06E8"], ["\u06EA", "\u06ED"], "\u0711", ["\u0730", "\u074A"], ["\u07A6", "\u07B0"], ["\u07EB", "\u07F3"], ["\u0816", "\u0819"], ["\u081B", "\u0823"], ["\u0825", "\u0827"], ["\u0829", "\u082D"], ["\u0859", "\u085B"], ["\u08E4", "\u08FE"], ["\u0900", "\u0902"], "\u093A", "\u093C", ["\u0941", "\u0948"], "\u094D", ["\u0951", "\u0957"], ["\u0962", "\u0963"], "\u0981", "\u09BC", ["\u09C1", "\u09C4"], "\u09CD", ["\u09E2", "\u09E3"], ["\u0A01", "\u0A02"], "\u0A3C", ["\u0A41", "\u0A42"], ["\u0A47", "\u0A48"], ["\u0A4B", "\u0A4D"], "\u0A51", ["\u0A70", "\u0A71"], "\u0A75", ["\u0A81", "\u0A82"], "\u0ABC", ["\u0AC1", "\u0AC5"], ["\u0AC7", "\u0AC8"], "\u0ACD", ["\u0AE2", "\u0AE3"], "\u0B01", "\u0B3C", "\u0B3F", ["\u0B41", "\u0B44"], "\u0B4D", "\u0B56", ["\u0B62", "\u0B63"], "\u0B82", "\u0BC0", "\u0BCD", ["\u0C3E", "\u0C40"], ["\u0C46", "\u0C48"], ["\u0C4A", "\u0C4D"], ["\u0C55", "\u0C56"], ["\u0C62", "\u0C63"], "\u0CBC", "\u0CBF", "\u0CC6", ["\u0CCC", "\u0CCD"], ["\u0CE2", "\u0CE3"], ["\u0D41", "\u0D44"], "\u0D4D", ["\u0D62", "\u0D63"], "\u0DCA", ["\u0DD2", "\u0DD4"], "\u0DD6", "\u0E31", ["\u0E34", "\u0E3A"], ["\u0E47", "\u0E4E"], "\u0EB1", ["\u0EB4", "\u0EB9"], ["\u0EBB", "\u0EBC"], ["\u0EC8", "\u0ECD"], ["\u0F18", "\u0F19"], "\u0F35", "\u0F37", "\u0F39", ["\u0F71", "\u0F7E"], ["\u0F80", "\u0F84"], ["\u0F86", "\u0F87"], ["\u0F8D", "\u0F97"], ["\u0F99", "\u0FBC"], "\u0FC6", ["\u102D", "\u1030"], ["\u1032", "\u1037"], ["\u1039", "\u103A"], ["\u103D", "\u103E"], ["\u1058", "\u1059"], ["\u105E", "\u1060"], ["\u1071", "\u1074"], "\u1082", ["\u1085", "\u1086"], "\u108D", "\u109D", ["\u135D", "\u135F"], ["\u1712", "\u1714"], ["\u1732", "\u1734"], ["\u1752", "\u1753"], ["\u1772", "\u1773"], ["\u17B4", "\u17B5"], ["\u17B7", "\u17BD"], "\u17C6", ["\u17C9", "\u17D3"], "\u17DD", ["\u180B", "\u180D"], "\u18A9", ["\u1920", "\u1922"], ["\u1927", "\u1928"], "\u1932", ["\u1939", "\u193B"], ["\u1A17", "\u1A18"], "\u1A1B", "\u1A56", ["\u1A58", "\u1A5E"], "\u1A60", "\u1A62", ["\u1A65", "\u1A6C"], ["\u1A73", "\u1A7C"], "\u1A7F", ["\u1B00", "\u1B03"], "\u1B34", ["\u1B36", "\u1B3A"], "\u1B3C", "\u1B42", ["\u1B6B", "\u1B73"], ["\u1B80", "\u1B81"], ["\u1BA2", "\u1BA5"], ["\u1BA8", "\u1BA9"], "\u1BAB", "\u1BE6", ["\u1BE8", "\u1BE9"], "\u1BED", ["\u1BEF", "\u1BF1"], ["\u1C2C", "\u1C33"], ["\u1C36", "\u1C37"], ["\u1CD0", "\u1CD2"], ["\u1CD4", "\u1CE0"], ["\u1CE2", "\u1CE8"], "\u1CED", "\u1CF4", ["\u1DC0", "\u1DE6"], ["\u1DFC", "\u1DFF"], ["\u20D0", "\u20DC"], "\u20E1", ["\u20E5", "\u20F0"], ["\u2CEF", "\u2CF1"], "\u2D7F", ["\u2DE0", "\u2DFF"], ["\u302A", "\u302D"], ["\u3099", "\u309A"], "\uA66F", ["\uA674", "\uA67D"], "\uA69F", ["\uA6F0", "\uA6F1"], "\uA802", "\uA806", "\uA80B", ["\uA825", "\uA826"], "\uA8C4", ["\uA8E0", "\uA8F1"], ["\uA926", "\uA92D"], ["\uA947", "\uA951"], ["\uA980", "\uA982"], "\uA9B3", ["\uA9B6", "\uA9B9"], "\uA9BC", ["\uAA29", "\uAA2E"], ["\uAA31", "\uAA32"], ["\uAA35", "\uAA36"], "\uAA43", "\uAA4C", "\uAAB0", ["\uAAB2", "\uAAB4"], ["\uAAB7", "\uAAB8"], ["\uAABE", "\uAABF"], "\uAAC1", ["\uAAEC", "\uAAED"], "\uAAF6", "\uABE5", "\uABE8", "\uABED", "\uFB1E", ["\uFE00", "\uFE0F"], ["\uFE20", "\uFE26"]], false, false),
        peg$c270 = /^[0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]/,
        peg$c271 = peg$classExpectation([["0", "9"], ["\u0660", "\u0669"], ["\u06F0", "\u06F9"], ["\u07C0", "\u07C9"], ["\u0966", "\u096F"], ["\u09E6", "\u09EF"], ["\u0A66", "\u0A6F"], ["\u0AE6", "\u0AEF"], ["\u0B66", "\u0B6F"], ["\u0BE6", "\u0BEF"], ["\u0C66", "\u0C6F"], ["\u0CE6", "\u0CEF"], ["\u0D66", "\u0D6F"], ["\u0E50", "\u0E59"], ["\u0ED0", "\u0ED9"], ["\u0F20", "\u0F29"], ["\u1040", "\u1049"], ["\u1090", "\u1099"], ["\u17E0", "\u17E9"], ["\u1810", "\u1819"], ["\u1946", "\u194F"], ["\u19D0", "\u19D9"], ["\u1A80", "\u1A89"], ["\u1A90", "\u1A99"], ["\u1B50", "\u1B59"], ["\u1BB0", "\u1BB9"], ["\u1C40", "\u1C49"], ["\u1C50", "\u1C59"], ["\uA620", "\uA629"], ["\uA8D0", "\uA8D9"], ["\uA900", "\uA909"], ["\uA9D0", "\uA9D9"], ["\uAA50", "\uAA59"], ["\uABF0", "\uABF9"], ["\uFF10", "\uFF19"]], false, false),
        peg$c272 = /^[\u16EE-\u16F0\u2160-\u2182\u2185-\u2188\u3007\u3021-\u3029\u3038-\u303A\uA6E6-\uA6EF]/,
        peg$c273 = peg$classExpectation([["\u16EE", "\u16F0"], ["\u2160", "\u2182"], ["\u2185", "\u2188"], "\u3007", ["\u3021", "\u3029"], ["\u3038", "\u303A"], ["\uA6E6", "\uA6EF"]], false, false),
        peg$c274 = /^[_\u203F-\u2040\u2054\uFE33-\uFE34\uFE4D-\uFE4F\uFF3F]/,
        peg$c275 = peg$classExpectation(["_", ["\u203F", "\u2040"], "\u2054", ["\uFE33", "\uFE34"], ["\uFE4D", "\uFE4F"], "\uFF3F"], false, false),
        peg$c276 = /^[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/,
        peg$c277 = peg$classExpectation([" ", "\xA0", "\u1680", ["\u2000", "\u200A"], "\u202F", "\u205F", "\u3000"], false, false),
        peg$currPos = 0,
        peg$savedPos = 0,
        peg$posDetailsCache = [{
      line: 1,
      column: 1
    }],
        peg$maxFailPos = 0,
        peg$maxFailExpected = [],
        peg$silentFails = 0,
        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description, location) {
      location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
      throw peg$buildStructuredError([peg$otherExpectation(description)], input.substring(peg$savedPos, peg$currPos), location);
    }

    function error(message, location) {
      location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
      throw peg$buildSimpleError(message, location);
    }

    function peg$literalExpectation(text, ignoreCase) {
      return {
        type: "literal",
        text: text,
        ignoreCase: ignoreCase
      };
    }

    function peg$classExpectation(parts, inverted, ignoreCase) {
      return {
        type: "class",
        parts: parts,
        inverted: inverted,
        ignoreCase: ignoreCase
      };
    }

    function peg$anyExpectation() {
      return {
        type: "any"
      };
    }

    function peg$endExpectation() {
      return {
        type: "end"
      };
    }

    function peg$otherExpectation(description) {
      return {
        type: "other",
        description: description
      };
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p;

      if (details) {
        return details;
      } else {
        p = pos - 1;

        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line: details.line,
          column: details.column
        };

        while (p < pos) {
          if (input.charCodeAt(p) === 10) {
            details.line++;
            details.column = 1;
          } else {
            details.column++;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails = peg$computePosDetails(endPos);
      return {
        start: {
          offset: startPos,
          line: startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line: endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) {
        return;
      }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildSimpleError(message, location) {
      return new peg$SyntaxError(message, null, null, location);
    }

    function peg$buildStructuredError(expected, found, location) {
      return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
    }

    function peg$parseStatementList() {
      var s0, s1, s2, s3, s4, s5;
      s0 = peg$currPos;
      s1 = peg$parse_();

      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$parseStatement();

        if (s4 === peg$FAILED) {
          s4 = null;
        }

        if (s4 !== peg$FAILED) {
          s5 = peg$parseStatementSeperator();

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }

        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parseStatement();

          if (s4 === peg$FAILED) {
            s4 = null;
          }

          if (s4 !== peg$FAILED) {
            s5 = peg$parseStatementSeperator();

            if (s5 !== peg$FAILED) {
              s4 = [s4, s5];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c0(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseStatementSeperator() {
      var s0, s1, s2, s3;
      s0 = peg$currPos;
      s1 = peg$parse_();

      if (s1 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 59) {
          s2 = peg$c1;
          peg$currPos++;
        } else {
          s2 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c2);
          }
        }

        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();

          if (s3 !== peg$FAILED) {
            s1 = [s1, s2, s3];
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseEditorText() {
      var s0, s1, s2;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parseEditorTextLine();

      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseEditorTextLine();
      }

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c3(s1);
      }

      s0 = s1;
      return s0;
    }

    function peg$parseEditorTextLine() {
      var s0, s1, s2, s3;
      s0 = peg$currPos;
      s1 = peg$parsenbsp();

      if (s1 !== peg$FAILED) {
        s2 = peg$parseStatement();

        if (s2 !== peg$FAILED) {
          s3 = peg$parseRestOfLine();

          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c4(s2, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseRestOfLine();

        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c5(s1);
        }

        s0 = s1;
      }

      return s0;
    }

    function peg$parseDocumentFirstParse() {
      var s0, s1, s2;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parseDocumentLineFirstParse();

      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseDocumentLineFirstParse();
      }

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c3(s1);
      }

      s0 = s1;
      return s0;
    }

    function peg$parseDocumentLineFirstParse() {
      var s0, s1, s2, s3;
      s0 = peg$currPos;
      s1 = peg$parsenbsp();

      if (s1 !== peg$FAILED) {
        s2 = peg$parseFirstParseStatement();

        if (s2 !== peg$FAILED) {
          s3 = peg$parseRestOfLine();

          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c6(s2, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseRestOfLine();

        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c7(s1);
        }

        s0 = s1;
      }

      return s0;
    }

    function peg$parseFirstParseStatement() {
      var s0;
      s0 = peg$parseImportStatement();

      if (s0 === peg$FAILED) {
        s0 = peg$parseFirstParseUnitDefinition();

        if (s0 === peg$FAILED) {
          s0 = peg$parseFirstParseVariableDefinition();
        }
      }

      return s0;
    }

    function peg$parseFirstParseUnitDefinition() {
      var s0, s1, s2, s3, s4, s5, s6, s7;
      s0 = peg$currPos;

      if (input.substr(peg$currPos, 4) === peg$c8) {
        s1 = peg$c8;
        peg$currPos += 4;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c9);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();

        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          s4 = peg$parseNumberLiteral();

          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();

            if (s5 !== peg$FAILED) {
              s4 = [s4, s5];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }

          if (s3 === peg$FAILED) {
            s3 = null;
          }

          if (s3 !== peg$FAILED) {
            s4 = peg$parseUnitDefinitionLeft();

            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              s6 = peg$parse_();

              if (s6 !== peg$FAILED) {
                s7 = peg$parseUnitAssignmentLiteral();

                if (s7 !== peg$FAILED) {
                  s6 = [s6, s7];
                  s5 = s6;
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }

              if (s5 === peg$FAILED) {
                s5 = null;
              }

              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c10(s4, s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseFirstParseVariableDefinition() {
      var s0, s1, s2, s3, s4;
      s0 = peg$currPos;
      s1 = peg$currPos;

      if (input.substr(peg$currPos, 5) === peg$c11) {
        s2 = peg$c11;
        peg$currPos += 5;
      } else {
        s2 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c12);
        }
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parse__();

        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }

      if (s1 === peg$FAILED) {
        s1 = null;
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$parseIdentifierLiteral();

        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();

          if (s3 !== peg$FAILED) {
            s4 = peg$parseAssignmentLiteral();

            if (s4 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c13(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseRestOfLine() {
      var s0, s1, s2;
      s0 = peg$currPos;
      s1 = [];

      if (peg$c14.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c15);
        }
      }

      while (s2 !== peg$FAILED) {
        s1.push(s2);

        if (peg$c14.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c15);
          }
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$parseCR();

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c16(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseCR() {
      var s0, s1;
      s0 = peg$currPos;

      if (peg$c17.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c18);
        }
      }

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c19();
      }

      s0 = s1;
      return s0;
    }

    function peg$parsePaddedStatement() {
      var s0, s1, s2, s3;
      s0 = peg$currPos;
      s1 = peg$parse_();

      if (s1 !== peg$FAILED) {
        s2 = peg$parseStatement();

        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();

          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c20(s2);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseStatement() {
      var s0, s1;
      s0 = peg$currPos;
      s1 = peg$parseRawStatement();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c21(s1);
      }

      s0 = s1;
      return s0;
    }

    function peg$parseRawStatement() {
      var s0;
      s0 = peg$parseUnitDefinitionStatement();

      if (s0 === peg$FAILED) {
        s0 = peg$parseImportStatement();

        if (s0 === peg$FAILED) {
          s0 = peg$parseConstDefinition();

          if (s0 === peg$FAILED) {
            s0 = peg$parseVariableDefinition();

            if (s0 === peg$FAILED) {
              s0 = peg$parseNumericalExpression();
            }
          }
        }
      }

      return s0;
    }

    function peg$parseUnitDefinitionStatement() {
      var s0, s1, s2, s3;
      s0 = peg$currPos;

      if (input.substr(peg$currPos, 4) === peg$c8) {
        s1 = peg$c8;
        peg$currPos += 4;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c9);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();

        if (s2 !== peg$FAILED) {
          s3 = peg$parseUnitDefinition();

          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c22(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseUnitDefinition() {
      var s0, s1;
      s0 = peg$currPos;
      s1 = peg$parseNewUnitDefinition();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c23(s1);
      }

      s0 = s1;

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseUnitSchemeAnnotation();

        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c24(s1);
        }

        s0 = s1;
      }

      return s0;
    }

    function peg$parseUnitSchemeAnnotation() {
      var s0, s1, s2, s3, s4;
      s0 = peg$currPos;
      s1 = peg$parseUnitIdentifier();

      if (s1 !== peg$FAILED) {
        s2 = peg$parseAlternativeUnitNames();

        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();

          if (s3 !== peg$FAILED) {
            s4 = peg$parseUnitSchemes();

            if (s4 === peg$FAILED) {
              s4 = null;
            }

            if (s4 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c25(s1, s2, s4);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseNewUnitDefinition() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
      s0 = peg$currPos;
      s1 = peg$parseUnitDefinitionLeft();

      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();

        if (s2 !== peg$FAILED) {
          s3 = peg$parseUnitAssignmentLiteral();

          if (s3 !== peg$FAILED) {
            s4 = peg$parsenbsp();

            if (s4 !== peg$FAILED) {
              s5 = peg$parseOptionalDimensionIdentifier();

              if (s5 === peg$FAILED) {
                s5 = null;
              }

              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();

                if (s6 !== peg$FAILED) {
                  s7 = peg$parseNumberLiteral();

                  if (s7 !== peg$FAILED) {
                    s8 = peg$parse_();

                    if (s8 !== peg$FAILED) {
                      s9 = peg$parseUnitExpression();

                      if (s9 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c26(s1, s5, s7, s9);
                        s0 = s1;
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseUnitDefinitionLeft();

        if (s1 !== peg$FAILED) {
          s2 = peg$parse_();

          if (s2 !== peg$FAILED) {
            s3 = peg$parseUnitAssignmentLiteral();

            if (s3 !== peg$FAILED) {
              s4 = peg$parsenbsp();

              if (s4 !== peg$FAILED) {
                s5 = peg$parseDimensionIdentifier();

                if (s5 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c27(s1, s5);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }

        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parseNumberLiteral();

          if (s1 !== peg$FAILED) {
            s2 = peg$parse_();

            if (s2 !== peg$FAILED) {
              s3 = peg$parseUnitDefinitionLeft();

              if (s3 !== peg$FAILED) {
                s4 = peg$parse_();

                if (s4 !== peg$FAILED) {
                  s5 = peg$parseUnitAssignmentLiteral();

                  if (s5 !== peg$FAILED) {
                    s6 = peg$parsenbsp();

                    if (s6 !== peg$FAILED) {
                      s7 = peg$parseOptionalDimensionIdentifier();

                      if (s7 === peg$FAILED) {
                        s7 = null;
                      }

                      if (s7 !== peg$FAILED) {
                        s8 = peg$parse_();

                        if (s8 !== peg$FAILED) {
                          s9 = peg$parseUnitExpression();

                          if (s9 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c28(s1, s3, s7, s9);
                            s0 = s1;
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        }
      }

      return s0;
    }

    function peg$parseUnitAssignmentLiteral() {
      var s0;
      s0 = peg$parseAssignmentLiteral();

      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 58) {
          s0 = peg$c29;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c30);
          }
        }
      }

      return s0;
    }

    function peg$parseUnitDefinitionLeft() {
      var s0, s1, s2, s3;
      s0 = peg$currPos;
      s1 = peg$parseUnitIdentifiers();

      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();

        if (s2 !== peg$FAILED) {
          s3 = peg$parseUnitSchemes();

          if (s3 === peg$FAILED) {
            s3 = null;
          }

          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c31(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseUnitIdentifiers() {
      var s0, s1, s2;
      s0 = peg$currPos;
      s1 = peg$parseNewUnitIdentifier();

      if (s1 !== peg$FAILED) {
        s2 = peg$parseAlternativeUnitNames();

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c32(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseAlternativeUnitNames() {
      var s0, s1, s2, s3, s4;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse__();

      if (s3 !== peg$FAILED) {
        s4 = peg$parseNewUnitIdentifier();

        if (s4 !== peg$FAILED) {
          s3 = [s3, s4];
          s2 = s3;
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$currPos;
        s3 = peg$parse__();

        if (s3 !== peg$FAILED) {
          s4 = peg$parseNewUnitIdentifier();

          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      }

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c33(s1);
      }

      s0 = s1;
      return s0;
    }

    function peg$parseUnitSchemes() {
      var s0, s1, s2, s3, s4, s5;
      s0 = peg$currPos;
      s1 = peg$parseParensOpen();

      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$parse_();

        if (s4 !== peg$FAILED) {
          s5 = peg$parseUnitScheme();

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }

        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parse_();

          if (s4 !== peg$FAILED) {
            s5 = peg$parseUnitScheme();

            if (s5 !== peg$FAILED) {
              s4 = [s4, s5];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }

        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();

          if (s3 !== peg$FAILED) {
            s4 = peg$parseParensClose();

            if (s4 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c34(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseOptionalDimensionIdentifier() {
      var s0, s1, s2, s3;
      s0 = peg$currPos;
      s1 = peg$parseDimensionIdentifier();

      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();

        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c35;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c36);
            }
          }

          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c37(s1);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseDimensionIdentifier() {
      var s0, s1;
      peg$silentFails++;
      s0 = peg$parseIdentifierLiteral();
      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c38);
        }
      }

      return s0;
    }

    function peg$parseNewUnitIdentifier() {
      var s0, s1;
      peg$silentFails++;
      s0 = peg$parseUnitIdentifierLiteral();
      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c39);
        }
      }

      return s0;
    }

    function peg$parseUnitScheme() {
      var s0, s1;
      peg$silentFails++;
      s0 = peg$parseIdentifierLiteral();
      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c40);
        }
      }

      return s0;
    }

    function peg$parseUnitExpression() {
      var s0, s1, s2, s3, s4, s5, s6, s7;
      s0 = peg$currPos;
      s1 = peg$parsenbsp();

      if (s1 !== peg$FAILED) {
        s2 = peg$currPos;
        s3 = peg$parseUnitPer();

        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();

          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }

        if (s2 === peg$FAILED) {
          s2 = null;
        }

        if (s2 !== peg$FAILED) {
          s3 = peg$parseUnitMultiplier();

          if (s3 !== peg$FAILED) {
            s4 = [];
            s5 = peg$currPos;
            s6 = peg$parseUnitMultiplicativeOperator();

            if (s6 !== peg$FAILED) {
              s7 = peg$parseUnitMultiplier();

              if (s7 !== peg$FAILED) {
                s6 = [s6, s7];
                s5 = s6;
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
            } else {
              peg$currPos = s5;
              s5 = peg$FAILED;
            }

            while (s5 !== peg$FAILED) {
              s4.push(s5);
              s5 = peg$currPos;
              s6 = peg$parseUnitMultiplicativeOperator();

              if (s6 !== peg$FAILED) {
                s7 = peg$parseUnitMultiplier();

                if (s7 !== peg$FAILED) {
                  s6 = [s6, s7];
                  s5 = s6;
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
            }

            if (s4 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c41(s2, s3, s4);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseUnitMultiplicativeOperator() {
      var s0, s1, s2, s3;
      s0 = peg$currPos;
      s1 = peg$parse_();

      if (s1 !== peg$FAILED) {
        s2 = peg$parseUnitPer();

        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();

          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c42(s2);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsenbsp_1();

        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c43(s1);
        }

        s0 = s1;
      }

      return s0;
    }

    function peg$parseUnitPer() {
      var s0, s1;
      peg$silentFails++;
      s0 = peg$currPos;
      s1 = peg$parseUnitPerLiteral();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c45(s1);
      }

      s0 = s1;
      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c44);
        }
      }

      return s0;
    }

    function peg$parseUnitPerLiteral() {
      var s0, s1, s2, s3;
      s0 = peg$currPos;

      if (input.substr(peg$currPos, 3) === peg$c46) {
        s1 = peg$c46;
        peg$currPos += 3;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c47);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$currPos;
        peg$silentFails++;
        s3 = peg$parseIdentifierPart();
        peg$silentFails--;

        if (s3 === peg$FAILED) {
          s2 = void 0;
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }

        if (s2 !== peg$FAILED) {
          s1 = [s1, s2];
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 47) {
          s0 = peg$c48;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c49);
          }
        }
      }

      return s0;
    }

    function peg$parseUnitMultiplier() {
      var s0, s1, s2, s3, s4, s5;
      s0 = peg$currPos;
      s1 = peg$parseUnitIdentifier();

      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();

        if (s2 !== peg$FAILED) {
          s3 = peg$parseRaiseToPowerOperator();

          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();

            if (s4 !== peg$FAILED) {
              s5 = peg$parseIntegerNode();

              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c50(s1, s3, s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseUnitIdentifier();

        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c51(s1);
        }

        s0 = s1;
      }

      return s0;
    }

    function peg$parseRaiseToPowerOperator() {
      var s0, s1;
      peg$silentFails++;
      s0 = peg$currPos;
      s1 = peg$parseRaiseToPowerOperatorLiteral();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c53(s1);
      }

      s0 = s1;
      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c52);
        }
      }

      return s0;
    }

    function peg$parseRaiseToPowerOperatorLiteral() {
      var s0, s1;

      if (input.charCodeAt(peg$currPos) === 94) {
        s0 = peg$c54;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c55);
        }
      }

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;

        if (input.substr(peg$currPos, 2) === peg$c56) {
          s1 = peg$c56;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c57);
          }
        }

        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c58();
        }

        s0 = s1;
      }

      return s0;
    }

    function peg$parseUnitIdentifier() {
      var s0, s1, s2;
      peg$silentFails++;
      s0 = peg$currPos;
      s1 = peg$parseUnitIdentifierLiteral();

      if (s1 !== peg$FAILED) {
        peg$savedPos = peg$currPos;
        s2 = peg$c60(s1);

        if (s2) {
          s2 = void 0;
        } else {
          s2 = peg$FAILED;
        }

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c61(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c59);
        }
      }

      return s0;
    }

    function peg$parseImportStatement() {
      var s0, s1, s2, s3;
      s0 = peg$currPos;

      if (input.substr(peg$currPos, 6) === peg$c62) {
        s1 = peg$c62;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c63);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();

        if (s2 !== peg$FAILED) {
          s3 = peg$parseStringLiteral();

          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c64(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseStringLiteral() {
      var s0, s1, s2, s3;
      s0 = peg$currPos;

      if (input.charCodeAt(peg$currPos) === 34) {
        s1 = peg$c65;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c66);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = [];

        if (peg$c67.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c68);
          }
        }

        while (s3 !== peg$FAILED) {
          s2.push(s3);

          if (peg$c67.test(input.charAt(peg$currPos))) {
            s3 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s3 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c68);
            }
          }
        }

        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 34) {
            s3 = peg$c65;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c66);
            }
          }

          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c69(s2);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseConstDefinition() {
      var s0, s1, s2, s3;
      s0 = peg$currPos;

      if (input.substr(peg$currPos, 5) === peg$c11) {
        s1 = peg$c11;
        peg$currPos += 5;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c12);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();

        if (s2 !== peg$FAILED) {
          s3 = peg$parseVariableDefinition();

          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c70(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseVariableDefinition() {
      var s0, s1, s2, s3, s4, s5;
      s0 = peg$currPos;
      s1 = peg$parseIdentifierLiteral();

      if (s1 !== peg$FAILED) {
        s2 = peg$parsenbsp();

        if (s2 !== peg$FAILED) {
          s3 = peg$parseAssignmentLiteral();

          if (s3 !== peg$FAILED) {
            s4 = peg$parsenbsp();

            if (s4 !== peg$FAILED) {
              s5 = peg$parseNumericalExpression();

              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c71(s1, s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseAssignmentLiteral() {
      var s0, s1, s2, s3, s4;
      peg$silentFails++;
      s0 = peg$currPos;

      if (input.charCodeAt(peg$currPos) === 58) {
        s1 = peg$c29;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c30);
        }
      }

      if (s1 === peg$FAILED) {
        s1 = null;
      }

      if (s1 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 61) {
          s2 = peg$c73;
          peg$currPos++;
        } else {
          s2 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c74);
          }
        }

        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          peg$silentFails++;

          if (input.charCodeAt(peg$currPos) === 61) {
            s4 = peg$c73;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c74);
            }
          }

          peg$silentFails--;

          if (s4 === peg$FAILED) {
            s3 = void 0;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }

          if (s3 !== peg$FAILED) {
            s1 = [s1, s2, s3];
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c72);
        }
      }

      return s0;
    }

    function peg$parseNumericalExpression() {
      var s0, s1, s2, s3, s4, s5, s6;
      s0 = peg$currPos;
      s1 = peg$parseNumbericalExpressionUnitConversion();

      if (s1 !== peg$FAILED) {
        s2 = peg$currPos;
        s3 = peg$parse_();

        if (s3 !== peg$FAILED) {
          s4 = peg$parseComparatorLiteral();

          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();

            if (s5 !== peg$FAILED) {
              s6 = peg$parseNumbericalExpressionUnitConversion();

              if (s6 !== peg$FAILED) {
                s3 = [s3, s4, s5, s6];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }

        if (s2 === peg$FAILED) {
          s2 = null;
        }

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c75(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseComparatorLiteral() {
      var s0, s1;
      peg$silentFails++;

      if (input.substr(peg$currPos, 2) === peg$c77) {
        s0 = peg$c77;
        peg$currPos += 2;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c78);
        }
      }

      if (s0 === peg$FAILED) {
        if (input.substr(peg$currPos, 2) === peg$c79) {
          s0 = peg$c79;
          peg$currPos += 2;
        } else {
          s0 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c80);
          }
        }

        if (s0 === peg$FAILED) {
          if (input.substr(peg$currPos, 2) === peg$c81) {
            s0 = peg$c81;
            peg$currPos += 2;
          } else {
            s0 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c82);
            }
          }

          if (s0 === peg$FAILED) {
            if (input.substr(peg$currPos, 2) === peg$c83) {
              s0 = peg$c83;
              peg$currPos += 2;
            } else {
              s0 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c84);
              }
            }

            if (s0 === peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 60) {
                s0 = peg$c85;
                peg$currPos++;
              } else {
                s0 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c86);
                }
              }

              if (s0 === peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 62) {
                  s0 = peg$c87;
                  peg$currPos++;
                } else {
                  s0 = peg$FAILED;

                  if (peg$silentFails === 0) {
                    peg$fail(peg$c88);
                  }
                }
              }
            }
          }
        }
      }

      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c76);
        }
      }

      return s0;
    }

    function peg$parseNumbericalExpressionUnitConversion() {
      var s0, s1, s2;
      s0 = peg$currPos;
      s1 = peg$parseAdditiveExpression();

      if (s1 !== peg$FAILED) {
        s2 = peg$parseUnitConversion();

        if (s2 === peg$FAILED) {
          s2 = null;
        }

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c89(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseUnitConversion() {
      var s0, s1, s2, s3, s4;
      s0 = peg$currPos;
      s1 = peg$parse_();

      if (s1 !== peg$FAILED) {
        s2 = peg$parseUnitConversionNode();

        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();

          if (s3 !== peg$FAILED) {
            s4 = peg$parseUnitExpression();

            if (s4 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c90(s2, s4);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseUnitConversionNode() {
      var s0, s1;
      peg$silentFails++;
      s0 = peg$currPos;

      if (input.substr(peg$currPos, 2) === peg$c92) {
        s1 = peg$c92;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c93);
        }
      }

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c94();
      }

      s0 = s1;
      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c91);
        }
      }

      return s0;
    }

    function peg$parseAdditiveExpression() {
      var s0, s1, s2, s3, s4, s5, s6, s7;
      s0 = peg$currPos;
      s1 = peg$parseMultiplicativeExpression();

      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$parse_();

        if (s4 !== peg$FAILED) {
          s5 = peg$parseAdditiveOperator();

          if (s5 !== peg$FAILED) {
            s6 = peg$parse_();

            if (s6 !== peg$FAILED) {
              s7 = peg$parseMultiplicativeExpression();

              if (s7 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }

        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parse_();

          if (s4 !== peg$FAILED) {
            s5 = peg$parseAdditiveOperator();

            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();

              if (s6 !== peg$FAILED) {
                s7 = peg$parseMultiplicativeExpression();

                if (s7 !== peg$FAILED) {
                  s4 = [s4, s5, s6, s7];
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c95(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseAdditiveOperator() {
      var s0, s1;
      s0 = peg$currPos;
      s1 = peg$parseAdditiveOperatorLiteral();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c96(s1);
      }

      s0 = s1;
      return s0;
    }

    function peg$parseAdditiveOperatorLiteral() {
      var s0, s1;
      peg$silentFails++;

      if (input.charCodeAt(peg$currPos) === 43) {
        s0 = peg$c98;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c99);
        }
      }

      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 45) {
          s0 = peg$c100;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c101);
          }
        }

        if (s0 === peg$FAILED) {
          if (input.substr(peg$currPos, 2) === peg$c102) {
            s0 = peg$c102;
            peg$currPos += 2;
          } else {
            s0 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c103);
            }
          }
        }
      }

      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c97);
        }
      }

      return s0;
    }

    function peg$parseMultiplicativeExpression() {
      var s0, s1, s2, s3, s4, s5, s6, s7;
      s0 = peg$currPos;
      s1 = peg$parseMultiplactionOperand();

      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$parse_();

        if (s4 !== peg$FAILED) {
          s5 = peg$parseMultiplicativeOperator();

          if (s5 !== peg$FAILED) {
            s6 = peg$parse_();

            if (s6 !== peg$FAILED) {
              s7 = peg$parseMultiplactionOperand();

              if (s7 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }

        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parse_();

          if (s4 !== peg$FAILED) {
            s5 = peg$parseMultiplicativeOperator();

            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();

              if (s6 !== peg$FAILED) {
                s7 = peg$parseMultiplactionOperand();

                if (s7 !== peg$FAILED) {
                  s4 = [s4, s5, s6, s7];
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c95(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseMultiplicativeOperator() {
      var s0, s1;
      peg$silentFails++;
      s0 = peg$currPos;
      s1 = peg$parseMultiplicativeOperatorLiteral();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c105(s1);
      }

      s0 = s1;
      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c104);
        }
      }

      return s0;
    }

    function peg$parseMultiplicativeOperatorLiteral() {
      var s0, s1, s2, s3;

      if (input.charCodeAt(peg$currPos) === 42) {
        s0 = peg$c106;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c107);
        }
      }

      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 215) {
          s0 = peg$c108;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c109);
          }
        }

        if (s0 === peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 47) {
            s0 = peg$c48;
            peg$currPos++;
          } else {
            s0 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c49);
            }
          }

          if (s0 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 247) {
              s0 = peg$c110;
              peg$currPos++;
            } else {
              s0 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c111);
              }
            }

            if (s0 === peg$FAILED) {
              if (input.substr(peg$currPos, 2) === peg$c112) {
                s0 = peg$c112;
                peg$currPos += 2;
              } else {
                s0 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c113);
                }
              }

              if (s0 === peg$FAILED) {
                s0 = peg$currPos;

                if (input.substr(peg$currPos, 2) === peg$c114) {
                  s1 = peg$c114;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;

                  if (peg$silentFails === 0) {
                    peg$fail(peg$c115);
                  }
                }

                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  peg$silentFails++;
                  s3 = peg$parseIdentifierPart();
                  peg$silentFails--;

                  if (s3 === peg$FAILED) {
                    s2 = void 0;
                  } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                  }

                  if (s2 !== peg$FAILED) {
                    s1 = [s1, s2];
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }

                if (s0 === peg$FAILED) {
                  s0 = peg$currPos;

                  if (input.substr(peg$currPos, 2) === peg$c116) {
                    s1 = peg$c116;
                    peg$currPos += 2;
                  } else {
                    s1 = peg$FAILED;

                    if (peg$silentFails === 0) {
                      peg$fail(peg$c117);
                    }
                  }

                  if (s1 !== peg$FAILED) {
                    s2 = peg$currPos;
                    peg$silentFails++;
                    s3 = peg$parseIdentifierPart();
                    peg$silentFails--;

                    if (s3 === peg$FAILED) {
                      s2 = void 0;
                    } else {
                      peg$currPos = s2;
                      s2 = peg$FAILED;
                    }

                    if (s2 !== peg$FAILED) {
                      s1 = [s1, s2];
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }

                  if (s0 === peg$FAILED) {
                    s0 = peg$currPos;

                    if (input.substr(peg$currPos, 2) === peg$c118) {
                      s1 = peg$c118;
                      peg$currPos += 2;
                    } else {
                      s1 = peg$FAILED;

                      if (peg$silentFails === 0) {
                        peg$fail(peg$c119);
                      }
                    }

                    if (s1 !== peg$FAILED) {
                      s2 = peg$currPos;
                      peg$silentFails++;
                      s3 = peg$parseIdentifierPart();
                      peg$silentFails--;

                      if (s3 === peg$FAILED) {
                        s2 = void 0;
                      } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                      }

                      if (s2 !== peg$FAILED) {
                        s1 = [s1, s2];
                        s0 = s1;
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }

                    if (s0 === peg$FAILED) {
                      s0 = peg$currPos;

                      if (input.substr(peg$currPos, 5) === peg$c120) {
                        s1 = peg$c120;
                        peg$currPos += 5;
                      } else {
                        s1 = peg$FAILED;

                        if (peg$silentFails === 0) {
                          peg$fail(peg$c121);
                        }
                      }

                      if (s1 !== peg$FAILED) {
                        s2 = peg$currPos;
                        peg$silentFails++;
                        s3 = peg$parseIdentifierPart();
                        peg$silentFails--;

                        if (s3 === peg$FAILED) {
                          s2 = void 0;
                        } else {
                          peg$currPos = s2;
                          s2 = peg$FAILED;
                        }

                        if (s2 !== peg$FAILED) {
                          s1 = [s1, s2];
                          s0 = s1;
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }

                      if (s0 === peg$FAILED) {
                        s0 = peg$currPos;

                        if (input.substr(peg$currPos, 3) === peg$c46) {
                          s1 = peg$c46;
                          peg$currPos += 3;
                        } else {
                          s1 = peg$FAILED;

                          if (peg$silentFails === 0) {
                            peg$fail(peg$c47);
                          }
                        }

                        if (s1 !== peg$FAILED) {
                          s2 = peg$currPos;
                          peg$silentFails++;
                          s3 = peg$parseIdentifierPart();
                          peg$silentFails--;

                          if (s3 === peg$FAILED) {
                            s2 = void 0;
                          } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                          }

                          if (s2 !== peg$FAILED) {
                            s1 = [s1, s2];
                            s0 = s1;
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parseMultiplactionOperand() {
      var s0, s1, s2;
      s0 = peg$currPos;
      s1 = peg$parseMultiplactionOperandWithoutUnit();

      if (s1 !== peg$FAILED) {
        s2 = peg$parseUnitExpression();

        if (s2 === peg$FAILED) {
          s2 = null;
        }

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c122(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseMultiplactionOperandWithoutUnit() {
      var s0, s1, s2, s3, s4;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parseAdditiveOperator();

      if (s3 !== peg$FAILED) {
        s4 = peg$parse_();

        if (s4 !== peg$FAILED) {
          s3 = [s3, s4];
          s2 = s3;
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$currPos;
        s3 = peg$parseAdditiveOperator();

        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();

          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$parseNamedBinaryOperation();

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c123(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseNamedBinaryOperation() {
      var s0, s1, s2, s3, s4, s5, s6, s7;
      s0 = peg$currPos;
      s1 = peg$parseNamedPostfixUnaryOperation();

      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$parse_();

        if (s4 !== peg$FAILED) {
          s5 = peg$parseNamedBinaryOperator();

          if (s5 !== peg$FAILED) {
            s6 = peg$parse_();

            if (s6 !== peg$FAILED) {
              s7 = peg$parseNamedPostfixUnaryOperation();

              if (s7 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }

        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parse_();

          if (s4 !== peg$FAILED) {
            s5 = peg$parseNamedBinaryOperator();

            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();

              if (s6 !== peg$FAILED) {
                s7 = peg$parseNamedPostfixUnaryOperation();

                if (s7 !== peg$FAILED) {
                  s4 = [s4, s5, s6, s7];
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c124(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseNamedBinaryOperator() {
      var s0, s1;
      peg$silentFails++;
      s0 = peg$currPos;
      s1 = peg$parseNamedBinaryOperatorLiteral();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c126(s1);
      }

      s0 = s1;
      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c125);
        }
      }

      return s0;
    }

    function peg$parseNamedBinaryOperatorLiteral() {
      var s0, s1, s2;
      s0 = peg$parseSpecialNamedBinaryOperator();

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseIdentifierLiteral();

        if (s1 !== peg$FAILED) {
          peg$savedPos = peg$currPos;
          s2 = peg$c127(s1);

          if (s2) {
            s2 = void 0;
          } else {
            s2 = peg$FAILED;
          }

          if (s2 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c128(s1);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }

      return s0;
    }

    function peg$parseSpecialNamedBinaryOperator() {
      var s0;

      if (input.charCodeAt(peg$currPos) === 94) {
        s0 = peg$c54;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c55);
        }
      }

      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 8730) {
          s0 = peg$c129;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c130);
          }
        }
      }

      return s0;
    }

    function peg$parseNamedPrefixUnaryOperation() {
      var s0, s1, s2, s3, s4;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parseNamedPrefixOperator();

      if (s3 !== peg$FAILED) {
        s4 = peg$parse_();

        if (s4 !== peg$FAILED) {
          s3 = [s3, s4];
          s2 = s3;
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$currPos;
        s3 = peg$parseNamedPrefixOperator();

        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();

          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$parseValueOrParens();

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c131(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseNamedPrefixOperator() {
      var s0, s1;
      peg$silentFails++;
      s0 = peg$currPos;
      s1 = peg$parseSymbolTablePrefixOperator();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c133(s1);
      }

      s0 = s1;
      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c132);
        }
      }

      return s0;
    }

    function peg$parseSymbolTablePrefixOperator() {
      var s0, s1, s2, s3;

      if (input.substr(peg$currPos, 4) === peg$c134) {
        s0 = peg$c134;
        peg$currPos += 4;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c135);
        }
      }

      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 8730) {
          s0 = peg$c129;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c130);
          }
        }

        if (s0 === peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 45) {
            s0 = peg$c100;
            peg$currPos++;
          } else {
            s0 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c101);
            }
          }

          if (s0 === peg$FAILED) {
            s0 = peg$currPos;

            if (input.charCodeAt(peg$currPos) === 33) {
              s1 = peg$c136;
              peg$currPos++;
            } else {
              s1 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c137);
              }
            }

            if (s1 !== peg$FAILED) {
              s2 = peg$currPos;
              peg$silentFails++;

              if (input.charCodeAt(peg$currPos) === 61) {
                s3 = peg$c73;
                peg$currPos++;
              } else {
                s3 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c74);
                }
              }

              peg$silentFails--;

              if (s3 === peg$FAILED) {
                s2 = void 0;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }

              if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c138();
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }

            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = peg$parseIdentifierLiteral();

              if (s1 !== peg$FAILED) {
                peg$savedPos = peg$currPos;
                s2 = peg$c139(s1);

                if (s2) {
                  s2 = void 0;
                } else {
                  s2 = peg$FAILED;
                }

                if (s2 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c140(s1);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parseNamedPostfixUnaryOperation() {
      var s0, s1, s2, s3, s4, s5;
      s0 = peg$currPos;
      s1 = peg$parseNamedPrefixUnaryOperation();

      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$parse_();

        if (s4 !== peg$FAILED) {
          s5 = peg$parseNamedPostfixOperator();

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }

        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parse_();

          if (s4 !== peg$FAILED) {
            s5 = peg$parseNamedPostfixOperator();

            if (s5 !== peg$FAILED) {
              s4 = [s4, s5];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c141(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseNamedPostfixOperator() {
      var s0, s1;
      peg$silentFails++;
      s0 = peg$currPos;
      s1 = peg$parseSymbolTablePostfixOperator();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c133(s1);
      }

      s0 = s1;
      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c142);
        }
      }

      return s0;
    }

    function peg$parseSymbolTablePostfixOperator() {
      var s0, s1, s2, s3;
      peg$silentFails++;
      s0 = peg$currPos;

      if (input.charCodeAt(peg$currPos) === 33) {
        s1 = peg$c136;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c137);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$currPos;
        peg$silentFails++;

        if (input.charCodeAt(peg$currPos) === 61) {
          s3 = peg$c73;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c74);
          }
        }

        peg$silentFails--;

        if (s3 === peg$FAILED) {
          s2 = void 0;
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c143();
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 37) {
          s0 = peg$c144;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c145);
          }
        }

        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parseIdentifierLiteral();

          if (s1 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s2 = peg$c146(s1);

            if (s2) {
              s2 = void 0;
            } else {
              s2 = peg$FAILED;
            }

            if (s2 !== peg$FAILED) {
              s1 = [s1, s2];
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        }
      }

      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c142);
        }
      }

      return s0;
    }

    function peg$parseValueOrParens() {
      var s0, s1, s2, s3, s4, s5;
      s0 = peg$currPos;
      s1 = peg$parseTerminal();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c147(s1);
      }

      s0 = s1;

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseParensOpen();

        if (s1 !== peg$FAILED) {
          s2 = peg$parse_();

          if (s2 !== peg$FAILED) {
            s3 = peg$parseNumericalExpression();

            if (s3 !== peg$FAILED) {
              s4 = peg$parse_();

              if (s4 !== peg$FAILED) {
                s5 = peg$parseParensClose();

                if (s5 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c148(s1, s3, s5);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }

      return s0;
    }

    function peg$parseParensOpen() {
      var s0, s1;
      peg$silentFails++;

      if (input.charCodeAt(peg$currPos) === 40) {
        s0 = peg$c150;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c151);
        }
      }

      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c149);
        }
      }

      return s0;
    }

    function peg$parseParensClose() {
      var s0, s1;
      peg$silentFails++;
      s0 = peg$currPos;

      if (input.charCodeAt(peg$currPos) === 41) {
        s1 = peg$c153;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c154);
        }
      }

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c155();
      }

      s0 = s1;
      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c152);
        }
      }

      return s0;
    }

    function peg$parseTerminal() {
      var s0;
      s0 = peg$parseNumber();

      if (s0 === peg$FAILED) {
        s0 = peg$parseIdentifier();
      }

      return s0;
    }

    function peg$parseIdentifier() {
      var s0, s1, s2;
      peg$silentFails++;
      s0 = peg$currPos;
      s1 = peg$parseIdentifierLiteral();

      if (s1 !== peg$FAILED) {
        peg$savedPos = peg$currPos;
        s2 = peg$c157(s1);

        if (s2) {
          s2 = void 0;
        } else {
          s2 = peg$FAILED;
        }

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c158(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c156);
        }
      }

      return s0;
    }

    function peg$parseUnitIdentifierLiteral() {
      var s0;
      s0 = peg$parseSpecialUnitLiteral();

      if (s0 === peg$FAILED) {
        s0 = peg$parseIdentifierLiteral();
      }

      return s0;
    }

    function peg$parseSpecialUnitLiteral() {
      var s0;

      if (input.charCodeAt(peg$currPos) === 65020) {
        s0 = peg$c159;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c160);
        }
      }

      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 8353) {
          s0 = peg$c161;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c162);
          }
        }

        if (s0 === peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 8366) {
            s0 = peg$c163;
            peg$currPos++;
          } else {
            s0 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c164);
            }
          }

          if (s0 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 8358) {
              s0 = peg$c165;
              peg$currPos++;
            } else {
              s0 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c166);
              }
            }

            if (s0 === peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 36) {
                s0 = peg$c167;
                peg$currPos++;
              } else {
                s0 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c168);
                }
              }

              if (s0 === peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 163) {
                  s0 = peg$c169;
                  peg$currPos++;
                } else {
                  s0 = peg$FAILED;

                  if (peg$silentFails === 0) {
                    peg$fail(peg$c170);
                  }
                }

                if (s0 === peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 8377) {
                    s0 = peg$c171;
                    peg$currPos++;
                  } else {
                    s0 = peg$FAILED;

                    if (peg$silentFails === 0) {
                      peg$fail(peg$c172);
                    }
                  }

                  if (s0 === peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 165) {
                      s0 = peg$c173;
                      peg$currPos++;
                    } else {
                      s0 = peg$FAILED;

                      if (peg$silentFails === 0) {
                        peg$fail(peg$c174);
                      }
                    }

                    if (s0 === peg$FAILED) {
                      if (input.charCodeAt(peg$currPos) === 8365) {
                        s0 = peg$c175;
                        peg$currPos++;
                      } else {
                        s0 = peg$FAILED;

                        if (peg$silentFails === 0) {
                          peg$fail(peg$c176);
                        }
                      }

                      if (s0 === peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 402) {
                          s0 = peg$c177;
                          peg$currPos++;
                        } else {
                          s0 = peg$FAILED;

                          if (peg$silentFails === 0) {
                            peg$fail(peg$c178);
                          }
                        }

                        if (s0 === peg$FAILED) {
                          if (input.charCodeAt(peg$currPos) === 8361) {
                            s0 = peg$c179;
                            peg$currPos++;
                          } else {
                            s0 = peg$FAILED;

                            if (peg$silentFails === 0) {
                              peg$fail(peg$c180);
                            }
                          }

                          if (s0 === peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 8360) {
                              s0 = peg$c181;
                              peg$currPos++;
                            } else {
                              s0 = peg$FAILED;

                              if (peg$silentFails === 0) {
                                peg$fail(peg$c182);
                              }
                            }

                            if (s0 === peg$FAILED) {
                              if (input.charCodeAt(peg$currPos) === 8364) {
                                s0 = peg$c183;
                                peg$currPos++;
                              } else {
                                s0 = peg$FAILED;

                                if (peg$silentFails === 0) {
                                  peg$fail(peg$c184);
                                }
                              }

                              if (s0 === peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 8362) {
                                  s0 = peg$c185;
                                  peg$currPos++;
                                } else {
                                  s0 = peg$FAILED;

                                  if (peg$silentFails === 0) {
                                    peg$fail(peg$c186);
                                  }
                                }

                                if (s0 === peg$FAILED) {
                                  if (input.charCodeAt(peg$currPos) === 8369) {
                                    s0 = peg$c187;
                                    peg$currPos++;
                                  } else {
                                    s0 = peg$FAILED;

                                    if (peg$silentFails === 0) {
                                      peg$fail(peg$c188);
                                    }
                                  }

                                  if (s0 === peg$FAILED) {
                                    if (input.charCodeAt(peg$currPos) === 3647) {
                                      s0 = peg$c189;
                                      peg$currPos++;
                                    } else {
                                      s0 = peg$FAILED;

                                      if (peg$silentFails === 0) {
                                        peg$fail(peg$c190);
                                      }
                                    }

                                    if (s0 === peg$FAILED) {
                                      if (input.charCodeAt(peg$currPos) === 1547) {
                                        s0 = peg$c191;
                                        peg$currPos++;
                                      } else {
                                        s0 = peg$FAILED;

                                        if (peg$silentFails === 0) {
                                          peg$fail(peg$c192);
                                        }
                                      }

                                      if (s0 === peg$FAILED) {
                                        if (input.charCodeAt(peg$currPos) === 6107) {
                                          s0 = peg$c193;
                                          peg$currPos++;
                                        } else {
                                          s0 = peg$FAILED;

                                          if (peg$silentFails === 0) {
                                            peg$fail(peg$c194);
                                          }
                                        }

                                        if (s0 === peg$FAILED) {
                                          if (input.charCodeAt(peg$currPos) === 8363) {
                                            s0 = peg$c195;
                                            peg$currPos++;
                                          } else {
                                            s0 = peg$FAILED;

                                            if (peg$silentFails === 0) {
                                              peg$fail(peg$c196);
                                            }
                                          }

                                          if (s0 === peg$FAILED) {
                                            if (input.charCodeAt(peg$currPos) === 8372) {
                                              s0 = peg$c197;
                                              peg$currPos++;
                                            } else {
                                              s0 = peg$FAILED;

                                              if (peg$silentFails === 0) {
                                                peg$fail(peg$c198);
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parseIdentifierLiteral() {
      var s0, s1, s2, s3, s4;
      peg$silentFails++;
      s0 = peg$currPos;
      s1 = peg$currPos;
      peg$silentFails++;
      s2 = peg$currPos;
      s3 = peg$parseKeywordLiteral();

      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();

        if (s4 !== peg$FAILED) {
          s3 = [s3, s4];
          s2 = s3;
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }

      peg$silentFails--;

      if (s2 === peg$FAILED) {
        s1 = void 0;
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$parseIdentifierStart();

        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseIdentifierPart();

          while (s4 !== peg$FAILED) {
            s3.push(s4);
            s4 = peg$parseIdentifierPart();
          }

          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c200(s2, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c199);
        }
      }

      return s0;
    }

    function peg$parseNumber() {
      var s0, s1;
      s0 = peg$currPos;
      s1 = peg$parseNumberLiteralString();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c201(s1);
      }

      s0 = s1;
      return s0;
    }

    function peg$parseNumberLiteral() {
      var s0, s1;
      s0 = peg$currPos;
      s1 = peg$parseNumberLiteralString();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c202(s1);
      }

      s0 = s1;
      return s0;
    }

    function peg$parseNumberLiteralString() {
      var s0, s1, s2, s3;
      s0 = peg$currPos;
      s1 = peg$parseAdditiveOperatorLiteral();

      if (s1 === peg$FAILED) {
        s1 = null;
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$parseNumberLiteralFromParts();

        if (s2 !== peg$FAILED) {
          s3 = peg$parseExponentLiteral();

          if (s3 === peg$FAILED) {
            s3 = null;
          }

          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c203(s1, s2, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseNumberLiteralFromParts() {
      var s0, s1, s2;
      s0 = peg$currPos;
      s1 = peg$parseNumberWholePart();

      if (s1 !== peg$FAILED) {
        s2 = peg$parseNumberDecimalPart();

        if (s2 === peg$FAILED) {
          s2 = null;
        }

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c204(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseNumberDecimalPart();

        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c205(s1);
        }

        s0 = s1;
      }

      return s0;
    }

    function peg$parseNumberWholePart() {
      var s0, s1;
      s0 = peg$currPos;
      s1 = peg$parseDigits();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c206(s1);
      }

      s0 = s1;
      return s0;
    }

    function peg$parseDigits() {
      var s0, s1, s2;
      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];

      if (peg$c208.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c209);
        }
      }

      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);

          if (peg$c208.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c209);
            }
          }
        }
      } else {
        s1 = peg$FAILED;
      }

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c210(s1);
      }

      s0 = s1;
      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c207);
        }
      }

      return s0;
    }

    function peg$parseNumberDecimalPart() {
      var s0, s1, s2;
      s0 = peg$currPos;
      s1 = peg$parseDecimalPoint();

      if (s1 !== peg$FAILED) {
        s2 = peg$parseDigits();

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c211(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseDecimalPoint() {
      var s0, s1;
      peg$silentFails++;

      if (input.charCodeAt(peg$currPos) === 46) {
        s0 = peg$c213;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c214);
        }
      }

      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c212);
        }
      }

      return s0;
    }

    function peg$parseExponentLiteral() {
      var s0, s1, s2;
      s0 = peg$currPos;
      s1 = peg$parseExponentSign();

      if (s1 !== peg$FAILED) {
        s2 = peg$parseIntegerString();

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c215(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseExponentSign() {
      var s0, s1;
      peg$silentFails++;

      if (input.charCodeAt(peg$currPos) === 101) {
        s0 = peg$c217;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c218);
        }
      }

      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 69) {
          s0 = peg$c219;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c220);
          }
        }
      }

      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c216);
        }
      }

      return s0;
    }

    function peg$parseIntegerNode() {
      var s0, s1;
      s0 = peg$currPos;
      s1 = peg$parseIntegerString();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c221(s1);
      }

      s0 = s1;
      return s0;
    }

    function peg$parseIntegerLiteral() {
      var s0, s1;
      s0 = peg$currPos;
      s1 = peg$parseIntegerString();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c222(s1);
      }

      s0 = s1;
      return s0;
    }

    function peg$parseIntegerString() {
      var s0, s1, s2;
      s0 = peg$currPos;
      s1 = peg$parseAdditiveOperatorLiteral();

      if (s1 === peg$FAILED) {
        s1 = null;
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$parseNumberWholePart();

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c223(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseKeywordLiteral() {
      var s0;

      if (input.substr(peg$currPos, 4) === peg$c8) {
        s0 = peg$c8;
        peg$currPos += 4;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c9);
        }
      }

      if (s0 === peg$FAILED) {
        if (input.substr(peg$currPos, 3) === peg$c46) {
          s0 = peg$c46;
          peg$currPos += 3;
        } else {
          s0 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c47);
          }
        }

        if (s0 === peg$FAILED) {
          if (input.substr(peg$currPos, 5) === peg$c11) {
            s0 = peg$c11;
            peg$currPos += 5;
          } else {
            s0 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c12);
            }
          }

          if (s0 === peg$FAILED) {
            if (input.substr(peg$currPos, 4) === peg$c224) {
              s0 = peg$c224;
              peg$currPos += 4;
            } else {
              s0 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c225);
              }
            }

            if (s0 === peg$FAILED) {
              if (input.substr(peg$currPos, 7) === peg$c226) {
                s0 = peg$c226;
                peg$currPos += 7;
              } else {
                s0 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c227);
                }
              }

              if (s0 === peg$FAILED) {
                if (input.substr(peg$currPos, 5) === peg$c228) {
                  s0 = peg$c228;
                  peg$currPos += 5;
                } else {
                  s0 = peg$FAILED;

                  if (peg$silentFails === 0) {
                    peg$fail(peg$c229);
                  }
                }

                if (s0 === peg$FAILED) {
                  if (input.substr(peg$currPos, 3) === peg$c230) {
                    s0 = peg$c230;
                    peg$currPos += 3;
                  } else {
                    s0 = peg$FAILED;

                    if (peg$silentFails === 0) {
                      peg$fail(peg$c231);
                    }
                  }

                  if (s0 === peg$FAILED) {
                    if (input.substr(peg$currPos, 2) === peg$c92) {
                      s0 = peg$c92;
                      peg$currPos += 2;
                    } else {
                      s0 = peg$FAILED;

                      if (peg$silentFails === 0) {
                        peg$fail(peg$c93);
                      }
                    }

                    if (s0 === peg$FAILED) {
                      if (input.substr(peg$currPos, 2) === peg$c114) {
                        s0 = peg$c114;
                        peg$currPos += 2;
                      } else {
                        s0 = peg$FAILED;

                        if (peg$silentFails === 0) {
                          peg$fail(peg$c115);
                        }
                      }

                      if (s0 === peg$FAILED) {
                        if (input.substr(peg$currPos, 2) === peg$c116) {
                          s0 = peg$c116;
                          peg$currPos += 2;
                        } else {
                          s0 = peg$FAILED;

                          if (peg$silentFails === 0) {
                            peg$fail(peg$c117);
                          }
                        }

                        if (s0 === peg$FAILED) {
                          if (input.substr(peg$currPos, 5) === peg$c120) {
                            s0 = peg$c120;
                            peg$currPos += 5;
                          } else {
                            s0 = peg$FAILED;

                            if (peg$silentFails === 0) {
                              peg$fail(peg$c121);
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2, s3, s4, s5, s6;
      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];

      if (peg$c233.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c234);
        }
      }

      while (s2 !== peg$FAILED) {
        s1.push(s2);

        if (peg$c233.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c234);
          }
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$parseComment();

        if (s4 !== peg$FAILED) {
          s5 = [];

          if (peg$c235.test(input.charAt(peg$currPos))) {
            s6 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s6 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c236);
            }
          }

          while (s6 !== peg$FAILED) {
            s5.push(s6);

            if (peg$c235.test(input.charAt(peg$currPos))) {
              s6 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s6 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c236);
              }
            }
          }

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }

        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parseComment();

          if (s4 !== peg$FAILED) {
            s5 = [];

            if (peg$c235.test(input.charAt(peg$currPos))) {
              s6 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s6 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c236);
              }
            }

            while (s6 !== peg$FAILED) {
              s5.push(s6);

              if (peg$c235.test(input.charAt(peg$currPos))) {
                s6 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s6 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c236);
                }
              }
            }

            if (s5 !== peg$FAILED) {
              s4 = [s4, s5];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }

        if (s2 !== peg$FAILED) {
          s1 = [s1, s2];
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c232);
        }
      }

      return s0;
    }

    function peg$parseComment() {
      var s0, s1, s2, s3;
      s0 = peg$currPos;

      if (input.substr(peg$currPos, 2) === peg$c237) {
        s1 = peg$c237;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c238);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = [];

        if (peg$c239.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c240);
          }
        }

        while (s3 !== peg$FAILED) {
          s2.push(s3);

          if (peg$c239.test(input.charAt(peg$currPos))) {
            s3 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s3 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c240);
            }
          }
        }

        if (s2 !== peg$FAILED) {
          s3 = peg$parseCR();

          if (s3 !== peg$FAILED) {
            s1 = [s1, s2, s3];
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parse__() {
      var s0, s1;
      peg$silentFails++;
      s0 = [];

      if (peg$c235.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c236);
        }
      }

      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);

          if (peg$c235.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c236);
            }
          }
        }
      } else {
        s0 = peg$FAILED;
      }

      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c241);
        }
      }

      return s0;
    }

    function peg$parsenbsp() {
      var s0, s1;
      s0 = [];

      if (peg$c235.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c236);
        }
      }

      while (s1 !== peg$FAILED) {
        s0.push(s1);

        if (peg$c235.test(input.charAt(peg$currPos))) {
          s1 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s1 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c236);
          }
        }
      }

      return s0;
    }

    function peg$parsenbsp_1() {
      var s0, s1;
      s0 = [];

      if (peg$c235.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c236);
        }
      }

      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);

          if (peg$c235.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c236);
            }
          }
        }
      } else {
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseIdentifierStart() {
      var s0, s1, s2;
      s0 = peg$parseUnicodeLetter();

      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 36) {
          s0 = peg$c167;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c168);
          }
        }

        if (s0 === peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 95) {
            s0 = peg$c242;
            peg$currPos++;
          } else {
            s0 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c243);
            }
          }

          if (s0 === peg$FAILED) {
            s0 = peg$currPos;

            if (input.charCodeAt(peg$currPos) === 92) {
              s1 = peg$c244;
              peg$currPos++;
            } else {
              s1 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c245);
              }
            }

            if (s1 !== peg$FAILED) {
              s2 = peg$parseUnicodeEscapeSequence();

              if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c246(s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          }
        }
      }

      return s0;
    }

    function peg$parseIdentifierPart() {
      var s0;
      s0 = peg$parseIdentifierStart();

      if (s0 === peg$FAILED) {
        s0 = peg$parseUnicodeCombiningMark();

        if (s0 === peg$FAILED) {
          s0 = peg$parseNd();

          if (s0 === peg$FAILED) {
            s0 = peg$parsePc();

            if (s0 === peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 8204) {
                s0 = peg$c247;
                peg$currPos++;
              } else {
                s0 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c248);
                }
              }

              if (s0 === peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 8205) {
                  s0 = peg$c249;
                  peg$currPos++;
                } else {
                  s0 = peg$FAILED;

                  if (peg$silentFails === 0) {
                    peg$fail(peg$c250);
                  }
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parseUnicodeLetter() {
      var s0;
      s0 = peg$parseLu();

      if (s0 === peg$FAILED) {
        s0 = peg$parseLl();

        if (s0 === peg$FAILED) {
          s0 = peg$parseLt();

          if (s0 === peg$FAILED) {
            s0 = peg$parseLm();

            if (s0 === peg$FAILED) {
              s0 = peg$parseLo();

              if (s0 === peg$FAILED) {
                s0 = peg$parseNl();
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parseUnicodeCombiningMark() {
      var s0;
      s0 = peg$parseMn();

      if (s0 === peg$FAILED) {
        s0 = peg$parseMc();
      }

      return s0;
    }

    function peg$parseUnicodeEscapeSequence() {
      var s0, s1, s2, s3, s4, s5, s6;
      s0 = peg$currPos;

      if (input.charCodeAt(peg$currPos) === 117) {
        s1 = peg$c251;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c252);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$currPos;
        s3 = peg$parseHexDigit();

        if (s3 !== peg$FAILED) {
          s4 = peg$parseHexDigit();

          if (s4 !== peg$FAILED) {
            s5 = peg$parseHexDigit();

            if (s5 !== peg$FAILED) {
              s6 = peg$parseHexDigit();

              if (s6 !== peg$FAILED) {
                s3 = [s3, s4, s5, s6];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c253(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseHexDigit() {
      var s0;

      if (peg$c254.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c255);
        }
      }

      return s0;
    }

    function peg$parseLl() {
      var s0;

      if (peg$c256.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c257);
        }
      }

      return s0;
    }

    function peg$parseLm() {
      var s0;

      if (peg$c258.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c259);
        }
      }

      return s0;
    }

    function peg$parseLo() {
      var s0;

      if (peg$c260.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c261);
        }
      }

      return s0;
    }

    function peg$parseLt() {
      var s0;

      if (peg$c262.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c263);
        }
      }

      return s0;
    }

    function peg$parseLu() {
      var s0;

      if (peg$c264.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c265);
        }
      }

      return s0;
    }

    function peg$parseMc() {
      var s0;

      if (peg$c266.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c267);
        }
      }

      return s0;
    }

    function peg$parseMn() {
      var s0;

      if (peg$c268.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c269);
        }
      }

      return s0;
    }

    function peg$parseNd() {
      var s0;

      if (peg$c270.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c271);
        }
      }

      return s0;
    }

    function peg$parseNl() {
      var s0;

      if (peg$c272.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c273);
        }
      }

      return s0;
    }

    function peg$parsePc() {
      var s0;

      if (peg$c274.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c275);
        }
      }

      return s0;
    }

    function peg$parseZs() {
      var s0;

      if (peg$c276.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c277);
        }
      }

      return s0;
    }

    var helper = __webpack_require__(23).default;

    var ast = __webpack_require__(7).default;

    var operators = this.operators;
    var self = this;
    var units = this.scope.units;
    var inputLength = this.inputLength || input.length;
    var parseContext = this.parseContext;
    this.reservedWords = ["unit", "per", "const", "include", "unit", "let"];
    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail(peg$endExpectation());
      }

      throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
    }
  }

  module.exports = {
    SyntaxError: peg$SyntaxError,
    parse: peg$parse
  };
  /***/
},
/* 23 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: true
  });
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__ast__ = __webpack_require__(7);

  var infixAliases = {
    '**': '^',
    '÷': '/',
    'per': '/',
    '√': 'nth_root',
    ' ': '*',
    '×': '*',
    'at': '*',
    'of': '*',
    'by': '*',
    'every': '/',
    '&&': 'AND',
    '||': 'OR'
  };
  var unaryAliases = {
    '√': 'sqrt'
  };

  function decorateTerminal(node, line, offset, string) {
    var last = offset + string.length - 1;
    node._offsetFirst = offset;
    node._offsetLast = last;
    node._offsetLiteralFirst = offset;
    node._offsetLiteralLast = last;
    node.line = line;
    return node;
  }

  function decorateNonTerminal(node, line, offset, string) {
    var last = offset + string.length - 1;
    node._offsetLiteralFirst = offset;
    node._offsetLiteralLast = last;
    node.line = line;
    return node;
  }

  function decorateStatement(node, line, offset, lineEnd) {
    if (!node) {
      if (lineEnd.text === 'undefined') {
        console.log('boingboing', lineEnd.text, node, line, offset);
      }

      node = new __WEBPACK_IMPORTED_MODULE_0__ast__["default"].UnparsedText(lineEnd.text, line, offset, lineEnd.lineLast);
    } else {
      node.textToEol = lineEnd.text;
      node.lineFirst = line;
      node.statementOffsetFirst = offset;
      node.statementOffsetLast = lineEnd.offsetLast;
      node.lineLast = lineEnd.lineLast;
    }

    return node;
  } ////////////////////////////////////////////////////////////


  function unpackLeftBinaryOperations(head, tail) {
    // head:MultiplicativeExpression
    // tail:(_ AdditiveOperator _ MultiplicativeExpression)* _
    var result = head,
        op;

    for (var i = 0, max = tail.length; i < max; i++) {
      op = tail[i][1];
      result = new __WEBPACK_IMPORTED_MODULE_0__ast__["default"].BinaryNode(result, tail[i][3], infixAliases[op.literal] || op.literal);
      decorateNonTerminal(result, op.line, op.offset, op.literal);
    }

    return result;
  }

  function unpackRightBinaryOperations(head, tail) {
    if (!tail || tail.length === 0) {
      return head;
    } // head:MultiplicativeExpression
    // tail:(_ AdditiveOperator _ MultiplicativeExpression)* _


    var left, result, op; // 1 op 2 op 3
    // 2^3^4 2^(3^4)

    for (var i = tail.length - 1; i >= 0; i--) {
      if (!result) {
        result = tail[i][3];
        op = tail[i][1];
      } else {
        left = tail[i][3];
        result = new __WEBPACK_IMPORTED_MODULE_0__ast__["default"].BinaryNode(left, result, infixAliases[op.literal] || op.literal);
        decorateNonTerminal(result, op.line, op.offset, op.literal);
        op = tail[i][1];
      }
    }

    result = new __WEBPACK_IMPORTED_MODULE_0__ast__["default"].BinaryNode(head, result, infixAliases[op.literal] || op.literal);
    return decorateNonTerminal(result, op.line, op.offset, op.literal);
  }

  function unpackUnaryOperations(current, operators, isPrefix) {
    // (NamedPostfixOperator _)*
    var op,
        literalIndex = 1;

    if (isPrefix) {
      operators = operators.reverse();
      literalIndex = 0;
    }

    for (var i = 0, max = operators.length; i < max; i++) {
      op = operators[i][literalIndex];
      current = new __WEBPACK_IMPORTED_MODULE_0__ast__["default"].UnaryOperationNode(current, unaryAliases[op.literal] || op.literal, isPrefix);
      current.line = op.line;
      current._offsetLiteralFirst = op.offset;
      current._offsetLiteralLast = op.offset + op.literal.length - 1;

      if (isPrefix) {
        current._offsetFirst = current._offsetLiteralFirst;
        delete current._offsetLast;
      } else {
        delete current._offsetFirst;
        current._offsetLast = current._offsetLiteralLast;
      }
    }

    return current;
  }
  /* harmony default export */


  __webpack_exports__["default"] = {
    decorateStatement: decorateStatement,
    decorateTerminal: decorateTerminal,
    decorateNonTerminal: decorateNonTerminal,
    unpackUnaryOperations: unpackUnaryOperations,
    unpackLeftBinaryOperations: unpackLeftBinaryOperations,
    unpackRightBinaryOperations: unpackRightBinaryOperations,
    unaryAliases: unaryAliases,
    infixAliases: infixAliases
  };
  /***/
},
/* 24 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  /**
   * The scope is a super set of files and function and block scopes.
   *
   * It is intended for the parser, the execution context and the 
   * editor to use this object.
   *
   * Imports are modelled as parent scopes to the current document scope.
   *
   * In this manner, we can have local variables, units and functions, as
   * well as specialized language features.
   *
   * This class deprecates many other symbol table type objects. i.e. Variables, Operators,
   * in favour of adding extra data structures to Scope.
   *
   * The class provides scope management, as well as finding and collecting objects that 
   * are available to statements in this scope.
   *
   * The scope search rules are:
   * - Any definitions in the document scope are available to documents imported into it.
   * - Any child scope (such as a function or block) has access to the definitions available 
   * in the parent scope, but not vice versa.
   * - Any scope can have definitions in them, including imports.
   * - Imports are searched before parents.
   */


  var nextId = function () {
    var currentId = 0;
    return function () {
      return currentId++;
    };
  }(); ////////////////////////////////////////////////////////////////////
  // DAO


  var Scope = function () {
    function Scope(parent, id, unitsTable) {
      _classCallCheck(this, Scope);

      this.parent = parent;
      this._unitsTable = unitsTable;
      this.id = id || nextId();

      this._init();

      this._nextChildId = 0;
    }

    _createClass(Scope, [{
      key: '_init',
      value: function _init() {
        this._variables = {};
        this._units = {};
        this._includes = {};
      }
    }, {
      key: 'clone',
      value: function clone() {
        var clone = new Scope(this.parent, this.id, this._unitsTable);
        return Object.assign(clone, this);
      }
    }, {
      key: 'getImport',
      value: function getImport(name) {
        return this._includes[name];
      }
    }, {
      key: 'addImport',
      value: function addImport(name, scope) {
        this._includes[name] = scope;
        return scope;
      }
    }, {
      key: 'findImport',
      value: function findImport(name) {
        return this._findFirst(this.getImport, arguments);
      } ////////////////////////////////////////////////////////////////////
      // Units
      ////////

    }, {
      key: 'getUnit',
      value: function getUnit(name) {
        return this._units[name];
      }
    }, {
      key: 'findUnit',
      value: function findUnit(name) {
        var unit = this._findFirst(this.getUnit, arguments);

        return unit;
      }
    }, {
      key: '_addUnit',
      value: function _addUnit(name, value) {
        if (name) this._units[name] = value;
      }
    }, {
      key: 'addUnit',
      value: function addUnit(unit, name, alternatives) {
        var _this = this;

        if (name) this._addUnit(name, unit);
        (alternatives || []).forEach(function (n) {
          return _this._addUnit(n, unit);
        });
        return unit;
      }
    }, {
      key: 'getAvailableUnits',
      value: function getAvailableUnits() {
        return this._getMineAndAncestors(function () {
          return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.keys(this._units);
        }, arguments);
      }
    }, {
      key: 'getVariableDefinition',
      ////////////////////////////////////////////////////////////////////
      // variables. We could use the existing symbol table here.
      ////////////// 
      value: function getVariableDefinition(name) {
        return this._variables[name];
      }
    }, {
      key: 'findVariable',
      value: function findVariable(name) {
        return this._findFirst(this.getVariableDefinition, arguments);
      }
    }, {
      key: 'findScopeWithVariable',
      value: function findScopeWithVariable(name) {
        return this._findScopeWith(this.getVariableDefinition, arguments);
      }
    }, {
      key: 'addVariable',
      value: function addVariable(name, value) {
        this._variables[name] = value;

        if (value) {
          value.definingScope = this;
        }

        return value;
      }
    }, {
      key: 'deleteVariable',
      value: function deleteVariable(name) {
        delete this._variables[name];
      }
    }, {
      key: 'getAvailableVariables',
      value: function getAvailableVariables() {
        return this._getMineAndAncestors(function () {
          return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.keys(this._variables);
        }, arguments);
      } ////////////////////////////////////////////////////////////////////

    }, {
      key: '_findFirst',
      value: function _findFirst(thisArrayFunction, args) {
        var scope = this._findScopeWith(thisArrayFunction, args, {});

        if (scope) {
          return thisArrayFunction.apply(scope, args);
        }
      }
    }, {
      key: '_findScopeWith',
      value: function _findScopeWith(thisAccessFunction, args, seen) {
        var scope, value;
        seen = seen || {};

        if (seen[this.id]) {
          return;
        }

        seen[this.id] = true;
        value = thisAccessFunction.apply(this, args);

        if (value !== undefined) {
          return this;
        }

        return this._findShadowedScopeWith(thisAccessFunction, args, seen);
      }
    }, {
      key: '_findShadowedScopeWith',
      value: function _findShadowedScopeWith(thisArrayFunction, args, seen) {
        var found;

        var includedScopes = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.values(this._includes);

        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.find(includedScopes, function (scope) {
          found = scope._findScopeWith(thisArrayFunction, args, seen);
          return found;
        });

        if (!found && this.parent) {
          found = this.parent._findScopeWith(thisArrayFunction, args, seen);
        }

        return found;
      }
    }, {
      key: '_getMineAndAncestors',
      value: function _getMineAndAncestors(thisMethod, args, seen) {
        seen = seen || {};

        if (seen[this.id]) {
          return [];
        }

        seen[this.id] = true;
        var thisArray = thisMethod.apply(this, args);

        var includedScopes = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.values(this._includes);

        if (this.parent) {
          includedScopes.push(this.parent);
        }

        var parentArrays = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.map(includedScopes, function (scope) {
          return scope._getMineAndAncestors(thisMethod, args, seen);
        });

        parentArrays.unshift(thisArray);
        return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.flatten(parentArrays);
      } ////////////////////////////////////////////////////////////////////

    }, {
      key: 'invalidateParentLookups',
      value: function invalidateParentLookups() {
        // TODO, when caching becomes necessary.
        return this;
      } ////////////////////////////////////////////////////////////////////

    }, {
      key: 'newScope',
      value: function newScope(id) {
        if (!id) {
          id = this.id + '/' + this._nextChildId;
          this._nextChildId++;
        }

        return new Scope(this, id);
      }
    }, {
      key: 'fresh',
      value: function fresh() {
        return new Scope(this.parent, this.id);
      }
    }, {
      key: 'popScope',
      value: function popScope() {
        return this.parent;
      }
    }, {
      key: 'units',
      get: function get() {
        if (this._unitsTable) {
          return this._unitsTable;
        }

        if (this.parent) {
          return this.parent.units;
        }
      }
    }], [{
      key: 'newScope',
      value: function newScope(id, unitsTable) {
        return new Scope(undefined, id, unitsTable);
      }
    }]);

    return Scope;
  }();
  /* harmony default export */


  __webpack_exports__["a"] = Scope;
  /***/
},
/* 25 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__basic_arithmetic__ = __webpack_require__(26);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__advanced_arithmetic__ = __webpack_require__(36);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__trigonometry__ = __webpack_require__(37);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__hyperbolic__ = __webpack_require__(38);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__percent__ = __webpack_require__(39);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__boolean__ = __webpack_require__(40);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__number_comparisons__ = __webpack_require__(41);

  var operations = [__WEBPACK_IMPORTED_MODULE_1__basic_arithmetic__["a"
  /* default */
  ], __WEBPACK_IMPORTED_MODULE_2__advanced_arithmetic__["a"
  /* default */
  ], __WEBPACK_IMPORTED_MODULE_3__trigonometry__["a"
  /* default */
  ], __WEBPACK_IMPORTED_MODULE_4__hyperbolic__["a"
  /* default */
  ], __WEBPACK_IMPORTED_MODULE_5__percent__["a"
  /* default */
  ], __WEBPACK_IMPORTED_MODULE_6__boolean__["a"
  /* default */
  ], __WEBPACK_IMPORTED_MODULE_7__number_comparisons__["a"
  /* default */
  ]];
  /* harmony default export */

  __webpack_exports__["a"] = function (opts) {
    operations.forEach(function (type) {
      return type.registerOperators(opts);
    });
    return opts;
  };

  ;
  /***/
},
/* 26 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__turo_number__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(2);

  var makeMixin = __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
  /* default */
  ].makeMixin,
      isDimensionless = __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
  /* default */
  ].isDimensionless;
  var number = 'number'; /////////////////////////////////////////////////////////////////////////////////////////////

  /* harmony default export */

  __webpack_exports__["a"] = {
    registerOperators: function registerOperators(ops) {
      ops.addInfixOperator('+', number, number, number, makeMixin(function (a, b) {
        return a + b;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryMatchingUnits));
      ops.addInfixOperator('-', number, number, number, makeMixin(function (a, b) {
        return a - b;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryMatchingUnits));
      ops.addInfixOperator('*', number, number, number, makeMixin(function (a, b) {
        return a * b;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryAnyUnits, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryMultiplyUtils));
      ops.addInfixOperator('/', number, number, number, makeMixin(function (a, b) {
        return a / b;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryAnyUnits, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryDivideUtils)); // unary -

      ops.addPrefixOperator('-', number, number, makeMixin(function (x) {
        return -x;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryIdentity)); // unary +

      ops.addPrefixOperator('+', number, number, [__WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryIdentity]);
      ops.addInfixOperator('in', number, 'unit', number, [{
        preflightCheck: function preflightCheck(leftNode, leftValue, rightNode, rightValue, ctx) {
          return !isDimensionless(leftValue) && leftValue.unit.matchesDimensions(rightValue.unit);
        },
        turoValueCalculator: function turoValueCalculator(leftValue, rightValue) {
          return leftValue.convert(rightValue.unit);
        }
      }]);
    }
  };
  /***/
},
/* 27 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "b", function () {
    return toStringWithDisplay;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return createToString;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return toTokenArray;
  });
  /* unused harmony export joinTokenArray */

  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__StringDisplay__ = __webpack_require__(12);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__ToTokensVisitor__ = __webpack_require__(28);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__outputPrefs__ = __webpack_require__(34);

  var stringDisplay = new __WEBPACK_IMPORTED_MODULE_1__StringDisplay__["a"
  /* default */
  ](); //////////////////////////////////////////////////////////////////////////////////

  function joinTokenArray(tokens, display, context) {
    var prefs = context.prefs || __WEBPACK_IMPORTED_MODULE_3__outputPrefs__["a"
    /* default */
    ],
        formatting = prefs.output_padding || __WEBPACK_IMPORTED_MODULE_3__outputPrefs__["a"
    /* default */
    ].output_padding,
        defaultPadding = prefs.output_defaultPadding !== undefined ? prefs.output_defaultPadding : __WEBPACK_IMPORTED_MODULE_3__outputPrefs__["a"
    /* default */
    ].output_defaultPadding,
        literals = context.literals || {};
    context.offsetCorrection = 0;
    /*
    {
      offset:
      literal:
      displayType:
      shortType:
    }
    */

    var output = [],
        t_prev,
        prevShortType,
        offset = 0,
        cursorPosition = context.cursorPosition,
        cursorNeeded = cursorPosition !== undefined && display && display.cursorString,
        cursorRendered = !cursorNeeded;
    tokens.forEach(function (t) {
      var literal = t.literal || '';

      if (literal) {
        literal = literals[t.literal] || literal;
        var shortType = t.shortType;

        if (t_prev) {
          var padding = formatting[prevShortType + shortType];

          if (padding === undefined) {
            padding = defaultPadding;
          } else if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isString(padding)) {// NOOP
          } else if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isFunction(padding)) {
            padding = padding(t_prev.literal, literal);
          } else {
            padding = ' ';
          }

          if (padding && __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isString(padding)) {
            output.push(padding);
            offset += padding.length;
          }
        }

        t_prev = t;
        prevShortType = shortType;
      }

      var fn = display[t.displayType],
          string;

      if (fn) {
        string = fn(t, literal, context, offset);
      }

      if (!cursorRendered && cursorPosition <= offset) {
        output.push(display.cursorString);
        cursorRendered = true;
      }

      output.push(string || literal); // mutate the tokens. Hmm. Not sure about that.

      t.startOffset = offset;
      offset += literal.length;
    });

    if (cursorNeeded && !cursorRendered) {
      output.push(display.cursorString);
    }

    delete context.cursorPosition;
    return output.join('');
  } //////////////////////////////////////////////////////////////////////////////////


  var toTokensVisitor = new __WEBPACK_IMPORTED_MODULE_2__ToTokensVisitor__["a"
  /* default */
  ]();

  var toTokenArray = function toTokenArray(node, context, optionalTokens) {
    var tokens = optionalTokens || [];
    context = context || {};

    if (!node) {
      return tokens;
    }

    if (node.accept) {
      node.accept(toTokensVisitor, tokens, context);
    } else if (node.valueType) {
      toTokensVisitor.tokenizeTuroNumber(node, tokens, context, {});
    }

    return tokens;
  }; //////////////////////////////////////////////////////////////////////////////////


  var createToString = function createToString(display) {
    return function toString(node) {
      var prefs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_3__outputPrefs__["a"
      /* default */
      ];
      return toStringWithDisplay(node, display, prefs);
    };
  };

  var toStringWithDisplay = function toStringWithDisplay(node) {
    var display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : stringDisplay;
    var prefs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_3__outputPrefs__["a"
    /* default */
    ];

    if (!node) {
      return '';
    }

    var context = {
      prefs: prefs
    };
    var tokens;

    if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isArray(node)) {
      tokens = node;
    } else if (node) {
      tokens = toTokenArray(node, context, []);
    }

    if (tokens) {
      return joinTokenArray(tokens, display, context);
    }
  }; //////////////////////////////////////////////////////////////////////////////////

  /***/

},
/* 28 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__visitors__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__Token__ = __webpack_require__(33);

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  function t() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return new (Function.prototype.bind.apply(__WEBPACK_IMPORTED_MODULE_2__Token__["a"
    /* default */
    ], [null].concat(args)))();
  }

  var ToSourceVisitor = function (_ASTVisitor) {
    _inherits(ToSourceVisitor, _ASTVisitor);

    function ToSourceVisitor() {
      _classCallCheck(this, ToSourceVisitor);

      return _possibleConstructorReturn(this, (ToSourceVisitor.__proto__ || Object.getPrototypeOf(ToSourceVisitor)).apply(this, arguments));
    }

    _createClass(ToSourceVisitor, [{
      key: 'bracketStart',
      value: function bracketStart(node, tokens, context) {
        var bracketCount = context.bracketCount || 0,
            token = t('bracketStart', '(', node.line, node.offsetFirst);
        bracketCount++;
        context.bracketCount = bracketCount;
        token.bracketCount = bracketCount;
        tokens.push(token);
      }
    }, {
      key: 'bracketEnd',
      value: function bracketEnd(node, tokens, context) {
        if (!node.isMissingParensClose) {
          var bracketCount = context.bracketCount || 0,
              token = t('bracketEnd', ')', node.line, node.offsetLast);
          token.bracketCount = bracketCount;
          bracketCount--;
          context.bracketCount = bracketCount;
          tokens.push(token);
        }
      }
    }, {
      key: 'optionalBracketStart',
      value: function optionalBracketStart(node, tokens, context) {
        var _context$prefs$output = context.prefs.output_displayImpliedParentheses,
            output_displayImpliedParentheses = _context$prefs$output === undefined ? false : _context$prefs$output;

        if (output_displayImpliedParentheses) {
          this.bracketStart(node, tokens, context);
        }
      }
    }, {
      key: 'optionalBracketEnd',
      value: function optionalBracketEnd(node, tokens, context) {
        var _context$prefs$output2 = context.prefs.output_displayImpliedParentheses,
            output_displayImpliedParentheses = _context$prefs$output2 === undefined ? false : _context$prefs$output2;

        if (output_displayImpliedParentheses) {
          this.bracketEnd(node, tokens, context);
        }
      }
    }, {
      key: 'errorStart',
      value: function errorStart(node, tokens, context) {
        if (node.error) {
          tokens.push(t('errorStart', undefined, node.line, node.offsetFirst));
        }
      }
    }, {
      key: 'errorEnd',
      value: function errorEnd(node, tokens, context) {
        if (node.error) {
          tokens.push(t('errorEnd', undefined, node.line, node.offsetLast));
        }
      }
    }, {
      key: 'percentValueType',
      value: function percentValueType(insertPoint, tokens, context, value) {
        tokens.push(t('operator', '%', undefined, insertPoint, '!', 'bang'));
      }
    }, {
      key: 'printUnit',
      value: function printUnit(node, tokens, context, value) {
        var valueTypeMethod = this[node.valueType + 'ValueType'];

        if (valueTypeMethod) {
          valueTypeMethod.call(this, node, tokens, context, value);
        }

        var unit = node.unitLiteral;

        if (!unit) {
          return;
        }

        tokens.push(t('unitStart'));

        if (node.unitNode) {
          node.unitNode.accept(this, tokens, context);
        } else {
          this.visitUnit(unit, tokens, context, value);
        }

        tokens.push(t('unitEnd'));
      }
    }, {
      key: 'visitBinaryOperator',
      value: function visitBinaryOperator(node, tokens, context) {
        var literal = node.literal,
            string,
            space;
        this.errorStart(node, tokens, context);
        this.optionalBracketStart(node, tokens, context);
        node.left.accept(this, tokens, context);
        this.optionalBracketEnd(node, tokens, context);

        if (literal === "^") {
          // XXX horible hack.
          // I expect this should all go into a templating language.
          tokens.push(t('powerStart', '^', node.line, node._offsetLiteralFirst, '^'));
          this.optionalBracketStart(node, tokens, context);
          node.right.accept(this, tokens, context);
          this.optionalBracketEnd(node, tokens, context);
          tokens.push(t('powerEnd'));
        } else {
          tokens.push(t('operator', literal, node.line, node._offsetLiteralFirst, '+', 'in'));
          this.optionalBracketStart(node, tokens, context);
          node.right.accept(this, tokens, context);
          this.optionalBracketEnd(node, tokens, context);
        }

        this.errorEnd(node, tokens, context);
        this.printUnit(node, tokens, context);
        return tokens;
      }
    }, {
      key: 'visitUnaryOperation',
      value: function visitUnaryOperation(node, tokens, context) {
        this.errorStart(node, tokens, context);

        if (node.isPrefix) {
          tokens.push(t('operator', node.literal, node.line, node._offsetLiteralFirst, '-', 'sqrt'));
          this.optionalBracketStart(node, tokens, context);
          node.value.accept(this, tokens, context);
          this.optionalBracketEnd(node, tokens, context);
        } else {
          this.optionalBracketStart(node, tokens, context);
          node.value.accept(this, tokens, context);
          this.optionalBracketEnd(node, tokens, context);
          tokens.push(t('operator', node.literal, node.line, node._offsetLiteralFirst, '!', 'bang'));
        }

        this.printUnit(node, tokens, context);
        this.errorEnd(node, tokens, context);
      }
    }, {
      key: 'visitParens',
      value: function visitParens(node, tokens, context) {
        this.bracketStart(node, tokens, context);
        this.errorStart(node, tokens, context);
        node.ast.accept(this, tokens, context);
        this.errorEnd(node, tokens, context);
        this.bracketEnd(node, tokens, context);
        this.printUnit(node, tokens, context);
      }
    }, {
      key: 'visitNumberNode',
      value: function visitNumberNode(node, tokens, context) {
        var display = this.display;
        this.errorStart(node, tokens, context);

        if (context.editable) {
          var offset = node.offsetFirst;
          node.literal.split('').forEach(function (char_) {
            tokens.push(t('number', char_, node.line, offset, '1'));
            offset++;
          });
        } else {
          tokens.push(t('number', node.literal, node.line, node.offsetFirst, '1'));
        }

        this.printUnit(node, tokens, context, node.value);
        this.errorEnd(node, tokens, context);
        return tokens;
      }
    }, {
      key: 'tokenizeTuroNumber',
      value: function tokenizeTuroNumber(turoValue, tokens, context, node) {
        turoValue.prepareLiteral(context.prefs);
        var value = turoValue.value,
            valueString = turoValue.literal || value + '';

        if (turoValue.valueType === 'number') {
          tokens.push(t('number', valueString, node.line, node._offsetFirstLiteral, '1'));
        } else {
          tokens.push(t(turoValue.valueType, valueString, node.line, node._offsetFirstLiteral, 'x'));
        }

        var valueTypeMethod = this[turoValue.valueType + 'ValueType'];

        if (valueTypeMethod) {
          valueTypeMethod.call(this, node, tokens, context, value);
        }

        if (turoValue.unit) {
          this.visitUnit(turoValue.unit, tokens, context, value);
        }

        return tokens;
      }
    }, {
      key: 'visitIdentifier',
      value: function visitIdentifier(node, tokens, context) {
        this.errorStart(node, tokens, context);
        var token = t('identifier', node.name, node.line, node.offsetFirst, 'x');
        token.isConstant = node.isConstant;
        tokens.push(token);
        this.printUnit(node, tokens, context);
        this.errorEnd(node, tokens, context);
        return tokens;
      }
    }, {
      key: 'visitVariableDefinition',
      value: function visitVariableDefinition(node, tokens, context) {
        this.errorStart(node, tokens, context);

        if (node.isConstant) {
          tokens.push(t('statement', 'const', node.line, node.offsetFirst, 'kwd'));
        }

        tokens.push(t('identifier', node.identifier, node.lineFirst, node.statementOffsetFirst, 'x'));
        tokens.push(t('equal', '=', node.lineFirst, -1, '='));

        if (node.ast) {
          node.ast.accept(this, tokens, context);
        } else if (node.definition) {
          tokens.push(node.definition);
        }

        this.errorEnd(node, tokens, context);
        return tokens;
      }
    }, {
      key: 'visitUnitDefinitionStatement',
      value: function visitUnitDefinitionStatement(node, tokens, context) {
        this.errorStart(node, tokens, context);
        var unit = node.ast;

        if (unit) {
          var line = node.line;

          if (unit.definitionUnit) {
            tokens.push(t('number', '' + unit.definitionMultiple.bottom, line, undefined, '1'));
            tokens.push(t('unit', unit.name, line, unit.offsetFirst, 'm'));
            tokens.push(t('equal', '=', line, node._offsetLiteralFirst, '='));
            tokens.push(t('number', '' + unit.definitionMultiple.top, line, undefined, '1'));
            unit.definitionUnit.accept(this, tokens, context);
          } else {
            tokens.push(t('unit', unit.name, line, unit.offsetFirst, 'm'));
            tokens.push(t('keyword', 'as a unit of', line, node._offsetLiteralFirst, 'kwd'));
            tokens.push(t('dimension', unit.getDimension().shortName, line, node._offsetLiteralFirst, 'm'));
          }

          this.errorEnd(node, tokens, context);
        }

        return tokens;
      }
    }, {
      key: 'visitResult',
      value: function visitResult(node, tokens, context) {
        this.errorStart(node, tokens, context);

        if (node && node.value) {
          node.resultValueNode.accept(this, tokens, context);
        } else {
          tokens.push(t('number', '' + node.result || '0', node.line, 0, '1'));

          if (node.ast.unit) {
            node.ast.unit.accept(this, tokens, context);
          }
        }

        this.errorEnd(node, tokens, context);
        return tokens;
      }
    }, {
      key: 'visitResultObject',
      value: function visitResultObject(node, tokens, context) {
        if (node.result === undefined) {
          return; // can't do anything with this.
        }

        if (node.ast.accept) {
          node.ast.accept(this, tokens, context);
        }

        tokens.push(t('equal', '=', node.line, 0, '=')); // node.value should be a node.

        this.visitResult(node, tokens, context);
        return tokens;
      }
    }, {
      key: 'visitUnit',
      value: function visitUnit(unit, tokens, context, value) {
        this.errorStart(unit, tokens, context);
        var node = unit,
            name = unit.name;

        if (name) {
          if (!context.prefs.output_shortUnitNames) {
            switch (value) {
              case undefined:
                break;

              case 1:
              case 1.0:
              case -1:
              case -1.0:
                name = unit.singular || name;
                break;

              default:
                name = unit.plural || name;
            }
          }

          tokens.push(t('unitLiteral', name, -1, 0, 'm'));
        } else {
          var simpleUnits = unit.simpleUnits,
              display = this.display,
              units = Object(__WEBPACK_IMPORTED_MODULE_1_underscore__["sortBy"])(Object.keys(simpleUnits), // TODO sort by alpha and sign of power, not just power
          function (k) {
            return -simpleUnits[k];
          }),
              wasNegative = false,
              string = "",
              first = true;
          units.forEach(function (u) {
            var pow = simpleUnits[u],
                negative = pow < 0;

            if (negative) {
              pow *= -1;

              if (!wasNegative) {
                tokens.push(t('unitPer', '/', 0, 0, '/'));
                wasNegative = false;
              }
            }

            if (pow) {
              tokens.push(t('unitLiteral', u, 0, 0, 'm'));

              if (pow !== 1) {
                tokens.push(t('powerStart', '^', 0, 0, '^'));
                tokens.push(t('number', '' + pow, 0, 0, '1'));
                tokens.push(t('powerEnd'));
              }
            }
          });
        }

        this.errorEnd(unit, tokens, context);
        return tokens;
      }
    }, {
      key: 'visitImportStatement',
      value: function visitImportStatement(node, tokens, context) {
        t.push(t('statement', 'include', node.line, node.offsetFirst, 'kwd'));
        t.push(t('string', '"' + node.ast + '"', 0, '"'));
      }
    }, {
      key: 'visitUnitPower',
      value: function visitUnitPower(node, tokens, context) {
        this.errorStart(node, tokens, context);
        node.unitNode.accept(this, tokens, context);
        tokens.push(t('powerStart', '^', node.line, node._offsetLiteralFirst, '^'));
        node.exponent.accept(this, tokens, context);
        tokens.push(t('powerEnd'));
        this.errorEnd(node, tokens, context);
      }
    }, {
      key: 'visitUnitLiteral',
      value: function visitUnitLiteral(node, tokens, context) {
        this.errorStart(node, tokens, context);
        tokens.push(t('unitLiteral', node.literal, node.line, node.offsetFirst, 'm'));
        this.errorEnd(node, tokens, context);
      }
    }, {
      key: 'visitUnitMultOp',
      value: function visitUnitMultOp(node, tokens, context) {
        this.errorStart(node, tokens, context);

        if (node.left) {
          // this is not a '1 /s' situation.  
          node.left.accept(this, tokens, context);
        }

        if (node.literal === '/') {
          tokens.push(t('unitPer', '/', node.line, node._offsetLiteralFirst, '/'));
        }

        node.right.accept(this, tokens, context);
        this.errorEnd(node, tokens, context);
      }
    }]);

    return ToSourceVisitor;
  }(__WEBPACK_IMPORTED_MODULE_0__visitors__["a"
  /* ASTVisitor */
  ]);
  /* harmony default export */


  __webpack_exports__["a"] = ToSourceVisitor;
  /***/
},
/* 29 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function descend(visitor, node) {
    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    var results = node.children.map(function (child) {
      return child.accept.apply(child, [visitor].concat(args));
    });

    switch (results.length) {
      case 0:
        return;

      case 1:
        return results[0];

      default:
        results;
    }
  }

  var ASTVisitor = function () {
    function ASTVisitor() {
      _classCallCheck(this, ASTVisitor);
    }

    _createClass(ASTVisitor, [{
      key: "visitImportStatement",
      value: function visitImportStatement(node) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        return descend.apply(undefined, [this, node].concat(args));
      }
    }, {
      key: "visitStatementList",
      value: function visitStatementList(node) {
        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }

        return descend.apply(undefined, [this, node].concat(args));
      }
    }, {
      key: "visitBinaryOperator",
      value: function visitBinaryOperator(node) {
        for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        return descend.apply(undefined, [this, node].concat(args));
      }
    }, {
      key: "visitUnaryOperation",
      value: function visitUnaryOperation(node) {
        for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
          args[_key5 - 1] = arguments[_key5];
        }

        return descend.apply(undefined, [this, node].concat(args));
      }
    }, {
      key: "visitParens",
      value: function visitParens(node) {
        for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
          args[_key6 - 1] = arguments[_key6];
        }

        return descend.apply(undefined, [this, node].concat(args));
      }
    }, {
      key: "visitNumberNode",
      value: function visitNumberNode(node) {
        for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
          args[_key7 - 1] = arguments[_key7];
        }

        return descend.apply(undefined, [this, node].concat(args));
      }
    }, {
      key: "visitIdentifier",
      value: function visitIdentifier(node) {}
    }, {
      key: "visitVariableDefinition",
      value: function visitVariableDefinition(node) {
        for (var _len8 = arguments.length, args = Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
          args[_key8 - 1] = arguments[_key8];
        }

        return descend.apply(undefined, [this, node].concat(args));
      }
    }, {
      key: "visitUnitDefinitionStatement",
      value: function visitUnitDefinitionStatement(node) {
        for (var _len9 = arguments.length, args = Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
          args[_key9 - 1] = arguments[_key9];
        }

        return descend.apply(undefined, [this, node].concat(args));
      }
    }, {
      key: "visitUnit",
      value: function visitUnit(node) {}
    }, {
      key: "visitUnitPower",
      value: function visitUnitPower(node) {
        for (var _len10 = arguments.length, args = Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
          args[_key10 - 1] = arguments[_key10];
        }

        return descend.apply(undefined, [this, node].concat(args));
      }
    }, {
      key: "visitUnitPer",
      value: function visitUnitPer(node) {
        for (var _len11 = arguments.length, args = Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
          args[_key11 - 1] = arguments[_key11];
        }

        return descend.apply(undefined, [this, node].concat(args));
      }
    }, {
      key: "visitUnitLiteral",
      value: function visitUnitLiteral(node) {
        for (var _len12 = arguments.length, args = Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
          args[_key12 - 1] = arguments[_key12];
        }

        return descend.apply(undefined, [this, node].concat(args));
      }
    }, {
      key: "visitUnitMultOp",
      value: function visitUnitMultOp(node) {
        for (var _len13 = arguments.length, args = Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
          args[_key13 - 1] = arguments[_key13];
        }

        return descend.apply(undefined, [this, node].concat(args));
      }
    }, {
      key: "visitEditorLinesNode",
      value: function visitEditorLinesNode(node) {
        for (var _len14 = arguments.length, args = Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
          args[_key14 - 1] = arguments[_key14];
        }

        return descend.apply(undefined, [this, node].concat(args));
      }
    }]);

    return ASTVisitor;
  }();
  /* harmony default export */


  __webpack_exports__["a"] = ASTVisitor;
  /***/
},
/* 30 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__ast__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__errors__ = __webpack_require__(31);

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var VisitorContext = function () {
    function VisitorContext(visitor, opts) {
      _classCallCheck(this, VisitorContext);

      this.visitor = visitor;
      Object.assign(this, opts);
    }

    _createClass(VisitorContext, [{
      key: 'evaluate',
      value: function evaluate(node) {
        if (node.accept) {
          return node.accept(this.visitor, this);
        }
      }
    }, {
      key: 'reportError',
      value: function reportError(errorCode) {
        var _this = this;

        for (var _len = arguments.length, highlightedNodes = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          highlightedNodes[_key - 1] = arguments[_key];
        }

        highlightedNodes.forEach(function (node) {
          var error = new __WEBPACK_IMPORTED_MODULE_1__errors__["a"
          /* TuroError */
          ](errorCode, node);
          node.error = error;

          _this.errors.push(error);
        });
      }
    }]);

    return VisitorContext;
  }();
  /* harmony default export */


  __webpack_exports__["a"] = VisitorContext;
  /***/
},
/* 31 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__TuroError__ = __webpack_require__(32);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__TuroError__["a"];
  });
  /***/

},
/* 32 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var TuroError = function TuroError(errorMessage, node) {
    _classCallCheck(this, TuroError); // deprecated, use errorCode.


    this.message = errorMessage;
    this.errorCode = errorMessage;
    this.node = node;
  };
  /* harmony default export */


  __webpack_exports__["a"] = TuroError;
  /***/
},
/* 33 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var Token = function Token(displayType, literal, line, offset, shortType, shortTypeAlpha) {
    _classCallCheck(this, Token);

    if (shortTypeAlpha && literal.match(/^\w+$/)) {
      shortType = shortTypeAlpha;
    }

    if (offset === undefined) {
      offset = -1;
    }

    if (literal === undefined) {
      literal = '';
    }

    this.literal = literal;
    this.displayType = displayType;
    this.shortType = shortType || literal;
    this.startOffset = offset;
    this.line = line;
  };
  /* harmony default export */


  __webpack_exports__["a"] = Token;
  ;
  /***/
},
/* 34 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  var output_padding = {
    'm/': '',
    // unit followed by unit per.
    '/m': '',
    // unit per followed by unit.
    'm^': '',
    // unit followed by unit pow
    '^1': '',
    // unit pow followed by number
    '1/': '',
    // a number followed by unit per
    '1m': ' ',
    // a number followed by a unit
    'mm': ' ',
    // a unit followed by a unit
    '(1': '',
    '1)': '',
    'sqrt1': ' ',
    'sqrtx': ' ',
    'sqrtsqrt': ' ',
    '!m': ' ',
    'bangm': ' ',
    '!/': ' ',
    'bang/': ' ',
    '1bang': ' ',
    'bangx': ' ',
    'bangbang': ' ',
    'insqrt': ' ',
    'bangin': ' ',
    'xin': ' ',
    'inx': ' ',
    'min': ' ',
    // unit followed by in
    'inm': ' ',
    // in followed by unit
    '-1': '',
    // nonalpha prefixOp followed by a number,
    'kwdm': ' ',
    'mkwd': ' ',
    'm=': ' ',
    '=1': ' ',
    'x=': ' '
  };
  /* harmony default export */

  __webpack_exports__["a"] = {
    output_padding: output_padding,
    output_defaultPadding: ' ',
    output_displayImpliedParentheses: false,
    output_shortUnitNames: false
  };
  /***/
},
/* 35 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  (function () {
    /**
     * Decimal adjustment of a number.
     *
     * @param {String}  type  The type of adjustment.
     * @param {Number}  value The number.
     * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
     * @returns {Number}      The adjusted value.
     */
    function decimalAdjust(type, value, exp) {
      // If the exp is undefined or zero...
      if (typeof exp === 'undefined' || +exp === 0) {
        return Math[type](value);
      }

      value = +value;
      exp = +exp; // If the value is not a number or the exp is not an integer...

      if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
        return NaN;
      } // Shift


      value = value.toString().split('e');
      value = Math[type](+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp))); // Shift back

      value = value.toString().split('e');
      return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp));
    } // Decimal round


    if (!Math.round10) {
      Math.round10 = function (value, exp) {
        return decimalAdjust('round', value, exp);
      };
    } // Decimal floor


    if (!Math.floor10) {
      Math.floor10 = function (value, exp) {
        return decimalAdjust('floor', value, exp);
      };
    } // Decimal ceil


    if (!Math.ceil10) {
      Math.ceil10 = function (value, exp) {
        return decimalAdjust('ceil', value, exp);
      };
    }
  })();

  function precision10(value) {
    var exponent, largest, smallest;
    value = value.toString().split('e');
    exponent = value[1] ? +value[1] : 0;
    value = value[0].toString().split('.'); //value = [ "integer part", "float part"]

    largest = exponent + (+value[0] ? value[0].length : 0);
    smallest = exponent - (value[1] ? value[1].length : 0);
    return [largest, smallest];
  }
  /* harmony default export */


  __webpack_exports__["a"] = {
    toPrecision10: function toPrecision10(value, desiredPrecision) {
      var precision = precision10(value),
          roundTo;

      if (precision[0] - precision[1] < desiredPrecision) {// NOP
      } else {
        roundTo = -desiredPrecision + precision[0];
        value = Math.round10(value, roundTo);
        value = parseFloat(value.toString(), 10);
      }

      if (precision[0] > desiredPrecision || -precision[0] > desiredPrecision) {
        return value.toExponential();
      }

      return value + "";
    }
  };
  /***/
},
/* 36 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__turo_number__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(2);

  var makeMixin = __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
  /* default */
  ].makeMixin,
      isDimensionless = __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
  /* default */
  ].isDimensionless;
  var number = 'number'; /////////////////////////////////////////////////////////////////////////////////////////////
  // Logs, factorials, powers.
  /////////////////////////////////////////////////////////////////////////////////////////////

  /* harmony default export */

  __webpack_exports__["a"] = {
    registerOperators: function registerOperators(ops) {
      ops.addInfixOperator('^', number, number, number, makeMixin(function (left, right) {
        return Math.pow(left, right);
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unitsUtils, {
        preflightCheck: function preflightCheck(leftNode, leftValue, rightNode, rightValue, ctx) {
          if (!isDimensionless(rightValue)) {
            // 2^4m
            ctx.reportError('DIMENSION_MISMATCH', rightNode);
            return false;
          }

          if (leftValue.value < 0 && rightValue.value % 1) {
            // -1^.5
            ctx.reportError('NEGATIVE_NUMBER_EXPONENTIATION', leftNode);
            return false;
          }

          if (!isDimensionless(leftValue)) {
            var rightNumber = rightValue.number;

            if (rightNumber > 1 && rightNumber % 1) {
              // (2m)^1.5
              ctx.reportError('FRACTIONAL_UNIT_POWER', leftNode);
              return false;
            }

            if (rightNumber < 1 && !this.canDimensionsIntegerDivide(leftValue, 1 / rightNumber)) {
              // (4m)^(1/3)
              ctx.reportError('FRACTIONAL_UNIT_POWER', leftNode);
              return false;
            }
          }

          return true;
        },
        // TODO refactor this into a 'prepareLeftOperand', 
        // 'prepareRightOperan' and 'prepareBothOperand', 'prepareNoOperands' mixins.
        turoValueCalculator: function turoValueCalculator(leftValue, rightValue) {
          var calculatedUnit = this.unitCalculator(leftValue, rightValue);
          var compatLeftValue = this.prepareLeft(leftValue, rightValue);
          var simpleValue = this.simpleValueCalculator(compatLeftValue.value, rightValue.value);
          return __WEBPACK_IMPORTED_MODULE_1__turo_number__["a"
          /* default */
          ].newInstance(simpleValue, calculatedUnit, this.returnValueType);
        },
        unitCalculator: function unitCalculator(leftValue, rightValue) {
          var unit = leftValue.unit,
              power = rightValue.number;

          if (!unit) {
            return;
          }

          if (power < 1) {
            unit = unit.simplify().unit; // Simplify if needed. We should convert the operand to this unit to start with.
            // XXX save a call to simplify.

            leftValue._simplifiedUnit = unit;
          }

          return unit.pow(power);
        },
        prepareLeft: function prepareLeft(leftValue, rightValue) {
          if (leftValue._simplifiedUnit) {
            return leftValue.convert(leftValue._simplifiedUnit);
          }

          return leftValue;
        }
      })); /////////////////////////////////////////////////////////////////////////////////////////////

      ops.addPrefixOperator('sqrt', number, number, makeMixin(function (x) {
        return Math.sqrt(x);
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unitsUtils, {
        preflightCheck: function preflightCheck(operandNode, operandValue, ctx) {
          if (!isDimensionless && !this.canDimensionsIntegerDivide(operandValue, 2)) {
            ctx.reportError('DIMENSION_MISMATCH', operandNode);
            return false;
          }

          if (operandValue.number < 0) {
            ctx.reportError('NEGATIVE_NUMBER_SQRT', operandNode);
            return false;
          }

          return true;
        },
        unitCalculator: function unitCalculator(innerValue) {
          if (isDimensionless(innerValue)) {
            return null;
          } // XXX save a simplify call.


          var convertToUnitFirst = innerValue.unit.simplify().unit;
          innerValue._simplifiedUnit = convertToUnitFirst;
          return convertToUnitFirst.pow(1 / 2);
        },
        prepareOperand: function prepareOperand(left) {
          var unit = left._simplifiedUnit;

          if (unit) {
            left = left.convert(unit);
          }

          return left;
        }
      })); /////////////////////////////////////////////////////////////////////////////////////////////

      ops.addInfixOperator('nth_root', number, number, number, makeMixin(function (left, right) {
        return Math.pow(right, 1 / left);
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unitsUtils, {
        preflightCheck: function preflightCheck(leftNode, leftValue, rightNode, rightValue, ctx) {
          if (!isDimensionless(leftValue)) {
            ctx.reportError('DIMENSION_MISMATCH', rightNode);
            return false;
          }

          if (!isDimensionless(rightValue) && !this.canDimensionsIntegerDivide(rightValue, leftValue.number)) {
            ctx.reportError('DIMENSION_MISMATCH', leftNode);
            return false;
          }

          if (rightValue.value < 0) {
            ctx.reportError('NEGATIVE_NUMBER_EXPONENTIATION', leftNode);
            return false;
          }

          return true;
        },
        unitCalculator: function unitCalculator(leftValue, rightValue) {
          if (rightValue.unit) {
            var simplifiedUnit = rightValue.unit.simplify().unit; // Simplify if needed. We should convert the operand to this unit to start with.
            // XXX save a call to simplify.

            rightValue._simplifiedUnit = simplifiedUnit;
            return simplifiedUnit.pow(1 / leftValue.number);
          }
        },
        prepareRight: function prepareRight(leftValue, rightValue) {
          if (rightValue.unit) {
            return rightValue.convert(rightValue._simplifiedUnit);
          }

          return rightValue;
        }
      })); /////////////////////////////////////////////////////////////////////////////////////////////
      // Logs.
      /////////////////////////////////////////////////////////////////////////////////////////////

      ops.addPrefixOperator('log', number, number, makeMixin(function (x) {
        return Math.log(x) / Math.LN10;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryNoUnits));
      ops.addPrefixOperator('ln', number, number, makeMixin(function (x) {
        return Math.log(x);
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryNoUnits)); /////////////////////////////////////////////////////////////////////////////////////////////
      // Factorial
      // http://stackoverflow.com/a/15454866/4737

      function gamma(n) {
        // accurate to about 15 decimal places
        //some magic constants 
        var g = 7,
            // g represents the precision desired, p is the values of p[i] to plug into Lanczos' formula
        p = [0.99999999999980993, 676.5203681218851, -1259.1392167224028, 771.32342877765313, -176.61502916214059, 12.507343278686905, -0.13857109526572012, 9.9843695780195716e-6, 1.5056327351493116e-7];

        if (n < 0.5) {
          return Math.PI / Math.sin(n * Math.PI) / gamma(1 - n);
        } else {
          n--;
          var x = p[0];

          for (var i = 1; i < g + 2; i++) {
            x += p[i] / (n + i);
          }

          var t = n + g + 0.5;
          return Math.sqrt(2 * Math.PI) * Math.pow(t, n + 0.5) * Math.exp(-t) * x;
        }
      }

      function factorial_decimal(n) {
        return gamma(n + 1);
      }

      function factorial_integer(n) {
        var product = 1;

        for (var i = n; i > 0; i--) {
          product *= i;
        }

        return product;
      }

      ops.addPostfixOperator('!', number, number, makeMixin(function (x) {
        if (x % 1 === 0) {
          return factorial_integer(x);
        } else {
          return factorial_decimal(x);
        }
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryNoUnits, {
        preflightCheck: function preflightCheck(operandNode, operandValue, ctx) {
          if (operandValue.number < 0) {
            ctx.reportError('COMPLICATED', operandNode);
            return false;
          }

          return __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
          /* default */
          ].unaryNoUnits.preflightCheck(operandNode, operandValue, ctx);
        }
      }));
    }
  };
  /***/
},
/* 37 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__turo_number__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(2);

  var makeMixin = __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
  /* default */
  ].makeMixin,
      isDimensionless = __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
  /* default */
  ].isDimensionless;
  var number = 'number'; /////////////////////////////////////////////////////////////////////////////////////////////
  // Basic trig.
  /////////////////////////////////////////////////////////////////////////////////////////////

  /* harmony default export */

  __webpack_exports__["a"] = {
    registerOperators: function registerOperators(ops) {
      ops.addPrefixOperator('sin', number, number, makeMixin(function (x) {
        return Math.sin(x);
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].trigUtils, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryAngleToDimensionless));
      ops.addPrefixOperator('asin', number, number, makeMixin(function (x) {
        // TODO check if -1 <= lNode <= 1
        return Math.asin(x);
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].trigUtils, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryDimensionlessToAngle));
      ops.addPrefixOperator('cos', number, number, makeMixin(function (x) {
        return Math.cos(x);
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].trigUtils, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryAngleToDimensionless));
      ops.addPrefixOperator('acos', number, number, makeMixin(function (x) {
        return Math.acos(x);
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].trigUtils, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryDimensionlessToAngle));
      ops.addPrefixOperator('tan', number, number, makeMixin(function (x) {
        return Math.tan(x);
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].trigUtils, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryAngleToDimensionless));
      ops.addPrefixOperator('atan', number, number, makeMixin(function (x) {
        return Math.atan(x);
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].trigUtils, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryDimensionlessToAngle));
    }
  };
  /***/
},
/* 38 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__turo_number__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(2);

  var makeMixin = __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
  /* default */
  ].makeMixin,
      isDimensionless = __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
  /* default */
  ].isDimensionless;
  var number = 'number'; /////////////////////////////////////////////////////////////////////////////////////////////
  // Hyperbolic functions.
  // http://keisan.casio.com/exec/system/1223040677
  /////////////////////////////////////////////////////////////////////////////////////////////

  /* harmony default export */

  __webpack_exports__["a"] = {
    registerOperators: function registerOperators(ops) {
      ops.addPrefixOperator('sinh', number, number, makeMixin(function (x) {
        console.log('hello dude', x);

        if (Math.sinh) {
          return Math.sinh(x);
        } else {
          return (Math.exp(x) - Math.exp(-x)) / 2;
        }
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryNoUnits));
      ops.addPrefixOperator('asinh', number, number, makeMixin(function (x) {
        if (Math.asinh) {
          return Math.asinh(x);
        } else {
          // ln(x + sqrt(x^2 + 1)) + 1
          return Math.ln(x + Math.sqrt(x * x + 1));
        }
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryNoUnits));
      ops.addPrefixOperator('cosh', number, number, makeMixin(function (x) {
        if (Math.cosh) {
          return Math.cosh(x);
        } else {
          return (Math.exp(x) + Math.exp(-x)) / 2;
        }
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryNoUnits));
      ops.addPrefixOperator('acosh', number, number, makeMixin(function (x) {
        if (Math.acosh) {
          return Math.acosh(x);
        } else {
          // ln(x + sqrt(x^2 - 1))
          return Math.ln(x + Math.sqrt(x * x - 1));
        }
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryNoUnits, {
        preflightCheck: function preflightCheck(operandNode, operandValue, ctx) {
          if (operandValue.value < 1) {
            ctx.reportError('COMPLICATED', operandNode);
            return false;
          }

          return __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
          /* default */
          ].unaryNoUnits.preflightCheck(operandNode, operandValue, ctx);
        }
      }));
      ops.addPrefixOperator('tanh', number, number, makeMixin(function (x) {
        if (Math.tanh) {
          return Math.tanh(x);
        } else {
          return (Math.exp(x) - Math.exp(-x)) / (Math.exp(x) + Math.exp(-x));
        }
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryNoUnits));
      ops.addPrefixOperator('atanh', number, number, makeMixin(function (x) {
        if (Math.atanh) {
          return Math.atanh(x);
        } else {
          // 1 / 2 * ln((1 + x) / (1 - x))
          return Math.ln((1 + x) / (1 - x)) / 2;
        }
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryNoUnits, {
        preflightCheck: function preflightCheck(operandNode, operandValue, ctx) {
          if (Math.abs(operandValue.number) >= 1) {
            ctx.reportError('COMPLICATED', operandNode);
            return false;
          }

          return __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
          /* default */
          ].unaryNoUnits.preflightCheck(operandNode, operandValue, ctx);
        }
      }));
    }
  };
  /***/
},
/* 39 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__turo_number__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(2);

  var makeMixin = __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
  /* default */
  ].makeMixin,
      isDimensionless = __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
  /* default */
  ].isDimensionless;
  var number = 'number',
      percent = 'percent'; /////////////////////////////////////////////////////////////////////////////////////////////
  // Percent special cases using a postfix operator to generate percents from numbers.
  /////////////////////////////////////////////////////////////////////////////////////////////

  function percentNumberMultiply(lValue, rValue) {
    return lValue * rValue / 100;
  }
  /* harmony default export */


  __webpack_exports__["a"] = {
    registerOperators: function registerOperators(ops) {
      // Making a percent type with a postfix operator.
      /////////////////////////////
      ops.addPostfixOperator('%', number, percent, [__WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryNoUnits, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryIdentity, {
        nodeCalculator: function nodeCalculator(operandNode, ctx) {
          var operandValue = ctx.evaluate(operandNode, ctx);

          if (!operandValue) {
            // An error occurred in the sub tree.
            // We don't need to report it again here.
            return;
          }

          if (!this.preflightCheck(operandNode, operandValue, ctx)) {
            return;
          }

          if (operandNode.astType === 'parens' && operandNode.ast.literal === '/') {
            // i.e. (10 / 1000) % = 1%
            return __WEBPACK_IMPORTED_MODULE_1__turo_number__["a"
            /* default */
            ].newInstance(operandValue * 100, null, this.returnValueType);
          }

          return this.turoValueCalculator(operandValue);
        }
      }]); // Percent percent arithmetic.
      /////////////////////////////

      ops.addInfixOperator( // 1% + 2%
      '+', percent, percent, percent, makeMixin(function (a, b) {
        return a + b;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryNoUnits));
      ops.addInfixOperator( // 1% - 2%
      '-', percent, percent, percent, makeMixin(function (a, b) {
        return a - b;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryNoUnits));
      ops.addInfixOperator( // 10% * 20% = 2%
      '*', percent, percent, percent, makeMixin(percentNumberMultiply, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryNoUnits));
      ops.addInfixOperator( // 200% / 100%
      '/', percent, percent, number, makeMixin(function (a, b) {
        return a / b;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryNoUnits, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryPercentNoUnits, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryDivideUtils, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryPercentNoUnitsDivide)); // Mixing numbers and percent.
      /////////////////////////////

      ops.addInfixOperator( // SPECIAL CASE
      // 10 $ + 10%
      '+', number, percent, number, makeMixin(function (a, b) {
        return a * (100 + b) / 100;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryPercentNoUnits));
      ops.addInfixOperator( // SPECIAL CASE
      // 10 $ - 10%
      '-', number, percent, number, makeMixin(function (a, b) {
        return a * (100 - b) / 100;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryPercentNoUnits));
      ops.addInfixOperator( // 50% * 10 m
      '*', percent, number, number, makeMixin(percentNumberMultiply, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryPercentNoUnits));
      ops.addInfixOperator( // 10m * 50%
      '*', number, percent, number, makeMixin(percentNumberMultiply, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryPercentNoUnits));
      ops.addInfixOperator( // 50% / 10 m
      '/', percent, number, number, makeMixin(function percentNumberDivide(lValue, rValue) {
        // L % / R = (L / 100) / R
        return lValue / rValue / 100;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryDivideUtils, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryPercentDivide));
      ops.addInfixOperator( // 10m / 50%
      '/', number, percent, number, makeMixin(function numberPercentDivide(lValue, rValue) {
        // L / R% = L / (R / 100)
        return lValue * 100 / rValue;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryDivideUtils, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryPercentDivide)); /////////////////////////////////////////////////////////////////////////////////////////////
      // unary -

      ops.addPrefixOperator('-', percent, percent, makeMixin(function (x) {
        return -x;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryIdentity)); // unary +

      ops.addPrefixOperator('+', percent, percent, [__WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryIdentity]);
    }
  };
  /***/
},
/* 40 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__turo_number__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(2);

  var makeMixin = __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
  /* default */
  ].makeMixin,
      isDimensionless = __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
  /* default */
  ].isDimensionless;
  var bool = 'boolean'; /////////////////////////////////////////////////////////////////////////////////////////////
  // Unit aware comparisons. 
  /////////////////////////////////////////////////////////////////////////////////////////////

  /* harmony default export */

  __webpack_exports__["a"] = {
    registerOperators: function registerOperators(ops) {
      /////////////////////////////////////////////////////////////////////////////////////////////
      // Boolean operators.
      /////////////////////////////////////////////////////////////////////////////////////////////
      ops.addInfixOperator( // 1 < x AND y > 2 m
      'AND', bool, bool, bool, makeMixin(function (l, r) {
        return l && r;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryNoUnits));
      ops.addInfixOperator( // 1 < x OR y > 2 m
      'OR', bool, bool, bool, makeMixin(function (l, r) {
        return l || r;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryNoUnits));
      ops.addPrefixOperator( // !(1 > x)
      '!', bool, bool, makeMixin(function (o) {
        return !o;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryNoUnits));
      ops.addPrefixOperator( // NOT (1 > x)
      'NOT', bool, bool, makeMixin(function (o) {
        return !o;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].unaryNoUnits));
    }
  };
  /***/
},
/* 41 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__turo_number__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(2);

  var makeMixin = __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
  /* default */
  ].makeMixin,
      isDimensionless = __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
  /* default */
  ].isDimensionless;
  var number = 'number',
      bool = 'boolean'; /////////////////////////////////////////////////////////////////////////////////////////////
  // Unit aware comparisons. 
  /////////////////////////////////////////////////////////////////////////////////////////////

  /* harmony default export */

  __webpack_exports__["a"] = {
    registerOperators: function registerOperators(ops) {
      ops.addInfixOperator( // 1 m < 1 yd
      '<', number, number, bool, makeMixin(function (l, r) {
        console.log('bool', l, r);
        return l < r;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryMatchingUnits, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryReturnNoUnits));
      ops.addInfixOperator( // 1 m <= 1 yd
      '<=', number, number, bool, makeMixin(function (l, r) {
        return l <= r;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryMatchingUnits, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryReturnNoUnits));
      ops.addInfixOperator( // 1 m == 1 yd
      '==', number, number, bool, makeMixin(function (l, r) {
        return l === r;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryMatchingUnits, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryReturnNoUnits));
      ops.addInfixOperator( // 1 m >= 1 yd
      '>=', number, number, bool, makeMixin(function (l, r) {
        return l >= r;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryMatchingUnits, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryReturnNoUnits));
      ops.addInfixOperator( // 1 m > 1 yd
      '>', number, number, bool, makeMixin(function (l, r) {
        return l > r;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryMatchingUnits, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryReturnNoUnits));
      ops.addInfixOperator( // 1 m != 1 yd
      '!=', number, number, bool, makeMixin(function (l, r) {
        return l !== r;
      }, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryMatchingUnits, __WEBPACK_IMPORTED_MODULE_2__mixins__["a"
      /* default */
      ].binaryReturnNoUnits));
    }
  };
  /***/
},
/* 42 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__UnaryOperation__ = __webpack_require__(43);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__BinaryOperation__ = __webpack_require__(44);

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return Array.from(arr);
    }
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  } //////////////////////////////////////////////////


  function makeKey(lValueType, literal, rValueType) {
    return lValueType + '::' + literal + '::' + rValueType;
  }

  var UNARY_OPERATION = "++N/A++";

  var Operators = function () {
    function Operators(table, prefs) {
      _classCallCheck(this, Operators);

      this.table = table || {};
      this._turoPrefs = prefs || {};
      this._infixOperatorNames = {};
      this._prefixOperatorNames = {};
      this._postfixOperatorNames = {};
    }

    _createClass(Operators, [{
      key: '_cacheGetOperatorNames',
      value: function _cacheGetOperatorNames(operatorType) {
        var key = "__cache_" + operatorType;

        if (!this[key]) {
          this[key] = Object.keys(this["_" + operatorType + "OperatorNames"]);
        }

        return this[key];
      }
    }, {
      key: '_putNameCache',
      value: function _putNameCache(operatorType, operatorName) {
        this["_" + operatorType + "OperatorNames"][operatorName] = true;
        delete this["__cache_" + operatorType];
      }
    }, {
      key: 'getInfixOperatorNames',
      value: function getInfixOperatorNames() {
        return this._cacheGetOperatorNames("infix");
      }
    }, {
      key: 'getPrefixOperatorNames',
      value: function getPrefixOperatorNames() {
        return this._cacheGetOperatorNames("prefix");
      }
    }, {
      key: 'getPostfixOperatorNames',
      value: function getPostfixOperatorNames() {
        return this._cacheGetOperatorNames("postfix");
      }
    }, {
      key: 'hasInfixOperator',
      value: function hasInfixOperator(literal) {
        return this._infixOperatorNames[literal];
      }
    }, {
      key: 'hasPrefixOperator',
      value: function hasPrefixOperator(literal) {
        return this._prefixOperatorNames[literal];
      }
    }, {
      key: 'hasPostfixOperator',
      value: function hasPostfixOperator(literal) {
        return this._postfixOperatorNames[literal];
      }
    }, {
      key: 'addInfixOperator',
      value: function addInfixOperator(literal, lValueType, rValueType, retValueType, mixins) {
        var op = Object.assign.apply(Object, [new __WEBPACK_IMPORTED_MODULE_1__BinaryOperation__["a"
        /* default */
        ]()].concat(_toConsumableArray(mixins)));

        this._addOperator(literal, lValueType, rValueType, retValueType, op); // XXX we can do this here, because 'in' is specifically mentioned in the parser.


        if (literal !== 'in') {
          this._putNameCache("infix", literal);
        } // TODO get autocomplete to work with the type system.

      }
    }, {
      key: 'addPrefixOperator',
      value: function addPrefixOperator(literal, rValueType, retValueType, mixins) {
        this._addUnaryOperator(literal, UNARY_OPERATION, rValueType, retValueType, mixins);

        this._putNameCache("prefix", literal);
      }
    }, {
      key: 'addPostfixOperator',
      value: function addPostfixOperator(literal, lValueType, retValueType, mixins) {
        this._addUnaryOperator(literal, lValueType, UNARY_OPERATION, retValueType, mixins);

        this._putNameCache("postfix", literal);
      }
    }, {
      key: '_addUnaryOperator',
      value: function _addUnaryOperator(literal, lValueType, rValueType, retValueType, mixins) {
        var operationObject = Object.assign.apply(Object, [new __WEBPACK_IMPORTED_MODULE_0__UnaryOperation__["a"
        /* default */
        ]()].concat(_toConsumableArray(mixins)));

        this._addOperator(literal, lValueType, rValueType, retValueType, operationObject);
      }
    }, {
      key: '_addOperator',
      value: function _addOperator(literal, lValueType, rValueType, retValueType, operationObject) {
        Object.assign(operationObject, {
          literal: literal,
          lValueType: lValueType,
          rValueType: rValueType,
          returnValueType: retValueType
        });
        this.table[makeKey(lValueType, literal, rValueType)] = operationObject;
      }
    }, {
      key: 'findOperator',
      value: function findOperator(literal, lNode, rNode) {
        return this.table[makeKey(lNode, literal, rNode)];
      }
    }, {
      key: 'findUnaryOperator',
      value: function findUnaryOperator(literal, nodeType, isPrefix) {
        var key = isPrefix ? makeKey(UNARY_OPERATION, literal, nodeType) : makeKey(nodeType, literal, UNARY_OPERATION);
        return this.table[key];
      }
    }]);

    return Operators;
  }();
  /* harmony default export */


  __webpack_exports__["a"] = Operators;
  /***/
},
/* 43 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__turo_number__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__AbstractOperation__ = __webpack_require__(13);

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var UnaryOperation = function (_AbstractOperation) {
    _inherits(UnaryOperation, _AbstractOperation);

    function UnaryOperation() {
      _classCallCheck(this, UnaryOperation);

      return _possibleConstructorReturn(this, (UnaryOperation.__proto__ || Object.getPrototypeOf(UnaryOperation)).apply(this, arguments));
    }

    _createClass(UnaryOperation, [{
      key: 'evaluate',
      value: function evaluate(x, ctx) {
        return this.nodeCalculator(x, ctx);
      }
    }, {
      key: 'performPreflightCheck',
      value: function performPreflightCheck(operandNode, operandValue, ctx) {
        if (!operandValue) {
          // An error occurred in the sub tree.
          // We don't need to report it again here.
          return;
        }

        if (!this.preflightCheck(operandNode, operandValue, ctx)) {
          return;
        }

        return true;
      }
    }, {
      key: 'nodeCalculator',
      value: function nodeCalculator(operandNode, ctx) {
        var operandValue = ctx.evaluate(operandNode, ctx);

        if (!this.performPreflightCheck(operandNode, operandValue, ctx)) {
          return;
        }

        return this.turoValueCalculator(operandValue, ctx);
      }
    }, {
      key: 'preflightCheck',
      value: function preflightCheck(leftNode, leftValue, ctx) {
        // check for units being incompatable.
        // report unit errors.
        return true;
      }
    }, {
      key: 'turoValueCalculator',
      value: function turoValueCalculator(leftValue) {
        var calculatedUnit = this.unitCalculator(leftValue),
            operand = this.prepareOperand(leftValue);
        var simpleValue = this.simpleValueCalculator(operand.value);
        return __WEBPACK_IMPORTED_MODULE_0__turo_number__["a"
        /* default */
        ].newInstance(simpleValue, calculatedUnit, this.returnValueType);
      }
    }, {
      key: 'prepareOperand',
      value: function prepareOperand(leftValue) {
        return leftValue;
      }
    }, {
      key: 'unitCalculator',
      value: function unitCalculator(leftValue) {
        return leftValue.unit;
      }
    }, {
      key: 'simpleValueCalculator',
      value: function simpleValueCalculator(left) {
        throw new Error('No simpleValueCalculator specified for ' + literal + ' operator over ' + lValueType + ' or ' + rValueType);
      }
    }]);

    return UnaryOperation;
  }(__WEBPACK_IMPORTED_MODULE_1__AbstractOperation__["a"
  /* default */
  ]);
  /* harmony default export */


  __webpack_exports__["a"] = UnaryOperation;
  /***/
},
/* 44 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__turo_number__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__AbstractOperation__ = __webpack_require__(13);

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var BinaryOperation = function (_AbstractOperation) {
    _inherits(BinaryOperation, _AbstractOperation);

    function BinaryOperation() {
      _classCallCheck(this, BinaryOperation);

      return _possibleConstructorReturn(this, (BinaryOperation.__proto__ || Object.getPrototypeOf(BinaryOperation)).apply(this, arguments));
    }

    _createClass(BinaryOperation, [{
      key: 'evaluate',
      value: function evaluate(leftNode, rightNode, ctx) {
        return this.nodeCalculator(leftNode, rightNode, ctx);
      }
    }, {
      key: 'nodeCalculator',
      value: function nodeCalculator(leftNode, rightNode, ctx) {
        var leftValue = ctx.evaluate(leftNode, ctx),
            rightValue = ctx.evaluate(rightNode, ctx);

        if (!this.performPreflightCheck(leftNode, leftValue, rightNode, rightValue, ctx)) {
          return;
        }

        return this.turoValueCalculator(leftValue, rightValue, ctx);
      }
    }, {
      key: 'performPreflightCheck',
      value: function performPreflightCheck(leftNode, leftValue, rightNode, rightValue, ctx) {
        if (!leftValue || !rightValue) {
          // An error occurred in the sub tree.
          // We don't need to report it again here.
          return;
        }

        if (!this.preflightCheck(leftNode, leftValue, rightNode, rightValue, ctx)) {
          return;
        }

        return true;
      }
    }, {
      key: 'preflightCheck',
      value: function preflightCheck(leftNode, leftValue, rightNode, rightValue, ctx) {
        // check for units being incompatable.
        // report unit errors.
        return true;
      }
    }, {
      key: 'turoValueCalculator',
      value: function turoValueCalculator(leftValue, rightValue) {
        var calculatedUnit = this.unitCalculator(leftValue, rightValue);
        var compatRightValue = this.prepareRight(leftValue, rightValue);
        var simpleValue = this.simpleValueCalculator(leftValue.value, compatRightValue.value);
        return __WEBPACK_IMPORTED_MODULE_0__turo_number__["a"
        /* default */
        ].newInstance(simpleValue, calculatedUnit, this.returnValueType);
      }
    }, {
      key: 'prepareRight',
      value: function prepareRight(leftValue, rightValue) {
        return rightValue;
      }
    }, {
      key: 'simpleValueCalculator',
      value: function simpleValueCalculator(left, right) {
        throw new Error('No simpleValueCalculator specified for ' + literal + ' operator over ' + lValueType + ' and ' + rValueType);
      }
    }]);

    return BinaryOperation;
  }(__WEBPACK_IMPORTED_MODULE_1__AbstractOperation__["a"
  /* default */
  ]);
  /* harmony default export */


  __webpack_exports__["a"] = BinaryOperation;
  /***/
},
/* 45 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__visitors__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_async__ = __webpack_require__(46);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_async__);

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  } //////////////////////////////////////////////////////////////////////////


  var ImportFinder = function (_ASTVisitor) {
    _inherits(ImportFinder, _ASTVisitor);

    function ImportFinder() {
      _classCallCheck(this, ImportFinder);

      return _possibleConstructorReturn(this, (ImportFinder.__proto__ || Object.getPrototypeOf(ImportFinder)).apply(this, arguments));
    }

    _createClass(ImportFinder, [{
      key: 'visitImportStatement',
      value: function visitImportStatement(node, context) {
        var documentId = node.ast;
        context.toImport[documentId] = true;
      }
    }]);

    return ImportFinder;
  }(__WEBPACK_IMPORTED_MODULE_0__visitors__["a"
  /* ASTVisitor */
  ]);

  var visitor = new ImportFinder(); //////////////////////////////////////////////////////////////////////////

  var DocumentHelper = function () {
    function DocumentHelper(storage) {
      _classCallCheck(this, DocumentHelper);

      this._storage = storage;
    }

    _createClass(DocumentHelper, [{
      key: 'evaluate',
      value: function evaluate(rootNode, callback, context) {
        context.toImport = {};
        rootNode.accept(visitor, context);

        var toImport = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.keys(context.toImport),
            documentCreator = context.documentEvaluator,
            doc = context.document;

        return this._doLoading(toImport, doc, doc.scope, documentCreator, callback);
      }
    }, {
      key: 'import',
      value: function _import(toImport, scope, documentCreator, callback) {
        return this._doLoading(toImport, scope, scope, documentCreator, callback);
      }
    }, {
      key: '_doLoading',
      value: function _doLoading(toImport, doc, scope, documentCreator, callback) {
        var _this2 = this;

        var storage = this._storage;

        var toLoad = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.filter(toImport, function (id) {
          return !storage.hasDocument(id);
        });

        if (__WEBPACK_IMPORTED_MODULE_1_underscore___default.a.isEmpty(toLoad)) {
          // We can evaluate immediately.
          this._finishLoading(toImport, scope);

          callback(null, doc);
          return true;
        }

        __WEBPACK_IMPORTED_MODULE_2_async___default.a.map(toLoad, function (documentId, cb) {
          return storage.loadDocument(documentId, documentCreator, cb);
        }, function (err, results) {
          if (err) {
            callback(err, doc);
            return;
          }

          _this2._finishLoading(toImport, scope);

          callback(null, doc);
        });

        return false;
      }
    }, {
      key: '_finishLoading',
      value: function _finishLoading(toImport, currentScope) {
        var storage = this._storage;
        toImport.forEach(function (id) {
          var doc = storage.getDocument(id); // Note: this is where the document is imported 
          // into the current scope. It is the only place 
          // where we should call this method.

          currentScope.addImport(id, doc.scope);
        });
      }
    }]);

    return DocumentHelper;
  }();
  /* harmony default export */


  __webpack_exports__["a"] = DocumentHelper;
  /***/
},
/* 46 */

/***/
function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
  /*!
  * async
  * https://github.com/caolan/async
  *
  * Copyright 2010-2014 Caolan McMahon
  * Released under the MIT license
  */

  /*jshint onevar: false, indent:4 */

  /*global setImmediate: false, setTimeout: false, console: false */


  (function () {
    var async = {}; // global on the server, window in the browser

    var root, previous_async;
    root = this;

    if (root != null) {
      previous_async = root.async;
    }

    async.noConflict = function () {
      root.async = previous_async;
      return async;
    };

    function only_once(fn) {
      var called = false;
      return function () {
        if (called) throw new Error("Callback was already called.");
        called = true;
        fn.apply(root, arguments);
      };
    } //// cross-browser compatiblity functions ////


    var _toString = Object.prototype.toString;

    var _isArray = Array.isArray || function (obj) {
      return _toString.call(obj) === '[object Array]';
    };

    var _each = function _each(arr, iterator) {
      for (var i = 0; i < arr.length; i += 1) {
        iterator(arr[i], i, arr);
      }
    };

    var _map = function _map(arr, iterator) {
      if (arr.map) {
        return arr.map(iterator);
      }

      var results = [];

      _each(arr, function (x, i, a) {
        results.push(iterator(x, i, a));
      });

      return results;
    };

    var _reduce = function _reduce(arr, iterator, memo) {
      if (arr.reduce) {
        return arr.reduce(iterator, memo);
      }

      _each(arr, function (x, i, a) {
        memo = iterator(memo, x, i, a);
      });

      return memo;
    };

    var _keys = function _keys(obj) {
      if (Object.keys) {
        return Object.keys(obj);
      }

      var keys = [];

      for (var k in obj) {
        if (obj.hasOwnProperty(k)) {
          keys.push(k);
        }
      }

      return keys;
    }; //// exported async module functions ////
    //// nextTick implementation with browser-compatible fallback ////


    if (typeof process === 'undefined' || !process.nextTick) {
      if (typeof setImmediate === 'function') {
        async.nextTick = function (fn) {
          // not a direct alias for IE10 compatibility
          setImmediate(fn);
        };

        async.setImmediate = async.nextTick;
      } else {
        async.nextTick = function (fn) {
          setTimeout(fn, 0);
        };

        async.setImmediate = async.nextTick;
      }
    } else {
      async.nextTick = process.nextTick;

      if (typeof setImmediate !== 'undefined') {
        async.setImmediate = function (fn) {
          // not a direct alias for IE10 compatibility
          setImmediate(fn);
        };
      } else {
        async.setImmediate = async.nextTick;
      }
    }

    async.each = function (arr, iterator, callback) {
      callback = callback || function () {};

      if (!arr.length) {
        return callback();
      }

      var completed = 0;

      _each(arr, function (x) {
        iterator(x, only_once(done));
      });

      function done(err) {
        if (err) {
          callback(err);

          callback = function callback() {};
        } else {
          completed += 1;

          if (completed >= arr.length) {
            callback();
          }
        }
      }
    };

    async.forEach = async.each;

    async.eachSeries = function (arr, iterator, callback) {
      callback = callback || function () {};

      if (!arr.length) {
        return callback();
      }

      var completed = 0;

      var iterate = function iterate() {
        iterator(arr[completed], function (err) {
          if (err) {
            callback(err);

            callback = function callback() {};
          } else {
            completed += 1;

            if (completed >= arr.length) {
              callback();
            } else {
              iterate();
            }
          }
        });
      };

      iterate();
    };

    async.forEachSeries = async.eachSeries;

    async.eachLimit = function (arr, limit, iterator, callback) {
      var fn = _eachLimit(limit);

      fn.apply(null, [arr, iterator, callback]);
    };

    async.forEachLimit = async.eachLimit;

    var _eachLimit = function _eachLimit(limit) {
      return function (arr, iterator, callback) {
        callback = callback || function () {};

        if (!arr.length || limit <= 0) {
          return callback();
        }

        var completed = 0;
        var started = 0;
        var running = 0;

        (function replenish() {
          if (completed >= arr.length) {
            return callback();
          }

          while (running < limit && started < arr.length) {
            started += 1;
            running += 1;
            iterator(arr[started - 1], function (err) {
              if (err) {
                callback(err);

                callback = function callback() {};
              } else {
                completed += 1;
                running -= 1;

                if (completed >= arr.length) {
                  callback();
                } else {
                  replenish();
                }
              }
            });
          }
        })();
      };
    };

    var doParallel = function doParallel(fn) {
      return function () {
        var args = Array.prototype.slice.call(arguments);
        return fn.apply(null, [async.each].concat(args));
      };
    };

    var doParallelLimit = function doParallelLimit(limit, fn) {
      return function () {
        var args = Array.prototype.slice.call(arguments);
        return fn.apply(null, [_eachLimit(limit)].concat(args));
      };
    };

    var doSeries = function doSeries(fn) {
      return function () {
        var args = Array.prototype.slice.call(arguments);
        return fn.apply(null, [async.eachSeries].concat(args));
      };
    };

    var _asyncMap = function _asyncMap(eachfn, arr, iterator, callback) {
      arr = _map(arr, function (x, i) {
        return {
          index: i,
          value: x
        };
      });

      if (!callback) {
        eachfn(arr, function (x, callback) {
          iterator(x.value, function (err) {
            callback(err);
          });
        });
      } else {
        var results = [];
        eachfn(arr, function (x, callback) {
          iterator(x.value, function (err, v) {
            results[x.index] = v;
            callback(err);
          });
        }, function (err) {
          callback(err, results);
        });
      }
    };

    async.map = doParallel(_asyncMap);
    async.mapSeries = doSeries(_asyncMap);

    async.mapLimit = function (arr, limit, iterator, callback) {
      return _mapLimit(limit)(arr, iterator, callback);
    };

    var _mapLimit = function _mapLimit(limit) {
      return doParallelLimit(limit, _asyncMap);
    }; // reduce only has a series version, as doing reduce in parallel won't
    // work in many situations.


    async.reduce = function (arr, memo, iterator, callback) {
      async.eachSeries(arr, function (x, callback) {
        iterator(memo, x, function (err, v) {
          memo = v;
          callback(err);
        });
      }, function (err) {
        callback(err, memo);
      });
    }; // inject alias


    async.inject = async.reduce; // foldl alias

    async.foldl = async.reduce;

    async.reduceRight = function (arr, memo, iterator, callback) {
      var reversed = _map(arr, function (x) {
        return x;
      }).reverse();

      async.reduce(reversed, memo, iterator, callback);
    }; // foldr alias


    async.foldr = async.reduceRight;

    var _filter = function _filter(eachfn, arr, iterator, callback) {
      var results = [];
      arr = _map(arr, function (x, i) {
        return {
          index: i,
          value: x
        };
      });
      eachfn(arr, function (x, callback) {
        iterator(x.value, function (v) {
          if (v) {
            results.push(x);
          }

          callback();
        });
      }, function (err) {
        callback(_map(results.sort(function (a, b) {
          return a.index - b.index;
        }), function (x) {
          return x.value;
        }));
      });
    };

    async.filter = doParallel(_filter);
    async.filterSeries = doSeries(_filter); // select alias

    async.select = async.filter;
    async.selectSeries = async.filterSeries;

    var _reject = function _reject(eachfn, arr, iterator, callback) {
      var results = [];
      arr = _map(arr, function (x, i) {
        return {
          index: i,
          value: x
        };
      });
      eachfn(arr, function (x, callback) {
        iterator(x.value, function (v) {
          if (!v) {
            results.push(x);
          }

          callback();
        });
      }, function (err) {
        callback(_map(results.sort(function (a, b) {
          return a.index - b.index;
        }), function (x) {
          return x.value;
        }));
      });
    };

    async.reject = doParallel(_reject);
    async.rejectSeries = doSeries(_reject);

    var _detect = function _detect(eachfn, arr, iterator, main_callback) {
      eachfn(arr, function (x, callback) {
        iterator(x, function (result) {
          if (result) {
            main_callback(x);

            main_callback = function main_callback() {};
          } else {
            callback();
          }
        });
      }, function (err) {
        main_callback();
      });
    };

    async.detect = doParallel(_detect);
    async.detectSeries = doSeries(_detect);

    async.some = function (arr, iterator, main_callback) {
      async.each(arr, function (x, callback) {
        iterator(x, function (v) {
          if (v) {
            main_callback(true);

            main_callback = function main_callback() {};
          }

          callback();
        });
      }, function (err) {
        main_callback(false);
      });
    }; // any alias


    async.any = async.some;

    async.every = function (arr, iterator, main_callback) {
      async.each(arr, function (x, callback) {
        iterator(x, function (v) {
          if (!v) {
            main_callback(false);

            main_callback = function main_callback() {};
          }

          callback();
        });
      }, function (err) {
        main_callback(true);
      });
    }; // all alias


    async.all = async.every;

    async.sortBy = function (arr, iterator, callback) {
      async.map(arr, function (x, callback) {
        iterator(x, function (err, criteria) {
          if (err) {
            callback(err);
          } else {
            callback(null, {
              value: x,
              criteria: criteria
            });
          }
        });
      }, function (err, results) {
        if (err) {
          return callback(err);
        } else {
          var fn = function fn(left, right) {
            var a = left.criteria,
                b = right.criteria;
            return a < b ? -1 : a > b ? 1 : 0;
          };

          callback(null, _map(results.sort(fn), function (x) {
            return x.value;
          }));
        }
      });
    };

    async.auto = function (tasks, callback) {
      callback = callback || function () {};

      var keys = _keys(tasks);

      var remainingTasks = keys.length;

      if (!remainingTasks) {
        return callback();
      }

      var results = {};
      var listeners = [];

      var addListener = function addListener(fn) {
        listeners.unshift(fn);
      };

      var removeListener = function removeListener(fn) {
        for (var i = 0; i < listeners.length; i += 1) {
          if (listeners[i] === fn) {
            listeners.splice(i, 1);
            return;
          }
        }
      };

      var taskComplete = function taskComplete() {
        remainingTasks--;

        _each(listeners.slice(0), function (fn) {
          fn();
        });
      };

      addListener(function () {
        if (!remainingTasks) {
          var theCallback = callback; // prevent final callback from calling itself if it errors

          callback = function callback() {};

          theCallback(null, results);
        }
      });

      _each(keys, function (k) {
        var task = _isArray(tasks[k]) ? tasks[k] : [tasks[k]];

        var taskCallback = function taskCallback(err) {
          var args = Array.prototype.slice.call(arguments, 1);

          if (args.length <= 1) {
            args = args[0];
          }

          if (err) {
            var safeResults = {};

            _each(_keys(results), function (rkey) {
              safeResults[rkey] = results[rkey];
            });

            safeResults[k] = args;
            callback(err, safeResults); // stop subsequent errors hitting callback multiple times

            callback = function callback() {};
          } else {
            results[k] = args;
            async.setImmediate(taskComplete);
          }
        };

        var requires = task.slice(0, Math.abs(task.length - 1)) || [];

        var ready = function ready() {
          return _reduce(requires, function (a, x) {
            return a && results.hasOwnProperty(x);
          }, true) && !results.hasOwnProperty(k);
        };

        if (ready()) {
          task[task.length - 1](taskCallback, results);
        } else {
          var listener = function listener() {
            if (ready()) {
              removeListener(listener);
              task[task.length - 1](taskCallback, results);
            }
          };

          addListener(listener);
        }
      });
    };

    async.retry = function (times, task, callback) {
      var DEFAULT_TIMES = 5;
      var attempts = []; // Use defaults if times not passed

      if (typeof times === 'function') {
        callback = task;
        task = times;
        times = DEFAULT_TIMES;
      } // Make sure times is a number


      times = parseInt(times, 10) || DEFAULT_TIMES;

      var wrappedTask = function wrappedTask(wrappedCallback, wrappedResults) {
        var retryAttempt = function retryAttempt(task, finalAttempt) {
          return function (seriesCallback) {
            task(function (err, result) {
              seriesCallback(!err || finalAttempt, {
                err: err,
                result: result
              });
            }, wrappedResults);
          };
        };

        while (times) {
          attempts.push(retryAttempt(task, !(times -= 1)));
        }

        async.series(attempts, function (done, data) {
          data = data[data.length - 1];
          (wrappedCallback || callback)(data.err, data.result);
        });
      }; // If a callback is passed, run this as a controll flow


      return callback ? wrappedTask() : wrappedTask;
    };

    async.waterfall = function (tasks, callback) {
      callback = callback || function () {};

      if (!_isArray(tasks)) {
        var err = new Error('First argument to waterfall must be an array of functions');
        return callback(err);
      }

      if (!tasks.length) {
        return callback();
      }

      var wrapIterator = function wrapIterator(iterator) {
        return function (err) {
          if (err) {
            callback.apply(null, arguments);

            callback = function callback() {};
          } else {
            var args = Array.prototype.slice.call(arguments, 1);
            var next = iterator.next();

            if (next) {
              args.push(wrapIterator(next));
            } else {
              args.push(callback);
            }

            async.setImmediate(function () {
              iterator.apply(null, args);
            });
          }
        };
      };

      wrapIterator(async.iterator(tasks))();
    };

    var _parallel = function _parallel(eachfn, tasks, callback) {
      callback = callback || function () {};

      if (_isArray(tasks)) {
        eachfn.map(tasks, function (fn, callback) {
          if (fn) {
            fn(function (err) {
              var args = Array.prototype.slice.call(arguments, 1);

              if (args.length <= 1) {
                args = args[0];
              }

              callback.call(null, err, args);
            });
          }
        }, callback);
      } else {
        var results = {};
        eachfn.each(_keys(tasks), function (k, callback) {
          tasks[k](function (err) {
            var args = Array.prototype.slice.call(arguments, 1);

            if (args.length <= 1) {
              args = args[0];
            }

            results[k] = args;
            callback(err);
          });
        }, function (err) {
          callback(err, results);
        });
      }
    };

    async.parallel = function (tasks, callback) {
      _parallel({
        map: async.map,
        each: async.each
      }, tasks, callback);
    };

    async.parallelLimit = function (tasks, limit, callback) {
      _parallel({
        map: _mapLimit(limit),
        each: _eachLimit(limit)
      }, tasks, callback);
    };

    async.series = function (tasks, callback) {
      callback = callback || function () {};

      if (_isArray(tasks)) {
        async.mapSeries(tasks, function (fn, callback) {
          if (fn) {
            fn(function (err) {
              var args = Array.prototype.slice.call(arguments, 1);

              if (args.length <= 1) {
                args = args[0];
              }

              callback.call(null, err, args);
            });
          }
        }, callback);
      } else {
        var results = {};
        async.eachSeries(_keys(tasks), function (k, callback) {
          tasks[k](function (err) {
            var args = Array.prototype.slice.call(arguments, 1);

            if (args.length <= 1) {
              args = args[0];
            }

            results[k] = args;
            callback(err);
          });
        }, function (err) {
          callback(err, results);
        });
      }
    };

    async.iterator = function (tasks) {
      var makeCallback = function makeCallback(index) {
        var fn = function fn() {
          if (tasks.length) {
            tasks[index].apply(null, arguments);
          }

          return fn.next();
        };

        fn.next = function () {
          return index < tasks.length - 1 ? makeCallback(index + 1) : null;
        };

        return fn;
      };

      return makeCallback(0);
    };

    async.apply = function (fn) {
      var args = Array.prototype.slice.call(arguments, 1);
      return function () {
        return fn.apply(null, args.concat(Array.prototype.slice.call(arguments)));
      };
    };

    var _concat = function _concat(eachfn, arr, fn, callback) {
      var r = [];
      eachfn(arr, function (x, cb) {
        fn(x, function (err, y) {
          r = r.concat(y || []);
          cb(err);
        });
      }, function (err) {
        callback(err, r);
      });
    };

    async.concat = doParallel(_concat);
    async.concatSeries = doSeries(_concat);

    async.whilst = function (test, iterator, callback) {
      if (test()) {
        iterator(function (err) {
          if (err) {
            return callback(err);
          }

          async.whilst(test, iterator, callback);
        });
      } else {
        callback();
      }
    };

    async.doWhilst = function (iterator, test, callback) {
      iterator(function (err) {
        if (err) {
          return callback(err);
        }

        var args = Array.prototype.slice.call(arguments, 1);

        if (test.apply(null, args)) {
          async.doWhilst(iterator, test, callback);
        } else {
          callback();
        }
      });
    };

    async.until = function (test, iterator, callback) {
      if (!test()) {
        iterator(function (err) {
          if (err) {
            return callback(err);
          }

          async.until(test, iterator, callback);
        });
      } else {
        callback();
      }
    };

    async.doUntil = function (iterator, test, callback) {
      iterator(function (err) {
        if (err) {
          return callback(err);
        }

        var args = Array.prototype.slice.call(arguments, 1);

        if (!test.apply(null, args)) {
          async.doUntil(iterator, test, callback);
        } else {
          callback();
        }
      });
    };

    async.queue = function (worker, concurrency) {
      if (concurrency === undefined) {
        concurrency = 1;
      }

      function _insert(q, data, pos, callback) {
        if (!q.started) {
          q.started = true;
        }

        if (!_isArray(data)) {
          data = [data];
        }

        if (data.length == 0) {
          // call drain immediately if there are no tasks
          return async.setImmediate(function () {
            if (q.drain) {
              q.drain();
            }
          });
        }

        _each(data, function (task) {
          var item = {
            data: task,
            callback: typeof callback === 'function' ? callback : null
          };

          if (pos) {
            q.tasks.unshift(item);
          } else {
            q.tasks.push(item);
          }

          if (q.saturated && q.tasks.length === q.concurrency) {
            q.saturated();
          }

          async.setImmediate(q.process);
        });
      }

      var workers = 0;
      var q = {
        tasks: [],
        concurrency: concurrency,
        saturated: null,
        empty: null,
        drain: null,
        started: false,
        paused: false,
        push: function push(data, callback) {
          _insert(q, data, false, callback);
        },
        kill: function kill() {
          q.drain = null;
          q.tasks = [];
        },
        unshift: function unshift(data, callback) {
          _insert(q, data, true, callback);
        },
        process: function process() {
          if (!q.paused && workers < q.concurrency && q.tasks.length) {
            var task = q.tasks.shift();

            if (q.empty && q.tasks.length === 0) {
              q.empty();
            }

            workers += 1;

            var next = function next() {
              workers -= 1;

              if (task.callback) {
                task.callback.apply(task, arguments);
              }

              if (q.drain && q.tasks.length + workers === 0) {
                q.drain();
              }

              q.process();
            };

            var cb = only_once(next);
            worker(task.data, cb);
          }
        },
        length: function length() {
          return q.tasks.length;
        },
        running: function running() {
          return workers;
        },
        idle: function idle() {
          return q.tasks.length + workers === 0;
        },
        pause: function pause() {
          if (q.paused === true) {
            return;
          }

          q.paused = true;
        },
        resume: function resume() {
          if (q.paused === false) {
            return;
          }

          q.paused = false; // Need to call q.process once per concurrent
          // worker to preserve full concurrency after pause

          for (var w = 1; w <= q.concurrency; w++) {
            async.setImmediate(q.process);
          }
        }
      };
      return q;
    };

    async.priorityQueue = function (worker, concurrency) {
      function _compareTasks(a, b) {
        return a.priority - b.priority;
      }

      ;

      function _binarySearch(sequence, item, compare) {
        var beg = -1,
            end = sequence.length - 1;

        while (beg < end) {
          var mid = beg + (end - beg + 1 >>> 1);

          if (compare(item, sequence[mid]) >= 0) {
            beg = mid;
          } else {
            end = mid - 1;
          }
        }

        return beg;
      }

      function _insert(q, data, priority, callback) {
        if (!q.started) {
          q.started = true;
        }

        if (!_isArray(data)) {
          data = [data];
        }

        if (data.length == 0) {
          // call drain immediately if there are no tasks
          return async.setImmediate(function () {
            if (q.drain) {
              q.drain();
            }
          });
        }

        _each(data, function (task) {
          var item = {
            data: task,
            priority: priority,
            callback: typeof callback === 'function' ? callback : null
          };
          q.tasks.splice(_binarySearch(q.tasks, item, _compareTasks) + 1, 0, item);

          if (q.saturated && q.tasks.length === q.concurrency) {
            q.saturated();
          }

          async.setImmediate(q.process);
        });
      } // Start with a normal queue


      var q = async.queue(worker, concurrency); // Override push to accept second parameter representing priority

      q.push = function (data, priority, callback) {
        _insert(q, data, priority, callback);
      }; // Remove unshift function


      delete q.unshift;
      return q;
    };

    async.cargo = function (worker, payload) {
      var working = false,
          tasks = [];
      var cargo = {
        tasks: tasks,
        payload: payload,
        saturated: null,
        empty: null,
        drain: null,
        drained: true,
        push: function push(data, callback) {
          if (!_isArray(data)) {
            data = [data];
          }

          _each(data, function (task) {
            tasks.push({
              data: task,
              callback: typeof callback === 'function' ? callback : null
            });
            cargo.drained = false;

            if (cargo.saturated && tasks.length === payload) {
              cargo.saturated();
            }
          });

          async.setImmediate(cargo.process);
        },
        process: function process() {
          if (working) return;

          if (tasks.length === 0) {
            if (cargo.drain && !cargo.drained) cargo.drain();
            cargo.drained = true;
            return;
          }

          var ts = typeof payload === 'number' ? tasks.splice(0, payload) : tasks.splice(0, tasks.length);

          var ds = _map(ts, function (task) {
            return task.data;
          });

          if (cargo.empty) cargo.empty();
          working = true;
          worker(ds, function () {
            working = false;
            var args = arguments;

            _each(ts, function (data) {
              if (data.callback) {
                data.callback.apply(null, args);
              }
            });

            process();
          });
        },
        length: function length() {
          return tasks.length;
        },
        running: function running() {
          return working;
        }
      };
      return cargo;
    };

    var _console_fn = function _console_fn(name) {
      return function (fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        fn.apply(null, args.concat([function (err) {
          var args = Array.prototype.slice.call(arguments, 1);

          if (typeof console !== 'undefined') {
            if (err) {
              if (console.error) {
                console.error(err);
              }
            } else if (console[name]) {
              _each(args, function (x) {
                console[name](x);
              });
            }
          }
        }]));
      };
    };

    async.log = _console_fn('log');
    async.dir = _console_fn('dir');
    /*async.info = _console_fn('info');
    async.warn = _console_fn('warn');
    async.error = _console_fn('error');*/

    async.memoize = function (fn, hasher) {
      var memo = {};
      var queues = {};

      hasher = hasher || function (x) {
        return x;
      };

      var memoized = function memoized() {
        var args = Array.prototype.slice.call(arguments);
        var callback = args.pop();
        var key = hasher.apply(null, args);

        if (key in memo) {
          async.nextTick(function () {
            callback.apply(null, memo[key]);
          });
        } else if (key in queues) {
          queues[key].push(callback);
        } else {
          queues[key] = [callback];
          fn.apply(null, args.concat([function () {
            memo[key] = arguments;
            var q = queues[key];
            delete queues[key];

            for (var i = 0, l = q.length; i < l; i++) {
              q[i].apply(null, arguments);
            }
          }]));
        }
      };

      memoized.memo = memo;
      memoized.unmemoized = fn;
      return memoized;
    };

    async.unmemoize = function (fn) {
      return function () {
        return (fn.unmemoized || fn).apply(null, arguments);
      };
    };

    async.times = function (count, iterator, callback) {
      var counter = [];

      for (var i = 0; i < count; i++) {
        counter.push(i);
      }

      return async.map(counter, iterator, callback);
    };

    async.timesSeries = function (count, iterator, callback) {
      var counter = [];

      for (var i = 0; i < count; i++) {
        counter.push(i);
      }

      return async.mapSeries(counter, iterator, callback);
    };

    async.seq = function ()
    /* functions... */
    {
      var fns = arguments;
      return function () {
        var that = this;
        var args = Array.prototype.slice.call(arguments);
        var callback = args.pop();
        async.reduce(fns, args, function (newargs, fn, cb) {
          fn.apply(that, newargs.concat([function () {
            var err = arguments[0];
            var nextargs = Array.prototype.slice.call(arguments, 1);
            cb(err, nextargs);
          }]));
        }, function (err, results) {
          callback.apply(that, [err].concat(results));
        });
      };
    };

    async.compose = function ()
    /* functions... */
    {
      return async.seq.apply(null, Array.prototype.reverse.call(arguments));
    };

    var _applyEach = function _applyEach(eachfn, fns
    /*args...*/
    ) {
      var go = function go() {
        var that = this;
        var args = Array.prototype.slice.call(arguments);
        var callback = args.pop();
        return eachfn(fns, function (fn, cb) {
          fn.apply(that, args.concat([cb]));
        }, callback);
      };

      if (arguments.length > 2) {
        var args = Array.prototype.slice.call(arguments, 2);
        return go.apply(this, args);
      } else {
        return go;
      }
    };

    async.applyEach = doParallel(_applyEach);
    async.applyEachSeries = doSeries(_applyEach);

    async.forever = function (fn, callback) {
      function next(err) {
        if (err) {
          if (callback) {
            return callback(err);
          }

          throw err;
        }

        fn(next);
      }

      next();
    }; // Node.js


    if (typeof module !== 'undefined' && module.exports) {
      module.exports = async;
    } // AMD / RequireJS
    else if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
          return async;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } // included directly via <script> tag
      else {
          root.async = async;
        }
  })();
  /***/

},
/* 47 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__DocumentGraphBuilder__ = __webpack_require__(48);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__TuroStatement__ = __webpack_require__(50);

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  } //////////////////////////////////////////////////////////////////////


  var State = {
    OK: 0,
    UNKNOWN: 1,
    INVALID: 2
  };
  var graphBuilder = new __WEBPACK_IMPORTED_MODULE_1__DocumentGraphBuilder__["a"
  /* default */
  ](); //////////////////////////////////////////////////////////////////////

  var nextDocumentId = 0;

  var DocumentModel = function () {
    function DocumentModel(documentId, overwriteExistingDefinitions) {
      _classCallCheck(this, DocumentModel);

      this.documentId = documentId ? documentId : '_' + nextDocumentId++;
      this.overwriteExistingDefinitions = !!overwriteExistingDefinitions;
      this._state = {
        updateId: 0,
        graph: graphBuilder.emptyGraph(),
        statementMap: {},
        idsInWrittenOrder: [],
        state: State.INVALID,
        scope: null,
        previousUpdate: []
      };
    } // A nodefinder function. Could be simplified.


    _createClass(DocumentModel, [{
      key: '_nodeFinder',
      value: function _nodeFinder(id) {
        var s = this._state.statementMap[id];

        if (s) {
          return s.node;
        }
      }
    }, {
      key: '_findStatementIdBy',
      value: function _findStatementIdBy(labelFirst, labelSecond, number) {
        if (!__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isNumber(number)) {
          return;
        }

        var state = this._state,
            statementMap = state.statementMap,
            ids = state.idsInWrittenOrder;

        var index = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.sortedIndex(ids, number, function (id) {
          if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isNumber(id)) {
            return id;
          }

          var s = statementMap[id];
          var info = s.info;

          if (info[labelFirst] <= number && number <= info[labelSecond]) {
            return number;
          }

          return info[labelFirst];
        });

        return ids[index];
      }
      /*
       * lineNum is one indexed.
       */

    }, {
      key: 'findStatementIdByLineCol',
      value: function findStatementIdByLineCol(lineNum) {
        return this._findStatementIdBy('lineFirst', 'lineLast', lineNum);
      }
    }, {
      key: 'findStatementIdByOffset',
      value: function findStatementIdByOffset(offset) {
        return this._findStatementIdBy('offsetFirst', 'offsetLast', offset);
      }
    }, {
      key: '_finalReturn',
      value: function _finalReturn(nodeIds) {
        var statementMap = this._state.statementMap;
        return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.map(nodeIds, function (id) {
          return statementMap[id];
        });
      }
    }, {
      key: '_insertNode',
      value: function _insertNode(id, node, statementMap) {
        node._id = id;
        var info = {
          id: id,
          documentId: this.documentId,
          lineFirst: node.lineFirst,
          lineLast: node.lineLast,
          offsetFirst: node.statementOffsetFirst,
          offsetLast: node.statementOffsetLast
        };
        var s = new __WEBPACK_IMPORTED_MODULE_2__TuroStatement__["a"
        /* default */
        ](id, node, info);
        statementMap[id] = s;
        return s;
      }
    }, {
      key: '_findNode',
      value: function _findNode(id, statementMap) {
        var s = statementMap[id];

        if (s) {
          return s.node;
        }
      }
    }, {
      key: '_workingDefinitionId',
      value: function _workingDefinitionId(variableId, g, discountFinal) {
        var definitionIds = g.outgoingEdges[variableId],
            numDefinitions = definitionIds.length;

        if (numDefinitions) {
          return definitionIds[numDefinitions - 1];
        }
      }
    }, {
      key: '_variableId',
      value: function _variableId(id, g) {
        return g.incomingEdges[id][0];
      }
      /**
       * Re-build the document from scratch.
       *
       * The nodes should be a list of evaluatable nodes
       * with the id given as node._id.
       *
       * The finalScope should be the final scope after the parser 
       * that produced the nodes has done with it.
       *
       * This will be available for other documents to import, but 
       * is not used internally by this model.
       * 
       * The nodes will be evaluated in the correct order,
       * though the statements will be returned in given order.
       * 
       * Statements will be given as:
       * {
       *   id  : id,
       *   node: node, 
       *   info: info,
       * }.
       */

    }, {
      key: 'batchUpdate',
      value: function batchUpdate(nodes, finalScope) {
        var _this = this;

        var prefix = this.documentId + '_',
            nextId = 0;
        var statementMap = {},
            ids = [];
        nodes.forEach(function (child) {
          // All of this document is being blown away.
          // Use a prefix so ids are stable across documents.
          // We should probably be tracking scope ids.
          // This is where node ids are generated.
          // For interactiveUpdate, it is passed in from the UI. 
          // This could probably be something really dumb like line number,
          // However this assumes that a statement takes a minimum of 
          // one line. 
          var nodeId = prefix + nextId;
          ids.push(nodeId);

          _this._insertNode(nodeId, child, statementMap);

          nextId++;
        });

        var validNodes = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.filter(nodes, function (child) {
          return !!child.accept;
        }); // Graph builder just deals with evaluation order.
        // It's not clear whether we need a different graph for 
        // functions, especially if this one is going to be good 
        // enough to use for navigation and refactoring.
        // Possible solution: get graph builder to build all graphs 
        // at once, then return g.evaluation.overallOrder()
        // We may have to build a graph for each function/scope.


        var g = graphBuilder.buildInitialGraph(validNodes);
        this._state = {
          graph: g,
          statementMap: statementMap,
          idsInWrittenOrder: ids,
          state: State.OK,
          scope: finalScope
        };

        try {
          var idsInEvalOrder = this._cascade(g.execution, statementMap);

          this._evaluateNodes(idsInEvalOrder, statementMap);
        } catch (e) {
          console.log(e);
        } finally {
          return this._finalReturn(ids);
        }
      }
      /**
       * Update the statement with the given id with the newly parsed AST.
       * The cascade in evaluation order will be returned.
       *
       * Some effort is made to ensure that the right thing happens.
       *
       * However, callers should check model.state following a call to
       * this method.
       *
       * If the model.state is a States.INVALID, callers should cause
       * a reparse of the document, and call this.batchUpdate() as
       * soon as possible.
       */

    }, {
      key: 'interactiveUpdate',
      value: function interactiveUpdate(id, node) {
        // calculate the side effects.
        var g = this._state.graph,
            statementMap = this._state.statementMap,
            s = statementMap[id]; // Find the old node to decide how to update the graph.

        var oldNode;

        if (s) {
          oldNode = s.node;
        } else {
          this._state.idsInWrittenOrder.push(id);
        } // The document state is up-to-date, but un-evaluated.


        this._insertNode(id, node, statementMap); // Calculate the cascade. Graph builder knows what to do,
        // with duplicating and deleting of variables etc.


        var cascade = graphBuilder.updateGraph(g, // The graph object
        id, // The id of the statement we're editing
        oldNode, // The previous AST node for this statement
        node, // The new AST node for this statement
        this._nodeFinder.bind(this), // Finds the AST for a given statement id
        this.overwriteExistingDefinitions // true - filter obsolete definitions from the cascade (a.k.a. repl mode)
        // false - include all statements in the cascade, even definitions that are obsolete.
        ); // Use the graph builder's feedback to determine if the whole document needs re parsing.
        // We may be declaring a brand new variable, and some unparseable lines could now be parsed.

        this._state.state = cascade.documentNeedsReparse ? State.INVALID : State.UNKNOWN;

        var updatedIds = this._cascade(cascade, statementMap);

        var evaluatedStatements = this._finalReturn(updatedIds),
            previouslyEvaluatedStatements = this._finalReturn(this._state.previousUpdate); // Do some book keeping on isUpdated.


        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(previouslyEvaluatedStatements, function (s) {
          s.isUpdated = false;
        });

        this._state.previousUpdate = updatedIds; // Now we can evaluate the nodes in the correct order.

        evaluatedStatements.forEach(function (s) {
          s.reevaluate();
          s.isUpdated = true;
        });
        return evaluatedStatements;
      } //////////////////////////////////////////////////////////////////////

    }, {
      key: 'getStatement',
      value: function getStatement(id) {
        return this._state.statementMap[id];
      } //////////////////////////////////////////////////////////////////////

    }, {
      key: '_evaluateNodes',
      value: function _evaluateNodes(statementIds, statementMap) {
        statementIds.map(function (id) {
          return statementMap[id];
        }).forEach(function (s) {
          return s.reevaluate();
        });
      }
    }, {
      key: '_cascade',
      value: function _cascade(g, statementMap) {
        return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.chain(g.overallOrder()).filter(function (id) {
          return statementMap[id];
        }).value();
      }
      /**
       * Returns the statements as returned by batchUpdate, 
       * with any updates done interactively.
       */

    }, {
      key: 'statementsInWrittenOrder',
      get: function get() {
        return this._finalReturn(this._state.idsInWrittenOrder);
      }
      /**
       * One of States.OK, States.UNKNOWN, States.INVALID.
       * - OK: nothing needs to be done.
       * - UNKNOWN: line numbering is screwed up, and we should re-parse when possible.
       *     The current graph is likely to be the same if you re-parse the document.
       * - INVALID: the model's graph is may no longer be accurate, and new variables may 
       *     cause previously unparseable statements to become parsable. Re-parse now.
       */

    }, {
      key: 'state',
      get: function get() {
        return this._state.state;
      }
    }]);

    return DocumentModel;
  }();
  /* harmony default export */


  __webpack_exports__["a"] = DocumentModel;
  DocumentModel.State = State;
  /***/
},
/* 48 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_dependency_graph__ = __webpack_require__(49);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_dependency_graph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dependency_graph__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__visitors__ = __webpack_require__(3);

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var statics;

  function createVariableId(node) {
    return node.definingScope.id + ':' + node.identifier;
  }

  function addDependency(g, from, to) {
    if (from === undefined || to === undefined) {
      throw new Error('Undefined node in addDependency: (' + from + ', ' + to + ')');
    }

    statics.addNode(g, from);
    statics.addNode(g, to);
    g.addDependency(from, to);
  }
  /**
  
  GraphNodeAdder
    - add a definition node to the graph, and a statement id, so 
      the graph cascades are close to being in-order.
  
  InitialGraphBuilder
    - variable definition
      - add id -> defId in nav graph
    - variable ref
      - add refId -> id in exec graph
      - add refId -> id in nav graph
  
  IdentifierRemovalVisitor
    - variable definition
      define the deletion {id, toDelete:'variableDef:$name', defId scope}
        - remove id -> defId (in execution graph)
        - remove id -> defId (in nav graph)
  IdentifierUpdateVisitor
    - variable definition
      - add id -> defId in nav graph
      - perform the deletion if this isn't toDelete. deletionToken is per statement.
    - variable ref
      - add refId -> id in exec graph
      - add refId -> id in nav graph
  
  For each defId, and scope
    - from nav graph, find the last incoming edge:
      - find node with id, 
        - Add node to scope 
        - add id -> defId in exec graph
  For each refId, find defId from sope.findScopeWith(test, arg).
    - if defId !== refId
      - add defId -> refId in both graphs
   */
  ////////////////////////////////////////////////////////////////


  var GraphNodeAdder = function (_ASTVisitor) {
    _inherits(GraphNodeAdder, _ASTVisitor);

    function GraphNodeAdder() {
      _classCallCheck(this, GraphNodeAdder);

      return _possibleConstructorReturn(this, (GraphNodeAdder.__proto__ || Object.getPrototypeOf(GraphNodeAdder)).apply(this, arguments));
    }

    _createClass(GraphNodeAdder, [{
      key: 'visitVariableDefinition',
      value: function visitVariableDefinition(node, context) {
        var g = context.graph,
            defId = statics.createIdentifierId('variable', node.definingScope, node.identifier);
        statics.addNode(g.execution, defId);
        statics.addNode(g.navigation, defId);
      }
    }, {
      key: 'visit',
      value: function visit(nodes, context) {
        var addToGraph = function (node) {
          node.accept(this, context);
          var g = context.graph,
              id = node._id;
          statics.addNode(g.execution, id);
          statics.addNode(g.navigation, id);
        }.bind(this);

        if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isArray(nodes)) {
          __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(nodes, addToGraph);
        } else {
          addToGraph(nodes);
        }
      }
    }]);

    return GraphNodeAdder;
  }(__WEBPACK_IMPORTED_MODULE_2__visitors__["a"
  /* ASTVisitor */
  ]); ////////////////////////////////////////////////////////////////


  var InitialGraphBuilder = function (_ASTVisitor2) {
    _inherits(InitialGraphBuilder, _ASTVisitor2);

    function InitialGraphBuilder() {
      _classCallCheck(this, InitialGraphBuilder);

      return _possibleConstructorReturn(this, (InitialGraphBuilder.__proto__ || Object.getPrototypeOf(InitialGraphBuilder)).apply(this, arguments));
    }

    _createClass(InitialGraphBuilder, [{
      key: 'visitVariableDefinition',

      /*
        InitialGraphBuilder
        - variable definition
          - add id -> defId in nav graph
        - variable ref
          - add refId -> id in exec graph
          - add refId -> id in nav graph
      */
      value: function visitVariableDefinition(node, context) {
        var g = context.graph,
            scope = node.definingScope,
            identifier = node.identifier,
            defId = statics.createIdentifierId('variable', scope, identifier),
            id = node._id;
        statics.addExecutionFlow(g.navigation, id, defId);
        var defMap = context.defMap;

        if (!defMap[defId]) {
          defMap[defId] = {
            defId: defId,
            identifier: identifier,
            scope: scope,
            type: 'variable'
          };
        }

        context.currentId = id;
        node.ast.accept(this, context); // This will be checked against the deleteToken, 
        // produced by IdentifierRemovalVisitor.

        return defId;
      }
    }, {
      key: 'visitIdentifier',
      value: function visitIdentifier(node, context) {
        var g = context.graph,
            identifier = node.name,
            scope = node.scope;
        var thisId = context.currentId,
            refId = statics.createIdentifierId('variable', scope, identifier),
            refMap = context.refMap;

        if (!refMap[refId]) {
          refMap[refId] = {
            identifier: identifier,
            refId: refId,
            scope: scope,
            type: 'variable'
          };
        }

        statics.addExecutionFlow(g.execution, refId, thisId);
        statics.addExecutionFlow(g.navigation, refId, thisId);
      }
    }, {
      key: 'visit',
      value: function visit(nodes, context) {
        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(nodes, function (node) {
          context.currentId = node._id;
          node.accept(this, context);
        }.bind(this));
      }
    }]);

    return InitialGraphBuilder;
  }(__WEBPACK_IMPORTED_MODULE_2__visitors__["a"
  /* ASTVisitor */
  ]); /////////////////////////////////////////////////////////
  // This visitor prepares a delete-token: enough information 
  // to delete this from the graph and the scope.
  // It may or may not be used, depending on 
  ////////////////////////////////////////////////////////


  var IdentifierRemovalVisitor = function (_ASTVisitor3) {
    _inherits(IdentifierRemovalVisitor, _ASTVisitor3);

    function IdentifierRemovalVisitor() {
      _classCallCheck(this, IdentifierRemovalVisitor);

      return _possibleConstructorReturn(this, (IdentifierRemovalVisitor.__proto__ || Object.getPrototypeOf(IdentifierRemovalVisitor)).apply(this, arguments));
    }

    _createClass(IdentifierRemovalVisitor, [{
      key: 'visitVariableDefinition',

      /*
      IdentifierRemovalVisitor
      - variable definition
        define the deletion {id, toDelete:'variableDef:$name', defId scope}
          - remove id -> defId (in execution graph)
          - remove id -> defId (in nav graph)
      */
      value: function visitVariableDefinition(node, context) {
        var scope = node.definingScope,
            identifier = node.identifier;
        var defId = statics.createIdentifierId('variable', scope, identifier);
        return {
          // the same as a def, but with a statement id.
          defId: defId,
          identifier: identifier,
          scope: scope,
          type: 'variable',
          prevId: node._id
        };
      }
    }]);

    return IdentifierRemovalVisitor;
  }(__WEBPACK_IMPORTED_MODULE_2__visitors__["a"
  /* ASTVisitor */
  ]); /////////////////////////////////////////////////////////
  // This visitor generates a variable definition id (defId)
  // for a given statement.
  // This is id will be compared against that of the deleteToken.
  ////////////////////////////////////////////////////////


  var IdentifierUpdateVisitor = function (_ASTVisitor4) {
    _inherits(IdentifierUpdateVisitor, _ASTVisitor4);

    function IdentifierUpdateVisitor() {
      _classCallCheck(this, IdentifierUpdateVisitor);

      return _possibleConstructorReturn(this, (IdentifierUpdateVisitor.__proto__ || Object.getPrototypeOf(IdentifierUpdateVisitor)).apply(this, arguments));
    }

    _createClass(IdentifierUpdateVisitor, [{
      key: 'visitVariableDefinition',
      value: function visitVariableDefinition(node, context) {
        var defId = statics.createIdentifierId('variable', node.definingScope, node.identifier);
        return defId;
      }
    }]);

    return IdentifierUpdateVisitor;
  }(__WEBPACK_IMPORTED_MODULE_2__visitors__["a"
  /* ASTVisitor */
  ]); /////////////////////////////////////////////////////////
  //
  ////////////////////////////////////////////////////////


  var graphNodeAdder = new GraphNodeAdder(),
      initialGraphBuilder = new InitialGraphBuilder(),
      identifierUpdater = new IdentifierUpdateVisitor(),
      identifierRemover = new IdentifierRemovalVisitor();

  var DocumentGraphBuilder = function () {
    function DocumentGraphBuilder() {
      _classCallCheck(this, DocumentGraphBuilder);
    }

    _createClass(DocumentGraphBuilder, [{
      key: 'emptyGraph',
      value: function emptyGraph() {
        return {
          // This is the execution order. It should be up-to-date for all parsed
          // statements at any one time.
          execution: new __WEBPACK_IMPORTED_MODULE_1_dependency_graph__["DepGraph"](),
          // This is the navigation graph. It is the same as the execution graph, 
          // but also keeps track of the duplicate definitions.
          navigation: new __WEBPACK_IMPORTED_MODULE_1_dependency_graph__["DepGraph"]()
        };
      }
    }, {
      key: '_orderingContext',
      value: function _orderingContext(graph) {
        var refMap = {},
            defMap = {};
        var context = {
          graph: graph,
          refMap: refMap,
          defMap: defMap
        };
        return context;
      }
    }, {
      key: 'buildInitialGraph',
      value: function buildInitialGraph(nodes) {
        var graph = this.emptyGraph();

        var context = this._orderingContext(graph);

        graphNodeAdder.visit(nodes, context);
        initialGraphBuilder.visit(nodes, context);
        statics.wireUpExecutionGraph(context, statics.createNodeFinder(nodes));
        return graph;
      }
    }, {
      key: 'updateGraph',
      value: function updateGraph(graph, id, oldNode, newNode, nodeFinder, overwriteExistingDefinitions) {
        var context = this._orderingContext(graph); // context is available everywhere.


        context.overwriteExistingDefinitions = overwriteExistingDefinitions;
        var returnGraph = new __WEBPACK_IMPORTED_MODULE_1_dependency_graph__["DepGraph"](),
            returnStatus = null; // the delete token will tell us what we need to delete if we need to delete it.

        var deleteToken;

        if (oldNode && oldNode.accept) {
          deleteToken = oldNode.accept(identifierRemover, context);
        }

        var newDefId;

        if (newNode.accept) {
          newDefId = newNode.accept(identifierUpdater, context);
        }

        if (newDefId) {
          // If this is a definition
          if (!graph.navigation.hasNode(newDefId)) {
            // that we haven't seen before, then 
            // perhaps we need to tell someone to reparse 
            // the whole document – there may be parseable 
            // statements now that we have a variable definition.
            returnStatus = newDefId;
          }
        }

        if (deleteToken && deleteToken.defId !== newDefId) {
          // The oldNode was a definition of some sort,
          // and not the same as the new one.
          // Some of the rest of the document may now be in error.
          // Add the old execution cascade from the statement id.
          // *we haven't mutated graph.execution yet*
          this.subgraphOfDependants(id, graph.execution, returnGraph);
          var defId = deleteToken.defId; // Now remove the node from both graphs altogether.
          // This is the belt & braces way of doing it.

          statics.removeNode(graph.execution, id);
          statics.removeNode(graph.navigation, id); // also: 
          // - remove id -> defId (in execution graph)
          // - remove id -> defId (in nav graph)
          // graph.execution.removeDependency(defId, id);
          // graph.navigation.removeDependency(defId, id);
          // we should also remove all refId to this statement.
          // refId -> id
          // this.removeDependencies(graph.execution, id);
          // this.removeDependencies(graph.navigation, id);
          // Remove from this scope.

          statics._removeFromScope(deleteToken.scope, deleteToken.type, deleteToken.identifier); // If there is anything left in scope to replace this 
          // definition, so add this to be wired up in the execution 
          // graph.


          context.defMap[defId] = deleteToken;
        } else {
          // The old node and the new node are either defining the same thing
          // or neither of them are defining anything.
          // We are no longer interested in updates from the previous definition.
          statics.removeDependencies(graph.execution, id);
          statics.removeDependencies(graph.navigation, id);
        }

        if (newNode.accept) {
          // If we don't have a old node, the new one is new to the document.
          if (!oldNode) {
            graphNodeAdder.visit(newNode, context);
          }

          context.currentId = id;
          newNode.accept(initialGraphBuilder, context);
        } // Everything so far has been about wiring 
        // refId -> id in both graphs 
        //   (every variable reference of the same identifier in the same scope is refering to the same thing)
        // id -> defId in the navigation graph 
        //   (every variable definition of the same identifier in the same scope is defining the same thing)
        // 
        // Now we need to ensure the execution plan:
        // id -> defId in execution graph
        //   (of the competing definitions (in the same scope) for the same identifier, which wins?)
        // defId -> refId in both graphs
        //   (if there are no definitions in the same scope, which scope should we use?)


        statics.wireUpExecutionGraph(context, nodeFinder, returnGraph); // Add the new cascade for the new definition.

        if (newNode.accept) {
          this.subgraphOfDependants(id, graph.execution, returnGraph);
        }

        returnGraph.documentNeedsReparse = returnStatus;
        return returnGraph;
      }
    }, {
      key: 'subgraphOfDependants',
      value: function subgraphOfDependants(id, graph, returnGraph) {
        var subgraph = returnGraph || new __WEBPACK_IMPORTED_MODULE_1_dependency_graph__["DepGraph"]();
        var ids = graph.dependantsOf(id);
        subgraph.addNode(id);

        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(ids, function (nodeId) {
          subgraph.addNode(nodeId);
        });

        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(ids, function (to) {
          __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(graph.incomingEdges[to], function (from) {
            if (subgraph.hasNode(from)) {
              addDependency(subgraph, from, to);
            }
          });
        });

        return subgraph;
      }
    }, {
      key: 'subgraphOfDependancies',
      value: function subgraphOfDependancies(id, graph, returnGraph) {
        var subgraph = returnGraph || new __WEBPACK_IMPORTED_MODULE_1_dependency_graph__["DepGraph"]();
        var ids = graph.dependenciesOf(id);
        subgraph.addNode(id);

        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(ids, function (nodeId) {
          subgraph.addNode(nodeId);
        });

        __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(ids, function (from) {
          __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(graph.outgoingEdges[from], function (to) {
            if (subgraph.hasNode(to)) {
              addDependency(subgraph, from, to);
            }
          });
        });

        return subgraph;
      }
    }]);

    return DocumentGraphBuilder;
  }(); ////////////////////////////////////////////////////////////////

  /* harmony default export */


  __webpack_exports__["a"] = DocumentGraphBuilder;
  statics = {
    ////////////////////////////////////////////////////////////////
    // Statement finding utils
    ////////////////////////////////////////////////////////////////
    createNodeFinder: function createNodeFinder(nodes) {
      var nodeMap = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.chain(nodes).pluck('_id').object(nodes).value();

      return function (id) {
        return nodeMap[id];
      };
    },
    ////////////////////////////////////////////////////////////////
    // Scope utils
    ////////////////////////////////////////////////////////////////
    _addToScope: function _addToScope(scope, definitionType, identifier, node) {
      switch (definitionType) {
        case 'variable':
          scope.addVariable(identifier, node);
          break;
      }
    },
    _findScopeWith: function _findScopeWith(scope, refType, identifier) {
      switch (refType) {
        case 'variable':
          return scope.findScopeWithVariable(identifier);
      }
    },
    _removeFromScope: function _removeFromScope(scope, definitionType, identifier) {
      switch (definitionType) {
        case 'variable':
          scope.addVariable(identifier, undefined);
          break;
      }
    },
    ////////////////////////////////////////////////////////////////
    // Graph utils
    ////////////////////////////////////////////////////////////////
    createIdentifierId: function createIdentifierId(defType, scope, identifier) {
      if (!identifier) {
        throw new Error('Identifier is undefined');
      }

      return defType + ':' + scope.id + '/' + identifier;
    },
    addNode: function addNode(g, id) {
      // if id is already in the graph, g.addNode will 
      // leave g in an inconsistent state.
      if (!g.hasNode(id)) {
        g.addNode(id);
      }
    },
    addExecutionFlow: function addExecutionFlow(g, from, to) {
      // Note that the execution flow is 
      // the reverse of the dependency flow.
      addDependency(g, to, from);
    },
    removeDependencies: function removeDependencies(g, name) {
      var outgoing = g.outgoingEdges[name];
      g.outgoingEdges[name] = [];

      __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(outgoing, function (to) {
        g.removeDependency(name, to);
      });
    },
    removeDependants: function removeDependants(g, name) {
      var incoming = g.incomingEdges[name];
      g.incomingEdges[name] = [];

      __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(incoming, function (from) {
        g.removeDependency(from, name);
      });
    },
    removeNode: function removeNode(g, name, forRealz) {
      statics.removeDependencies(g, name);
      statics.removeDependants(g, name);

      if (forRealz) {
        delete g.nodes[name];
        delete g.incomingEdges[name];
        delete g.outgoingEdges[name];
      }
    },
    wireUpExecutionGraph: function wireUpExecutionGraph(context, nodeFinder) {
      statics._wireUpExecutionGraph(context.graph, __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.values(context.defMap), __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.values(context.refMap), nodeFinder, context.overwriteExistingDefinitions);
    },
    ////////////////////////////////////////////////////////////////
    // This is the workhorse of the execution model.
    // It decides which definition propagates,
    // And how it propagates across scopes. 
    ////////////////////////////////////////////////////////////////
    _wireUpExecutionGraph: function _wireUpExecutionGraph(g, defs, refs, nodeFinder, overwriteExistingDefinitions) {
      /*
      For each defId, scope in defs
        - from nav graph, find the last incoming edge:
          - find node with id, 
            - Add node to scope 
            - add id -> defId in exec graph
      For each refId, find defId from sope.findScopeWith(test, arg).
        - if defId !== refId
          - add defId -> refId in both graphs
       */
      ///////////////////////////////////////////////////////////
      // Make the scope fit the graph, for duplicate definitions
      // of the same identifier.
      ///////////////////////////////////////////////////////////
      // From the navigation graph, find the correct id -> defId.
      // id -> defId in execution graph.
      defs.forEach(function (def) {
        var defName = def.identifier,
            defType = def.type,
            defId = def.defId,
            defScope = def.scope; // We use the graph to define which definitions are used for 
        // each variable. It is possible to use the same variable 
        // multiple times, so we must decide which one we're going to use.

        var defStatementIds = g.navigation.outgoingEdges[defId]; // Q What happens if we have multiple statements defining the same thing?
        // A This should be the last definition we have in the document.
        //   If we could sorting alphanumerically defStatementIds assumes an 
        //   id structure concordant with the document structure.

        var statementId;

        switch (defStatementIds.length) {
          case 0:
            break;

          case 1:
            statementId = defStatementIds[0];
            break;

          default:
            defStatementIds = defStatementIds.sort();

            if (overwriteExistingDefinitions) {
              // We are in REPL or a file processing mode.
              // We don't want to [re-]evaluate obsolete definitions.
              statementId = defStatementIds.pop();

              __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(defStatementIds, function (obsolete) {
                statics.removeNode(g.execution, obsolete, true);
              });
            } else {
              statementId = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.last(defStatementIds);
            }

        } // Trim the link between the previous definition and this defId.
        // This will only happen during an updateGraph, 
        // because during buildInitialGraph, the previous definition hasn't been 
        // chosen yet.


        statics.removeDependencies(g.execution, defId);

        if (statementId) {
          // This is the statement id that will be used to define this 
          // variable in this scope.
          statics.addExecutionFlow(g.execution, statementId, defId);
        } else {
          // Q What happens when there are zero defStatementIds?
          // A When we have the whole document, this is not possible.
          //   This is only possible with the deletion of the last definition 
          //   in this scope,
          if (!def.prevId) {
            throw new Error('Assertion Failed: ' + defId);
          } //   However there may be shadowed definitions that can take over
          //   We should chain this definition as a ref id.
          //   In which case, all usages of this definition drops down to use that one.


          def.refId = def.defId;
          refs.push(def); //   It is safe to delete from this def scope.
          //   The subgraph of the previous execution graph for defId will 
        } // Q What happens when this defId's new statementId is different to the old one.
        // A This is only possible when we have 
        // Next job: make the scope match the graph.
        // This is the only place outside of the parser that we 
        // directly edit the scope.
        // (In document helper, we add imports.)


        var node = nodeFinder(statementId); // We are adding something which is declared in this scope.
        // If node is falsey, then it was defined in this scope, but now is not,
        // so may safely be removed.

        statics._addToScope(defScope, defType, defName, node);
      }); ///////////////////////////////////////////////////////////
      // Make the graph fit the scope for child-to-parent scoping.
      ///////////////////////////////////////////////////////////
      //
      // defId -> refId in both graphs.
      // This is the usages of the same variable in the same scope to decide which 
      // version of the variable to use.

      __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.each(refs, function (ref) {
        var refName = ref.identifier,
            refType = ref.type,
            refId = ref.refId,
            refScope = ref.scope,
            defId; // Use the scope's id to update the refId to point to nearest available
        // defId's.
        // Use the scope that this variable is used in to find the next closest
        // definition id.

        var defScope = statics._findScopeWith(refScope, refType, refName); // Most of the time, the variable will be used in the same scope 
        // as it is used.
        // In this case, we don't need to do anything, 
        // because the refId and the defId are the same node, and will already have zero or 
        // one statements defining it.
        // However, there are two cases to consider.


        if (!defScope) {
          // If this variable definition doesn't exist in any scope,
          // it may be worth deleting it from the graph altogether.
          // If the identifier is still in use, then don't.
          if (g.navigation.incomingEdges[refId].length === 0) {
            // Remove the node from both graphs. They are definitely not in use 
            // and have no definitions.
            // This lets us keep an intact graph in the face of 
            // live editing an already valid variable name and not clutter up 
            // the graph with prefixes to the final name.
            statics.removeNode(g.execution, refId);
            statics.removeNode(g.navigation, refId);
          }
        } else if (defScope !== refScope) {
          // 2. Imported files can export constants and units, which may be used 
          // in this scope.
          // We definitely want to do this if this is the same document,  
          defId = statics.createIdentifierId(refType, defScope, refName);
          statics.addExecutionFlow(g.execution, defId, refId); // There is no harm in adding extra defIds if they come from 
          // other documents:
          // if we want to do incremental updates across 
        }
      });
    }
  };
  /***/
},
/* 49 */

/***/
function (module, exports) {
  /**
   * A simple dependency graph
   */

  /**
   * Helper for creating a Depth-First-Search on
   * a set of edges.
   *
   * Detects cycles and throws an Error if one is detected.
   *
   * @param edges The set of edges to DFS through
   * @param leavesOnly Whether to only return "leaf" nodes (ones who have no edges)
   * @param result An array in which the results will be populated
   * @param circular A boolean to allow circular dependencies
   */
  function createDFS(edges, leavesOnly, result, circular) {
    var currentPath = [];
    var visited = {};
    return function DFS(currentNode) {
      visited[currentNode] = true;
      currentPath.push(currentNode);
      edges[currentNode].forEach(function (node) {
        if (!visited[node]) {
          DFS(node);
        } else if (currentPath.indexOf(node) >= 0) {
          currentPath.push(node);

          if (!circular) {
            throw new Error('Dependency Cycle Found: ' + currentPath.join(' -> '));
          }
        }
      });
      currentPath.pop();

      if ((!leavesOnly || edges[currentNode].length === 0) && result.indexOf(currentNode) === -1) {
        result.push(currentNode);
      }
    };
  }
  /**
   * Simple Dependency Graph
   */


  var DepGraph = exports.DepGraph = function DepGraph(opts) {
    this.nodes = {}; // Node -> Node/Data (treated like a Set)

    this.outgoingEdges = {}; // Node -> [Dependency Node]

    this.incomingEdges = {}; // Node -> [Dependant Node]

    this.circular = opts && !!opts.circular; // Allows circular deps
  };

  DepGraph.prototype = {
    /**
     * The number of nodes in the graph.
     */
    size: function size() {
      return Object.keys(this.nodes).length;
    },

    /**
     * Add a node to the dependency graph. If a node already exists, this method will do nothing.
     */
    addNode: function addNode(node, data) {
      if (!this.hasNode(node)) {
        // Checking the arguments length allows the user to add a node with undefined data
        if (arguments.length === 2) {
          this.nodes[node] = data;
        } else {
          this.nodes[node] = node;
        }

        this.outgoingEdges[node] = [];
        this.incomingEdges[node] = [];
      }
    },

    /**
     * Remove a node from the dependency graph. If a node does not exist, this method will do nothing.
     */
    removeNode: function removeNode(node) {
      if (this.hasNode(node)) {
        delete this.nodes[node];
        delete this.outgoingEdges[node];
        delete this.incomingEdges[node];
        [this.incomingEdges, this.outgoingEdges].forEach(function (edgeList) {
          Object.keys(edgeList).forEach(function (key) {
            var idx = edgeList[key].indexOf(node);

            if (idx >= 0) {
              edgeList[key].splice(idx, 1);
            }
          }, this);
        });
      }
    },

    /**
     * Check if a node exists in the graph
     */
    hasNode: function hasNode(node) {
      return this.nodes.hasOwnProperty(node);
    },

    /**
     * Get the data associated with a node name
     */
    getNodeData: function getNodeData(node) {
      if (this.hasNode(node)) {
        return this.nodes[node];
      } else {
        throw new Error('Node does not exist: ' + node);
      }
    },

    /**
     * Set the associated data for a given node name. If the node does not exist, this method will throw an error
     */
    setNodeData: function setNodeData(node, data) {
      if (this.hasNode(node)) {
        this.nodes[node] = data;
      } else {
        throw new Error('Node does not exist: ' + node);
      }
    },

    /**
     * Add a dependency between two nodes. If either of the nodes does not exist,
     * an Error will be thrown.
     */
    addDependency: function addDependency(from, to) {
      if (!this.hasNode(from)) {
        throw new Error('Node does not exist: ' + from);
      }

      if (!this.hasNode(to)) {
        throw new Error('Node does not exist: ' + to);
      }

      if (this.outgoingEdges[from].indexOf(to) === -1) {
        this.outgoingEdges[from].push(to);
      }

      if (this.incomingEdges[to].indexOf(from) === -1) {
        this.incomingEdges[to].push(from);
      }

      return true;
    },

    /**
     * Remove a dependency between two nodes.
     */
    removeDependency: function removeDependency(from, to) {
      var idx;

      if (this.hasNode(from)) {
        idx = this.outgoingEdges[from].indexOf(to);

        if (idx >= 0) {
          this.outgoingEdges[from].splice(idx, 1);
        }
      }

      if (this.hasNode(to)) {
        idx = this.incomingEdges[to].indexOf(from);

        if (idx >= 0) {
          this.incomingEdges[to].splice(idx, 1);
        }
      }
    },

    /**
     * Return a clone of the dependency graph. If any custom data is attached
     * to the nodes, it will only be shallow copied.
     */
    clone: function clone() {
      var source = this;
      var result = new DepGraph();
      var keys = Object.keys(source.nodes);
      keys.forEach(function (n) {
        result.nodes[n] = source.nodes[n];
        result.outgoingEdges[n] = source.outgoingEdges[n].slice(0);
        result.incomingEdges[n] = source.incomingEdges[n].slice(0);
      });
      return result;
    },

    /**
     * Get an array containing the nodes that the specified node depends on (transitively).
     *
     * Throws an Error if the graph has a cycle, or the specified node does not exist.
     *
     * If `leavesOnly` is true, only nodes that do not depend on any other nodes will be returned
     * in the array.
     */
    dependenciesOf: function dependenciesOf(node, leavesOnly) {
      if (this.hasNode(node)) {
        var result = [];
        var DFS = createDFS(this.outgoingEdges, leavesOnly, result, this.circular);
        DFS(node);
        var idx = result.indexOf(node);

        if (idx >= 0) {
          result.splice(idx, 1);
        }

        return result;
      } else {
        throw new Error('Node does not exist: ' + node);
      }
    },

    /**
     * get an array containing the nodes that depend on the specified node (transitively).
     *
     * Throws an Error if the graph has a cycle, or the specified node does not exist.
     *
     * If `leavesOnly` is true, only nodes that do not have any dependants will be returned in the array.
     */
    dependantsOf: function dependantsOf(node, leavesOnly) {
      if (this.hasNode(node)) {
        var result = [];
        var DFS = createDFS(this.incomingEdges, leavesOnly, result, this.circular);
        DFS(node);
        var idx = result.indexOf(node);

        if (idx >= 0) {
          result.splice(idx, 1);
        }

        return result;
      } else {
        throw new Error('Node does not exist: ' + node);
      }
    },

    /**
     * Construct the overall processing order for the dependency graph.
     *
     * Throws an Error if the graph has a cycle.
     *
     * If `leavesOnly` is true, only nodes that do not depend on any other nodes will be returned.
     */
    overallOrder: function overallOrder(leavesOnly) {
      var self = this;
      var result = [];
      var keys = Object.keys(this.nodes);

      if (keys.length === 0) {
        return result; // Empty graph
      } else {
        // Look for cycles - we run the DFS starting at all the nodes in case there
        // are several disconnected subgraphs inside this dependency graph.
        var CycleDFS = createDFS(this.outgoingEdges, false, [], this.circular);
        keys.forEach(function (n) {
          CycleDFS(n);
        });
        var DFS = createDFS(this.outgoingEdges, leavesOnly, result, this.circular); // Find all potential starting points (nodes with nothing depending on them) an
        // run a DFS starting at these points to get the order

        keys.filter(function (node) {
          return self.incomingEdges[node].length === 0;
        }).forEach(function (n) {
          DFS(n);
        });
        return result;
      }
    }
  };
  /***/
},
/* 50 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__output__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__eval__ = __webpack_require__(51);

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var TuroStatement = function () {
    function TuroStatement(id, node, info, updateId) {
      _classCallCheck(this, TuroStatement);

      this._id = id;
      this._node = node;
      /*
      info = {
        id: id,
        documentId: this.documentId,
        lineFirst: node.lineFirst,
        lineLast: node.lineLast,
        offsetFirst: node.statementOffsetFirst,
        offsetLast: node.statementOffsetLast,
      };
       */

      this._info = info;
      this._currentValue = null;
      this._errors = null;
      this._updateId = updateId;
    }

    _createClass(TuroStatement, [{
      key: 'isParseable',
      value: function isParseable() {
        return !!this.node.accept && !this.node.isUnparsed;
      }
    }, {
      key: 'hasErrors',
      value: function hasErrors() {
        if (!this.isParseable()) {
          return true;
        }

        var value = this.currentValue;
        return this.errors && this.errors.length;
      }
    }, {
      key: 'toTokens',
      value: function toTokens() {
        var prefs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return __WEBPACK_IMPORTED_MODULE_1__output__["a"
        /* default */
        ].toTokenArray(this.node, {
          prefs: prefs
        });
      }
    }, {
      key: 'valueToString',
      value: function valueToString(display, prefs) {
        return __WEBPACK_IMPORTED_MODULE_1__output__["a"
        /* default */
        ].toStringWithDisplay(this.currentValue, display, prefs);
      }
    }, {
      key: 'expressionToString',
      value: function expressionToString(display, prefs) {
        return __WEBPACK_IMPORTED_MODULE_1__output__["a"
        /* default */
        ].toStringWithDisplay(this.expression, display, prefs);
      }
    }, {
      key: 'verboseToString',
      value: function verboseToString(display, prefs) {
        var t = [__WEBPACK_IMPORTED_MODULE_1__output__["a"
        /* default */
        ].toStringWithDisplay(this.node, display, prefs), '=', this.valueToString(display, prefs)];
        return t.join(' ');
      }
    }, {
      key: 'errorToString',
      value: function errorToString(display) {}
    }, {
      key: 'reevaluate',
      value: function reevaluate() {
        if (!this.isParseable()) {
          return;
        }

        var currentValue = __WEBPACK_IMPORTED_MODULE_2__eval__["a"
        /* default */
        ].evaluate(this.node);

        this._currentValue = currentValue;
        return currentValue;
      }
    }, {
      key: 'toString',
      value: function toString(display, prefs) {
        return this.verboseToString(display, prefs);
      }
    }, {
      key: 'tokens',
      get: function get() {
        return this.toTokens();
      }
    }, {
      key: 'id',
      get: function get() {
        return this._id;
      }
    }, {
      key: 'errors',
      get: function get() {
        return this.node.errors;
      }
    }, {
      key: 'expression',
      get: function get() {
        var node = this._node;

        if (node.definition) {
          return node.definition;
        }

        return node;
      }
    }, {
      key: 'identifier',
      get: function get() {
        return this._node.identifier;
      }
    }, {
      key: 'info',
      get: function get() {
        return this._info;
      }
    }, {
      key: 'node',
      get: function get() {
        return this._node;
      }
    }, {
      key: 'currentValue',
      get: function get() {
        if (this._currentValue) {
          return this._currentValue;
        }

        this._currentValue = this.reevaluate();
        return this._currentValue;
      }
    }, {
      key: 'text',
      get: function get() {
        return this._info.text;
      }
    }]);

    return TuroStatement;
  }();
  /* harmony default export */


  __webpack_exports__["a"] = TuroStatement;
  /***/
},
/* 51 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__operators__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__visitors__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__OperationLabeller__ = __webpack_require__(52);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__EvaluatorVisitor__ = __webpack_require__(53);

  var operationLabellerVisitor = new __WEBPACK_IMPORTED_MODULE_2__OperationLabeller__["a"
  /* default */
  ]();
  var evaluatorVisitor = new __WEBPACK_IMPORTED_MODULE_3__EvaluatorVisitor__["a"
  /* default */
  ]();

  function evaluate(node) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$prefs = _ref.prefs,
        prefs = _ref$prefs === undefined ? {} : _ref$prefs,
        _ref$operators = _ref.operators,
        operators = _ref$operators === undefined ? __WEBPACK_IMPORTED_MODULE_0__operators__["b"
    /* defaultOperators */
    ] : _ref$operators; // we need to do this because we can't detect if the variables
    // have changed units or types.


    var errors = node.errors || [],
        scope = node.scope,
        units = scope ? scope.units : undefined;
    var len = errors.length;
    var labellerContext = new __WEBPACK_IMPORTED_MODULE_1__visitors__["b"
    /* VisitorContext */
    ](operationLabellerVisitor, {
      prefs: prefs,
      errors: errors,
      operators: operators
    });
    labellerContext.evaluate(node);

    if (errors.length !== len) {
      node.errors = errors;
      return;
    } // now we have units and operations, we can evaluate.


    var evalContext = new __WEBPACK_IMPORTED_MODULE_1__visitors__["b"
    /* VisitorContext */
    ](evaluatorVisitor, {
      prefs: prefs,
      errors: errors,
      units: units
    });
    var value = evalContext.evaluate(node);

    if (errors.length !== len) {
      node.errors = errors;
    }

    return value;
  }
  /* harmony default export */


  __webpack_exports__["a"] = {
    evaluate: evaluate
  };
  /***/
},
/* 52 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__visitors__ = __webpack_require__(3);

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var OperationLabellerVisitor = function (_ASTVisitor) {
    _inherits(OperationLabellerVisitor, _ASTVisitor);

    function OperationLabellerVisitor() {
      _classCallCheck(this, OperationLabellerVisitor);

      return _possibleConstructorReturn(this, (OperationLabellerVisitor.__proto__ || Object.getPrototypeOf(OperationLabellerVisitor)).apply(this, arguments));
    }

    _createClass(OperationLabellerVisitor, [{
      key: "visitBinaryOperator",
      value: function visitBinaryOperator(node, context) {
        var len = context.errors.length;
        var lType = node.left.accept(this, context),
            rType = node.right.accept(this, context);

        if (!(lType && rType)) {
          // An error happened further down the tree.
          return;
        }

        var operation = context.operators.findOperator(node.literal, lType, rType);

        if (!operation) {
          context.reportError("TYPE_MISMATCH", node, node.left, node.right);
          return;
        }

        node.operation = operation;
        return operation.returnValueType;
      }
    }, {
      key: "visitUnaryOperation",
      value: function visitUnaryOperation(node, context) {
        var operandType = node.value.accept(this, context);

        if (!operandType) {
          // An error happened further down the tree.
          return;
        }

        var operation = context.operators.findUnaryOperator(node.literal, operandType, node.isPrefix);

        if (!operation) {
          context.reportError("TYPE_MISMATCH", node);
          return;
        }

        node.operation = operation;
        return operation.returnValueType;
      }
    }, {
      key: "visitParens",
      value: function visitParens(node, context) {
        return node.ast.accept(this, context);
      }
    }, {
      key: "visitNumberNode",
      value: function visitNumberNode(node, context) {
        return node.valueType;
      }
    }, {
      key: "visitIdentifier",
      value: function visitIdentifier(node, context) {
        if (!context.variables && !node.scope) {
          // not throw, because our earlier tests
          // won't pass. TODO
          return;
        }

        var definitionNode;

        if (node.scope) {
          definitionNode = node.scope.findVariable(node.name);
        }

        if (!definitionNode || !definitionNode.accept) {
          context.reportError("NO_SUCH_VARIABLE", node);
          return;
        } // TODO detect cycles


        if (definitionNode._isBusy) {
          context.reportError("UNCALCULATED_VARIABLE", node);
          context.reportError("CYCLIC_DEFINITION", definitionNode);
          return;
        }

        definitionNode._isBusy = true;
        var retValueType = definitionNode.accept(this, context); // This is incidental to operation labelling.

        node.definition = definitionNode;
        node.isConstant = definitionNode.isConstant;
        delete definitionNode._isBusy;
        return retValueType;
      }
    }, {
      key: "visitVariableDefinition",
      value: function visitVariableDefinition(node, context) {
        // This is OK to do here, because a) it's only done infrequently
        // we could lazily calculate, but valueType is an intermediate value,
        // but changes in the variables used in this definition may change a
        // this variable.
        node.valueType = node.ast.accept(this, context);
        return node.valueType;
      }
    }, {
      key: "visitUnit",
      value: function visitUnit(unit, context) {
        return "unit";
      }
    }, {
      key: "visitUnitPower",
      value: function visitUnitPower(unit, context) {
        return "unit";
      }
    }, {
      key: "visitUnitLiteral",
      value: function visitUnitLiteral(unit, context) {
        return "unit";
      }
    }, {
      key: "visitUnitMultOp",
      value: function visitUnitMultOp(unit, context) {
        return "unit";
      }
    }]);

    return OperationLabellerVisitor;
  }(__WEBPACK_IMPORTED_MODULE_0__visitors__["a"
  /* ASTVisitor */
  ]);
  /* harmony default export */


  __webpack_exports__["a"] = OperationLabellerVisitor;
  /***/
},
/* 53 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__operators__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__turo_number__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__visitors__ = __webpack_require__(3);

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  function unitConversion(node, resultValue) {
    if (resultValue === undefined) {
      // This is an error condition
      // where the result of an operation 
      // is in error.
      return;
    } // unitLiteral = the unit the user typed.


    var sourceUnit = resultValue.unit,
        unitLiteral = node.unitLiteral;

    if (sourceUnit && unitLiteral) {
      if (unitLiteral.matchesDimensions(sourceUnit)) {
        return resultValue.convert(unitLiteral);
      }

      return __WEBPACK_IMPORTED_MODULE_1__turo_number__["a"
      /* default */
      ].newInstance(resultValue.number, unitLiteral.by(sourceUnit), resultValue.valueType);
    } else if (unitLiteral && !sourceUnit) {
      return __WEBPACK_IMPORTED_MODULE_1__turo_number__["a"
      /* default */
      ].newInstance(resultValue.number, unitLiteral, resultValue.valueType);
    }

    return resultValue;
  } ///////////////////////////////////////////////////////////////


  var EvaluatorVisitor = function (_ASTVisitor) {
    _inherits(EvaluatorVisitor, _ASTVisitor);

    function EvaluatorVisitor() {
      _classCallCheck(this, EvaluatorVisitor);

      return _possibleConstructorReturn(this, (EvaluatorVisitor.__proto__ || Object.getPrototypeOf(EvaluatorVisitor)).apply(this, arguments));
    }

    _createClass(EvaluatorVisitor, [{
      key: 'visitImportStatement',
      value: function visitImportStatement(node, context) {// NOP, we do this in the parser.
      }
    }, {
      key: 'visitStatementList',
      value: function visitStatementList(node, context) {
        node.ast.forEach(function (st) {
          node.accept(this, context);
        });
      }
    }, {
      key: 'visitBinaryOperator',
      value: function visitBinaryOperator(node, context) {
        var operation = node.operation,
            result = operation.evaluate(node.left, node.right, context);
        return unitConversion(node, result);
      }
    }, {
      key: 'visitUnaryOperation',
      value: function visitUnaryOperation(node, context) {
        var operation = node.operation,
            result = operation.evaluate(node.value, context);
        return unitConversion(node, result);
      }
    }, {
      key: 'visitParens',
      value: function visitParens(node, context) {
        var child = node.ast,
            result = child.accept(this, context);
        return unitConversion(node, result);
      }
    }, {
      key: 'visitNumberNode',
      value: function visitNumberNode(node, context) {
        node.value = node._value; // XXX WTF

        return __WEBPACK_IMPORTED_MODULE_1__turo_number__["a"
        /* default */
        ].newInstance(node.value, node.unitLiteral, node.valueType);
      }
    }, {
      key: 'visitIdentifier',
      value: function visitIdentifier(node, context) {
        var definition = node.definition,
            value = definition.currentValue;

        if (value) {
          return unitConversion(node, value);
        }

        if (definition) {
          value = definition.accept(this, context);
        }

        if (value === undefined) {
          context.reportError("NO_SUCH_VARIABLE", node);
          return;
        }

        delete node.error;
        return unitConversion(node, value);
      }
    }, {
      key: 'visitVariableDefinition',
      value: function visitVariableDefinition(node, context) {
        var value = node.ast.accept(this, context);
        node.currentValue = value;
        return value;
      }
    }, {
      key: 'visitUnitDefinitionStatement',
      value: function visitUnitDefinitionStatement(node, context) {
        return node;
      }
    }, {
      key: 'visitUnit',
      value: function visitUnit(node, context) {
        return node;
      }
    }, {
      key: 'visitUnitPower',
      value: function visitUnitPower(node, context) {
        return node;
      }
    }, {
      key: 'visitUnitPer',
      value: function visitUnitPer(node, context) {
        return node;
      }
    }, {
      key: 'visitUnitLiteral',
      value: function visitUnitLiteral(node, context) {
        return node;
      }
    }, {
      key: 'visitUnitMultOp',
      value: function visitUnitMultOp(node, context) {
        return node;
      }
    }]);

    return EvaluatorVisitor;
  }(__WEBPACK_IMPORTED_MODULE_2__visitors__["a"
  /* ASTVisitor */
  ]);
  /* harmony default export */


  __webpack_exports__["a"] = EvaluatorVisitor;
  /***/
},
/* 54 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return bundleLoader;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return storage;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_turo_documents__ = __webpack_require__(55);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__storage_abstract_storage__ = __webpack_require__(14);

  var bundleLoader = new __WEBPACK_IMPORTED_MODULE_1__storage_abstract_storage__["a"
  /* BundleDocumentLoader */
  ](__WEBPACK_IMPORTED_MODULE_0_turo_documents__);
  var storage = new __WEBPACK_IMPORTED_MODULE_1__storage_abstract_storage__["b"
  /* CompositeStorage */
  ]([bundleLoader]);
  /***/
},
/* 55 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: true
  });
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__documents_app__ = __webpack_require__(56);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__documents_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__documents_app__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__documents_computerscience__ = __webpack_require__(57);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__documents_computerscience___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__documents_computerscience__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__documents_design__ = __webpack_require__(58);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__documents_design___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__documents_design__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__documents_fundamental__ = __webpack_require__(59);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__documents_fundamental___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__documents_fundamental__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__documents_imperial__ = __webpack_require__(60);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__documents_imperial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__documents_imperial__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__documents_metric__ = __webpack_require__(61);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__documents_metric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__documents_metric__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__documents_science__ = __webpack_require__(62);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__documents_science___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__documents_science__);
  /* harmony reexport (default from non-hamory) */


  __webpack_require__.d(__webpack_exports__, "app", function () {
    return __WEBPACK_IMPORTED_MODULE_0__documents_app___default.a;
  });
  /* harmony reexport (default from non-hamory) */


  __webpack_require__.d(__webpack_exports__, "computerscience", function () {
    return __WEBPACK_IMPORTED_MODULE_1__documents_computerscience___default.a;
  });
  /* harmony reexport (default from non-hamory) */


  __webpack_require__.d(__webpack_exports__, "design", function () {
    return __WEBPACK_IMPORTED_MODULE_2__documents_design___default.a;
  });
  /* harmony reexport (default from non-hamory) */


  __webpack_require__.d(__webpack_exports__, "fundamental", function () {
    return __WEBPACK_IMPORTED_MODULE_3__documents_fundamental___default.a;
  });
  /* harmony reexport (default from non-hamory) */


  __webpack_require__.d(__webpack_exports__, "imperial", function () {
    return __WEBPACK_IMPORTED_MODULE_4__documents_imperial___default.a;
  });
  /* harmony reexport (default from non-hamory) */


  __webpack_require__.d(__webpack_exports__, "metric", function () {
    return __WEBPACK_IMPORTED_MODULE_5__documents_metric___default.a;
  });
  /* harmony reexport (default from non-hamory) */


  __webpack_require__.d(__webpack_exports__, "science", function () {
    return __WEBPACK_IMPORTED_MODULE_6__documents_science___default.a;
  });
  /***/

},
/* 56 */

/***/
function (module, exports) {
  module.exports = "import \"metric\";\nimport \"imperial\";\n\nimport \"design\";\nimport \"science\";\n\nimport \"computerscience\"\n\n";
  /***/
},
/* 57 */

/***/
function (module, exports) {
  module.exports = "// definition based on http://de.wikipedia.org/wiki/Byte\n// you can do thinks like: 1GB / 3000 KB/s in min\n\nunit B byte bytes Byte : Information\nunit 8 bit bits : Byte\n\nunit kB kilobyte kilobytes KB kb : 1e3 Byte\nunit MB megabyte megabytes       : 1e6 Byte\nunit GB gigabyte gigabytes gb    : 1e9 Byte\nunit TB terabyte terabytes       : 1e12 Byte\nunit PB petabyte petabytes       : 1e15 Byte\n\nunit KiB kibibyte : 2e10 Byte\nunit MiB mibibyte : 1024 KiB\nunit GiB gibibyte : 1024 MiB\nunit TiB tebibyte : 1024 GiB\n\n";
  /***/
},
/* 58 */

/***/
function (module, exports) {
  module.exports = "// design.turo\n\nimport \"imperial\";\n\n// it would be great if we tag operators and variables:\n// http://bjango.com/articles/soulver/\n\n\n// from http://static.zealous-studios.co.uk/projects/web_tests/PPI%20tests.html\nunit 72 pt (Design) : inch;\nunit picas pc : 12pt;\n\n// This is not the dimension of a physical pixel.\nunit px (Design) : 0.75 pt;\n\nconst phi = (1 + sqrt 5) / 2;";
  /***/
},
/* 59 */

/***/
function (module, exports) {
  module.exports = "// Keep all dimensions to a minimal set.\n// Put other units in other files with other unit schemes.\n// Length.\nunit m metre metres meter meters (SI) : Length;\n\n\n// Time\nunit s second seconds : Time;\n// TODO in order to be included with all unit schemes,\n // but we'd like to filter these in some of them\nunit min minute minutes : 60 s;\nunit h hour hours : 60 min;\nunit day day days : 24 h;\nunit wk week weeks : 7 day;\n// Julian Astronomical Year\n// https://en.wikipedia.org/wiki/Year\nunit yr year years : 365.25 day;\n// month is calendar month.\nunit 12 mo month months : year;\n\n// Mass\nunit kg kilogram kilograms (SI) : Mass;\n\n// Angle\nunit deg degree degrees : Angle;\n// unit 2 * pi radians (SI) : 360 deg;\nunit 0.017453292519943295769236907684886127134428718885417254560971 rad radian radians (SI) : Angle, deg;\n\n// Constants\nconst pi = 3.141592653589793238462643383279502884197169399375105820974944;\nconst e = 2.7182818284590452353602874713526624977572470936999595;\n\nconst true = (1 == 1);\nconst false = !true;";
  /***/
},
/* 60 */

/***/
function (module, exports) {
  module.exports = "import \"fundamental\";\n\n// Length\nunit yd yard yards (Imperial) : 0.9144 m;\nunit 3 ft foot feet : yd;\nunit 12 inch inches : ft;\nunit mile miles : 5280 ft;\n\n// Mass\nunit lb (Imperial) : 0.45359237 kg;\nunit st stone : 14 lb;\nunit hdwt hundredweight : 112 lb;\nunit ton : 2240 lb;\nunit 16 oz ounce : lb;\n\n// Area\nunit acre (Imperial) : Area, 43560 ft^2;\n\n// Volume\nunit gallon (Imperial) : Volume, 0.00454609 m^3;\nunit 8 pint pints : gallon;\nunit 20 fl_oz floz : pint;\n\n// Speed\nunit mph (Imperial) : Speed, 1 mile/h;\n\n// Imperial Science\nimport \"science\";\n\n// Energy, dimension taken from J.\nunit cal (Imperial) : 4.184 J;\nunit kcal : 1000 cal;\n\n// Pressure, dimension taken from Pa.\nunit mmHg (Imperial) : 133.322387415 Pa;\nunit atm (Imperial) : 1.01325e5 Pa;\nunit psi (Imperial) : 6.8948e3 Pa;";
  /***/
},
/* 61 */

/***/
function (module, exports) {
  module.exports = "import \"fundamental\";\n\nunit m (Metric);\n\nunit km (Metric) : 1000 m;\n\nunit 100 cm (Metric) : m;\nunit 10 mm : cm;\n\nunit kg kilogram kilograms (Metric);\nunit 1000 g (Metric) : kg;\nunit tonne (Metric) : 1000 kg;\nunit 1000 mg : g;\n\nunit kph : Speed, 1 km/h;\n\nunit l litre litres liter liters : Volume, 1000 cm^3;\nunit 1000 ml : litre;\n\nunit ha hectare hectares (Metric) : Area, 10000 m^2;";
  /***/
},
/* 62 */

/***/
function (module, exports) {
  module.exports = "import \"fundamental\";\n\n// Force\nunit N newton newtons (Science) : Force, 1 kg m/s^2;\n\n// Pressure\nunit Pa pascal pascals (Science) : Pressure, 1 N/m^2;\nunit bar : 1e5 Pa;\nunit 1000 mbar millibar millibars : bar;\n\n// Energy\nunit J joule joules (Science) : Energy, 1 N m;\n\n// Power\nunit W Watt (Science) : Power, 1 J/s;\nunit MW megawatt : 1e6 W;\nunit kW kilowatt : 1e3 W;\n\n// Current\nunit A amp amps (Science) : Current;\nunit 1000 mA milliamp milliamps : A;\n\n// Charge\nunit C coulomb (Science) : Charge, 1 A s;\n\n// Potential Difference\nunit V volt volts (Science) : Potential, 1 W/A;\nunit 1000 kV kilovolt kilovolts: V;\n\n// Resistance\nunit ohm (Science) : Resistance, 1 V/A;\n\n// Constants\n\n// Speed of light in a vacuum.\nconst c = 299792458 m/s;\n\n// Earth's gravity\nconst g = 9.80665 m/s^2;";
  /***/
},
/* 63 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(64);
  /***/
},
/* 64 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  // This method of obtaining a reference to the global object needs to be
  // kept identical to the way it is obtained in runtime.js
  var g = function () {
    return this;
  }() || Function("return this")(); // Use `getOwnPropertyNames` because not all browsers support calling
  // `hasOwnProperty` on the global `self` object in a worker. See #183.


  var hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0; // Save the old regeneratorRuntime in case it needs to be restored later.

  var oldRuntime = hadRuntime && g.regeneratorRuntime; // Force reevalutation of runtime.js.

  g.regeneratorRuntime = undefined;
  module.exports = __webpack_require__(65);

  if (hadRuntime) {
    // Restore the original runtime.
    g.regeneratorRuntime = oldRuntime;
  } else {
    // Remove the global property added by runtime.js.
    try {
      delete g.regeneratorRuntime;
    } catch (e) {
      g.regeneratorRuntime = undefined;
    }
  }
  /***/

},
/* 65 */

/***/
function (module, exports) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  !function (global) {
    "use strict";

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    var inModule = typeof module === "object";
    var runtime = global.regeneratorRuntime;

    if (runtime) {
      if (inModule) {
        // If regeneratorRuntime is defined globally and we're in a module,
        // make the exports object identical to regeneratorRuntime.
        module.exports = runtime;
      } // Don't bother evaluating the rest of this file if the runtime was
      // already defined globally.


      return;
    } // Define the runtime globally (as expected by generated code) as either
    // module.exports (if we're in a module) or a new, empty object.


    runtime = global.regeneratorRuntime = inModule ? module.exports : {};

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    runtime.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        prototype[method] = function (arg) {
          return this._invoke(method, arg);
        };
      });
    }

    runtime.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    runtime.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;

        if (!(toStringTagSymbol in genFun)) {
          genFun[toStringTagSymbol] = "GeneratorFunction";
        }
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    runtime.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return Promise.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return Promise.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration. If the Promise is rejected, however, the
            // result for this iteration will be rejected with the same
            // reason. Note that rejections of yielded Promises are not
            // thrown back into the generator function, as is the case
            // when an awaited Promise is rejected. This difference in
            // behavior between yield and await is important, because it
            // allows the consumer to decide what to do with the yielded
            // rejection (swallow it and continue, manually .throw it back
            // into the generator, abandon iteration, whatever). With
            // await, by contrast, there is no opportunity to examine the
            // rejection reason outside the generator function, so the
            // only option is to throw it from the await expression, and
            // let the generator function handle the exception.
            result.value = unwrapped;
            resolve(result);
          }, reject);
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new Promise(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    runtime.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    runtime.async = function (innerFn, outerFn, self, tryLocsList) {
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
      return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          if (delegate.iterator.return) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    runtime.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    runtime.values = values;

    function doneResult() {
      return {
        value: undefined,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined;
        }

        return ContinueSentinel;
      }
    };
  }( // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  function () {
    return this;
  }() || Function("return this")());
  /***/
}
/******/
]));